// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2328a745%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/images/login_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/images/icons/unit-input-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./assets/images/tvscreenbg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(http://fonts.cdnfonts.com/css/avenir-lt-std);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Bootstrap v4.6.2 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #007bff;
  --secondary: #6c757d;
  --success: #28a745;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }

*,
*::before,
*::after {
  box-sizing: border-box; }

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block; }

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff; }

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important; }

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible; }

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem; }

p {
  margin-top: 0;
  margin-bottom: 1rem; }

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none; }

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit; }

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem; }

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0; }

dt {
  font-weight: 700; }

dd {
  margin-bottom: .5rem;
  margin-left: 0; }

blockquote {
  margin: 0 0 1rem; }

b,
strong {
  font-weight: bolder; }

small {
  font-size: 80%; }

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline; }

sub {
  bottom: -.25em; }

sup {
  top: -.5em; }

a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent; }
  a:hover {
    color: #0056b3;
    text-decoration: underline; }

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none; }
  a:not([href]):not([class]):hover {
    color: inherit;
    text-decoration: none; }

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em; }

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar; }

figure {
  margin: 0 0 1rem; }

img {
  vertical-align: middle;
  border-style: none; }

svg {
  overflow: hidden;
  vertical-align: middle; }

table {
  border-collapse: collapse; }

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom; }

th {
  text-align: inherit;
  text-align: -webkit-match-parent; }

label {
  display: inline-block;
  margin-bottom: 0.5rem; }

button {
  border-radius: 0; }

button:focus:not(:focus-visible) {
  outline: 0; }

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button,
input {
  overflow: visible; }

button,
select {
  text-transform: none; }

[role="button"] {
  cursor: pointer; }

select {
  word-wrap: normal; }

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }

button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  cursor: pointer; }

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  padding: 0;
  border-style: none; }

input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0; }

textarea {
  overflow: auto;
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: .5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal; }

progress {
  vertical-align: baseline; }

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto; }

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none; }

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; }

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button; }

output {
  display: inline-block; }

summary {
  display: list-item;
  cursor: pointer; }

template {
  display: none; }

[hidden] {
  display: none !important; }

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2; }

h1, .h1 {
  font-size: 2.5rem; }

h2, .h2 {
  font-size: 2rem; }

h3, .h3 {
  font-size: 1.75rem; }

h4, .h4 {
  font-size: 1.5rem; }

h5, .h5 {
  font-size: 1.25rem; }

h6, .h6 {
  font-size: 1rem; }

.lead {
  font-size: 1.25rem;
  font-weight: 300; }

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2; }

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2; }

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2; }

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2; }

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1); }

small,
.small {
  font-size: 0.875em;
  font-weight: 400; }

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3; }

.list-unstyled {
  padding-left: 0;
  list-style: none; }

.list-inline {
  padding-left: 0;
  list-style: none; }

.list-inline-item {
  display: inline-block; }
  .list-inline-item:not(:last-child) {
    margin-right: 0.5rem; }

.initialism {
  font-size: 90%;
  text-transform: uppercase; }

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem; }

.blockquote-footer {
  display: block;
  font-size: 0.875em;
  color: #6c757d; }
  .blockquote-footer::before {
    content: "\\2014\\00A0"; }

.img-fluid {
  max-width: 100%;
  height: auto; }

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto; }

.figure {
  display: inline-block; }

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1; }

.figure-caption {
  font-size: 90%;
  color: #6c757d; }

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word; }
  a > code {
    color: inherit; }

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem; }
  kbd kbd {
    padding: 0;
    font-size: 100%;
    font-weight: 700; }

pre {
  display: block;
  font-size: 87.5%;
  color: #212529; }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal; }

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll; }

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto; }

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px; } }

@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px; } }

@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px; } }

@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px; } }

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px; }

.no-gutters {
  margin-right: 0;
  margin-left: 0; }
  .no-gutters > .col,
  .no-gutters > [class*="col-"] {
    padding-right: 0;
    padding-left: 0; }

.col-1, .col-2, .col-3, .col-4, .ant-tabs-nav .ant-tabs-tab, .doctorViewTabs .ant-tabs-nav .ant-tabs-tab, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px; }

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%; }

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%; }

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%; }

.row-cols-3 > * {
  flex: 0 0 33.33333%;
  max-width: 33.33333%; }

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%; }

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%; }

.row-cols-6 > * {
  flex: 0 0 16.66667%;
  max-width: 16.66667%; }

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%; }

.col-1 {
  flex: 0 0 8.33333%;
  max-width: 8.33333%; }

.col-2 {
  flex: 0 0 16.66667%;
  max-width: 16.66667%; }

.col-3 {
  flex: 0 0 25%;
  max-width: 25%; }

.col-4, .ant-tabs-nav .ant-tabs-tab, .doctorViewTabs .ant-tabs-nav .ant-tabs-tab {
  flex: 0 0 33.33333%;
  max-width: 33.33333%; }

.col-5 {
  flex: 0 0 41.66667%;
  max-width: 41.66667%; }

.col-6 {
  flex: 0 0 50%;
  max-width: 50%; }

.col-7 {
  flex: 0 0 58.33333%;
  max-width: 58.33333%; }

.col-8 {
  flex: 0 0 66.66667%;
  max-width: 66.66667%; }

.col-9 {
  flex: 0 0 75%;
  max-width: 75%; }

.col-10 {
  flex: 0 0 83.33333%;
  max-width: 83.33333%; }

.col-11 {
  flex: 0 0 91.66667%;
  max-width: 91.66667%; }

.col-12 {
  flex: 0 0 100%;
  max-width: 100%; }

.order-first {
  order: -1; }

.order-last {
  order: 13; }

.order-0 {
  order: 0; }

.order-1 {
  order: 1; }

.order-2 {
  order: 2; }

.order-3 {
  order: 3; }

.order-4 {
  order: 4; }

.order-5 {
  order: 5; }

.order-6 {
  order: 6; }

.order-7 {
  order: 7; }

.order-8 {
  order: 8; }

.order-9 {
  order: 9; }

.order-10 {
  order: 10; }

.order-11 {
  order: 11; }

.order-12 {
  order: 12; }

.offset-1 {
  margin-left: 8.33333%; }

.offset-2 {
  margin-left: 16.66667%; }

.offset-3 {
  margin-left: 25%; }

.offset-4 {
  margin-left: 33.33333%; }

.offset-5 {
  margin-left: 41.66667%; }

.offset-6 {
  margin-left: 50%; }

.offset-7 {
  margin-left: 58.33333%; }

.offset-8 {
  margin-left: 66.66667%; }

.offset-9 {
  margin-left: 75%; }

.offset-10 {
  margin-left: 83.33333%; }

.offset-11 {
  margin-left: 91.66667%; }

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-sm-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-sm-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-sm-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-sm-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-sm-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-sm-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-sm-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-sm-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-sm-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-sm-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-sm-first {
    order: -1; }
  .order-sm-last {
    order: 13; }
  .order-sm-0 {
    order: 0; }
  .order-sm-1 {
    order: 1; }
  .order-sm-2 {
    order: 2; }
  .order-sm-3 {
    order: 3; }
  .order-sm-4 {
    order: 4; }
  .order-sm-5 {
    order: 5; }
  .order-sm-6 {
    order: 6; }
  .order-sm-7 {
    order: 7; }
  .order-sm-8 {
    order: 8; }
  .order-sm-9 {
    order: 9; }
  .order-sm-10 {
    order: 10; }
  .order-sm-11 {
    order: 11; }
  .order-sm-12 {
    order: 12; }
  .offset-sm-0 {
    margin-left: 0; }
  .offset-sm-1 {
    margin-left: 8.33333%; }
  .offset-sm-2 {
    margin-left: 16.66667%; }
  .offset-sm-3 {
    margin-left: 25%; }
  .offset-sm-4 {
    margin-left: 33.33333%; }
  .offset-sm-5 {
    margin-left: 41.66667%; }
  .offset-sm-6 {
    margin-left: 50%; }
  .offset-sm-7 {
    margin-left: 58.33333%; }
  .offset-sm-8 {
    margin-left: 66.66667%; }
  .offset-sm-9 {
    margin-left: 75%; }
  .offset-sm-10 {
    margin-left: 83.33333%; }
  .offset-sm-11 {
    margin-left: 91.66667%; } }

@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-md-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-md-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-md-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-md-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-md-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-md-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-md-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-md-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-md-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-md-first {
    order: -1; }
  .order-md-last {
    order: 13; }
  .order-md-0 {
    order: 0; }
  .order-md-1 {
    order: 1; }
  .order-md-2 {
    order: 2; }
  .order-md-3 {
    order: 3; }
  .order-md-4 {
    order: 4; }
  .order-md-5 {
    order: 5; }
  .order-md-6 {
    order: 6; }
  .order-md-7 {
    order: 7; }
  .order-md-8 {
    order: 8; }
  .order-md-9 {
    order: 9; }
  .order-md-10 {
    order: 10; }
  .order-md-11 {
    order: 11; }
  .order-md-12 {
    order: 12; }
  .offset-md-0 {
    margin-left: 0; }
  .offset-md-1 {
    margin-left: 8.33333%; }
  .offset-md-2 {
    margin-left: 16.66667%; }
  .offset-md-3 {
    margin-left: 25%; }
  .offset-md-4 {
    margin-left: 33.33333%; }
  .offset-md-5 {
    margin-left: 41.66667%; }
  .offset-md-6 {
    margin-left: 50%; }
  .offset-md-7 {
    margin-left: 58.33333%; }
  .offset-md-8 {
    margin-left: 66.66667%; }
  .offset-md-9 {
    margin-left: 75%; }
  .offset-md-10 {
    margin-left: 83.33333%; }
  .offset-md-11 {
    margin-left: 91.66667%; } }

@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-lg-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-lg-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-lg-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-lg-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-lg-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-lg-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-lg-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-lg-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-lg-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-lg-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-lg-first {
    order: -1; }
  .order-lg-last {
    order: 13; }
  .order-lg-0 {
    order: 0; }
  .order-lg-1 {
    order: 1; }
  .order-lg-2 {
    order: 2; }
  .order-lg-3 {
    order: 3; }
  .order-lg-4 {
    order: 4; }
  .order-lg-5 {
    order: 5; }
  .order-lg-6 {
    order: 6; }
  .order-lg-7 {
    order: 7; }
  .order-lg-8 {
    order: 8; }
  .order-lg-9 {
    order: 9; }
  .order-lg-10 {
    order: 10; }
  .order-lg-11 {
    order: 11; }
  .order-lg-12 {
    order: 12; }
  .offset-lg-0 {
    margin-left: 0; }
  .offset-lg-1 {
    margin-left: 8.33333%; }
  .offset-lg-2 {
    margin-left: 16.66667%; }
  .offset-lg-3 {
    margin-left: 25%; }
  .offset-lg-4 {
    margin-left: 33.33333%; }
  .offset-lg-5 {
    margin-left: 41.66667%; }
  .offset-lg-6 {
    margin-left: 50%; }
  .offset-lg-7 {
    margin-left: 58.33333%; }
  .offset-lg-8 {
    margin-left: 66.66667%; }
  .offset-lg-9 {
    margin-left: 75%; }
  .offset-lg-10 {
    margin-left: 83.33333%; }
  .offset-lg-11 {
    margin-left: 91.66667%; } }

@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%; }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-xl-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-xl-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-xl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-xl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-xl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-xl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-xl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-xl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-xl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-xl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-xl-first {
    order: -1; }
  .order-xl-last {
    order: 13; }
  .order-xl-0 {
    order: 0; }
  .order-xl-1 {
    order: 1; }
  .order-xl-2 {
    order: 2; }
  .order-xl-3 {
    order: 3; }
  .order-xl-4 {
    order: 4; }
  .order-xl-5 {
    order: 5; }
  .order-xl-6 {
    order: 6; }
  .order-xl-7 {
    order: 7; }
  .order-xl-8 {
    order: 8; }
  .order-xl-9 {
    order: 9; }
  .order-xl-10 {
    order: 10; }
  .order-xl-11 {
    order: 11; }
  .order-xl-12 {
    order: 12; }
  .offset-xl-0 {
    margin-left: 0; }
  .offset-xl-1 {
    margin-left: 8.33333%; }
  .offset-xl-2 {
    margin-left: 16.66667%; }
  .offset-xl-3 {
    margin-left: 25%; }
  .offset-xl-4 {
    margin-left: 33.33333%; }
  .offset-xl-5 {
    margin-left: 41.66667%; }
  .offset-xl-6 {
    margin-left: 50%; }
  .offset-xl-7 {
    margin-left: 58.33333%; }
  .offset-xl-8 {
    margin-left: 66.66667%; }
  .offset-xl-9 {
    margin-left: 75%; }
  .offset-xl-10 {
    margin-left: 83.33333%; }
  .offset-xl-11 {
    margin-left: 91.66667%; } }

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529; }
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6; }
  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6; }
  .table tbody + tbody {
    border-top: 2px solid #dee2e6; }

.table-sm th,
.table-sm td {
  padding: 0.3rem; }

.table-bordered {
  border: 1px solid #dee2e6; }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6; }
  .table-bordered thead th,
  .table-bordered thead td {
    border-bottom-width: 2px; }

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0; }

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05); }

.table-hover tbody tr:hover {
  color: #212529;
  background-color: rgba(0, 0, 0, 0.075); }

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #b8daff; }

.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #7abaff; }

.table-hover .table-primary:hover {
  background-color: #9fcdff; }
  .table-hover .table-primary:hover > td,
  .table-hover .table-primary:hover > th {
    background-color: #9fcdff; }

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #d6d8db; }

.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #b3b7bb; }

.table-hover .table-secondary:hover {
  background-color: #c8cbcf; }
  .table-hover .table-secondary:hover > td,
  .table-hover .table-secondary:hover > th {
    background-color: #c8cbcf; }

.table-success,
.table-success > th,
.table-success > td {
  background-color: #c3e6cb; }

.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #8fd19e; }

.table-hover .table-success:hover {
  background-color: #b1dfbb; }
  .table-hover .table-success:hover > td,
  .table-hover .table-success:hover > th {
    background-color: #b1dfbb; }

.table-info,
.table-info > th,
.table-info > td {
  background-color: #bee5eb; }

.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #86cfda; }

.table-hover .table-info:hover {
  background-color: #abdde5; }
  .table-hover .table-info:hover > td,
  .table-hover .table-info:hover > th {
    background-color: #abdde5; }

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #ffeeba; }

.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #ffdf7e; }

.table-hover .table-warning:hover {
  background-color: #ffe8a1; }
  .table-hover .table-warning:hover > td,
  .table-hover .table-warning:hover > th {
    background-color: #ffe8a1; }

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #f5c6cb; }

.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #ed969e; }

.table-hover .table-danger:hover {
  background-color: #f1b0b7; }
  .table-hover .table-danger:hover > td,
  .table-hover .table-danger:hover > th {
    background-color: #f1b0b7; }

.table-light,
.table-light > th,
.table-light > td {
  background-color: #fdfdfe; }

.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #fbfcfc; }

.table-hover .table-light:hover {
  background-color: #ececf6; }
  .table-hover .table-light:hover > td,
  .table-hover .table-light:hover > th {
    background-color: #ececf6; }

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c6c8ca; }

.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #95999c; }

.table-hover .table-dark:hover {
  background-color: #b9bbbe; }
  .table-hover .table-dark:hover > td,
  .table-hover .table-dark:hover > th {
    background-color: #b9bbbe; }

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075); }

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075); }
  .table-hover .table-active:hover > td,
  .table-hover .table-active:hover > th {
    background-color: rgba(0, 0, 0, 0.075); }

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55; }

.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6; }

.table-dark {
  color: #fff;
  background-color: #343a40; }
  .table-dark th,
  .table-dark td,
  .table-dark thead th {
    border-color: #454d55; }
  .table-dark.table-bordered {
    border: 0; }
  .table-dark.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(255, 255, 255, 0.05); }
  .table-dark.table-hover tbody tr:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.075); }

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-sm > .table-bordered {
      border: 0; } }

@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-md > .table-bordered {
      border: 0; } }

@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-lg > .table-bordered {
      border: 0; } }

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-xl > .table-bordered {
      border: 0; } }

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; }
  .table-responsive > .table-bordered {
    border: 0; }

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-control {
      transition: none; } }
  .form-control::-ms-expand {
    background-color: transparent;
    border: 0; }
  .form-control:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .form-control::placeholder {
    color: #6c757d;
    opacity: 1; }
  .form-control:disabled, .form-control[readonly] {
    background-color: #e9ecef;
    opacity: 1; }

input[type="date"].form-control,
input[type="time"].form-control,
input[type="datetime-local"].form-control,
input[type="month"].form-control {
  -webkit-appearance: none;
          appearance: none; }

select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057; }

select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff; }

.form-control-file,
.form-control-range {
  display: block;
  width: 100%; }

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5; }

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5; }

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5; }

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0; }
  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0; }

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem; }

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem; }

select.form-control[size], select.form-control[multiple] {
  height: auto; }

textarea.form-control {
  height: auto; }

.form-group {
  margin-bottom: 1rem; }

.form-text {
  display: block;
  margin-top: 0.25rem; }

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px; }
  .form-row > .col,
  .form-row > [class*="col-"] {
    padding-right: 5px;
    padding-left: 5px; }

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem; }

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem; }
  .form-check-input[disabled] ~ .form-check-label,
  .form-check-input:disabled ~ .form-check-label {
    color: #6c757d; }

.form-check-label {
  margin-bottom: 0; }

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem; }
  .form-check-inline .form-check-input {
    position: static;
    margin-top: 0;
    margin-right: 0.3125rem;
    margin-left: 0; }

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #28a745; }

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.9);
  border-radius: 0.25rem; }
  .form-row > .col > .valid-tooltip,
  .form-row > [class*="col-"] > .valid-tooltip {
    left: 5px; }

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.was-validated select.form-control:valid, select.form-control.is-valid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center; }

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #28a745;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat; }
  .was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #28a745; }

.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #28a745; }
  .was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
    border-color: #28a745; }

.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #34ce57;
  background-color: #34ce57; }

.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #28a745; }

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28a745; }

.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25); }

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545; }

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.25rem; }
  .form-row > .col > .invalid-tooltip,
  .form-row > [class*="col-"] > .invalid-tooltip {
    left: 5px; }

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.was-validated select.form-control:invalid, select.form-control.is-invalid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center; }

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #dc3545;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat; }
  .was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545; }

.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545; }
  .was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
    border-color: #dc3545; }

.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #e4606d;
  background-color: #e4606d; }

.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545; }

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545; }

.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25); }

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center; }
  .form-inline .form-check {
    width: 100%; }
  @media (min-width: 576px) {
    .form-inline label {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0; }
    .form-inline .form-group {
      display: flex;
      flex: 0 0 auto;
      flex-flow: row wrap;
      align-items: center;
      margin-bottom: 0; }
    .form-inline .form-control {
      display: inline-block;
      width: auto;
      vertical-align: middle; }
    .form-inline .form-control-plaintext {
      display: inline-block; }
    .form-inline .input-group,
    .form-inline .custom-select {
      width: auto; }
    .form-inline .form-check {
      display: flex;
      align-items: center;
      justify-content: center;
      width: auto;
      padding-left: 0; }
    .form-inline .form-check-input {
      position: relative;
      flex-shrink: 0;
      margin-top: 0;
      margin-right: 0.25rem;
      margin-left: 0; }
    .form-inline .custom-control {
      align-items: center;
      justify-content: center; }
    .form-inline .custom-control-label {
      margin-bottom: 0; } }

.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .btn {
      transition: none; } }
  .btn:hover {
    color: #212529;
    text-decoration: none; }
  .btn:focus, .btn.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .btn.disabled, .btn:disabled {
    opacity: 0.65; }
  .btn:not(:disabled):not(.disabled) {
    cursor: pointer; }

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none; }

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff; }
  .btn-primary:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc; }
  .btn-primary:focus, .btn-primary.focus {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5); }
  .btn-primary.disabled, .btn-primary:disabled {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }
  .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,
  .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #0062cc;
    border-color: #005cbf; }
    .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5); }

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d; }
  .btn-secondary:hover {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62; }
  .btn-secondary:focus, .btn-secondary.focus {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62;
    box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }
  .btn-secondary.disabled, .btn-secondary:disabled {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
  .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,
  .show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: #545b62;
    border-color: #4e555b; }
    .btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-secondary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }

.btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745; }
  .btn-success:hover {
    color: #fff;
    background-color: #218838;
    border-color: #1e7e34; }
  .btn-success:focus, .btn-success.focus {
    color: #fff;
    background-color: #218838;
    border-color: #1e7e34;
    box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5); }
  .btn-success.disabled, .btn-success:disabled {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745; }
  .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,
  .show > .btn-success.dropdown-toggle {
    color: #fff;
    background-color: #1e7e34;
    border-color: #1c7430; }
    .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,
    .show > .btn-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5); }

.btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8; }
  .btn-info:hover {
    color: #fff;
    background-color: #138496;
    border-color: #117a8b; }
  .btn-info:focus, .btn-info.focus {
    color: #fff;
    background-color: #138496;
    border-color: #117a8b;
    box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5); }
  .btn-info.disabled, .btn-info:disabled {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8; }
  .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,
  .show > .btn-info.dropdown-toggle {
    color: #fff;
    background-color: #117a8b;
    border-color: #10707f; }
    .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,
    .show > .btn-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5); }

.btn-warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107; }
  .btn-warning:hover {
    color: #212529;
    background-color: #e0a800;
    border-color: #d39e00; }
  .btn-warning:focus, .btn-warning.focus {
    color: #212529;
    background-color: #e0a800;
    border-color: #d39e00;
    box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5); }
  .btn-warning.disabled, .btn-warning:disabled {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107; }
  .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,
  .show > .btn-warning.dropdown-toggle {
    color: #212529;
    background-color: #d39e00;
    border-color: #c69500; }
    .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,
    .show > .btn-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5); }

.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545; }
  .btn-danger:hover {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130; }
  .btn-danger:focus, .btn-danger.focus {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130;
    box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5); }
  .btn-danger.disabled, .btn-danger:disabled {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545; }
  .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,
  .show > .btn-danger.dropdown-toggle {
    color: #fff;
    background-color: #bd2130;
    border-color: #b21f2d; }
    .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,
    .show > .btn-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5); }

.btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa; }
  .btn-light:hover {
    color: #212529;
    background-color: #e2e6ea;
    border-color: #dae0e5; }
  .btn-light:focus, .btn-light.focus {
    color: #212529;
    background-color: #e2e6ea;
    border-color: #dae0e5;
    box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5); }
  .btn-light.disabled, .btn-light:disabled {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa; }
  .btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,
  .show > .btn-light.dropdown-toggle {
    color: #212529;
    background-color: #dae0e5;
    border-color: #d3d9df; }
    .btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,
    .show > .btn-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5); }

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40; }
  .btn-dark:hover {
    color: #fff;
    background-color: #23272b;
    border-color: #1d2124; }
  .btn-dark:focus, .btn-dark.focus {
    color: #fff;
    background-color: #23272b;
    border-color: #1d2124;
    box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5); }
  .btn-dark.disabled, .btn-dark:disabled {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
  .btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,
  .show > .btn-dark.dropdown-toggle {
    color: #fff;
    background-color: #1d2124;
    border-color: #171a1d; }
    .btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,
    .show > .btn-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5); }

.btn-outline-primary {
  color: #007bff;
  border-color: #007bff; }
  .btn-outline-primary:hover {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }
  .btn-outline-primary:focus, .btn-outline-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }
  .btn-outline-primary.disabled, .btn-outline-primary:disabled {
    color: #007bff;
    background-color: transparent; }
  .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,
  .show > .btn-outline-primary.dropdown-toggle {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }
    .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-primary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d; }
  .btn-outline-secondary:hover {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
  .btn-outline-secondary:focus, .btn-outline-secondary.focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }
  .btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
    color: #6c757d;
    background-color: transparent; }
  .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,
  .show > .btn-outline-secondary.dropdown-toggle {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
    .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-secondary.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }

.btn-outline-success {
  color: #28a745;
  border-color: #28a745; }
  .btn-outline-success:hover {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745; }
  .btn-outline-success:focus, .btn-outline-success.focus {
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }
  .btn-outline-success.disabled, .btn-outline-success:disabled {
    color: #28a745;
    background-color: transparent; }
  .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,
  .show > .btn-outline-success.dropdown-toggle {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745; }
    .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-success.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }

.btn-outline-info {
  color: #17a2b8;
  border-color: #17a2b8; }
  .btn-outline-info:hover {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8; }
  .btn-outline-info:focus, .btn-outline-info.focus {
    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }
  .btn-outline-info.disabled, .btn-outline-info:disabled {
    color: #17a2b8;
    background-color: transparent; }
  .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,
  .show > .btn-outline-info.dropdown-toggle {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8; }
    .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-info.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }

.btn-outline-warning {
  color: #ffc107;
  border-color: #ffc107; }
  .btn-outline-warning:hover {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107; }
  .btn-outline-warning:focus, .btn-outline-warning.focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }
  .btn-outline-warning.disabled, .btn-outline-warning:disabled {
    color: #ffc107;
    background-color: transparent; }
  .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,
  .show > .btn-outline-warning.dropdown-toggle {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107; }
    .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-warning.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545; }
  .btn-outline-danger:hover {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545; }
  .btn-outline-danger:focus, .btn-outline-danger.focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }
  .btn-outline-danger.disabled, .btn-outline-danger:disabled {
    color: #dc3545;
    background-color: transparent; }
  .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,
  .show > .btn-outline-danger.dropdown-toggle {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545; }
    .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-danger.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }

.btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa; }
  .btn-outline-light:hover {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa; }
  .btn-outline-light:focus, .btn-outline-light.focus {
    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }
  .btn-outline-light.disabled, .btn-outline-light:disabled {
    color: #f8f9fa;
    background-color: transparent; }
  .btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,
  .show > .btn-outline-light.dropdown-toggle {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa; }
    .btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-light.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40; }
  .btn-outline-dark:hover {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
  .btn-outline-dark:focus, .btn-outline-dark.focus {
    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }
  .btn-outline-dark.disabled, .btn-outline-dark:disabled {
    color: #343a40;
    background-color: transparent; }
  .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,
  .show > .btn-outline-dark.dropdown-toggle {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40; }
    .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-dark.dropdown-toggle:focus {
      box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }

.btn-link {
  font-weight: 400;
  color: #007bff;
  text-decoration: none; }
  .btn-link:hover {
    color: #0056b3;
    text-decoration: underline; }
  .btn-link:focus, .btn-link.focus {
    text-decoration: underline; }
  .btn-link:disabled, .btn-link.disabled {
    color: #6c757d;
    pointer-events: none; }

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem; }

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem; }

.btn-block {
  display: block;
  width: 100%; }
  .btn-block + .btn-block {
    margin-top: 0.5rem; }

input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%; }

.fade {
  transition: opacity 0.15s linear; }
  @media (prefers-reduced-motion: reduce) {
    .fade {
      transition: none; } }
  .fade:not(.show) {
    opacity: 0; }

.collapse:not(.show) {
  display: none; }

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }
  @media (prefers-reduced-motion: reduce) {
    .collapsing {
      transition: none; } }
  .collapsing.width {
    width: 0;
    height: auto;
    transition: width 0.35s ease; }
    @media (prefers-reduced-motion: reduce) {
      .collapsing.width {
        transition: none; } }

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative; }

.dropdown-toggle {
  white-space: nowrap; }
  .dropdown-toggle::after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent; }
  .dropdown-toggle:empty::after {
    margin-left: 0; }

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem; }

.dropdown-menu-left {
  right: auto;
  left: 0; }

.dropdown-menu-right {
  right: 0;
  left: auto; }

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0; }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto; } }

@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0; }
  .dropdown-menu-md-right {
    right: 0;
    left: auto; } }

@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0; }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto; } }

@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0; }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto; } }

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem; }

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent; }

.dropup .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem; }

.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid; }

.dropright .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropright .dropdown-toggle::after {
  vertical-align: 0; }

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem; }

.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: ""; }

.dropleft .dropdown-toggle::after {
  display: none; }

.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent; }

.dropleft .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropleft .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-menu[x-placement^="top"], .dropdown-menu[x-placement^="right"], .dropdown-menu[x-placement^="bottom"], .dropdown-menu[x-placement^="left"] {
  right: auto;
  bottom: auto; }

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef; }

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0; }
  .dropdown-item:hover, .dropdown-item:focus {
    color: #16181b;
    text-decoration: none;
    background-color: #e9ecef; }
  .dropdown-item.active, .dropdown-item:active {
    color: #fff;
    text-decoration: none;
    background-color: #007bff; }
  .dropdown-item.disabled, .dropdown-item:disabled {
    color: #adb5bd;
    pointer-events: none;
    background-color: transparent; }

.dropdown-menu.show {
  display: block; }

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap; }

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529; }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    position: relative;
    flex: 1 1 auto; }
    .btn-group > .btn:hover,
    .btn-group-vertical > .btn:hover {
      z-index: 1; }
    .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
    .btn-group-vertical > .btn:focus,
    .btn-group-vertical > .btn:active,
    .btn-group-vertical > .btn.active {
      z-index: 1; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px; }

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem; }
  .dropdown-toggle-split::after,
  .dropup .dropdown-toggle-split::after,
  .dropright .dropdown-toggle-split::after {
    margin-left: 0; }
  .dropleft .dropdown-toggle-split::before {
    margin-right: 0; }

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical > .btn,
  .btn-group-vertical > .btn-group {
    width: 100%; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) {
    margin-top: -1px; }
  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0; }
  .btn-group-toggle > .btn input[type="radio"],
  .btn-group-toggle > .btn input[type="checkbox"],
  .btn-group-toggle > .btn-group > .btn input[type="radio"],
  .btn-group-toggle > .btn-group > .btn input[type="checkbox"] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none; }

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .form-control-plaintext,
  .input-group > .custom-select,
  .input-group > .custom-file {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    margin-bottom: 0; }
    .input-group > .form-control + .form-control,
    .input-group > .form-control + .custom-select,
    .input-group > .form-control + .custom-file,
    .input-group > .form-control-plaintext + .form-control,
    .input-group > .form-control-plaintext + .custom-select,
    .input-group > .form-control-plaintext + .custom-file,
    .input-group > .custom-select + .form-control,
    .input-group > .custom-select + .custom-select,
    .input-group > .custom-select + .custom-file,
    .input-group > .custom-file + .form-control,
    .input-group > .custom-file + .custom-select,
    .input-group > .custom-file + .custom-file {
      margin-left: -1px; }
  .input-group > .form-control:focus,
  .input-group > .custom-select:focus,
  .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
    z-index: 3; }
  .input-group > .custom-file .custom-file-input:focus {
    z-index: 4; }
  .input-group > .form-control:not(:first-child),
  .input-group > .custom-select:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }
  .input-group > .custom-file {
    display: flex;
    align-items: center; }
    .input-group > .custom-file:not(:last-child) .custom-file-label,
    .input-group > .custom-file:not(:last-child) .custom-file-label::after {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0; }
    .input-group > .custom-file:not(:first-child) .custom-file-label {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0; }
  .input-group:not(.has-validation) > .form-control:not(:last-child),
  .input-group:not(.has-validation) > .custom-select:not(:last-child),
  .input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
  .input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .input-group.has-validation > .form-control:nth-last-child(n + 3),
  .input-group.has-validation > .custom-select:nth-last-child(n + 3),
  .input-group.has-validation > .custom-file:nth-last-child(n + 3) .custom-file-label,
  .input-group.has-validation > .custom-file:nth-last-child(n + 3) .custom-file-label::after {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }

.input-group-prepend,
.input-group-append {
  display: flex; }
  .input-group-prepend .btn,
  .input-group-append .btn {
    position: relative;
    z-index: 2; }
    .input-group-prepend .btn:focus,
    .input-group-append .btn:focus {
      z-index: 3; }
  .input-group-prepend .btn + .btn,
  .input-group-prepend .btn + .input-group-text,
  .input-group-prepend .input-group-text + .input-group-text,
  .input-group-prepend .input-group-text + .btn,
  .input-group-append .btn + .btn,
  .input-group-append .btn + .input-group-text,
  .input-group-append .input-group-text + .input-group-text,
  .input-group-append .input-group-text + .btn {
    margin-left: -1px; }

.input-group-prepend {
  margin-right: -1px; }

.input-group-append {
  margin-left: -1px; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem; }
  .input-group-text input[type="radio"],
  .input-group-text input[type="checkbox"] {
    margin-top: 0; }

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px); }

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem; }

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px); }

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem; }

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem; }

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact; }

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem; }

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0; }
  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #007bff;
    background-color: #007bff; }
  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: #80bdff; }
  .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
    color: #fff;
    background-color: #b3d7ff;
    border-color: #b3d7ff; }
  .custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
    color: #6c757d; }
    .custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
      background-color: #e9ecef; }

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top; }
  .custom-control-label::before {
    position: absolute;
    top: 0.25rem;
    left: -1.5rem;
    display: block;
    width: 1rem;
    height: 1rem;
    pointer-events: none;
    content: "";
    background-color: #fff;
    border: 1px solid #adb5bd; }
  .custom-control-label::after {
    position: absolute;
    top: 0.25rem;
    left: -1.5rem;
    display: block;
    width: 1rem;
    height: 1rem;
    content: "";
    background: 50% / 50% 50% no-repeat; }

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem; }

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #007bff;
  background-color: #007bff; }

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5); }

.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5); }

.custom-radio .custom-control-label::before {
  border-radius: 50%; }

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }

.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5); }

.custom-switch {
  padding-left: 2.25rem; }
  .custom-switch .custom-control-label::before {
    left: -2.25rem;
    width: 1.75rem;
    pointer-events: all;
    border-radius: 0.5rem; }
  .custom-switch .custom-control-label::after {
    top: calc(0.25rem + 2px);
    left: calc(-2.25rem + 2px);
    width: calc(1rem - 4px);
    height: calc(1rem - 4px);
    background-color: #adb5bd;
    border-radius: 0.5rem;
    transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .custom-switch .custom-control-label::after {
        transition: none; } }
  .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    background-color: #fff;
    transform: translateX(0.75rem); }
  .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
    background-color: rgba(0, 123, 255, 0.5); }

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
          appearance: none; }
  .custom-select:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
    .custom-select:focus::-ms-value {
      color: #495057;
      background-color: #fff; }
  .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: 0.75rem;
    background-image: none; }
  .custom-select:disabled {
    color: #6c757d;
    background-color: #e9ecef; }
  .custom-select::-ms-expand {
    display: none; }
  .custom-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #495057; }

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem; }

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem; }

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0; }

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0; }
  .custom-file-input:focus ~ .custom-file-label {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .custom-file-input[disabled] ~ .custom-file-label,
  .custom-file-input:disabled ~ .custom-file-label {
    background-color: #e9ecef; }
  .custom-file-input:lang(en) ~ .custom-file-label::after {
    content: "Browse"; }
  .custom-file-input ~ .custom-file-label[data-browse]::after {
    content: attr(data-browse); }

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem; }
  .custom-file-label::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: calc(1.5em + 0.75rem);
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: #495057;
    content: "Browse";
    background-color: #e9ecef;
    border-left: inherit;
    border-radius: 0 0.25rem 0.25rem 0; }

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
          appearance: none; }
  .custom-range:focus {
    outline: 0; }
    .custom-range:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
    .custom-range:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
    .custom-range:focus::-ms-thumb {
      box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .custom-range::-moz-focus-outer {
    border: 0; }
  .custom-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    background-color: #007bff;
    border: 0;
    border-radius: 1rem;
    -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    -webkit-appearance: none;
            appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none; } }
    .custom-range::-webkit-slider-thumb:active {
      background-color: #b3d7ff; }
  .custom-range::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #dee2e6;
    border-color: transparent;
    border-radius: 1rem; }
  .custom-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #007bff;
    border: 0;
    border-radius: 1rem;
    -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none; } }
    .custom-range::-moz-range-thumb:active {
      background-color: #b3d7ff; }
  .custom-range::-moz-range-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #dee2e6;
    border-color: transparent;
    border-radius: 1rem; }
  .custom-range::-ms-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: 0;
    margin-right: 0.2rem;
    margin-left: 0.2rem;
    background-color: #007bff;
    border: 0;
    border-radius: 1rem;
    -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-ms-thumb {
        -ms-transition: none;
        transition: none; } }
    .custom-range::-ms-thumb:active {
      background-color: #b3d7ff; }
  .custom-range::-ms-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: transparent;
    border-color: transparent;
    border-width: 0.5rem; }
  .custom-range::-ms-fill-lower {
    background-color: #dee2e6;
    border-radius: 1rem; }
  .custom-range::-ms-fill-upper {
    margin-right: 15px;
    background-color: #dee2e6;
    border-radius: 1rem; }
  .custom-range:disabled::-webkit-slider-thumb {
    background-color: #adb5bd; }
  .custom-range:disabled::-webkit-slider-runnable-track {
    cursor: default; }
  .custom-range:disabled::-moz-range-thumb {
    background-color: #adb5bd; }
  .custom-range:disabled::-moz-range-track {
    cursor: default; }
  .custom-range:disabled::-ms-thumb {
    background-color: #adb5bd; }

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .custom-control-label::before,
    .custom-file-label,
    .custom-select {
      transition: none; } }

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }

.nav-link {
  display: block;
  padding: 0.5rem 1rem; }
  .nav-link:hover, .nav-link:focus {
    text-decoration: none; }
  .nav-link.disabled {
    color: #6c757d;
    pointer-events: none;
    cursor: default; }

.nav-tabs {
  border-bottom: 1px solid #dee2e6; }
  .nav-tabs .nav-link {
    margin-bottom: -1px;
    background-color: transparent;
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem; }
    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
      isolation: isolate;
      border-color: #e9ecef #e9ecef #dee2e6; }
    .nav-tabs .nav-link.disabled {
      color: #6c757d;
      background-color: transparent;
      border-color: transparent; }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff; }
  .nav-tabs .dropdown-menu {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem; }

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #007bff; }

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center; }

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center; }

.tab-content > .tab-pane {
  display: none; }

.tab-content > .active {
  display: block; }

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem; }
  .navbar .container,
  .navbar .container-fluid, .navbar .container-sm, .navbar .container-md, .navbar .container-lg, .navbar .container-xl {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between; }

.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap; }
  .navbar-brand:hover, .navbar-brand:focus {
    text-decoration: none; }

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }
  .navbar-nav .nav-link {
    padding-right: 0;
    padding-left: 0; }
  .navbar-nav .dropdown-menu {
    position: static;
    float: none; }

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem; }

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center; }

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem; }
  .navbar-toggler:hover, .navbar-toggler:focus {
    text-decoration: none; }

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50% / 100% 100% no-repeat; }

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto; }

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-sm .navbar-nav {
      flex-direction: row; }
      .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-sm > .container,
    .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {
      flex-wrap: nowrap; }
    .navbar-expand-sm .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-sm .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-sm .navbar-toggler {
      display: none; } }

@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-md .navbar-nav {
      flex-direction: row; }
      .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-md .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-md > .container,
    .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {
      flex-wrap: nowrap; }
    .navbar-expand-md .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-md .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-md .navbar-toggler {
      display: none; } }

@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-lg .navbar-nav {
      flex-direction: row; }
      .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-lg > .container,
    .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {
      flex-wrap: nowrap; }
    .navbar-expand-lg .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-lg .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-lg .navbar-toggler {
      display: none; } }

@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-xl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-xl > .container,
    .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {
      flex-wrap: nowrap; }
    .navbar-expand-xl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xl .navbar-toggler {
      display: none; } }

.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start; }
  .navbar-expand > .container,
  .navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {
    padding-right: 0;
    padding-left: 0; }
  .navbar-expand .navbar-nav {
    flex-direction: row; }
    .navbar-expand .navbar-nav .dropdown-menu {
      position: absolute; }
    .navbar-expand .navbar-nav .nav-link {
      padding-right: 0.5rem;
      padding-left: 0.5rem; }
  .navbar-expand > .container,
  .navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {
    flex-wrap: nowrap; }
  .navbar-expand .navbar-nav-scroll {
    overflow: visible; }
  .navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto; }
  .navbar-expand .navbar-toggler {
    display: none; }

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9); }
  .navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
    color: rgba(0, 0, 0, 0.9); }

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5); }
  .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
    color: rgba(0, 0, 0, 0.7); }
  .navbar-light .navbar-nav .nav-link.disabled {
    color: rgba(0, 0, 0, 0.3); }

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9); }

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1); }

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); }

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5); }
  .navbar-light .navbar-text a {
    color: rgba(0, 0, 0, 0.9); }
    .navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
      color: rgba(0, 0, 0, 0.9); }

.navbar-dark .navbar-brand {
  color: #fff; }
  .navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
    color: #fff; }

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5); }
  .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
    color: rgba(255, 255, 255, 0.75); }
  .navbar-dark .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, 0.25); }

.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff; }

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1); }

.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); }

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5); }
  .navbar-dark .navbar-text a {
    color: #fff; }
    .navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
      color: #fff; }

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem; }
  .card > hr {
    margin-right: 0;
    margin-left: 0; }
  .card > .list-group {
    border-top: inherit;
    border-bottom: inherit; }
    .card > .list-group:first-child {
      border-top-width: 0;
      border-top-left-radius: calc(0.25rem - 1px);
      border-top-right-radius: calc(0.25rem - 1px); }
    .card > .list-group:last-child {
      border-bottom-width: 0;
      border-bottom-right-radius: calc(0.25rem - 1px);
      border-bottom-left-radius: calc(0.25rem - 1px); }
  .card > .card-header + .list-group,
  .card > .list-group + .card-footer {
    border-top: 0; }

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem; }

.card-title {
  margin-bottom: 0.75rem; }

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0; }

.card-text:last-child {
  margin-bottom: 0; }

.card-link:hover {
  text-decoration: none; }

.card-link + .card-link {
  margin-left: 1.25rem; }

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125); }
  .card-header:first-child {
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0; }

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125); }
  .card-footer:last-child {
    border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px); }

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0; }

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem; }

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.25rem - 1px); }

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%; }

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px); }

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px); }

.card-deck .card {
  margin-bottom: 15px; }

@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px; }
    .card-deck .card {
      flex: 1 0;
      margin-right: 15px;
      margin-bottom: 0;
      margin-left: 15px; } }

.card-group > .card {
  margin-bottom: 15px; }

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap; }
    .card-group > .card {
      flex: 1 0;
      margin-bottom: 0; }
      .card-group > .card + .card {
        margin-left: 0;
        border-left: 0; }
      .card-group > .card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-top,
        .card-group > .card:not(:last-child) .card-header {
          border-top-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-bottom,
        .card-group > .card:not(:last-child) .card-footer {
          border-bottom-right-radius: 0; }
      .card-group > .card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-top,
        .card-group > .card:not(:first-child) .card-header {
          border-top-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-bottom,
        .card-group > .card:not(:first-child) .card-footer {
          border-bottom-left-radius: 0; } }

.card-columns .card {
  margin-bottom: 0.75rem; }

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1; }
    .card-columns .card {
      display: inline-block;
      width: 100%; } }

.accordion {
  overflow-anchor: none; }
  .accordion > .card {
    overflow: hidden; }
    .accordion > .card:not(:last-of-type) {
      border-bottom: 0;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0; }
    .accordion > .card:not(:first-of-type) {
      border-top-left-radius: 0;
      border-top-right-radius: 0; }
    .accordion > .card > .card-header {
      border-radius: 0;
      margin-bottom: -1px; }

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem; }

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem; }
  .breadcrumb-item + .breadcrumb-item::before {
    float: left;
    padding-right: 0.5rem;
    color: #6c757d;
    content: "/"; }

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline; }

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none; }

.breadcrumb-item.active {
  color: #6c757d; }

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem; }

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6; }
  .page-link:hover {
    z-index: 2;
    color: #0056b3;
    text-decoration: none;
    background-color: #e9ecef;
    border-color: #dee2e6; }
  .page-link:focus {
    z-index: 3;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem; }

.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem; }

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff; }

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6; }

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5; }

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem; }

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem; }

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5; }

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem; }

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem; }

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .badge {
      transition: none; } }
  a.badge:hover, a.badge:focus {
    text-decoration: none; }
  .badge:empty {
    display: none; }

.btn .badge {
  position: relative;
  top: -1px; }

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem; }

.badge-primary {
  color: #fff;
  background-color: #007bff; }
  a.badge-primary:hover, a.badge-primary:focus {
    color: #fff;
    background-color: #0062cc; }
  a.badge-primary:focus, a.badge-primary.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5); }

.badge-secondary {
  color: #fff;
  background-color: #6c757d; }
  a.badge-secondary:hover, a.badge-secondary:focus {
    color: #fff;
    background-color: #545b62; }
  a.badge-secondary:focus, a.badge-secondary.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }

.badge-success {
  color: #fff;
  background-color: #28a745; }
  a.badge-success:hover, a.badge-success:focus {
    color: #fff;
    background-color: #1e7e34; }
  a.badge-success:focus, a.badge-success.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5); }

.badge-info {
  color: #fff;
  background-color: #17a2b8; }
  a.badge-info:hover, a.badge-info:focus {
    color: #fff;
    background-color: #117a8b; }
  a.badge-info:focus, a.badge-info.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5); }

.badge-warning {
  color: #212529;
  background-color: #ffc107; }
  a.badge-warning:hover, a.badge-warning:focus {
    color: #212529;
    background-color: #d39e00; }
  a.badge-warning:focus, a.badge-warning.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5); }

.badge-danger {
  color: #fff;
  background-color: #dc3545; }
  a.badge-danger:hover, a.badge-danger:focus {
    color: #fff;
    background-color: #bd2130; }
  a.badge-danger:focus, a.badge-danger.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5); }

.badge-light {
  color: #212529;
  background-color: #f8f9fa; }
  a.badge-light:hover, a.badge-light:focus {
    color: #212529;
    background-color: #dae0e5; }
  a.badge-light:focus, a.badge-light.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }

.badge-dark {
  color: #fff;
  background-color: #343a40; }
  a.badge-dark:hover, a.badge-dark:focus {
    color: #fff;
    background-color: #1d2124; }
  a.badge-dark:focus, a.badge-dark.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem; }
  @media (min-width: 576px) {
    .jumbotron {
      padding: 4rem 2rem; } }

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0; }

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem; }

.alert-heading {
  color: inherit; }

.alert-link {
  font-weight: 700; }

.alert-dismissible {
  padding-right: 4rem; }
  .alert-dismissible .close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 0.75rem 1.25rem;
    color: inherit; }

.alert-primary {
  color: #004085;
  background-color: #cce5ff;
  border-color: #b8daff; }
  .alert-primary hr {
    border-top-color: #9fcdff; }
  .alert-primary .alert-link {
    color: #002752; }

.alert-secondary {
  color: #383d41;
  background-color: #e2e3e5;
  border-color: #d6d8db; }
  .alert-secondary hr {
    border-top-color: #c8cbcf; }
  .alert-secondary .alert-link {
    color: #202326; }

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb; }
  .alert-success hr {
    border-top-color: #b1dfbb; }
  .alert-success .alert-link {
    color: #0b2e13; }

.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb; }
  .alert-info hr {
    border-top-color: #abdde5; }
  .alert-info .alert-link {
    color: #062c33; }

.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba; }
  .alert-warning hr {
    border-top-color: #ffe8a1; }
  .alert-warning .alert-link {
    color: #533f03; }

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb; }
  .alert-danger hr {
    border-top-color: #f1b0b7; }
  .alert-danger .alert-link {
    color: #491217; }

.alert-light {
  color: #818182;
  background-color: #fefefe;
  border-color: #fdfdfe; }
  .alert-light hr {
    border-top-color: #ececf6; }
  .alert-light .alert-link {
    color: #686868; }

.alert-dark {
  color: #1b1e21;
  background-color: #d6d8d9;
  border-color: #c6c8ca; }
  .alert-dark hr {
    border-top-color: #b9bbbe; }
  .alert-dark .alert-link {
    color: #040505; }

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0; }
  to {
    background-position: 0 0; } }

.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem; }

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #007bff;
  transition: width 0.6s ease; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar {
      transition: none; } }

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem; }

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar-animated {
      animation: none; } }

.media {
  display: flex;
  align-items: flex-start; }

.media-body {
  flex: 1 1; }

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem; }

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit; }
  .list-group-item-action:hover, .list-group-item-action:focus {
    z-index: 1;
    color: #495057;
    text-decoration: none;
    background-color: #f8f9fa; }
  .list-group-item-action:active {
    color: #212529;
    background-color: #e9ecef; }

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125); }
  .list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit; }
  .list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit; }
  .list-group-item.disabled, .list-group-item:disabled {
    color: #6c757d;
    pointer-events: none;
    background-color: #fff; }
  .list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #007bff;
    border-color: #007bff; }
  .list-group-item + .list-group-item {
    border-top-width: 0; }
    .list-group-item + .list-group-item.active {
      margin-top: -1px;
      border-top-width: 1px; }

.list-group-horizontal {
  flex-direction: row; }
  .list-group-horizontal > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0; }
  .list-group-horizontal > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0; }
  .list-group-horizontal > .list-group-item.active {
    margin-top: 0; }
  .list-group-horizontal > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0; }
    .list-group-horizontal > .list-group-item + .list-group-item.active {
      margin-left: -1px;
      border-left-width: 1px; }

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row; }
    .list-group-horizontal-sm > .list-group-item:first-child {
      border-bottom-left-radius: 0.25rem;
      border-top-right-radius: 0; }
    .list-group-horizontal-sm > .list-group-item:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-sm > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-sm > .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row; }
    .list-group-horizontal-md > .list-group-item:first-child {
      border-bottom-left-radius: 0.25rem;
      border-top-right-radius: 0; }
    .list-group-horizontal-md > .list-group-item:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-md > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-md > .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row; }
    .list-group-horizontal-lg > .list-group-item:first-child {
      border-bottom-left-radius: 0.25rem;
      border-top-right-radius: 0; }
    .list-group-horizontal-lg > .list-group-item:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-lg > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-lg > .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row; }
    .list-group-horizontal-xl > .list-group-item:first-child {
      border-bottom-left-radius: 0.25rem;
      border-top-right-radius: 0; }
    .list-group-horizontal-xl > .list-group-item:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xl > .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

.list-group-flush {
  border-radius: 0; }
  .list-group-flush > .list-group-item {
    border-width: 0 0 1px; }
    .list-group-flush > .list-group-item:last-child {
      border-bottom-width: 0; }

.list-group-item-primary {
  color: #004085;
  background-color: #b8daff; }
  .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
    color: #004085;
    background-color: #9fcdff; }
  .list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: #004085;
    border-color: #004085; }

.list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db; }
  .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
    color: #383d41;
    background-color: #c8cbcf; }
  .list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: #383d41;
    border-color: #383d41; }

.list-group-item-success {
  color: #155724;
  background-color: #c3e6cb; }
  .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
    color: #155724;
    background-color: #b1dfbb; }
  .list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: #155724;
    border-color: #155724; }

.list-group-item-info {
  color: #0c5460;
  background-color: #bee5eb; }
  .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
    color: #0c5460;
    background-color: #abdde5; }
  .list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: #0c5460;
    border-color: #0c5460; }

.list-group-item-warning {
  color: #856404;
  background-color: #ffeeba; }
  .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
    color: #856404;
    background-color: #ffe8a1; }
  .list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: #856404;
    border-color: #856404; }

.list-group-item-danger {
  color: #721c24;
  background-color: #f5c6cb; }
  .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
    color: #721c24;
    background-color: #f1b0b7; }
  .list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: #721c24;
    border-color: #721c24; }

.list-group-item-light {
  color: #818182;
  background-color: #fdfdfe; }
  .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
    color: #818182;
    background-color: #ececf6; }
  .list-group-item-light.list-group-item-action.active {
    color: #fff;
    background-color: #818182;
    border-color: #818182; }

.list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca; }
  .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
    color: #1b1e21;
    background-color: #b9bbbe; }
  .list-group-item-dark.list-group-item-action.active {
    color: #fff;
    background-color: #1b1e21;
    border-color: #1b1e21; }

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: .5; }
  .close:hover {
    color: #000;
    text-decoration: none; }
  .close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
    opacity: .75; }

button.close {
  padding: 0;
  background-color: transparent;
  border: 0; }

a.close.disabled {
  pointer-events: none; }

.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem; }
  .toast:not(:last-child) {
    margin-bottom: 0.75rem; }
  .toast.showing {
    opacity: 1; }
  .toast.show {
    display: block;
    opacity: 1; }
  .toast.hide {
    display: none; }

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px); }

.toast-body {
  padding: 0.75rem; }

.modal-open {
  overflow: hidden; }
  .modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto; }

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none; }
  .modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, -50px); }
    @media (prefers-reduced-motion: reduce) {
      .modal.fade .modal-dialog {
        transition: none; } }
  .modal.show .modal-dialog {
    transform: none; }
  .modal.modal-static .modal-dialog {
    transform: scale(1.02); }

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem); }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 1rem);
    overflow: hidden; }
  .modal-dialog-scrollable .modal-header,
  .modal-dialog-scrollable .modal-footer {
    flex-shrink: 0; }
  .modal-dialog-scrollable .modal-body {
    overflow-y: auto; }

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem); }
  .modal-dialog-centered::before {
    display: block;
    height: calc(100vh - 1rem);
    height: -webkit-min-content;
    height: min-content;
    content: ""; }
  .modal-dialog-centered.modal-dialog-scrollable {
    flex-direction: column;
    justify-content: center;
    height: 100%; }
    .modal-dialog-centered.modal-dialog-scrollable .modal-content {
      max-height: none; }
    .modal-dialog-centered.modal-dialog-scrollable::before {
      content: none; }

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0; }

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000; }
  .modal-backdrop.fade {
    opacity: 0; }
  .modal-backdrop.show {
    opacity: 0.5; }

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px); }
  .modal-header .close {
    padding: 1rem 1rem;
    margin: -1rem -1rem -1rem auto; }

.modal-title {
  margin-bottom: 0;
  line-height: 1.5; }

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem; }

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px); }
  .modal-footer > * {
    margin: 0.25rem; }

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll; }

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto; }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem); }
    .modal-dialog-scrollable .modal-content {
      max-height: calc(100vh - 3.5rem); }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem); }
    .modal-dialog-centered::before {
      height: calc(100vh - 3.5rem);
      height: -webkit-min-content;
      height: min-content; }
  .modal-sm {
    max-width: 300px; } }

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px; } }

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px; } }

.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0; }
  .tooltip.show {
    opacity: 0.9; }
  .tooltip .arrow {
    position: absolute;
    display: block;
    width: 0.8rem;
    height: 0.4rem; }
    .tooltip .arrow::before {
      position: absolute;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-tooltip-top, .bs-tooltip-auto[x-placement^="top"] {
  padding: 0.4rem 0; }
  .bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^="top"] .arrow {
    bottom: 0; }
    .bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
      top: 0;
      border-width: 0.4rem 0.4rem 0;
      border-top-color: #000; }

.bs-tooltip-right, .bs-tooltip-auto[x-placement^="right"] {
  padding: 0 0.4rem; }
  .bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^="right"] .arrow {
    left: 0;
    width: 0.4rem;
    height: 0.8rem; }
    .bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^="right"] .arrow::before {
      right: 0;
      border-width: 0.4rem 0.4rem 0.4rem 0;
      border-right-color: #000; }

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^="bottom"] {
  padding: 0.4rem 0; }
  .bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^="bottom"] .arrow {
    top: 0; }
    .bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
      bottom: 0;
      border-width: 0 0.4rem 0.4rem;
      border-bottom-color: #000; }

.bs-tooltip-left, .bs-tooltip-auto[x-placement^="left"] {
  padding: 0 0.4rem; }
  .bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^="left"] .arrow {
    right: 0;
    width: 0.4rem;
    height: 0.8rem; }
    .bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^="left"] .arrow::before {
      left: 0;
      border-width: 0.4rem 0 0.4rem 0.4rem;
      border-left-color: #000; }

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem; }

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem; }
  .popover .arrow {
    position: absolute;
    display: block;
    width: 1rem;
    height: 0.5rem;
    margin: 0 0.3rem; }
    .popover .arrow::before, .popover .arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-popover-top, .bs-popover-auto[x-placement^="top"] {
  margin-bottom: 0.5rem; }
  .bs-popover-top > .arrow, .bs-popover-auto[x-placement^="top"] > .arrow {
    bottom: calc(-0.5rem - 1px); }
    .bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^="top"] > .arrow::before {
      bottom: 0;
      border-width: 0.5rem 0.5rem 0;
      border-top-color: rgba(0, 0, 0, 0.25); }
    .bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^="top"] > .arrow::after {
      bottom: 1px;
      border-width: 0.5rem 0.5rem 0;
      border-top-color: #fff; }

.bs-popover-right, .bs-popover-auto[x-placement^="right"] {
  margin-left: 0.5rem; }
  .bs-popover-right > .arrow, .bs-popover-auto[x-placement^="right"] > .arrow {
    left: calc(-0.5rem - 1px);
    width: 0.5rem;
    height: 1rem;
    margin: 0.3rem 0; }
    .bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^="right"] > .arrow::before {
      left: 0;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: rgba(0, 0, 0, 0.25); }
    .bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^="right"] > .arrow::after {
      left: 1px;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: #fff; }

.bs-popover-bottom, .bs-popover-auto[x-placement^="bottom"] {
  margin-top: 0.5rem; }
  .bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^="bottom"] > .arrow {
    top: calc(-0.5rem - 1px); }
    .bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^="bottom"] > .arrow::before {
      top: 0;
      border-width: 0 0.5rem 0.5rem 0.5rem;
      border-bottom-color: rgba(0, 0, 0, 0.25); }
    .bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^="bottom"] > .arrow::after {
      top: 1px;
      border-width: 0 0.5rem 0.5rem 0.5rem;
      border-bottom-color: #fff; }
  .bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^="bottom"] .popover-header::before {
    position: absolute;
    top: 0;
    left: 50%;
    display: block;
    width: 1rem;
    margin-left: -0.5rem;
    content: "";
    border-bottom: 1px solid #f7f7f7; }

.bs-popover-left, .bs-popover-auto[x-placement^="left"] {
  margin-right: 0.5rem; }
  .bs-popover-left > .arrow, .bs-popover-auto[x-placement^="left"] > .arrow {
    right: calc(-0.5rem - 1px);
    width: 0.5rem;
    height: 1rem;
    margin: 0.3rem 0; }
    .bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^="left"] > .arrow::before {
      right: 0;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: rgba(0, 0, 0, 0.25); }
    .bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^="left"] > .arrow::after {
      right: 1px;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: #fff; }

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px); }
  .popover-header:empty {
    display: none; }

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529; }

.carousel {
  position: relative; }

.carousel.pointer-event {
  touch-action: pan-y; }

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden; }
  .carousel-inner::after {
    display: block;
    clear: both;
    content: ""; }

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  transition: transform 0.6s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-item {
      transition: none; } }

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block; }

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%); }

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%); }

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none; }

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1; }

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-fade .active.carousel-item-left,
    .carousel-fade .active.carousel-item-right {
      transition: none; } }

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-control-prev,
    .carousel-control-next {
      transition: none; } }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: 0.9; }

.carousel-control-prev {
  left: 0; }

.carousel-control-next {
  right: 0; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50% / 100% 100% no-repeat; }

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}); }

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___}); }

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none; }
  .carousel-indicators li {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: .5;
    transition: opacity 0.6s ease; }
    @media (prefers-reduced-motion: reduce) {
      .carousel-indicators li {
        transition: none; } }
  .carousel-indicators .active {
    opacity: 1; }

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center; }

@keyframes spinner-border {
  to {
    transform: rotate(360deg); } }

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: .75s linear infinite spinner-border; }

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em; }

@keyframes spinner-grow {
  0% {
    transform: scale(0); }
  50% {
    opacity: 1;
    transform: none; } }

.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: .75s linear infinite spinner-grow; }

.spinner-grow-sm {
  width: 1rem;
  height: 1rem; }

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s; } }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

.bg-primary {
  background-color: #007bff !important; }

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #0062cc !important; }

.bg-secondary {
  background-color: #6c757d !important; }

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #545b62 !important; }

.bg-success {
  background-color: #28a745 !important; }

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #1e7e34 !important; }

.bg-info {
  background-color: #17a2b8 !important; }

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #117a8b !important; }

.bg-warning {
  background-color: #ffc107 !important; }

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #d39e00 !important; }

.bg-danger {
  background-color: #dc3545 !important; }

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #bd2130 !important; }

.bg-light {
  background-color: #f8f9fa !important; }

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #dae0e5 !important; }

.bg-dark {
  background-color: #343a40 !important; }

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #1d2124 !important; }

.bg-white {
  background-color: #fff !important; }

.bg-transparent {
  background-color: transparent !important; }

.border {
  border: 1px solid #dee2e6 !important; }

.border-top {
  border-top: 1px solid #dee2e6 !important; }

.border-right {
  border-right: 1px solid #dee2e6 !important; }

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important; }

.border-left {
  border-left: 1px solid #dee2e6 !important; }

.border-0 {
  border: 0 !important; }

.border-top-0 {
  border-top: 0 !important; }

.border-right-0 {
  border-right: 0 !important; }

.border-bottom-0 {
  border-bottom: 0 !important; }

.border-left-0 {
  border-left: 0 !important; }

.border-primary {
  border-color: #007bff !important; }

.border-secondary {
  border-color: #6c757d !important; }

.border-success {
  border-color: #28a745 !important; }

.border-info {
  border-color: #17a2b8 !important; }

.border-warning {
  border-color: #ffc107 !important; }

.border-danger {
  border-color: #dc3545 !important; }

.border-light {
  border-color: #f8f9fa !important; }

.border-dark {
  border-color: #343a40 !important; }

.border-white {
  border-color: #fff !important; }

.rounded-sm {
  border-radius: 0.2rem !important; }

.rounded {
  border-radius: 0.25rem !important; }

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important; }

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important; }

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important; }

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important; }

.rounded-lg {
  border-radius: 0.3rem !important; }

.rounded-circle {
  border-radius: 50% !important; }

.rounded-pill {
  border-radius: 50rem !important; }

.rounded-0 {
  border-radius: 0 !important; }

.clearfix::after {
  display: block;
  clear: both;
  content: ""; }

.d-none {
  display: none !important; }

.d-inline {
  display: inline !important; }

.d-inline-block {
  display: inline-block !important; }

.d-block {
  display: block !important; }

.d-table {
  display: table !important; }

.d-table-row {
  display: table-row !important; }

.d-table-cell {
  display: table-cell !important; }

.d-flex {
  display: flex !important; }

.d-inline-flex {
  display: inline-flex !important; }

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important; }
  .d-sm-inline {
    display: inline !important; }
  .d-sm-inline-block {
    display: inline-block !important; }
  .d-sm-block {
    display: block !important; }
  .d-sm-table {
    display: table !important; }
  .d-sm-table-row {
    display: table-row !important; }
  .d-sm-table-cell {
    display: table-cell !important; }
  .d-sm-flex {
    display: flex !important; }
  .d-sm-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 768px) {
  .d-md-none {
    display: none !important; }
  .d-md-inline {
    display: inline !important; }
  .d-md-inline-block {
    display: inline-block !important; }
  .d-md-block {
    display: block !important; }
  .d-md-table {
    display: table !important; }
  .d-md-table-row {
    display: table-row !important; }
  .d-md-table-cell {
    display: table-cell !important; }
  .d-md-flex {
    display: flex !important; }
  .d-md-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important; }
  .d-lg-inline {
    display: inline !important; }
  .d-lg-inline-block {
    display: inline-block !important; }
  .d-lg-block {
    display: block !important; }
  .d-lg-table {
    display: table !important; }
  .d-lg-table-row {
    display: table-row !important; }
  .d-lg-table-cell {
    display: table-cell !important; }
  .d-lg-flex {
    display: flex !important; }
  .d-lg-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important; }
  .d-xl-inline {
    display: inline !important; }
  .d-xl-inline-block {
    display: inline-block !important; }
  .d-xl-block {
    display: block !important; }
  .d-xl-table {
    display: table !important; }
  .d-xl-table-row {
    display: table-row !important; }
  .d-xl-table-cell {
    display: table-cell !important; }
  .d-xl-flex {
    display: flex !important; }
  .d-xl-inline-flex {
    display: inline-flex !important; } }

@media print {
  .d-print-none {
    display: none !important; }
  .d-print-inline {
    display: inline !important; }
  .d-print-inline-block {
    display: inline-block !important; }
  .d-print-block {
    display: block !important; }
  .d-print-table {
    display: table !important; }
  .d-print-table-row {
    display: table-row !important; }
  .d-print-table-cell {
    display: table-cell !important; }
  .d-print-flex {
    display: flex !important; }
  .d-print-inline-flex {
    display: inline-flex !important; } }

.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden; }
  .embed-responsive::before {
    display: block;
    content: ""; }
  .embed-responsive .embed-responsive-item,
  .embed-responsive iframe,
  .embed-responsive embed,
  .embed-responsive object,
  .embed-responsive video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0; }

.embed-responsive-21by9::before {
  padding-top: 42.85714%; }

.embed-responsive-16by9::before {
  padding-top: 56.25%; }

.embed-responsive-4by3::before {
  padding-top: 75%; }

.embed-responsive-1by1::before {
  padding-top: 100%; }

.flex-row {
  flex-direction: row !important; }

.flex-column {
  flex-direction: column !important; }

.flex-row-reverse {
  flex-direction: row-reverse !important; }

.flex-column-reverse {
  flex-direction: column-reverse !important; }

.flex-wrap {
  flex-wrap: wrap !important; }

.flex-nowrap {
  flex-wrap: nowrap !important; }

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.flex-fill {
  flex: 1 1 auto !important; }

.flex-grow-0 {
  flex-grow: 0 !important; }

.flex-grow-1 {
  flex-grow: 1 !important; }

.flex-shrink-0 {
  flex-shrink: 0 !important; }

.flex-shrink-1 {
  flex-shrink: 1 !important; }

.justify-content-start {
  justify-content: flex-start !important; }

.justify-content-end {
  justify-content: flex-end !important; }

.justify-content-center {
  justify-content: center !important; }

.justify-content-between {
  justify-content: space-between !important; }

.justify-content-around {
  justify-content: space-around !important; }

.align-items-start {
  align-items: flex-start !important; }

.align-items-end {
  align-items: flex-end !important; }

.align-items-center {
  align-items: center !important; }

.align-items-baseline {
  align-items: baseline !important; }

.align-items-stretch {
  align-items: stretch !important; }

.align-content-start {
  align-content: flex-start !important; }

.align-content-end {
  align-content: flex-end !important; }

.align-content-center {
  align-content: center !important; }

.align-content-between {
  align-content: space-between !important; }

.align-content-around {
  align-content: space-around !important; }

.align-content-stretch {
  align-content: stretch !important; }

.align-self-auto {
  align-self: auto !important; }

.align-self-start {
  align-self: flex-start !important; }

.align-self-end {
  align-self: flex-end !important; }

.align-self-center {
  align-self: center !important; }

.align-self-baseline {
  align-self: baseline !important; }

.align-self-stretch {
  align-self: stretch !important; }

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important; }
  .flex-sm-column {
    flex-direction: column !important; }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-sm-wrap {
    flex-wrap: wrap !important; }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important; }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-sm-fill {
    flex: 1 1 auto !important; }
  .flex-sm-grow-0 {
    flex-grow: 0 !important; }
  .flex-sm-grow-1 {
    flex-grow: 1 !important; }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-sm-start {
    justify-content: flex-start !important; }
  .justify-content-sm-end {
    justify-content: flex-end !important; }
  .justify-content-sm-center {
    justify-content: center !important; }
  .justify-content-sm-between {
    justify-content: space-between !important; }
  .justify-content-sm-around {
    justify-content: space-around !important; }
  .align-items-sm-start {
    align-items: flex-start !important; }
  .align-items-sm-end {
    align-items: flex-end !important; }
  .align-items-sm-center {
    align-items: center !important; }
  .align-items-sm-baseline {
    align-items: baseline !important; }
  .align-items-sm-stretch {
    align-items: stretch !important; }
  .align-content-sm-start {
    align-content: flex-start !important; }
  .align-content-sm-end {
    align-content: flex-end !important; }
  .align-content-sm-center {
    align-content: center !important; }
  .align-content-sm-between {
    align-content: space-between !important; }
  .align-content-sm-around {
    align-content: space-around !important; }
  .align-content-sm-stretch {
    align-content: stretch !important; }
  .align-self-sm-auto {
    align-self: auto !important; }
  .align-self-sm-start {
    align-self: flex-start !important; }
  .align-self-sm-end {
    align-self: flex-end !important; }
  .align-self-sm-center {
    align-self: center !important; }
  .align-self-sm-baseline {
    align-self: baseline !important; }
  .align-self-sm-stretch {
    align-self: stretch !important; } }

@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important; }
  .flex-md-column {
    flex-direction: column !important; }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-md-wrap {
    flex-wrap: wrap !important; }
  .flex-md-nowrap {
    flex-wrap: nowrap !important; }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-md-fill {
    flex: 1 1 auto !important; }
  .flex-md-grow-0 {
    flex-grow: 0 !important; }
  .flex-md-grow-1 {
    flex-grow: 1 !important; }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-md-start {
    justify-content: flex-start !important; }
  .justify-content-md-end {
    justify-content: flex-end !important; }
  .justify-content-md-center {
    justify-content: center !important; }
  .justify-content-md-between {
    justify-content: space-between !important; }
  .justify-content-md-around {
    justify-content: space-around !important; }
  .align-items-md-start {
    align-items: flex-start !important; }
  .align-items-md-end {
    align-items: flex-end !important; }
  .align-items-md-center {
    align-items: center !important; }
  .align-items-md-baseline {
    align-items: baseline !important; }
  .align-items-md-stretch {
    align-items: stretch !important; }
  .align-content-md-start {
    align-content: flex-start !important; }
  .align-content-md-end {
    align-content: flex-end !important; }
  .align-content-md-center {
    align-content: center !important; }
  .align-content-md-between {
    align-content: space-between !important; }
  .align-content-md-around {
    align-content: space-around !important; }
  .align-content-md-stretch {
    align-content: stretch !important; }
  .align-self-md-auto {
    align-self: auto !important; }
  .align-self-md-start {
    align-self: flex-start !important; }
  .align-self-md-end {
    align-self: flex-end !important; }
  .align-self-md-center {
    align-self: center !important; }
  .align-self-md-baseline {
    align-self: baseline !important; }
  .align-self-md-stretch {
    align-self: stretch !important; } }

@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important; }
  .flex-lg-column {
    flex-direction: column !important; }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-lg-wrap {
    flex-wrap: wrap !important; }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important; }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-lg-fill {
    flex: 1 1 auto !important; }
  .flex-lg-grow-0 {
    flex-grow: 0 !important; }
  .flex-lg-grow-1 {
    flex-grow: 1 !important; }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-lg-start {
    justify-content: flex-start !important; }
  .justify-content-lg-end {
    justify-content: flex-end !important; }
  .justify-content-lg-center {
    justify-content: center !important; }
  .justify-content-lg-between {
    justify-content: space-between !important; }
  .justify-content-lg-around {
    justify-content: space-around !important; }
  .align-items-lg-start {
    align-items: flex-start !important; }
  .align-items-lg-end {
    align-items: flex-end !important; }
  .align-items-lg-center {
    align-items: center !important; }
  .align-items-lg-baseline {
    align-items: baseline !important; }
  .align-items-lg-stretch {
    align-items: stretch !important; }
  .align-content-lg-start {
    align-content: flex-start !important; }
  .align-content-lg-end {
    align-content: flex-end !important; }
  .align-content-lg-center {
    align-content: center !important; }
  .align-content-lg-between {
    align-content: space-between !important; }
  .align-content-lg-around {
    align-content: space-around !important; }
  .align-content-lg-stretch {
    align-content: stretch !important; }
  .align-self-lg-auto {
    align-self: auto !important; }
  .align-self-lg-start {
    align-self: flex-start !important; }
  .align-self-lg-end {
    align-self: flex-end !important; }
  .align-self-lg-center {
    align-self: center !important; }
  .align-self-lg-baseline {
    align-self: baseline !important; }
  .align-self-lg-stretch {
    align-self: stretch !important; } }

@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important; }
  .flex-xl-column {
    flex-direction: column !important; }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xl-wrap {
    flex-wrap: wrap !important; }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-xl-fill {
    flex: 1 1 auto !important; }
  .flex-xl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-xl-start {
    justify-content: flex-start !important; }
  .justify-content-xl-end {
    justify-content: flex-end !important; }
  .justify-content-xl-center {
    justify-content: center !important; }
  .justify-content-xl-between {
    justify-content: space-between !important; }
  .justify-content-xl-around {
    justify-content: space-around !important; }
  .align-items-xl-start {
    align-items: flex-start !important; }
  .align-items-xl-end {
    align-items: flex-end !important; }
  .align-items-xl-center {
    align-items: center !important; }
  .align-items-xl-baseline {
    align-items: baseline !important; }
  .align-items-xl-stretch {
    align-items: stretch !important; }
  .align-content-xl-start {
    align-content: flex-start !important; }
  .align-content-xl-end {
    align-content: flex-end !important; }
  .align-content-xl-center {
    align-content: center !important; }
  .align-content-xl-between {
    align-content: space-between !important; }
  .align-content-xl-around {
    align-content: space-around !important; }
  .align-content-xl-stretch {
    align-content: stretch !important; }
  .align-self-xl-auto {
    align-self: auto !important; }
  .align-self-xl-start {
    align-self: flex-start !important; }
  .align-self-xl-end {
    align-self: flex-end !important; }
  .align-self-xl-center {
    align-self: center !important; }
  .align-self-xl-baseline {
    align-self: baseline !important; }
  .align-self-xl-stretch {
    align-self: stretch !important; } }

.float-left {
  float: left !important; }

.float-right {
  float: right !important; }

.float-none {
  float: none !important; }

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important; }
  .float-sm-right {
    float: right !important; }
  .float-sm-none {
    float: none !important; } }

@media (min-width: 768px) {
  .float-md-left {
    float: left !important; }
  .float-md-right {
    float: right !important; }
  .float-md-none {
    float: none !important; } }

@media (min-width: 992px) {
  .float-lg-left {
    float: left !important; }
  .float-lg-right {
    float: right !important; }
  .float-lg-none {
    float: none !important; } }

@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important; }
  .float-xl-right {
    float: right !important; }
  .float-xl-none {
    float: none !important; } }

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important; }

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important; }

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important; }

.overflow-auto {
  overflow: auto !important; }

.overflow-hidden {
  overflow: hidden !important; }

.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important; }

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030; }

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sticky-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020; } }

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0; }

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal; }

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important; }

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important; }

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important; }

.shadow-none {
  box-shadow: none !important; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.w-auto {
  width: auto !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.h-auto {
  height: auto !important; }

.mw-100 {
  max-width: 100% !important; }

.mh-100 {
  max-height: 100% !important; }

.min-vw-100 {
  min-width: 100vw !important; }

.min-vh-100 {
  min-height: 100vh !important; }

.vw-100 {
  width: 100vw !important; }

.vh-100 {
  height: 100vh !important; }

.m-0 {
  margin: 0 !important; }

.mt-0,
.my-0 {
  margin-top: 0 !important; }

.mr-0,
.mx-0 {
  margin-right: 0 !important; }

.mb-0,
.my-0 {
  margin-bottom: 0 !important; }

.ml-0,
.mx-0 {
  margin-left: 0 !important; }

.m-1 {
  margin: 0.25rem !important; }

.mt-1,
.my-1 {
  margin-top: 0.25rem !important; }

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important; }

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important; }

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important; }

.m-2 {
  margin: 0.5rem !important; }

.mt-2,
.my-2 {
  margin-top: 0.5rem !important; }

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important; }

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important; }

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important; }

.m-3 {
  margin: 1rem !important; }

.mt-3,
.my-3 {
  margin-top: 1rem !important; }

.mr-3,
.mx-3 {
  margin-right: 1rem !important; }

.mb-3,
.my-3 {
  margin-bottom: 1rem !important; }

.ml-3,
.mx-3 {
  margin-left: 1rem !important; }

.m-4 {
  margin: 1.5rem !important; }

.mt-4,
.my-4 {
  margin-top: 1.5rem !important; }

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important; }

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important; }

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important; }

.m-5 {
  margin: 3rem !important; }

.mt-5,
.my-5 {
  margin-top: 3rem !important; }

.mr-5,
.mx-5 {
  margin-right: 3rem !important; }

.mb-5,
.my-5 {
  margin-bottom: 3rem !important; }

.ml-5,
.mx-5 {
  margin-left: 3rem !important; }

.p-0 {
  padding: 0 !important; }

.pt-0,
.py-0 {
  padding-top: 0 !important; }

.pr-0,
.px-0 {
  padding-right: 0 !important; }

.pb-0,
.py-0 {
  padding-bottom: 0 !important; }

.pl-0,
.px-0 {
  padding-left: 0 !important; }

.p-1 {
  padding: 0.25rem !important; }

.pt-1,
.py-1 {
  padding-top: 0.25rem !important; }

.pr-1,
.px-1 {
  padding-right: 0.25rem !important; }

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important; }

.pl-1,
.px-1 {
  padding-left: 0.25rem !important; }

.p-2 {
  padding: 0.5rem !important; }

.pt-2,
.py-2 {
  padding-top: 0.5rem !important; }

.pr-2,
.px-2 {
  padding-right: 0.5rem !important; }

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important; }

.pl-2,
.px-2 {
  padding-left: 0.5rem !important; }

.p-3 {
  padding: 1rem !important; }

.pt-3,
.py-3 {
  padding-top: 1rem !important; }

.pr-3,
.px-3 {
  padding-right: 1rem !important; }

.pb-3,
.py-3 {
  padding-bottom: 1rem !important; }

.pl-3,
.px-3 {
  padding-left: 1rem !important; }

.p-4 {
  padding: 1.5rem !important; }

.pt-4,
.py-4 {
  padding-top: 1.5rem !important; }

.pr-4,
.px-4 {
  padding-right: 1.5rem !important; }

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important; }

.pl-4,
.px-4 {
  padding-left: 1.5rem !important; }

.p-5 {
  padding: 3rem !important; }

.pt-5,
.py-5 {
  padding-top: 3rem !important; }

.pr-5,
.px-5 {
  padding-right: 3rem !important; }

.pb-5,
.py-5 {
  padding-bottom: 3rem !important; }

.pl-5,
.px-5 {
  padding-left: 3rem !important; }

.m-n1 {
  margin: -0.25rem !important; }

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important; }

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important; }

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important; }

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important; }

.m-n2 {
  margin: -0.5rem !important; }

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important; }

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important; }

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important; }

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important; }

.m-n3 {
  margin: -1rem !important; }

.mt-n3,
.my-n3 {
  margin-top: -1rem !important; }

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important; }

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important; }

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important; }

.m-n4 {
  margin: -1.5rem !important; }

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important; }

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important; }

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important; }

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important; }

.m-n5 {
  margin: -3rem !important; }

.mt-n5,
.my-n5 {
  margin-top: -3rem !important; }

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important; }

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important; }

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important; }

.m-auto {
  margin: auto !important; }

.mt-auto,
.my-auto {
  margin-top: auto !important; }

.mr-auto,
.mx-auto {
  margin-right: auto !important; }

.mb-auto,
.my-auto {
  margin-bottom: auto !important; }

.ml-auto,
.mx-auto {
  margin-left: auto !important; }

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important; }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important; }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important; }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important; }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important; }
  .m-sm-1 {
    margin: 0.25rem !important; }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important; }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important; }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important; }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important; }
  .m-sm-2 {
    margin: 0.5rem !important; }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important; }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important; }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important; }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important; }
  .m-sm-3 {
    margin: 1rem !important; }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important; }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important; }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important; }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important; }
  .m-sm-4 {
    margin: 1.5rem !important; }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important; }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important; }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important; }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important; }
  .m-sm-5 {
    margin: 3rem !important; }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important; }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important; }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important; }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important; }
  .p-sm-0 {
    padding: 0 !important; }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important; }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important; }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important; }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important; }
  .p-sm-1 {
    padding: 0.25rem !important; }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important; }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important; }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important; }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important; }
  .p-sm-2 {
    padding: 0.5rem !important; }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important; }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important; }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important; }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important; }
  .p-sm-3 {
    padding: 1rem !important; }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important; }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important; }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important; }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important; }
  .p-sm-4 {
    padding: 1.5rem !important; }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important; }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important; }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important; }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important; }
  .p-sm-5 {
    padding: 3rem !important; }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important; }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important; }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important; }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important; }
  .m-sm-n1 {
    margin: -0.25rem !important; }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important; }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important; }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important; }
  .m-sm-n2 {
    margin: -0.5rem !important; }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important; }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important; }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important; }
  .m-sm-n3 {
    margin: -1rem !important; }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important; }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important; }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important; }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important; }
  .m-sm-n4 {
    margin: -1.5rem !important; }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important; }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important; }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important; }
  .m-sm-n5 {
    margin: -3rem !important; }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important; }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important; }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important; }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important; }
  .m-sm-auto {
    margin: auto !important; }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important; }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important; }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important; }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important; } }

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important; }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important; }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important; }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important; }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important; }
  .m-md-1 {
    margin: 0.25rem !important; }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important; }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important; }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important; }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important; }
  .m-md-2 {
    margin: 0.5rem !important; }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important; }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important; }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important; }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important; }
  .m-md-3 {
    margin: 1rem !important; }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important; }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important; }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important; }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important; }
  .m-md-4 {
    margin: 1.5rem !important; }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important; }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important; }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important; }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important; }
  .m-md-5 {
    margin: 3rem !important; }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important; }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important; }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important; }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important; }
  .p-md-0 {
    padding: 0 !important; }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important; }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important; }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important; }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important; }
  .p-md-1 {
    padding: 0.25rem !important; }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important; }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important; }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important; }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important; }
  .p-md-2 {
    padding: 0.5rem !important; }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important; }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important; }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important; }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important; }
  .p-md-3 {
    padding: 1rem !important; }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important; }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important; }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important; }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important; }
  .p-md-4 {
    padding: 1.5rem !important; }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important; }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important; }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important; }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important; }
  .p-md-5 {
    padding: 3rem !important; }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important; }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important; }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important; }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important; }
  .m-md-n1 {
    margin: -0.25rem !important; }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important; }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important; }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important; }
  .m-md-n2 {
    margin: -0.5rem !important; }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important; }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important; }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important; }
  .m-md-n3 {
    margin: -1rem !important; }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important; }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important; }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important; }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important; }
  .m-md-n4 {
    margin: -1.5rem !important; }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important; }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important; }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important; }
  .m-md-n5 {
    margin: -3rem !important; }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important; }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important; }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important; }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important; }
  .m-md-auto {
    margin: auto !important; }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important; }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important; }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important; }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important; } }

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important; }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important; }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important; }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important; }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important; }
  .m-lg-1 {
    margin: 0.25rem !important; }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important; }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important; }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important; }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important; }
  .m-lg-2 {
    margin: 0.5rem !important; }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important; }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important; }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important; }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important; }
  .m-lg-3 {
    margin: 1rem !important; }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important; }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important; }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important; }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important; }
  .m-lg-4 {
    margin: 1.5rem !important; }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important; }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important; }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important; }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important; }
  .m-lg-5 {
    margin: 3rem !important; }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important; }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important; }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important; }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important; }
  .p-lg-0 {
    padding: 0 !important; }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important; }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important; }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important; }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important; }
  .p-lg-1 {
    padding: 0.25rem !important; }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important; }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important; }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important; }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important; }
  .p-lg-2 {
    padding: 0.5rem !important; }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important; }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important; }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important; }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important; }
  .p-lg-3 {
    padding: 1rem !important; }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important; }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important; }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important; }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important; }
  .p-lg-4 {
    padding: 1.5rem !important; }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important; }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important; }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important; }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important; }
  .p-lg-5 {
    padding: 3rem !important; }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important; }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important; }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important; }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important; }
  .m-lg-n1 {
    margin: -0.25rem !important; }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important; }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important; }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important; }
  .m-lg-n2 {
    margin: -0.5rem !important; }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important; }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important; }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important; }
  .m-lg-n3 {
    margin: -1rem !important; }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important; }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important; }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important; }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important; }
  .m-lg-n4 {
    margin: -1.5rem !important; }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important; }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important; }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important; }
  .m-lg-n5 {
    margin: -3rem !important; }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important; }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important; }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important; }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important; }
  .m-lg-auto {
    margin: auto !important; }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important; }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important; }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important; }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important; } }

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important; }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important; }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important; }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important; }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important; }
  .m-xl-1 {
    margin: 0.25rem !important; }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important; }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important; }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important; }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important; }
  .m-xl-2 {
    margin: 0.5rem !important; }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important; }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important; }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important; }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important; }
  .m-xl-3 {
    margin: 1rem !important; }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important; }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important; }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important; }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important; }
  .m-xl-4 {
    margin: 1.5rem !important; }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important; }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important; }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important; }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important; }
  .m-xl-5 {
    margin: 3rem !important; }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important; }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important; }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important; }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important; }
  .p-xl-0 {
    padding: 0 !important; }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important; }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important; }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important; }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important; }
  .p-xl-1 {
    padding: 0.25rem !important; }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important; }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important; }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important; }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important; }
  .p-xl-2 {
    padding: 0.5rem !important; }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important; }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important; }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important; }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important; }
  .p-xl-3 {
    padding: 1rem !important; }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important; }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important; }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important; }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important; }
  .p-xl-4 {
    padding: 1.5rem !important; }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important; }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important; }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important; }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important; }
  .p-xl-5 {
    padding: 3rem !important; }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important; }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important; }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important; }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important; }
  .m-xl-n1 {
    margin: -0.25rem !important; }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important; }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important; }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important; }
  .m-xl-n2 {
    margin: -0.5rem !important; }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important; }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important; }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important; }
  .m-xl-n3 {
    margin: -1rem !important; }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important; }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important; }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important; }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important; }
  .m-xl-n4 {
    margin: -1.5rem !important; }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important; }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important; }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important; }
  .m-xl-n5 {
    margin: -3rem !important; }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important; }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important; }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important; }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important; }
  .m-xl-auto {
    margin: auto !important; }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important; }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important; }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important; }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important; } }

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0); }

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important; }

.text-justify {
  text-align: justify !important; }

.text-wrap {
  white-space: normal !important; }

.text-nowrap {
  white-space: nowrap !important; }

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.text-left {
  text-align: left !important; }

.text-right {
  text-align: right !important; }

.text-center {
  text-align: center !important; }

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important; }
  .text-sm-right {
    text-align: right !important; }
  .text-sm-center {
    text-align: center !important; } }

@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important; }
  .text-md-right {
    text-align: right !important; }
  .text-md-center {
    text-align: center !important; } }

@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important; }
  .text-lg-right {
    text-align: right !important; }
  .text-lg-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important; }
  .text-xl-right {
    text-align: right !important; }
  .text-xl-center {
    text-align: center !important; } }

.text-lowercase {
  text-transform: lowercase !important; }

.text-uppercase {
  text-transform: uppercase !important; }

.text-capitalize {
  text-transform: capitalize !important; }

.font-weight-light {
  font-weight: 300 !important; }

.font-weight-lighter {
  font-weight: lighter !important; }

.font-weight-normal {
  font-weight: 400 !important; }

.font-weight-bold {
  font-weight: 700 !important; }

.font-weight-bolder {
  font-weight: bolder !important; }

.font-italic {
  font-style: italic !important; }

.text-white {
  color: #fff !important; }

.text-primary {
  color: #007bff !important; }

a.text-primary:hover, a.text-primary:focus {
  color: #0056b3 !important; }

.text-secondary {
  color: #6c757d !important; }

a.text-secondary:hover, a.text-secondary:focus {
  color: #494f54 !important; }

.text-success {
  color: #28a745 !important; }

a.text-success:hover, a.text-success:focus {
  color: #19692c !important; }

.text-info {
  color: #17a2b8 !important; }

a.text-info:hover, a.text-info:focus {
  color: #0f6674 !important; }

.text-warning {
  color: #ffc107 !important; }

a.text-warning:hover, a.text-warning:focus {
  color: #ba8b00 !important; }

.text-danger {
  color: #dc3545 !important; }

a.text-danger:hover, a.text-danger:focus {
  color: #a71d2a !important; }

.text-light {
  color: #f8f9fa !important; }

a.text-light:hover, a.text-light:focus {
  color: #cbd3da !important; }

.text-dark {
  color: #343a40 !important; }

a.text-dark:hover, a.text-dark:focus {
  color: #121416 !important; }

.text-body {
  color: #212529 !important; }

.text-muted {
  color: #6c757d !important; }

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important; }

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important; }

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0; }

.text-decoration-none {
  text-decoration: none !important; }

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important; }

.text-reset {
  color: inherit !important; }

.visible {
  visibility: visible !important; }

.invisible {
  visibility: hidden !important; }

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important; }
  a:not(.btn) {
    text-decoration: underline; }
  abbr[title]::after {
    content: " (" attr(title) ")"; }
  pre {
    white-space: pre-wrap !important; }
  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid; }
  tr,
  img {
    page-break-inside: avoid; }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3; }
  h2,
  h3 {
    page-break-after: avoid; }
  @page {
    size: a3; }
  body {
    min-width: 992px !important; }
  .container {
    min-width: 992px !important; }
  .navbar {
    display: none; }
  .badge {
    border: 1px solid #000; }
  .table {
    border-collapse: collapse !important; }
    .table td,
    .table th {
      background-color: #fff !important; }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important; }
  .table-dark {
    color: inherit; }
    .table-dark th,
    .table-dark td,
    .table-dark thead th,
    .table-dark tbody + tbody {
      border-color: #dee2e6; }
  .table .thead-dark th {
    color: inherit;
    border-color: #dee2e6; } }

*,
html,
body {
  margin: 0;
  padding: 0;
  font-family: "Avenir LT Std", sans-serif !important;
  -webkit-font-smoothing: antialiased; }

*,
body {
  outline: none; }

a {
  text-decoration: none; }
  a:hover, a:focus {
    text-decoration: none; }

body {
  overflow: hidden; }

header {
  background-color: #364152;
  position: fixed;
  width: 100%;
  z-index: 1030; }
  header .logo {
    width: 129px;
    height: 41px; }
  header .menu-List {
    position: relative;
    height: 100%; }
    header .menu-List ul {
      width: 100%;
      height: 100%; }
      header .menu-List ul li {
        position: relative;
        margin-right: 0rem !important; }
        header .menu-List ul li .menuIcon {
          background-color: white;
          margin: 2px 6px 2px 0; }
        header .menu-List ul li a {
          font-size: 14px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: normal;
          text-align: right;
          text-decoration: none;
          color: #6c3964;
          padding: 18px 15px;
          top: calc(100% - 40px);
          display: block;
          position: relative; }
          header .menu-List ul li a:hover {
            background-color: #6c3964;
            color: #fff !important; }
          header .menu-List ul li a.active {
            background-color: #0075ad;
            color: #fff !important; }
          header .menu-List ul li a img {
            width: 30px;
            height: 30px;
            object-fit: contain;
            margin-right: 8px;
            margin-top: -2px; }
        header .menu-List ul li.list-inline-item.dropdown.show i {
          transform: rotateX(160deg);
          transition: 0.3s ease-in-out; }
        header .menu-List ul li .dropdown-menu {
          position: relative; }
          header .menu-List ul li .dropdown-menu a {
            color: #212529;
            text-align: left;
            padding-bottom: 10px;
            padding-top: 10px;
            top: 0px; }
    header .menu-List .nav-info {
      position: absolute;
      margin: 1px auto;
      top: 40px;
      left: 39px;
      font-size: 10px; }
  header .profile-menu-List {
    position: relative;
    height: 100%; }
    header .profile-menu-List ul {
      width: 100%;
      height: 100%; }
      header .profile-menu-List ul li {
        position: relative; }
        header .profile-menu-List ul li .menuIcon {
          background-color: white; }
        header .profile-menu-List ul li a {
          font-size: 14px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: normal;
          text-align: right;
          text-decoration: none;
          color: #6c3964;
          padding: 18px 0;
          top: calc(100% - 40px);
          display: block;
          position: relative; }
          header .profile-menu-List ul li a:hover {
            background-color: #6c3964;
            color: #fff !important; }
          header .profile-menu-List ul li a.active {
            background-color: #0075ad;
            color: #fff !important; }
          header .profile-menu-List ul li a img {
            width: 30px;
            height: 30px;
            object-fit: contain;
            margin-right: 8px;
            margin-top: -2px; }
        header .profile-menu-List ul li.list-inline-item.dropdown.show i {
          transform: rotateX(160deg);
          transition: 0.3s ease-in-out; }
        header .profile-menu-List ul li .dropdown-menu {
          position: relative; }
          header .profile-menu-List ul li .dropdown-menu a {
            color: #212529;
            text-align: left;
            padding-bottom: 10px;
            padding-top: 10px;
            top: 0px; }
    header .profile-menu-List .nav-info {
      position: absolute;
      margin: 0px auto;
      top: 40px;
      left: 39px;
      font-size: 10px; }

.dropdown-toggle::after {
  display: none !important; }

@media (min-width: 992px) {
  .animate {
    animation-duration: 0.3s;
    -webkit-animation-duration: 0.3s;
    animation-fill-mode: both;
    -webkit-animation-fill-mode: both; } }

@keyframes slideIn {
  0% {
    transform: translateY(1rem);
    opacity: 0; }
  100% {
    transform: translateY(0rem);
    opacity: 1; }
  0% {
    transform: translateY(1rem);
    opacity: 0; } }

.slideIn {
  animation-name: slideIn;
  top: 50px !important; }

footer {
  position: fixed;
  bottom: 2%;
  left: 0;
  right: 0; }
  footer p {
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.73;
    letter-spacing: normal;
    text-align: left; }
    footer p a {
      color: #fff; }

.breadCrums {
  border: solid 1px #d4dade;
  background-color: #fff;
  padding: 7px 0px; }
  .breadCrums p {
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.4;
    margin-bottom: 0px;
    letter-spacing: normal;
    text-align: left;
    color: #364152; }
  .breadCrums ol {
    margin-bottom: 0px; }
    .breadCrums ol.list-inline {
      display: inline; }
      .breadCrums ol.list-inline:hover a::after {
        animation: 1s fadeInLeft infinite; }
    .breadCrums ol li a {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #455a64;
      padding: 0px 15px 0px 0px;
      position: relative;
      text-transform: capitalize; }
      .breadCrums ol li a::after {
        content: ">";
        font-size: 18px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #54667a;
        padding: 0px 0px 0px 5px;
        position: absolute; }
    .breadCrums ol li:last-child a {
      color: #a6afbb; }
      .breadCrums ol li:last-child a::after {
        content: ""; }

.body-container {
  position: relative;
  top: 70px;
  min-height: 80vh;
  background-color: #f9f9f9; }

.custom-container {
  padding: 10px 0px 20px 0px;
  height: auto; }
  .custom-container h6 {
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.67;
    letter-spacing: normal;
    text-align: left;
    color: #364152; }
  .custom-container .table-container {
    border: solid 1px #d4dade;
    background-color: #fff;
    padding: 40px 0 0;
    overflow-x: hidden;
    overflow-y: auto;
    height: 75vh;
    margin-top: 10px; }
    .custom-container .table-container input {
      border: solid 1px #b2b9c4;
      background-color: #fff;
      padding: 15px 10px;
      font-size: 14px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 3.43;
      letter-spacing: normal;
      text-align: left;
      color: black; }
      .custom-container .table-container input::-moz-placeholder {
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.43;
        letter-spacing: normal;
        text-align: left;
        color: #b2b9c4; }
      .custom-container .table-container input:focus {
        box-shadow: none;
        box-shadow: initial; }
    .custom-container .table-container button {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: center;
      color: #fff; }
      .custom-container .table-container button:focus {
        box-shadow: none;
        box-shadow: initial; }
    .custom-container .table-container thead tr th {
      font-size: 14px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 3.43;
      letter-spacing: normal;
      text-align: left;
      color: #b2b9c4; }
    .custom-container .table-container tbody tr {
      border: solid 1px #d4dbdb;
      background-color: #fff;
      padding: 15px 15px;
      vertical-align: sub; }
      .custom-container .table-container tbody tr img {
        width: 22px;
        height: 21px;
        object-fit: contain; }
      .custom-container .table-container tbody tr td {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.29;
        letter-spacing: normal;
        text-align: left;
        color: #455a64;
        margin-bottom: 0px; }
        .custom-container .table-container tbody tr td.light {
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: left;
          color: #647485; }

tbody tr th {
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #455a64; }

tbody tr td label {
  width: 25px;
  margin: 5px 0px;
  position: relative;
  float: left;
  margin-bottom: 0px; }

tbody tr td label span {
  cursor: pointer;
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  background: #ffffff;
  border: 2px solid #6c3964; }

tbody tr td label input[type="checkbox"]:checked + span {
  cursor: pointer;
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  background: #ffffff;
  border: 2px solid #04c82d; }

tbody tr td label input[type="checkbox"]:disabled + span {
  cursor: pointer;
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  background: #f4f4f4;
  border: 2px solid #f4f4f4; }

tbody tr td label input[type="checkbox"]:checked + span:after {
  opacity: 1;
  content: "";
  position: absolute;
  width: 18px;
  height: 9px;
  background: #fff;
  top: -1px;
  left: 4px;
  border: 3px solid #04c82d;
  border-top: none;
  border-right: none;
  transition: all 0.5s ease-in-out;
  transform: rotate(-45deg); }

.work-flow-stages h2 {
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.4;
  letter-spacing: normal;
  text-align: center;
  color: #607d8b; }

.work-flow-stages p {
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.2;
  letter-spacing: normal;
  text-align: center;
  color: #607d8b;
  margin-bottom: 0px; }

.work-flow-stages .icon {
  width: 34px;
  height: 34px;
  object-fit: contain;
  margin: 0px auto; }
  .work-flow-stages .icon img {
    width: 100%;
    height: 100%; }

.queue-imahe {
  height: 458px;
  object-fit: contain; }

.q-check {
  overflow: auto;
  float: left;
  padding: 0px; }
  .q-check label {
    float: left;
    width: 100%;
    margin-bottom: 0px; }
    .q-check label input {
      position: absolute;
      top: -20px; }
    .q-check label span {
      border: solid 1px #b2b9c4;
      background-color: #fff;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: center;
      color: #b2b9c4;
      line-height: 2;
      cursor: pointer;
      display: block; }
    .q-check label input:checked + span {
      border: solid 1px #b2b9c4;
      background-color: #d4dce0;
      font-size: 14px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: center;
      color: #364152; }

.b-card-footerColor {
  background-color: #d4dce0;
  border-radius: 10px;
  margin-top: 10px; }

.q-p-details .h-card {
  height: 90px;
  border: solid 1px #d4dade;
  background-color: #6c3964;
  border-radius: 8px; }
  .q-p-details .h-card p {
    font-family: Avenir;
    font-size: 25px;
    font-weight: 900;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.3;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
    margin-bottom: 0px; }
  .q-p-details .h-card .q-p-add {
    width: 22px;
    height: 22px;
    position: relative;
    font-size: 20px;
    color: #6c3964;
    background-color: #fff;
    border: 0px solid #fff;
    border-radius: 50%;
    outline: transparent; }
    .q-p-details .h-card .q-p-add::before {
      content: "+";
      position: absolute;
      color: #6c3964;
      top: -3px;
      left: 0;
      right: 0;
      bottom: 0; }

.q-p-details .b-card {
  border-radius: 8px;
  border: solid 1px #d4dade;
  height: 420px;
  padding: 10px;
  position: relative; }
  .q-p-details .b-card .b-card-scroll {
    height: 350px;
    overflow-y: auto;
    overflow-x: hidden; }
    .q-p-details .b-card .b-card-scroll::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #f5f5f5; }
    .q-p-details .b-card .b-card-scroll::-webkit-scrollbar {
      width: 5px;
      background-color: #f5f5f5; }
    .q-p-details .b-card .b-card-scroll::-webkit-scrollbar-thumb {
      background-color: #000000;
      border: 2px solid #555555; }
  .q-p-details .b-card .b-card-body {
    border: solid 1px #d4dade;
    border-radius: 10px;
    margin-bottom: 2px;
    background-color: #f5fafe; }
    .q-p-details .b-card .b-card-body .ant-select {
      font-size: 12px;
      line-height: 1;
      height: 25px; }
      .q-p-details .b-card .b-card-body .ant-select .ant-select-selection--single {
        height: 25px; }
      .q-p-details .b-card .b-card-body .ant-select .ant-select-selection {
        height: 32px; }
      .q-p-details .b-card .b-card-body .ant-select .ant-select-selection__rendered {
        line-height: 25px; }
    .q-p-details .b-card .b-card-body p {
      margin-bottom: 0px;
      position: relative; }
      .q-p-details .b-card .b-card-body p.text-p-light {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #455a64;
        word-break: break-all;
        height: 20px;
        overflow: hidden; }
      .q-p-details .b-card .b-card-body p.text-p-bold {
        font-size: 14px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.7;
        letter-spacing: normal;
        text-align: left;
        color: #455a64; }
      .q-p-details .b-card .b-card-body p img {
        width: 13px;
        height: 14px;
        object-fit: contain;
        position: relative;
        margin-right: 7px;
        top: -2px; }
      .q-p-details .b-card .b-card-body p i {
        font-size: 30px;
        transform: rotate(90deg); }
  .q-p-details .b-card .b-card-footer {
    border-radius: 10px;
    background-color: #dee9ef;
    width: 80%;
    bottom: 0px; }
    .q-p-details .b-card .b-card-footer figure {
      border-right: 1px solid #ffffff;
      cursor: pointer; }
      .q-p-details .b-card .b-card-footer figure:last-child {
        border-right: 0px solid #ffffff; }
      .q-p-details .b-card .b-card-footer figure.active {
        background-color: #7593a4;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px; }
        .q-p-details .b-card .b-card-footer figure.active:last-child {
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px; }

.q-p-d-list .h-card {
  border: solid 1px #d4dade;
  background-color: #26c7db; }
  .q-p-d-list .h-card .ant-select {
    font-size: 12px;
    line-height: 1;
    height: 25px; }
    .q-p-d-list .h-card .ant-select .ant-select-selection--single {
      height: 25px; }
    .q-p-d-list .h-card .ant-select .ant-select-selection {
      border: 0px solid transparent; }
    .q-p-d-list .h-card .ant-select .ant-select-selection__rendered {
      line-height: 25px; }
  .q-p-d-list .h-card p {
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
    word-break: break-all;
    height: 20px;
    overflow: hidden;
    text-transform: capitalize; }
    .q-p-d-list .h-card p.text-light-d {
      font-size: 13px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.13;
      letter-spacing: normal;
      text-align: left;
      color: #fff; }
    .q-p-d-list .h-card p.line-height-0 {
      line-height: inherit; }

.q-p-d-list button {
  border-radius: 3.6px;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.7;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
  border: 0px;
  width: 100%;
  text-align: center; }
  .q-p-d-list button.text-checkin {
    background-color: #6c3964; }
  .q-p-d-list button.text-vitals {
    background-color: #522bb6; }
  .q-p-d-list button.text-reports {
    background-color: #6c3964; }
  .q-p-d-list button.text-checkout {
    background-color: #fc4b6c; }
  .q-p-d-list button.text-hold {
    background-color: #d0ac02; }
  .q-p-d-list button.text-cancel {
    background-color: #df0136; }

.popup img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  position: absolute;
  right: -25px;
  top: -22px;
  cursor: pointer; }

.popup h4 {
  position: relative;
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.7;
  letter-spacing: normal;
  text-align: left;
  color: #607d8b;
  margin-bottom: 4px; }

.popup Button {
  margin: 5px 7px;
  width: 110px;
  height: 34px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  border-radius: 0px;
  outline: transparent;
  outline: none;
  border: 0px solid transparent; }
  .popup Button.btn-gray {
    background-color: #d7d9dd;
    color: #364152; }
  .popup Button.btn-red {
    background-color: #fc4b6c !important;
    color: #fff; }

.k-modal h2 {
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.4;
  letter-spacing: normal;
  text-align: center;
  color: #607d8b; }

.k-modal button {
  margin: 5px 7px;
  width: 125px;
  border: 0px solid transparent;
  border-radius: 0px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center; }
  .k-modal button.btn-dark-gray {
    color: #fff;
    background-color: #364152; }
  .k-modal button.btn-dark-red {
    background-color: #df0136;
    color: #fff; }

.ant-select-selection {
  display: block;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-top-width: 1.02px;
  border-radius: 0px;
  outline: none;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  user-select: none; }

.ant-select-disabled .ant-select-selection {
  background: #f5f5f5 !important;
  cursor: not-allowed; }

.checkboxFive {
  width: 25px;
  margin: 5px 0px;
  position: relative;
  float: right; }

.checkboxFive label {
  cursor: pointer;
  position: absolute;
  width: 25px;
  height: 25px;
  top: 0;
  left: 0;
  background: #ffffff;
  border: 2px solid #2196f3; }

.checkboxFive input[type="checkbox"]:checked + label {
  cursor: pointer;
  position: absolute;
  width: 25px;
  height: 25px;
  top: 0;
  left: 0;
  background: #ffffff;
  border: 2px solid #04c82d; }

.checkboxFive input[type="checkbox"]:checked + label:after {
  opacity: 1;
  content: "";
  position: absolute;
  width: 22px;
  height: 12px;
  background: #fff;
  top: 0px;
  left: 5px;
  border: 3px solid #04c82d;
  border-top: none;
  border-right: none;
  transition: all 0.5s ease-in-out;
  transform: rotate(-45deg); }

.checkboxFive .checked + label {
  cursor: not-allowed;
  position: absolute;
  width: 25px;
  height: 25px;
  top: 0;
  left: 0;
  background: #ffffff;
  border: 2px solid #04c82d; }

.checkboxFive .checked + label:after {
  opacity: 1;
  content: "";
  position: absolute;
  width: 22px;
  height: 12px;
  background: #fff;
  top: 0px;
  left: 5px;
  border: 3px solid #04c82d;
  border-top: none;
  border-right: none;
  transition: all 0.5s ease-in-out;
  transform: rotate(-45deg); }

.q-table thead th {
  border-top: solid 1px #d4dade;
  border-bottom: solid 1px #d4dade;
  background-color: #fff;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #b2b9c4; }

.q-table tbody td {
  border-top: solid 0px transparent;
  border-bottom: solid 1px #d4dade;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #364152; }

.ant-input-number {
  width: 100% !important; }

.generate-button {
  background-color: #364152;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 3;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
  border: 0px;
  padding: 0px 60px; }

.queeadd button {
  padding: 0px 50px !important; }

.addButton {
  background-color: #364152;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
  border: 0px solid transparent;
  padding: 3px 40px; }

.f-12 {
  font-size: 12px !important; }

.appt {
  width: 100px;
  height: 19px;
  margin: 0 0 0 5.1px;
  font-family: Avenir-Roman;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1f1f39; }

.appointement-screen button {
  font-size: 14px;
  border: 0px solid transparent;
  margin: auto 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 3;
  padding: 0px 20px;
  letter-spacing: normal;
  text-align: left;
  color: #fff; }
  .appointement-screen button img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    margin-right: 10px; }

.appointement-screen .card {
  border: solid 1px #d4dade;
  background-color: #fff;
  border-radius: 0px; }

.appointement-screen .ant-calendar-picker .ant-input {
  border: solid 1px #b2b9c4;
  border-radius: 0px; }

.appointement-screen .gobutton {
  background-color: #0075ad;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  width: 100%;
  height: 100%;
  margin: 0px; }

.appointement-screen .btn {
  line-height: 2.4;
  border-radius: 0px;
  outline: none; }

.timecard {
  padding-left: 15px;
  padding-right: 15px; }
  .timecard .time-block {
    border-bottom: solid 0.5px #d4dade;
    border-right: solid 0.5px #d4dade;
    background-color: #fff;
    min-height: 141px;
    cursor: pointer; }
    .timecard .time-block.disable {
      background-color: #f5f4f4;
      cursor: not-allowed; }
    .timecard .time-block p {
      font-size: 15px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 2;
      letter-spacing: normal;
      text-align: center;
      margin-bottom: 0px;
      color: #455a64; }
      .timecard .time-block p .assigned {
        background-color: #26c6da;
        color: #fff; }

.appointment-modal .ant-modal-header,
.dissable-modal .ant-modal-header,
.appointment-view-modal .ant-modal-header {
  border-bottom: 0px solid transparent; }
  .appointment-modal .ant-modal-header .ant-modal-title,
  .dissable-modal .ant-modal-header .ant-modal-title,
  .appointment-view-modal .ant-modal-header .ant-modal-title {
    font-size: 20px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.4;
    letter-spacing: normal;
    text-align: center;
    color: #607d8b; }

.appointment-modal .ant-modal-body p,
.dissable-modal .ant-modal-body p,
.appointment-view-modal .ant-modal-body p {
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.43;
  letter-spacing: normal;
  text-align: left;
  padding: 0px 20px;
  color: #6f848e;
  background-color: #e7f0f4; }
  .appointment-modal .ant-modal-body p img,
  .dissable-modal .ant-modal-body p img,
  .appointment-view-modal .ant-modal-body p img {
    width: 20px;
    height: 20px;
    object-fit: contain;
    margin-right: 7px;
    position: relative;
    top: -1px; }

.appointment-modal .ant-modal-footer,
.dissable-modal .ant-modal-footer,
.appointment-view-modal .ant-modal-footer {
  border-top: 0px solid transparent;
  text-align: center; }
  .appointment-modal .ant-modal-footer button,
  .dissable-modal .ant-modal-footer button,
  .appointment-view-modal .ant-modal-footer button {
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: left;
    border-radius: 0px; }
    .appointment-modal .ant-modal-footer button.add,
    .dissable-modal .ant-modal-footer button.add,
    .appointment-view-modal .ant-modal-footer button.add {
      color: #fff;
      border: 0px solid transparent;
      background-color: #df0136;
      padding: 0px 30px; }

.reports-details .card {
  padding-left: 15px;
  padding-right: 15px; }

.reports-details th {
  border: 0px solid transparent;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: #b2b9c4; }

.reports-details td {
  border-bottom: solid 1px #d4dade;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: #455a64;
  padding: 30px 15px; }
  .reports-details td:first-child {
    border-right: solid 2px #d4dade; }
  .reports-details td.text-primary {
    font-weight: 600;
    color: #1d84b6; }
  .reports-details td.text-success {
    font-weight: 600;
    color: #0ec200; }
  .reports-details td.text-error {
    font-weight: 600;
    color: #df0136; }

.timecard .new_name_data {
  min-height: 60px;
  border-bottom: solid 1px #d4dade; }

.new-details-table th {
  border: 0px solid transparent;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: #b2b9c4;
  padding: 15px;
  border-bottom: solid 1px #d4dade;
  vertical-align: middle !important;
  min-width: 170px !important; }
  .new-details-table th tr th {
    vertical-align: middle;
    border-bottom: solid 0px #d4dade;
    min-width: 170px !important; }
    .new-details-table th tr th.name {
      min-width: 100px !important; }

.new-details-table tr:last-child {
  border-bottom: solid 0px transparent; }

.new-details-table td {
  border-bottom: solid 1px transparent;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: #455a64;
  padding: 15px;
  min-width: 170px !important;
  vertical-align: middle; }
  .new-details-table td tr td {
    padding: 15px !important;
    min-width: 170px !important; }
    .new-details-table td tr td.name {
      min-width: 100px !important; }
  .new-details-table td tr.ip {
    background-color: #df0136; }
    .new-details-table td tr.ip td {
      color: #ffffff; }
  .new-details-table td tr.IP {
    background-color: #df0136; }
    .new-details-table td tr.IP td {
      color: #ffffff; }
  .new-details-table td tr.notLinked {
    background-color: #ff003dde; }
    .new-details-table td tr.notLinked td {
      color: #ffffff; }
  .new-details-table td tr.cancelled {
    background-color: gray; }
    .new-details-table td tr.cancelled td {
      color: #ffffff; }
  .new-details-table td tr.linked {
    background-color: chartreuse; }
    .new-details-table td tr.linked td {
      color: #ffffff; }
  .new-details-table td tr.op {
    background-color: #26c6da; }
    .new-details-table td tr.op td {
      color: #ffffff; }
  .new-details-table td tr.OP {
    background-color: #26c6da; }
    .new-details-table td tr.OP td {
      color: #ffffff; }
  .new-details-table td tr.Bedside {
    background-color: #6f848e; }
    .new-details-table td tr.Bedside td {
      color: #ffffff; }
  .new-details-table td tr.Buffer {
    background-color: green; }
    .new-details-table td tr.Buffer td {
      color: #ffffff; }
  .new-details-table td td {
    min-width: 150px !important;
    border-top: solid 0px transparent; }
  .new-details-table td:first-child {
    border-right: solid 0px transparent; }
  .new-details-table td.text-primary {
    font-weight: 600;
    color: #1d84b6; }
  .new-details-table td.text-success {
    font-weight: 600;
    color: #0ec200; }
  .new-details-table td.text-error {
    font-weight: 600;
    color: #df0136; }

.dissable-modal {
  width: 80% !important; }

.appointment-view-modal {
  width: 60% !important; }

.cursor-pointer {
  cursor: pointer; }

.new-time-block {
  min-height: 100px !important; }

.patient-type {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0; }
  .patient-type p {
    color: #ffffff !important;
    text-align: left !important;
    margin-bottom: 0px !important;
    font-size: 10px !important;
    line-height: inherit !important; }
  .patient-type.IP {
    background-color: #df0136; }
  .patient-type.OP {
    background-color: #26c6da; }
  .patient-type.BedSide {
    background-color: #6f848e; }
  .patient-type.Buffer {
    background-color: green; }
  .patient-type.emergency {
    background-color: rgba(255, 0, 0, 0.911); }

.appointment-modal .umr .form-group,
.appointment-modal .mobile .form-group {
  width: 90%; }
  .appointment-modal .umr .form-group::after,
  .appointment-modal .mobile .form-group::after {
    content: "OR";
    color: black;
    position: absolute;
    top: 5px;
    font-size: 16px;
    bottom: 0;
    margin: auto;
    right: 2px; }

.appointment-modal .ipnumber {
  width: 80%; }
  .appointment-modal .ipnumber button {
    position: absolute;
    top: 0;
    right: 16px;
    font-size: 19px;
    border-radius: 0px;
    padding: 0p;
    line-height: 0px; }

.queue-config-list .text-p-light {
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.43;
  letter-spacing: normal;
  text-align: left;
  color: #b2b9c4; }

.queue-config-list .text-p-bold {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #455a64; }

.queue-config-list .number-p-light {
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #0089ca; }

.queue-config-list .text-p-bold-exceeds {
  width: 48px;
  height: 11px;
  font-family: "Avenir", sans-serif;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #ff2400; }

.queue-config-list .number-p-center {
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: #455a64; }

.card-top-heading {
  border: solid 1px #d4dade;
  background-color: #26c7db; }
  .card-top-heading p {
    font-size: 18px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: left;
    color: #fff; }
    .card-top-heading p.text-light-d {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.13;
      letter-spacing: normal;
      text-align: left;
      color: #fff; }

.next-btn {
  width: 100%;
  background-color: #26c7db;
  border-color: #26c7db; }

.next-btn:hover {
  width: 100%;
  background-color: #26c7db;
  border-color: #26c7db; }

.checkout-btn {
  width: 100%;
  background-color: #fc4b6c;
  border-color: #fc4b6c; }

.skip-btn {
  width: 100%;
  background-color: #cde7f4;
  border-color: #cde7f4; }

.checkout-btn:hover {
  width: 100%;
  background-color: #fc4b6c;
  border-color: #fc4b6c; }

.skip-btn:hover {
  width: 100%;
  background-color: #cde7f4;
  border-color: #cde7f4; }

.card-detail-text-light {
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: #607d8b; }

.card-detail-text-bold {
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: #364152; }

.card-detail-text-token {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: left;
  color: #fc4b6c; }

.card-colon::after {
  content: ":";
  position: absolute;
  right: 0; }

.card-text-icons {
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.43;
  letter-spacing: normal;
  text-align: left;
  color: #455a64; }

.dashboard-container .info-card {
  border-radius: 5.3px;
  border: 0px solid transparent;
  box-shadow: 0 0 3px 0 rgba(45, 58, 66, 0.35); }
  .dashboard-container .info-card.bg-purple {
    background-color: #745af2; }
  .dashboard-container .info-card.bg-blue {
    background-color: #26c6da; }
  .dashboard-container .info-card.bg-primary {
    background-color: #1e88e5; }
  .dashboard-container .info-card.bg-warning {
    background-color: #ffb22b; }
  .dashboard-container .info-card p {
    font-size: 36px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
    margin-bottom: 0px; }
    .dashboard-container .info-card p.text-primary {
      color: #1e88e5; }
    .dashboard-container .info-card p.text-greenblue {
      color: #26da90; }
    .dashboard-container .info-card p.text-warning {
      color: #ffb22b; }
    .dashboard-container .info-card p.text-error {
      color: #fc4b6c; }
  .dashboard-container .info-card span {
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.6;
    letter-spacing: normal;
    text-align: left;
    color: #fff; }
    .dashboard-container .info-card span.text-black {
      color: #455a64; }
  .dashboard-container .info-card figure {
    text-align: right;
    margin-bottom: 0px; }
    .dashboard-container .info-card figure img {
      width: 20px;
      height: 20px;
      object-fit: contain; }

.card-horizantal .c-head {
  border-bottom: 1px solid #e9f1f3; }

.card-horizantal h2 {
  margin-bottom: 0px;
  font-size: 21px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #083f88; }

.card-horizantal p {
  margin-bottom: 0px;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.4;
  letter-spacing: normal;
  text-align: left;
  color: #99abb4; }
  .card-horizantal p.text-black {
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.4;
    letter-spacing: normal;
    text-align: left;
    color: #455a64; }
  .card-horizantal p.text-red {
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.57;
    letter-spacing: normal;
    text-align: left;
    color: #fc4b6c; }

.card-horizantal .c-body {
  padding: 0px 15px 0px 15px; }
  .card-horizantal .c-body .table-card p {
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: left;
    color: #b2b9c4; }
    .card-horizantal .c-body .table-card p.text-black {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.29;
      letter-spacing: normal;
      text-align: left;
      color: #455a64; }
  .card-horizantal .c-body .border {
    border-top: solid 1px #d4dade;
    border-bottom: solid 1px #d4dade; }
    .card-horizantal .c-body .border .col-1 {
      position: relative; }
      .card-horizantal .c-body .border .col-1::after {
        content: "";
        width: 2px;
        right: 0px;
        height: 120%;
        background-color: #d4dade;
        position: absolute;
        top: -7px; }

.admin-addform .ant-modal-body {
  padding: 0px; }
  .admin-addform .ant-modal-body .figure-block figure {
    width: 100%;
    height: 100%;
    object-fit: contain;
    margin-bottom: 0px; }
  .admin-addform .ant-modal-body .figure-block p {
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
    position: absolute;
    top: 0;
    padding: 24px 50px 24px 24px; }
  .admin-addform .ant-modal-body .form-block h2 {
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: left;
    color: #364152; }
  .admin-addform .ant-modal-body .form-block input {
    border-radius: 0px; }
  .admin-addform .ant-modal-body .form-block button {
    background-color: #364152;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.43;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
    border: 0px;
    padding: 4px 60px; }

.counter-details .card {
  border-radius: 0px;
  border: 0px solid transparent; }
  .counter-details .card .head-row {
    background-color: #6c3964; }
    .counter-details .card .head-row th {
      font-size: 20px;
      font-weight: 900;
      font-style: normal;
      font-stretch: normal;
      line-height: 3.4;
      letter-spacing: normal;
      color: #fff;
      text-transform: uppercase;
      border-right: 1px solid #f2f2f2; }
      @media screen and (min-width: 1900px) {
        .counter-details .card .head-row th {
          letter-spacing: 1px;
          font-size: 40px;
          line-height: 2;
          transform: matrix(1.1, 0, 0, 1.1, 0, 0); } }
  .counter-details .card .table-body td {
    font-size: 30px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    color: #607d8b;
    border-right: 1px solid #f2f2f2;
    padding: 15px; }
    @media only screen and (min-width: 1900px) {
      .counter-details .card .table-body td {
        letter-spacing: 1px;
        font-size: 40px;
        transform: matrix(1.1, 0, 0, 1.1, 0, 0); } }
  .counter-details .card .table-body tr:nth-child(even) {
    background-color: #d7e6ef; }
  .counter-details .card .table-body tr:nth-child(odd) {
    background-color: #f2f2f2; }

.table-header {
  display: flex;
  justify-content: center;
  font-size: 26px !important;
  font-weight: 900 !important;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal; }

.tv-screen-bg {
  background-color: #d4dade; }

.new-details-table .table-responsive {
  padding: 0px; }

.new-details-table thead tr th {
  min-width: 135px;
  padding: 20px 15px; }

.new-details-table tbody tr {
  border-bottom: solid 1px #d4dade; }

.new-details-table tbody td {
  border-bottom: solid 0px #d4dade;
  padding: 20px 15px;
  min-width: 135px;
  line-height: 1.4;
  text-transform: capitalize; }

.static {
  padding: 0px 15px; }
  .static label {
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.43;
    letter-spacing: normal;
    text-align: left;
    color: #b2b9c4; }
  .static p {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: #455a64;
    margin-bottom: 0px; }

.booked-slot {
  position: relative;
  background-color: #26c6da !important; }
  .booked-slot.ip {
    background-color: #df0136 !important; }
    .booked-slot.ip.emergency {
      background-color: rgba(255, 0, 0, 0.911) !important; }
  .booked-slot.IP {
    background-color: #df0136 !important; }
    .booked-slot.IP.emergency {
      background-color: rgba(255, 0, 0, 0.911) !important; }
  .booked-slot.op {
    background-color: #26c6da !important; }
    .booked-slot.op.emergency {
      background-color: rgba(255, 0, 0, 0.911) !important; }
  .booked-slot.OP {
    background-color: #26c6da !important; }
    .booked-slot.OP.emergency {
      background-color: rgba(255, 0, 0, 0.911) !important; }
  .booked-slot.Bedside {
    background-color: #6f848e !important; }
    .booked-slot.Bedside.emergency {
      background-color: rgba(255, 0, 0, 0.911) !important; }
  .booked-slot.Buffer {
    background-color: green !important; }
    .booked-slot.Buffer.emergency {
      background-color: rgba(255, 0, 0, 0.911) !important; }
  .booked-slot p {
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: left;
    color: #fff !important; }
  .booked-slot .booked-data {
    margin: 30px 0px; }
    .booked-slot .booked-data p,
    .booked-slot .booked-data small {
      background-color: transparent;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.71;
      letter-spacing: normal;
      text-align: center;
      color: #fff !important;
      display: block; }

.ant-popover {
  width: auto; }

.ant-select-dropdown {
  z-index: 1600; }

@keyframes lds-magnify {
  0% {
    transform: translate(2px, 2px); }
  33.33% {
    transform: translate(102px, 2px); }
  66.66% {
    transform: translate(42px, 102px); }
  100% {
    transform: translate(2px, 2px); } }

.lds-magnify {
  position: relative; }

.lds-magnify > div {
  transform: scale(0.8);
  transform-origin: 100px 100px; }

.lds-magnify > div > div {
  animation: lds-magnify 1s linear infinite;
  position: absolute; }

.lds-magnify > div > div div:nth-child(1) {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  border: 12px solid #337ab7;
  background: #5bc0de; }

.lds-magnify > div > div div:nth-child(2) {
  width: 17px;
  height: 51px;
  transform: rotate(-45deg);
  background: #337ab7;
  border-radius: 0 0 8px 8px;
  position: absolute;
  top: 68px;
  left: 85px; }

.lds-magnify {
  width: 200px !important;
  height: 200px !important;
  transform: translate(-100px, -100px) scale(1) translate(100px, 100px); }

.time-exceed {
  border: 3px solid #fd000d !important; }

.dissablslotLi {
  height: 200px;
  overflow-y: auto; }
  .dissablslotLi div {
    background-color: #eef5f9;
    padding: 5px;
    border-radius: 20px; }
    .dissablslotLi div button {
      top: -2px;
      bottom: 0;
      left: 20px; }

.f-14 {
  font-size: 14px; }

.disabled {
  background-color: #e9ecef; }

.login-bg {
  background-color: #00000091;
  display: flex;
  align-items: center;
  font-family: Avenir;
  color: #fff; }

iframe#webpack-dev-server-client-overlay {
  display: none !important; }

.new-login-layer {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100vh; }
  .new-login-layer figure {
    width: 155px;
    height: 49px;
    object-fit: contain; }
  .new-login-layer h1 {
    font-size: 60px;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.3;
    letter-spacing: 1.2px;
    color: #fff; }
  .new-login-layer sup {
    top: -0.3em; }
  .new-login-layer h2 {
    font-size: 33px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.3;
    letter-spacing: 1.2px;
    color: #fff; }
  .new-login-layer ul li {
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: left;
    color: #fff; }
  .new-login-layer .forgot-pass {
    font-size: 12px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.5;
    letter-spacing: normal;
    text-align: left;
    color: #ffffff; }
  .new-login-layer .login-card {
    padding: 50px;
    margin: 50px;
    border-radius: 10px;
    background-color: #fff;
    opacity: 1; }
    .new-login-layer .login-card h2 {
      font-size: 20px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      text-transform: uppercase; }
    .new-login-layer .login-card h2 + small {
      font-size: 13px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 2;
      letter-spacing: normal;
      text-align: center;
      color: #868686; }
    .new-login-layer .login-card .ant-input-prefix i {
      color: #fff !important; }
    .new-login-layer .login-card .ant-input-suffix i {
      color: #fff !important; }
    .new-login-layer .login-card input {
      border-radius: 5px;
      border: solid 1px #66b1d0;
      font-size: 14px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 2.2;
      letter-spacing: normal;
      text-align: left;
      color: #000; }
      .new-login-layer .login-card input::placeholder {
        font-size: 13px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.2;
        letter-spacing: normal;
        text-align: left;
        color: gray; }
    .new-login-layer .login-card button {
      width: 50%;
      border-radius: 5px;
      background-color: #6c3964;
      font-size: 16px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 2.2;
      letter-spacing: 0.9px;
      text-align: center;
      color: #fff;
      border: 0px; }

.text-explination img {
  width: 36px;
  height: 36px;
  object-fit: contain; }

.text-explination h3 {
  font-size: 22px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
  margin-bottom: 0px; }

.text-explination p {
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: 0.7px;
  text-align: left;
  color: #fff; }

.text-explination ul li {
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.14;
  letter-spacing: 0.28px;
  text-align: left;
  color: #fff; }

.border-botton-lay {
  border-bottom: 1px solid #02a3b3; }

.login-footer {
  position: absolute;
  bottom: 50px; }
  .login-footer p {
    font-size: 11px;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 1.2px;
    text-align: left;
    color: #fff;
    margin-bottom: 0px; }
    .login-footer p:nth-child(2) {
      color: #77c8f2; }
    .login-footer p a {
      color: #fff; }

.card-row {
  display: flex;
  margin-left: -20px;
  overflow: auto;
  white-space: nowrap; }
  .card-row .card-dynamic {
    display: block;
    width: auto;
    height: auto; }

.loader {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(212, 218, 222, 0.5);
  z-index: 2000;
  top: 0;
  cursor: wait;
  left: 0;
  z-index: 2000; }

.app-loader {
  width: 100%;
  height: 100%;
  background-color: rgba(96, 125, 139, 0.5);
  top: 0%;
  left: 0%;
  position: fixed;
  z-index: 2000; }

.ant-spin-spinning {
  position: relative;
  top: calc(100% - 50%);
  bottom: calc(100% - 50%);
  left: calc(100% - 50%);
  right: calc(100% - 50%);
  margin: auto; }

.popover-custom {
  width: auto; }

.pagination {
  display: inline-block; }

.pagination li {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  border: 1px solid #c1c1cc;
  background-color: #ffffff; }

.pagination li.active {
  background-color: #337ab7;
  color: white;
  border: 1px solid #337ab7; }

.pagination li.active a {
  color: white; }

.pagination li:hover:not(.active) {
  background-color: #ddd; }

.pagination li:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px; }

.pagination li:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px; }

.error-color {
  color: red; }

.download-csv-btn {
  background-color: #6c3964;
  font-size: 14px;
  border: 0px solid transparent;
  margin: auto 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 3 !important;
  padding: 0px 20px !important;
  letter-spacing: normal;
  text-align: left;
  color: #fff; }
  .download-csv-btn:focus, .download-csv-btn:hover, .download-csv-btn:active {
    color: #fff; }
  .download-csv-btn img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    margin-right: 10px; }

.not-active-download {
  pointer-events: inherit;
  text-decoration: none; }
  .not-active-download:focus, .not-active-download:hover, .not-active-download:active {
    cursor: wait; }

.search-btn-modal {
  width: 62px !important;
  border-bottom-right-radius: 4px !important;
  border-top-right-radius: 4px !important;
  margin: 0px !important;
  background-color: #6c3964; }

.bill-search-btn {
  border-bottom-right-radius: 0px !important;
  border-top-right-radius: 0px !important; }

.input-padding {
  padding: 0px !important; }

.left-adding {
  left: -2px !important; }

.dropdown-img {
  width: 13px;
  height: 14px;
  margin-right: 3px; }

.service-in-card {
  padding-left: 2.5em !important;
  text-indent: -1.5em !important;
  height: auto !important; }

.ant-calendar-picker {
  width: 100%; }

.operator-card-clock {
  position: absolute;
  top: 0;
  z-index: 9;
  left: -8px;
  cursor: pointer; }

.cursor-pointer {
  cursor: pointer; }

.remove-icon-app {
  position: absolute !important;
  right: 3px !important;
  cursor: pointer;
  width: 11px !important;
  height: 20px !important; }

.operator-service-app-p {
  position: static !important;
  position: initial !important; }

.text-checkin-disable {
  background: #7593a4;
  cursor: not-allowed; }

.chart-filter {
  margin-top: 10px;
  margin-bottom: 15px; }

.ant-badge {
  width: 100%; }

.patient-queue-title h3 {
  border-bottom: 1px solid #eef5f9; }

.patient-queue {
  overflow-y: auto;
  overflow-x: hidden;
  height: 595px;
  padding-top: 5px;
  background-color: #eef5f9; }
  .patient-queue h6 {
    line-height: 1.5;
    margin-bottom: 0;
    padding-left: 10px;
    padding-bottom: 5px;
    font-size: 14px;
    text-transform: uppercase; }
  .patient-queue h6:first-child {
    padding-top: 10px; }
  .patient-queue h4 {
    line-height: 1.5;
    margin-bottom: 0;
    padding-left: 10px;
    padding-bottom: 5px;
    text-transform: uppercase; }
  .patient-queue .borderb {
    border-bottom: 1px solid #eef5f9;
    padding-top: 10px;
    margin-bottom: 5px;
    position: relative;
    background-color: #fff; }
  .patient-queue .borderb:last-child {
    border-bottom: 1px solid #fff; }
  .patient-queue .borderb:hover .overlay {
    display: block;
    background: rgba(0, 0, 0, 0.3); }
  .patient-queue .btn {
    margin-right: 10px;
    background-color: #6c3964;
    color: #fff; }
  .patient-queue .btn-success {
    padding: 0.375rem 1rem; }

.popup-close {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 14px;
  line-height: 1.2;
  background-color: #6c3964;
  color: #fff;
  position: absolute;
  right: -10px;
  top: -10px;
  border: 1px solid #d9d9d9; }

.ant-radio-checked .ant-radio-inner {
  border-color: #6c3964 !important; }

.ant-radio-checked .ant-radio-inner:after {
  background-color: #6c3964; }

.ant-radio:hover .ant-radio-inner {
  border-color: #6c3964; }

.checkbox-container {
  display: flex;
  flex-direction: row;
  color: black; }

.vitals-label {
  margin-right: 10px;
  /* Adjust the margin for tab space */ }

.selec2Class .ant-select-selection {
  padding: 0px 35px;
  background-color: #fff;
  position: relative; }
  .selec2Class .ant-select-selection::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    width: 24px;
    height: 24px;
    position: absolute;
    left: calc(6.7% - 24px);
    top: calc(100% - 24px); }

.btn-magenta {
  background-color: #6c3964;
  color: #fff;
  border: 1px solid #6c3964;
  border-radius: 5px; }
  .btn-magenta::after {
    border: 1px solid #6c3964;
    border-radius: 5%; }

.btn-red {
  background-color: #fc4b6c;
  color: #fff;
  border: 1px solid #fc4b6c;
  border-radius: 5px; }
  .btn-red::after {
    border: 1px solid #fc4b6c; }

.loginLayer {
  height: 100vh;
  background-color: #364152; }
  .loginLayer h2 {
    color: #fff;
    font-size: 24px; }
  .loginLayer button {
    background-color: transparent;
    border: 1.5px solid #d4dade;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.45;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
    padding: 0px 30px; }

.nav-info {
  position: absolute;
  margin: 0px auto;
  top: 40px;
  left: 39px;
  font-size: 10px; }

.form-row p.readonly {
  font-size: 13px;
  background-color: whitesmoke;
  color: #696d71;
  line-height: 1.5; }

.work-flow-stages p.readonly {
  font-size: 13px;
  text-align: left;
  background-color: whitesmoke;
  color: #696d71;
  line-height: 1.5; }

.q-check label.checked span {
  border: solid 1px #b2b9c4;
  background-color: #d4dce0;
  font-size: 14px;
  font-weight: 500;
  cursor: not-allowed;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  color: #364152; }

.data-label {
  min-width: 2em;
  color: #455a64;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: normal;
  text-transform: capitalize; }

.data-item {
  color: #455a64;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: normal;
  text-transform: capitalize; }

.btn-success {
  padding: 5px 30px;
  background-color: #6c3964;
  border-color: #6c3964; }

.btn-success:focus {
  background-color: #6c3964 !important;
  color: #fff;
  border: 1px solid transparent; }

.btn-next {
  padding: 5px 30px;
  color: #fff;
  background-color: #b37f40 !important; }

.btn-next:hover {
  color: #fff; }

label {
  color: #455a64;
  margin-bottom: 0rem; }

.ant-modal-body {
  background-color: #f4f4f4;
  border-radius: 10px; }

.ant-modal-close {
  display: none; }

.ant-select-selection {
  border-radius: 5px !important; }

.checkoutModal:where(.css-dev-only-do-not-override-1okl62o).ant-modal .ant-modal-content {
  border-radius: 4px !important;
  padding: 25px 37px !important;
  width: 73%;
  margin-left: 12%; }

.ant-select-arrow {
  background-color: #6c3964;
  width: 30px !important;
  height: 32px !important;
  position: absolute !important;
  top: 5px !important;
  right: 0px !important;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  color: white !important;
  font-size: 18px !important;
  font-weight: 900;
  padding-left: 6px; }

.ant-select-arrow-icon {
  padding: 5px 0 1px; }

span.ant-time-picker-icon {
  background-color: #6c3964;
  width: 30px;
  height: 32px;
  position: absolute;
  top: 7px;
  right: 0px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  color: white;
  font-size: 18px;
  font-weight: 900; }

.ant-time-picker-clock-icon {
  padding-top: 5px;
  color: #fff !important; }

.generate-token .umr .form-group,
.generate-token .mobile .form-group {
  width: 90%; }
  .generate-token .umr .form-group::after,
  .generate-token .mobile .form-group::after {
    content: "or";
    color: black;
    position: absolute;
    font-size: 16px;
    bottom: 5px;
    margin: auto;
    right: -33px; }

.generate-token .ipnumber {
  width: 80%; }
  .generate-token .ipnumber button {
    position: absolute;
    top: 0;
    right: 16px;
    font-size: 19px;
    border-radius: 0px;
    padding: 0p;
    line-height: 0px; }

.cou-dash h1 {
  font-size: 40px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #364152; }

.cou-dash h6 {
  font-size: 25px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #455a64; }

.text-heading {
  font-size: 40px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #364152; }

.textarea {
  background-color: #f5f5f5;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
  width: 100%;
  height: 120px;
  padding: 10px; }

.insurance h5 {
  font-size: 25px; }

.insurance li {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: #455a64; }

.insurance .one {
  color: #364152;
  font-size: 18px;
  line-height: 1.5;
  font-weight: normal; }

.insurance .two {
  color: #455a64;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 300; }

.anticon-calendar {
  background-color: #6c3964;
  width: 30px;
  height: 32px;
  position: absolute;
  top: 7px;
  right: -1px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  color: white;
  font-size: 18px;
  font-weight: 900; }
  .anticon-calendar svg {
    margin-top: 6px; }
  .anticon-calendar .ant-input-suffix {
    background-color: #067fb8;
    width: 30px;
    height: 31px;
    right: 0px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    color: white;
    font-size: 18px;
    font-weight: 900; }
  .anticon-calendar .anticon.anticon-user {
    color: #fff;
    margin-top: 5px;
    margin-left: 5px; }

.ant-calendar-picker:hover .anticon-close-circle.ant-calendar-picker-clear {
  opacity: 1;
  pointer-events: auto;
  width: 30px;
  height: 32px;
  position: absolute;
  right: 0px;
  top: 7px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #1890ff;
  border-left: none; }
  .ant-calendar-picker:hover .anticon-close-circle.ant-calendar-picker-clear svg {
    margin-top: 8px;
    display: inline-block; }

.card .anticon-calendar {
  top: 6px; }

.card .ant-calendar-picker:hover .anticon-close-circle.ant-calendar-picker-clear {
  top: 6px; }

.financial-table .track-bills {
  width: 170%; }

.financial-table thead {
  color: #fff;
  background-color: #87979f; }
  .financial-table thead td {
    text-transform: capitalize;
    font-weight: 500;
    font-weight: 14px; }

.financial-table tbody td {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: #455a64; }

.financial-table tbody td ul {
  padding-left: 20px; }

.table-bordered td:last-child {
  border-right: 0px solid #dee2e6; }

.table-bordered td:first-child {
  border-left: 0px solid #dee2e6; }

.man-dash .card {
  height: 170px;
  width: 100%;
  display: flex;
  justify-content: center; }
  .man-dash .card h1 {
    font-size: 60px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.69;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff; }
  .man-dash .card h2 {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.27;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    margin-bottom: 0px; }

.role_table thead {
  background-color: #6c3964; }
  .role_table thead th {
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.5;
    letter-spacing: normal;
    text-align: left;
    color: #084b6b;
    text-transform: capitalize; }

.role_table tbody th {
  color: #455a64;
  border-top: 1px solid #dee2e6; }

.role_table tbody td {
  color: #455a64;
  border-top: 1px solid #dee2e6; }

.queue-cards .btn-refresh {
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #b37f40;
  padding: 3px 5px;
  margin-top: 4px !important; }

.queue-cards .card .card-header {
  font-size: 25px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  padding: 5px; }

.queue-cards .card thead {
  background-color: #d4dade; }
  .queue-cards .card thead td {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    text-align: left;
    color: #084b6b;
    text-transform: capitalize; }
  .queue-cards .card thead tbody td {
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: left;
    color: #455a64; }

.queue-cards .card h1 {
  font-size: 25px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-transform: capitalize;
  line-height: 1.5;
  letter-spacing: 0.5px;
  text-align: center;
  color: #ffffff;
  border-bottom: 1px solid #257aca;
  margin-bottom: 0px;
  padding: 5px; }

.queue-cards .card h2 {
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-transform: capitalize;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin-bottom: 0px;
  padding-top: 20px; }

.queue-cards .card h3 {
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-transform: capitalize;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin-bottom: 0px;
  padding-bottom: 20px; }

.queue-cards .card h4 {
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-transform: uppercase;
  line-height: 0.8;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  background-color: #257aca;
  padding: 15px; }

.queue-cards .card p {
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  text-transform: capitalize;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff; }

.card-table .card-header {
  color: #fff;
  border-bottom: 0px; }

.card-table thead {
  background-color: #dee9ef; }
  .card-table thead td {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #084b6b;
    text-transform: capitalize; }

.card-table tbody td {
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #455a64; }

.card-table tbody tr.last {
  background-color: #fff1e1; }

.table-hover tbody tr:hover {
  color: #212529;
  background-color: #f5f5f5 !important; }

.bill-details .data-label {
  width: 120px; }

.pagination li {
  color: black;
  float: left;
  padding: 6px 16px;
  text-decoration: none;
  border: 1px solid #c1c1cc;
  background-color: #ffffff; }

.pagenation-col {
  align-items: center;
  justify-content: center;
  display: flex; }

.ant-pagination .ant-pagination-item {
  border: 1px solid gray !important;
  border-radius: 4px !important; }

.ant-pagination .ant-pagination-item-active {
  border: 1px solid blue !important; }

.ant-pagination .ant-pagination-prev {
  color: gray; }

.ant-pagination .ant-pagination-next {
  color: gray; }

.ant-select .ant-select-selection-item {
  color: gray;
  padding-right: 24px !important; }

.token-popup h1 {
  font-size: 70px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.6;
  letter-spacing: normal;
  text-align: center;
  color: #364152; }

.token-popup h2 {
  font-size: 35px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.07;
  letter-spacing: normal;
  text-align: center;
  color: #455a64;
  margin-bottom: 0px; }

.token-popup h3 {
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #455a64;
  margin-bottom: 0px; }

.token-popup p {
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.4;
  letter-spacing: normal;
  text-align: center;
  color: #455a64; }

.disable {
  color: #455a64; }

@media print {
  .token-popup h1 {
    font-size: 80pt;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.8;
    letter-spacing: normal;
    text-align: center;
    color: black !important; }
  .token-popup h2 {
    font-size: 25pt;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: center;
    color: black !important;
    margin-bottom: 0px; }
  .token-popup h3 {
    font-size: 18pt;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.6;
    letter-spacing: normal;
    text-align: center;
    color: black !important;
    margin-bottom: 0px; }
  .token-popup p {
    font-size: 16pt;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.4;
    letter-spacing: normal;
    text-align: center;
    color: black !important; } }

.user-map table tbody td.active {
  background-color: #b37f40;
  color: #fff; }

.user-map table tbody td.active::after {
  position: absolute;
  width: 20px;
  height: 25px;
  background-color: #b37f40;
  content: "";
  transform: rotate(45deg);
  right: -8px; }

.input-group-append .btn-primary {
  background-color: #3093b4 !important;
  border-color: #3093b4 !important; }

.input-group-append .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #3093b4 !important;
  border-color: #3093b4 !important; }

.ant-switch-checked {
  background-color: #6c3964 !important; }

.input-group-prepend.show {
  position: relative;
  height: 100%; }
  .input-group-prepend.show .dropdown-menu a {
    color: #fff;
    text-align: left;
    padding-bottom: 13px;
    padding-top: 13px;
    font-size: 16px;
    border-bottom: 0.1px solid #7fc3e3; }
  .input-group-prepend.show .dropdown-menu.show {
    background-color: #067fb8;
    margin-top: 20px;
    animation: 1s fadeIn;
    padding: 3px 15px 25px; }
  .input-group-prepend.show .dropdown-menu.show::before {
    content: "";
    width: 15px;
    height: 23px;
    background-color: #067fb8;
    position: absolute;
    top: -8px;
    left: 12%;
    transform: rotate(45deg);
    border-radius: 4px; }
  .input-group-prepend.show .dropdown-item:hover,
  .input-group-prepend.show .dropdown-item:focus {
    color: #084b69;
    text-decoration: none;
    background-color: #067fb8; }

.form-group {
  position: relative; }

.form-text {
  position: absolute;
  bottom: -20px; }

.form-text.text-danger {
  animation: 1s fadeInDown; }

.hand {
  position: absolute;
  top: 50%;
  right: 0px;
  height: 50%;
  animation: 1s fadeInRight; }

.download button {
  margin-top: 2px; }

.download button:hover img {
  animation: 1s flash infinite; }

.download .btn-success-disabled:hover img {
  animation: none; }

.download span {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-transform: uppercase; }

.download .btn-success-disabled {
  padding: 5px 31px;
  color: #fff;
  background-color: #6c3964;
  font-size: 16px;
  height: 36px; }

i.anticon.anticon-loading {
  position: absolute;
  top: 8px; }

table tbody tr td img {
  cursor: pointer; }

.anticon-edit {
  color: #6c3964;
  outline: transparent;
  font-size: large; }

.room_eligibility_ward .ant-select-arrow {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px; }

.upgrade_room_ward .ant-select-arrow {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px; }

.ailment_capping .ant-select-arrow {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px; }

.surgery_procedure_capped_ailment .ant-select-arrow {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px; }

.fc-patient-copy .d-inline-flex {
  padding-top: 12px; }

.fc-patient-copy span.w-label {
  min-width: 170px; }

.fc-patient-copy span.w-100 {
  text-transform: capitalize;
  width: 100% !important; }

.no-data {
  color: #e3e3e3; }

.ant-btn[disabled]:hover {
  color: #fff;
  background-color: #676767; }

::-webkit-scrollbar {
  width: 8px;
  height: 8px; }

::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);  */
  background-color: #f4f4f4;
  /* border-radius: 10px; */ }

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #c1c1c1;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);  */ }

.ant-input {
  border: white !important;
  padding: 0 !important; }

:where(.css-dev-only-do-not-override-1okl62o).ant-input-affix-wrapper {
  padding: 0;
  box-shadow: 0 1px 8px rgba(23, 110, 222, 0.1);
  line-height: 2.3;
  border: 0; }

.ant-select-selector {
  border: 0 !important;
  box-shadow: 0 1px 8px rgba(23, 110, 222, 0.1); }

.group-td {
  padding: 10px;
  height: 40px;
  border-top: 1px solid #dee2e6; }
  .group-td:first-child {
    border-top: 0px solid #dee2e6; }

tr.hide-table-padding td {
  padding: 0.75rem;
  background-color: #fbeede; }

.expand-button {
  position: relative;
  cursor: pointer; }

.accordion-toggle .expand-button:after {
  position: absolute;
  left: 2.3rem;
  color: #b37f40;
  font-weight: 600;
  font-size: 20px;
  top: 18%;
  transform: translate(0, -50%);
  transform: rotate(45deg);
  content: "+";
  transition: 0.2s linear; }

.accordion-toggle.collapsed .expand-button:after {
  content: "+";
  transform: rotate(0deg); }

.collapse.show {
  transition: 0.3s linear;
  transition-delay: 0.1s; }

.bg1 {
  background-color: #488bd6; }

.bg2 {
  background-color: #40b391; }

.bg3 {
  background-color: #40a7b3; }

.bg4 {
  background-color: #b37f40; }

.bg5 {
  background-image: linear-gradient(#2d6296, #224c73, #183551); }

.bg6 {
  background-image: linear-gradient(#2e81b9, #246590, #194766); }

.bg7 {
  background-image: linear-gradient(#568095, #426171, #2e4550); }

.bg8 {
  background-color: #87979f; }

.bg9 {
  background-color: #dee9ef; }

.tv-row td {
  border-bottom: 0px solid transparent;
  font-size: 23px; }

.tv-row tr {
  border-bottom: solid 1px d4dade; }

.tv-row .token {
  line-height: 1 !important;
  font-size: 6pc !important; }

.tv-row .councellor {
  line-height: 1 !important;
  font-size: 4.5pc !important; }

.loadding {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  background: #f1f1f180; }

.ant-spin-dot-item {
  background-color: #084b69; }

.ant-spin {
  color: #084b69; }

.ant-spin-text {
  font-size: 20px; }

.ant-input[disabled] {
  color: #000000c7; }

.ant-calendar-picker-icon {
  background-color: #6c3964; }

.ant-select-disabled .ant-select-selection .ant-select-selection-selected-value {
  color: #000000c7; }

.ant-select-sm .ant-select-selection--single {
  height: 30px; }

.ant-select-sm .ant-select-selection__placeholder {
  height: 30px;
  top: 13px;
  right: 10px; }

.ant-select-sm .ant-select-arrow {
  background-color: #067fb8;
  width: 30px;
  height: 30px;
  right: -1px; }

.ant-select-sm .ant-select-arrow-icon {
  padding-top: 6px;
  font-size: 16px; }

.token-mobile .form-text {
  position: absolute;
  bottom: -40px; }

.blink_me {
  animation: blinker 1s linear infinite; }

@keyframes blinker {
  50% {
    opacity: 0; } }

.ant-pagination {
  margin-bottom: 3rem; }

@media only screen and (max-width: 1024px) {
  .hand {
    top: 55%;
    height: 50%; } }

.text-ixons {
  display: flex;
  align-items: center;
  justify-content: center; }
  .text-ixons span {
    cursor: pointer; }
  .text-ixons .disable {
    cursor: default; }
  .text-ixons .active {
    cursor: pointer; }
  .text-ixons p {
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    color: #084b6b;
    margin-bottom: 0px;
    margin: 0px 12px;
    width: 20%; }

.date-container {
  position: absolute;
  width: 18%;
  right: 1.5%;
  top: 0;
  bottom: 0;
  margin: auto;
  height: 30px; }
  .date-container .text-ixons input {
    background-color: transparent;
    border: 0px;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    color: #084b6b;
    margin-bottom: 0px;
    margin: 0px 12px;
    width: 90%;
    position: relative;
    left: 4%; }
    .date-container .text-ixons input:focus, .date-container .text-ixons input:active {
      outline: 0;
      box-shadow: none; }
  .date-container .text-ixons .anticon-calendar {
    background-color: transparent;
    width: 30px;
    height: 32px;
    position: absolute;
    top: 7px;
    left: 4px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    color: #084b6b;
    font-size: 18px;
    font-weight: 500; }

.oppintment-table {
  position: relative; }
  .oppintment-table .bg-dark-gray {
    background-color: #dee9ef !important; }
  .oppintment-table .title-head {
    background-color: #dee9ef;
    padding: 0px 0px 0px 15px;
    position: relative; }
    .oppintment-table .title-head p {
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #084b6b;
      margin-bottom: 0px;
      text-transform: uppercase;
      position: absolute;
      top: -14px;
      z-index: 1040;
      right: 20px; }
      .oppintment-table .title-head p::after {
        content: "";
        background-color: #87979f;
        width: 25%;
        height: 1px;
        position: absolute;
        right: -37%;
        top: 18%; }
    .oppintment-table .title-head.later p {
      top: -19px; }
      .oppintment-table .title-head.later p:after {
        top: 43%; }
  .oppintment-table .table-head .table-head-title {
    padding: 15px 0px;
    position: relative; }
    .oppintment-table .table-head .table-head-title h5 {
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      margin-bottom: 0px; }
  .oppintment-table .table-body {
    border-top: 1px solid #dee2e68f;
    border-left: 1px solid #dee2e6;
    background-color: #fff;
    position: relative;
    top: -10px; }
    .oppintment-table .table-body.bold-color {
      border-top: 1px solid #87979f; }
    .oppintment-table .table-body .table-body-title {
      border-right: 0.5px solid #dee2e6;
      height: 10px;
      cursor: pointer; }
      .oppintment-table .table-body .table-body-title p {
        font-size: 14px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: 2.2;
        padding: 0px 10px;
        letter-spacing: normal;
        text-align: left;
        color: #455a64;
        margin-bottom: 0px; }

.oppintment-table-body {
  height: 61.7vh;
  overflow: auto;
  padding-top: 10px;
  background-color: #dee9ef; }
  .oppintment-table-body p {
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    color: #455a64; }

.active-block-booked {
  background-color: #067fb8;
  background-color: #067fb8;
  width: 99.9%;
  z-index: 1020;
  position: absolute;
  cursor: pointer; }
  .active-block-booked p,
  .active-block-booked small,
  .active-block-booked label {
    color: #fff !important;
    display: block;
    width: 100%;
    text-align: left;
    margin-bottom: 5px;
    line-height: normal !important; }
  .active-block-booked p {
    font-size: 14px;
    margin-bottom: 1px !important;
    margin-top: 1%;
    padding: 2px 0px 2px 0px !important; }
  .active-block-booked small {
    font-size: 12px; }
  .active-block-booked label {
    font-size: 14px;
    margin-bottom: 0px;
    line-height: 10px;
    font-weight: 300; }
  .active-block-booked.tentative {
    background-color: #ff7f00; }
  .active-block-booked.confirm {
    background-color: #067fb8; }
  .active-block-booked.wheel-in {
    background-color: #22ac50; }
    .active-block-booked.wheel-in p,
    .active-block-booked.wheel-in small,
    .active-block-booked.wheel-in label {
      color: #212529; }
  .active-block-booked.delayed {
    background-color: palevioletred; }
  .active-block-booked.wheel-out {
    background-color: darkgreen; }
  .active-block-booked.delayed-shifted {
    background-color: red; }

.active-block-cleaning {
  color: white;
  background: repeating-linear-gradient(45deg, #606dbc, #606dbc 10px, #465298 10px, #465298 20px);
  top: -6px;
  position: relative;
  width: 99.9%;
  z-index: 1020; }
  .active-block-cleaning p {
    font-size: 14px !important;
    margin-bottom: 5px !important;
    margin-top: 1.1%;
    color: #fff !important;
    text-align: center !important; }

.appointment-modal {
  position: relative; }
  .appointment-modal .resend-sms {
    width: 32%;
    position: absolute;
    right: 2%;
    top: 4%;
    display: flex; }
  .appointment-modal .ant-modal-header {
    padding-bottom: 10px; }
  .appointment-modal .ant-modal-body {
    background-color: #fff !important;
    border-radius: 10px;
    padding-top: 0px; }
    .appointment-modal .ant-modal-body .modal-body h2 {
      font-size: 20px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 2;
      letter-spacing: normal;
      text-align: center;
      color: #607d8b;
      margin-bottom: 0px; }
    .appointment-modal .ant-modal-body .modal-body label {
      font-size: 16px;
      margin-bottom: 5px;
      padding: 0px 0px; }
    .appointment-modal .ant-modal-body .modal-body p {
      font-size: 14px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      padding: 0px 10px;
      letter-spacing: normal;
      text-align: left;
      color: #455a64;
      overflow: hidden;
      word-break: break-all;
      text-transform: capitalize; }
    .appointment-modal .ant-modal-body .top-border {
      position: relative; }
      .appointment-modal .ant-modal-body .top-border::before {
        content: "";
        background-color: #bdc0c38f;
        width: 99%;
        height: 1.5px;
        position: absolute;
        top: -15px;
        left: 0;
        right: 0;
        margin: auto; }

.close-icon {
  display: flex;
  position: absolute;
  top: 2%;
  left: 5%;
  background-color: #fff;
  box-shadow: 0px 2px 6px #eeeeee;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer; }
  .close-icon.left {
    left: auto;
    left: initial;
    right: 2%; }

.search-width .form-group {
  width: 400px; }

.sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1000; }

.slot_disabled {
  background-color: #dddddd;
  height: 100%;
  cursor: not-allowed; }

.title-Text {
  font-size: 19px;
  font-weight: 600; }

footer p {
  margin-bottom: 0px; }

.calendar-button {
  position: absolute;
  background: #fff;
  /* padding: 10px; */
  border-radius: 50%;
  height: 55%;
  margin: auto;
  width: 2.5%;
  top: 0;
  bottom: 0;
  z-index: 100; }
  .calendar-button.right {
    right: 1%; }
    .calendar-button.right span {
      padding: 0px 9px; }
  .calendar-button.left {
    left: 9.4%; }
    .calendar-button.left span {
      padding: 0px 7px; }

.table-head {
  background-color: #13b6a5;
  position: relative; }
  .table-head:after {
    content: "";
    width: 1px;
    height: 100%;
    position: absolute;
    right: 2px;
    top: 0;
    background-color: #dee2e6; }
  .table-head.last-child:after {
    background-color: transparent; }

.card-table .card-header {
  color: #fff;
  border-bottom: 0px; }

.active-block {
  z-index: 200; }

.card-table thead td:not(:first-child) {
  min-width: 150px; }

.text-blue-color {
  position: absolute;
  top: -12px;
  color: #067fb8; }

.slegend span {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: text-top;
  margin-right: 3px;
  border-radius: 3px; }

.slegend b {
  font-weight: 400;
  font-size: 14px; }

.slegend .legtentative {
  background-color: #ff7f00; }

.slegend .legconfirm {
  background-color: #067fb8; }

.slegend .legemergency {
  background-color: red; }

.slegend .legwheelin {
  background-color: #22ac50; }

.slegend .legwheelout {
  background-color: darkgreen; }

.slegend .legshifted {
  background-color: red; }

.slegend .legdelayed {
  background-color: palevioletred; }

.badgee {
  background-color: red;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  position: absolute;
  right: 5px;
  top: 8px; }

@media screen and (max-width: 1024px) {
  /* Styles go here */
  .login-footer {
    bottom: 0px;
    position: static;
    position: initial;
    padding-top: 10px; } }

.table-scroll {
  max-height: 100%;
  overflow-y: visible;
  overflow-y: initial;
  overflow-x: visible;
  overflow-x: initial;
  margin-left: -48px;
  transition: ease-in-out 1s;
  top: 50px; }
  .table-scroll thead tr td {
    top: 38px; }

.table-scroll2 {
  max-height: 100%;
  overflow-y: visible;
  overflow-y: initial;
  overflow-x: visible;
  overflow-x: initial;
  margin-left: -48px;
  transition: ease-in-out 1s;
  top: 50px; }
  .table-scroll2 thead tr:first-child td {
    background-color: #dee9ef;
    position: -webkit-sticky;
    position: sticky;
    top: 39px; }
  .table-scroll2 thead tr:nth-child(2) td {
    background-color: #dee9ef;
    position: -webkit-sticky;
    position: sticky;
    top: 84px; }

.btn-sticky {
  position: fixed;
  width: 100%;
  left: -3rem; }

.sticky-header {
  transition: ease-in-out 0.5s;
  width: 100%;
  height: 100%; }
  .sticky-header thead td {
    background-color: #dee9ef;
    position: -webkit-sticky;
    position: sticky;
    top: 0px; }
  .sticky-header thead tr td:nth-child(2) {
    position: -webkit-sticky;
    position: sticky;
    width: 140px;
    min-width: 140px;
    max-width: 140px;
    left: -1px;
    background-color: #dee9ef;
    -webkit-clip-path: inset(0px -15px 0px 0px);
            clip-path: inset(0px -15px 0px 0px);
    box-shadow: 0 0 15px #dee2e6;
    z-index: 1; }
  .sticky-header tbody tr:hover td {
    background-color: #f5f5f5 !important; }
  .sticky-header tbody tr td:nth-child(2) {
    position: -webkit-sticky;
    position: sticky;
    width: 140px;
    min-width: 140px;
    max-width: 140px;
    left: -1px;
    background-color: #fff;
    -webkit-clip-path: inset(0px -15px 0px 0px);
            clip-path: inset(0px -15px 0px 0px);
    box-shadow: 0 0 15px #dee2e6; }

.sticky-header2 {
  width: 100%;
  height: 100%;
  transition: ease-in-out 1s;
  overflow-y: auto; }
  .sticky-header2 thead tr:first-child td {
    background-color: #dee9ef;
    position: -webkit-sticky;
    position: sticky;
    top: -1px; }
  .sticky-header2 thead tr:nth-child(2) td {
    background-color: #dee9ef;
    position: -webkit-sticky;
    position: sticky;
    top: 44px; }
  .sticky-header2 thead tr:first-child td:nth-child(2) {
    position: -webkit-sticky;
    position: sticky;
    width: 140px;
    min-width: 140px;
    max-width: 140px;
    left: -1px;
    background-color: #dee9ef;
    -webkit-clip-path: inset(0px -15px 0px 0px);
            clip-path: inset(0px -15px 0px 0px);
    box-shadow: 0 0 15px #dee2e6;
    z-index: 1; }
  .sticky-header2 tbody tr:hover td {
    background-color: #f5f5f5 !important; }
  .sticky-header2 tbody tr td:nth-child(2) {
    position: -webkit-sticky;
    position: sticky;
    width: 140px;
    min-width: 140px;
    max-width: 140px;
    left: -1px;
    background-color: #fff;
    -webkit-clip-path: inset(0px -15px 0px 0px);
            clip-path: inset(0px -15px 0px 0px);
    box-shadow: 0 0 15px #dee2e6; }

.table-body-title:hover .active-block.overflow-hidden {
  overflow: visible !important; }

.table-body-title:hover .active-block-cleaning {
  transform: scale(1.1);
  z-index: 1021;
  transition: ease-in-out 0.5s; }

.table-body-title:hover .active-block-booked {
  transform: scale(1.1);
  z-index: 1021;
  height: 110px !important;
  transition: ease-in-out 0.5s; }

.active-block-booked {
  transition: ease-in-out 0.5s; }

.active-block-cleaning {
  transition: ease-in-out 0.5s; }

.dropdown-toggle::after {
  content: none; }

.card-label {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  overflow: hidden;
  word-break: break-all;
  text-transform: capitalize;
  margin-bottom: 5px;
  padding: 0px 0px;
  color: #17b1a7; }

.card-item {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  padding: 0px 0px;
  margin-bottom: 0px;
  letter-spacing: normal;
  text-align: left;
  color: #455a64;
  overflow: hidden;
  word-break: break-all;
  text-transform: capitalize; }

.radio-button input[type="radio"] {
  display: none; }

.radio-button label {
  padding: 5px 20px;
  display: inline-block;
  cursor: pointer;
  color: #676767;
  border-radius: 25px;
  border: 1px solid #17b1a7;
  font-weight: 500;
  opacity: 0.5;
  font-size: 16px;
  width: 100%;
  text-align: center; }

.radio-button .blank-label {
  display: none; }

.radio-button input[type="radio"]:checked + label {
  color: #17b1a7;
  padding: 5px 20px;
  border-radius: 25px;
  border: 1px solid #17b1a7;
  background-color: #676767;
  font-weight: 500;
  opacity: 0.5;
  font-size: 16px; }

.radio-button input[type="radio"][disabled] + label {
  cursor: not-allowed; }

.text-height-5 {
  line-height: 3rem; }

.appointment-radio-group {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 50%; }
  .appointment-radio-group label {
    margin-bottom: 0px !important; }

span.ant-time-picker.timepicker-width {
  width: 220px; }

.radio_button_clear_label {
  margin-top: -5px;
  margin-left: 5px; }

.radio-button input[type="radio"][disabled] + label {
  background: #e7f0f4; }

.border {
  border: 2px solid rgba(0, 0, 0, 0.1) !important; }

.saveSize svg {
  width: 20px;
  height: 20px;
  color: #17b1a7; }

.table_new_medical {
  max-height: 450px;
  overflow: auto; }
  .table_new_medical .radio-button label {
    padding: 4px 16px;
    display: inline-block;
    cursor: pointer;
    color: #000;
    border-radius: 25px;
    border: 1px solid #1930d2;
    font-weight: 500;
    opacity: 0.6;
    font-size: 12px;
    width: 100%;
    text-align: center; }
  .table_new_medical .radio-button input[type="radio"]:checked + label {
    color: #fff;
    padding: 4px 16px;
    border-radius: 25px;
    border: 1px solid #1930d2;
    background-color: #1930d2;
    font-weight: 500;
    opacity: 0.6;
    font-size: 12px; }

.medical_button {
  background-color: #fff;
  box-shadow: 0px 2px 6px #eeeeee;
  border: 1px solid #1930d2;
  color: #1930d2; }

.new-login-layer {
  overflow: auto; }

.login-para-1 {
  width: 390px;
  height: 75px;
  flex-grow: 0;
  margin: 10px 0 15px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  padding-right: 2em; }

.login-btn {
  width: 8em;
  padding: 0 4.5em 2em 2em; }

.heading {
  width: 540px;
  height: 152px;
  margin: 0 0 25px;
  font-size: 56px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff; }

.login-para-2 {
  width: 534px;
  height: 132px;
  margin: 25px 6px 0 0;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff; }

.displaySpaceBetween {
  display: flex;
  justify-content: space-between; }

.Biller-Screen {
  width: 1440px;
  height: 84vh;
  background-color: #f9f9f9;
  overflow: hidden; }

.Biller {
  width: 72px;
  height: 35px;
  margin: 8px 322px 0 22px;
  font-family: Avenir;
  font-size: 30px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.DoctorDetailsCard {
  width: 340px;
  height: 90px;
  flex-grow: 0;
  padding: 10px 0 10px 8px;
  border-radius: 10px;
  border: solid 1px #d4dade;
  background-color: #fff; }

.DoctorImgOval {
  width: 60px;
  height: 60px;
  flex-grow: 0;
  border: solid 4px #6c3964;
  border-radius: 50%; }

.Billing-Station-Gro {
  width: 110px;
  height: 44px;
  font-family: Avenir;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000; }

.Billing-Station-Gro .text-style-1 {
  font-size: 18px;
  font-weight: 500; }

.PatientCardsDisplay {
  width: 340px;
  height: auto;
  margin: 8px 0 0;
  padding: 11.4px 14px 0px 10px;
  border-radius: 10px;
  background-color: #fff;
  border: solid 1px #d4dade; }

.PatientCardsDisplayScroll {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden; }
  .PatientCardsDisplayScroll::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5; }
  .PatientCardsDisplayScroll::-webkit-scrollbar {
    width: 5px;
    background-color: #f5f5f5; }
  .PatientCardsDisplayScroll::-webkit-scrollbar-thumb {
    background-color: #000000;
    border: 2px solid #555555; }

.PatientsTitle {
  width: 135px;
  height: 33px;
  margin: 0 20px 10px 0;
  font-family: Avenir;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1f1f39; }

.biller-search-icon-img {
  width: 50px;
  height: 32.2px;
  flex-grow: 0; }

.PatientCard {
  width: auto;
  height: 100px;
  margin: 2px 10px 0 -15px;
  border-radius: 5px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.patientIcon {
  width: 17.9px;
  height: 21.6px;
  flex-grow: 0;
  margin-left: 10px; }

.Patientname {
  width: 150px;
  height: 19px;
  margin: 1px 0 1.6px 5.6px;
  font-family: Avenir-Roman;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1f1f39; }

.time {
  width: 36px;
  height: 10px;
  margin: 0 9.9px 15px 32.5px;
  font-family: Avenir;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1f1f39;
  padding-left: 10px; }

.statusDiv {
  width: 60px;
  height: 30px;
  flex-grow: 0;
  margin: 0 10px;
  padding: 2px 0 7px 17px;
  border-radius: 3px;
  background-color: #6c3964; }

.status {
  width: 50px;
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  margin: 10px 20px; }

.uidIcon {
  width: 17.9px;
  height: 18px;
  flex-grow: 0;
  margin: 1.2px 5.6px 0 0; }

.PatientUid {
  width: 105px;
  height: 19px;
  font-family: Avenir-Roman;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1f1f39; }

.currentpatient {
  width: 1002px;
  height: 580px;
  margin: 0 22px 0 25px;
  padding: 20px 357px 387px 23px;
  border-radius: 10px;
  background-color: #fff; }

.Current-Patient-Title {
  height: 33px;
  margin: 0 108px 30px 0;
  font-family: Avenir;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.billerPatientDetails {
  width: 400px;
  height: 300px;
  margin: 26px 0 53px 1px;
  padding: 39px 31px 38px 16px;
  border-radius: 7px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.patientNameIcon {
  width: 50px;
  height: 50px;
  margin: 0 10px 0 0;
  padding: 13px 10px 12px 13px;
  border-radius: 6px;
  background-color: #6c3964; }

.patientNameIconImage {
  width: 25px;
  height: 25px;
  object-fit: contain; }

.patientNamedetails {
  width: 200px;
  height: 48px;
  margin: 2px 30px 0 0;
  font-family: Avenir;
  font-size: 18px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.patientNamedetails .text-style-1 {
  font-size: 16px;
  font-weight: normal; }

.patientGenderIcon {
  width: 50px;
  height: 50px;
  margin: 25px 10px 0 0;
  padding: 13px 13.3px 12px 13px;
  border-radius: 6px;
  background-color: #ff8b3e; }

.patientGenderIconImage {
  width: 23.8px;
  height: 25px;
  object-fit: contain; }

.patientGender {
  width: 60px;
  height: 48px;
  margin: 27px 165px 0 1px;
  font-family: Avenir;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.patientGender .text-style-1 {
  font-size: 18px;
  font-weight: 900; }

.patientageIcon {
  width: 50px;
  height: 50px;
  margin: 25px 10px 0 0;
  padding: 13px 13.5px 12px 13px;
  border-radius: 6px;
  background-color: #12539e; }

.patientageIconImage {
  width: 23.5px;
  height: 25px;
  object-fit: contain; }

.patientAge {
  width: 230px;
  height: 48px;
  margin: 26px 0 1px 1px;
  font-family: Avenir;
  font-size: 18px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.patientAge .text-style-1 {
  font-size: 16px;
  font-weight: normal; }

.uidcard {
  width: 270px;
  height: 86px;
  margin: 26px 0 14px 12px;
  padding: 18px 100px 17px 15px;
  border-radius: 7px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.uidcardIcon {
  width: 25px;
  height: 25px;
  margin: 11px 9px 12px 0;
  object-fit: contain; }

.PatientIcon {
  width: 30px;
  height: 30px;
  margin: 11px 4px 12px 0;
  object-fit: contain; }

.LineCopy {
  width: 1px;
  height: 40px;
  margin: 2px 0 7px;
  border: solid 1px #979797; }

.UID-no {
  width: 200px;
  margin: 0 0 0 9px;
  font-family: Avenir;
  font-size: 18px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.UID-no .text-style-1 {
  font-size: 16px;
  font-weight: normal; }

.tokenCard {
  width: 270px;
  height: 86px;
  margin: 20px 0 20px 12px;
  padding: 18px 100px 17px 15px;
  border-radius: 7px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.tokenCardIcon {
  width: 25px;
  height: 25px;
  margin: 12px 10px 11px 0;
  padding: 0.6px 0.6px 0.6px 0.6px; }

.Token-No {
  width: 100px;
  height: 48px;
  margin: 0 0 0 9px;
  font-family: Avenir;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.Token-No .text-style-1 {
  font-size: 18px;
  font-weight: 900; }

.serviceCard {
  width: 270px;
  height: 86px;
  margin: 14px 0 53px 12px;
  padding: 18px 100px 17px 15px;
  border-radius: 7px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.serviceCardimg {
  width: 24.4px;
  height: 25px;
  margin: 11px 9.6px 12px 0;
  object-fit: contain; }

.Service-Name-Billing {
  width: 200px;
  margin: 0 0 0 9px;
  font-family: Avenir;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.Service-Name-Billing .text-style-1 {
  font-size: 18px;
  font-weight: 900; }

.Chekoutandnext {
  width: 186px;
  height: 46px;
  margin: 0 20px 0 18px;
  padding: 11px 20px 10px;
  border-radius: 4px;
  background-color: #6c3964;
  font-family: Avenir;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff; }

.CheckOut {
  width: 146px;
  height: 25px;
  font-family: Avenir;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff; }

.Skipandnext {
  width: 140px;
  height: 46px;
  margin: 0 0 0 20px;
  padding: 11px 21px 10px;
  border-radius: 4px;
  border: solid 1px #6c3964;
  font-family: Avenir;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #6c3964; }

.Skip {
  width: 98px;
  height: 25px;
  font-family: Avenir;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #6c3964; }

.StartTG {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center; }

.TGStartBtn {
  width: 300px; }

.-Operator-View-OPD-or-Radiology {
  width: auto;
  height: 100vh;
  flex-grow: 0;
  padding: 5px 0 0;
  background-color: #f9f9f9; }

.Operator {
  width: 131px;
  height: 41px;
  margin: 33px 223px 29px 22px;
  font-family: Avenir;
  font-size: 30px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.OperatorName {
  width: 129px;
  height: 25px;
  margin: 0 0 1.9px;
  font-family: Avenir;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000; }

.OperatorType {
  width: 77px;
  height: 19px;
  margin: 1.9px 52px 0 0;
  font-family: Avenir;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000; }

.operatorRoom {
  width: 100px;
  height: 19px;
  margin: 11.2px 0.2px 0 4px;
  font-family: Avenir-Roman;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  white-space: normal; }

.operatorSearchicon {
  padding-left: 18px;
  margin-left: -20px; }

.-Token-Generator {
  width: auto;
  height: 60vh;
  background-color: #f9f9f9;
  margin: 6px 0 0.4px 0; }

.Token-Generator {
  width: 500px;
  height: 41px;
  margin: 33px 100px 25px 22px;
  font-family: Avenir;
  font-size: 30px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.tokenGenerationDiv {
  width: auto;
  border: solid 1px #d4dade;
  border-radius: 10px;
  background-color: #fff; }

.Token-Generation {
  height: 33px;
  margin: 0 108px 30px 0;
  font-family: Avenir;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.Token-Type {
  width: 136px;
  height: 19px;
  margin: 0 60px 10px 0;
  font-family: Avenir;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.tokenRadioGroup {
  width: 300px;
  height: 24px;
  margin: 10px 0 0;
  font-size: 20px; }

.Enter-Phone-No {
  width: 250px;
  height: 19px;
  margin: 50px 111px 10px 0;
  font-family: Avenir;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.Rectangle-Copy-10 {
  width: 250px;
  height: 40px;
  border-radius: 5px;
  background-color: #6c3964;
  color: white; }

.Rectangle-Copy-11 {
  width: 121px;
  height: 46px;
  flex-grow: 0;
  margin: 0 0 0 20px;
  padding: 12px 34px 12px 35px;
  border-radius: 5px;
  border: solid 1px #6c3964;
  color: #6c3964; }

.tPatientname {
  font-family: Avenir-Roman;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1f1f39;
  display: flex; }

.tstatus {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  margin: 10px 20px;
  border-radius: 3px;
  background-color: #6c3964;
  padding: 6px 18px 3px 18px; }

.buttonVitals {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  margin: 0px 20px;
  border-radius: 3px;
  background-color: #6c3964;
  padding: 6px 18px 3px 18px; }

.navBar {
  width: auto;
  height: 70px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
  background-color: #fff; }

.hospitalicon {
  margin: 5px 20px;
  flex-grow: 0; }

.multiple-unit:where(.css-dev-only-do-not-override-1okl62o).ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
  border: 1px solid #d9d9d9;
  color: white !important;
  background-color: #8c2ba4;
  font-size: 16px !important; }

.multiple-unit.ant-select .ant-select-selection-item {
  color: white;
  padding-right: 24px !important; }

.custom-input {
  color: white !important; }

.custom-input .ant-input-affix-wrapper-focused {
  background-color: #12539e !important; }

.custom-input:-webkit-autofill,
.custom-input:-webkit-autofill:hover,
.custom-input:-webkit-autofill:focus,
.custom-input:-webkit-autofill:active {
  background-color: lightgray !important;
  color: white !important;
  border: solid 1px #66b1d0 !important;
  box-shadow: 0 0 0 1000px lightgray inset !important; }

.custom-input input::placeholder {
  color: white !important;
  /* Change this to your desired placeholder color */
  opacity: 1;
  /* Ensure the color is not transparent */ }

.ant-picker-clear {
  display: none !important; }

.ant-picker-suffix {
  display: flex;
  align-items: center;
  justify-content: center; }

/* Prevent hover effect from replacing the suffix icon with the clear icon */
.ant-picker-input:hover .ant-picker-suffix {
  display: flex !important;
  visibility: visible;
  opacity: 1; }

.vitals-header .ant-modal-header {
  padding: 0%;
  margin: 0%;
  background-color: #f4f4f4; }

.someting {
  color: #cfd3d5; }

.multiple-unit .ant-select-arrow {
  background-color: #8c2ba4; }

.navDivider {
  width: 1px;
  height: 40px;
  margin: 15px 35px 0 6px;
  border: solid 1px #6c3964; }

.dashboardIcon {
  width: 24px;
  height: 24px; }

.DashboardSpan {
  width: 70px;
  height: 22px;
  margin: 1px 0 1px 10px;
  font-family: Avenir-Roman;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #6c3964; }

.tokenGeneratorIcon {
  width: 24px;
  height: 24px;
  flex-grow: 0;
  padding: 0.6px 0.6px 0.6px 0.6px; }

.Token-GeneratorSpan {
  width: 121px; }

.billerIcon {
  width: 18.7px;
  height: 24px;
  flex-grow: 0;
  padding: 1.1px 1.1px 1.2px 1.1px; }

.BillerSpan {
  width: 37px;
  margin: 1px 0 1px 4px; }

.OperatorSpan {
  width: 67px;
  margin: 1px 0 1px 10.6px; }

.DoctorSpan {
  width: 50px;
  margin: 1px 0 1px 11.1px; }

.reportsIcon {
  width: 24px;
  height: 24px;
  flex-grow: 0;
  padding: 2.6px 2.6px 0 0; }

.ReportsSpan {
  width: 57px;
  margin: 1px 0 1px 4px; }

.technician {
  width: auto;
  height: 100vh;
  flex-grow: 0;
  padding: 10px 0 10px 20px;
  background-color: #f9f9f9; }

.TechnicianCard {
  width: 340px;
  height: 90px;
  flex-grow: 0;
  padding: 10px 20px 10px 10px;
  border-radius: 10px;
  border: solid 1px #d4dade;
  background-color: #fff; }

.TechnicianCardsDisplay {
  width: 340px;
  height: 71%;
  margin: 8px 0 0;
  padding: 11.4px 14px 0 10px;
  border-radius: 10px;
  background-color: #fff;
  border: solid 1px #d4dade; }

.TechnicianPatientCard {
  width: 300px;
  height: 100px;
  margin: 2px 10px 0 0;
  border-radius: 5px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.doctorNurseScreen {
  width: auto;
  background-color: #f9f9f9;
  margin: 6px 0 0.4px 0; }

.DNuidcard {
  width: 270px;
  height: 92px;
  padding: 18px 100px 17px 15px;
  border-radius: 7px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.DNtokenCard {
  width: 270px;
  height: 92px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 18px 100px 17px 15px;
  border-radius: 7px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.DNserviceCard {
  width: 270px;
  height: 92px;
  padding: 18px 100px 17px 15px;
  border-radius: 7px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.doctorcurrentpatient {
  width: auto;
  border-radius: 10px;
  background-color: #fff; }

.PatientDetails {
  width: 400px;
  padding: 39px 50px 38px 16px;
  border-radius: 7px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.patient {
  width: 281px;
  height: 83px;
  margin: 0 0 13px;
  padding: 18px 126px 17px 25px;
  border-radius: 7px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.qConfigScroll {
  height: 85vh;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f9f9f9; }
  .qConfigScroll::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5; }
  .qConfigScroll::-webkit-scrollbar {
    width: 5px;
    background-color: #f5f5f5; }
  .qConfigScroll::-webkit-scrollbar-thumb {
    background-color: #000000;
    border: 2px solid #555555; }

.addQueue {
  padding-bottom: 150px; }

.DashboardView {
  height: 90vh;
  width: auto;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f9f9f9;
  padding: 0 10px 0 20px; }

.titles {
  height: 33px;
  font-family: Avenir;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f; }

.dashboard {
  width: 629px;
  height: 380px;
  flex-grow: 0;
  border-radius: 10px;
  border: solid 3px rgba(204, 203, 203, 0.16);
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08); }

.dashboardPatientDetails {
  margin: 20px 28px 0 22px;
  padding: 24px 31px 25px 27px; }

.cpdTitle {
  width: 249px;
  margin: 0 0 0 10px; }

.dashboardOpd {
  margin: 20px 22px 0 0px;
  padding: 24px 31px 25px 28px; }

.opdTitle {
  width: 269.4px;
  margin: 0 319.6px 25.8px 10px; }

.dashboardRadiology {
  margin: 20px 28px 150px 22px;
  padding: 24px 32px 28.2px 27px; }

.radiologyTitle {
  width: 109px;
  margin: 0 300px 25px 10px; }

.patientImg {
  width: 25px;
  height: 30px;
  margin: 5px 0 10px;
  object-fit: contain; }

.dashboardCard {
  width: 140px;
  height: 83px;
  margin: 10px 11.2px 0 0;
  padding: 7px 74.8px 12px 20px;
  border-radius: 7px;
  border: solid 1px rgba(151, 151, 151, 0.15);
  background-color: #f5fafe; }

.dashboardCardDetails {
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #09050f;
  cursor: pointer; }

.count {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 900; }

.detail {
  width: 200px;
  padding: 8px 0 0;
  font-family: Avenir-Roman;
  font-size: 15px;
  font-weight: normal; }

.tvScreen1 {
  height: 95vh;
  width: 105%;
  margin: 10px 2px 10px 20px; }

.doctorsDetailsDiv {
  margin: 0 10px 0 0;
  padding: 55px 30px 50px;
  background-color: #6c3964;
  font-family: Avenir;
  font-size: 30px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  text-align: center; }

.qdoctorImg {
  width: 150px;
  height: 150px;
  margin: 30px 130px 10px; }

.qdoctorImg1 {
  min-width: 200px;
  min-height: 190px;
  max-width: 200px;
  max-height: 190px;
  margin: 10px 100px;
  border-radius: 60%;
  background-color: #6c3964; }

.qdoctorName {
  margin: 14px 0;
  display: flex;
  justify-content: center; }

.qdoctorProf {
  display: flex;
  justify-content: center;
  margin: 20px 0; }

.qdoctorExp {
  display: flex;
  justify-content: center;
  margin: 15px 0;
  letter-spacing: 1.5px; }

.qroom_status {
  display: flex;
  justify-content: space-around;
  margin: 20px 0 50px; }

.qdoctorRoom {
  font-weight: 500;
  letter-spacing: 1.5px; }

.qdoctor-text-style-1 {
  font-weight: 900; }

.qdoctorStatus {
  font-weight: 500;
  letter-spacing: 1.5px; }

.qdocTimings {
  display: flex;
  justify-content: space-between; }

.qdoctorTimings {
  margin: 10px 0;
  letter-spacing: 1.5px;
  margin: 10px 0;
  display: flex;
  justify-content: center; }

.qdoctorTime {
  height: 41px;
  font-family: Avenir;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.13px;
  color: #fff; }

.patientQHeader {
  width: auto;
  height: 10%;
  padding: 10px 0;
  background-color: #6c3964;
  display: flex;
  flex-direction: row; }

.patientQDetails {
  width: auto;
  height: 85.5vh;
  border: solid 1px #979797;
  background-color: #f2f2f2; }

.patientQHeaderTitles {
  font-family: Avenir;
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.8px;
  text-align: center;
  color: #fff; }

.docTitle {
  display: flex;
  justify-content: left;
  margin-left: 10px; }

.TVDoctor {
  margin-left: 25px; }

.Line {
  width: auto;
  height: 1px;
  margin: 10px 0;
  border: solid 1px #979797; }

.qdoctorFonts {
  font-family: Avenir;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000; }

.qdoctor {
  font-size: 25px; }

.qdoctorProfq {
  font-size: 14px; }

.tvScreen2 {
  height: 95vh;
  width: auto;
  margin: 0 80px 100px 0;
  display: flex;
  flex-direction: row; }

.screenColumn {
  margin: 10px 15px 0 10px;
  padding: 0;
  border: solid 1px #979797; }

.screen2doctorsDetailsDiv {
  width: 100%;
  height: 50%;
  margin: auto;
  padding: 10px 30px 0 25px;
  background-color: #6c3964;
  font-family: Avenir;
  font-size: 30px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  text-align: center; }

.qroomstatus2 {
  display: flex;
  justify-content: space-between; }

.screen2qdoctorRoom {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.5px;
  color: #fff; }

.screen2qdoctorStatus {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.5px;
  text-align: left;
  color: #fff; }

.screen2qdoctorImgDiv {
  display: flex;
  justify-content: center; }

.screen2qdoctorImg {
  width: 80px;
  height: 80px; }

.screen2qdoctorname {
  font-family: Avenir;
  font-size: 30px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  display: flex;
  justify-content: center;
  margin: 10px 0; }

.DividerLine {
  width: auto;
  height: 1px;
  border: solid 1px #979797; }

.rowDetails {
  display: flex;
  flex-direction: column;
  margin: 0 30px 10px; }

.CurrentNextQ {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  margin: 25px 0 10px; }

.CNQPatientDetails {
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000; }

.tvScreen3 {
  height: 100vh;
  margin: 5px 10px 100px; }

.patientQHeader3 {
  width: auto;
  height: 8vh;
  background-color: #6c3964;
  padding: 10px 0;
  display: flex;
  flex-direction: row; }

.TVDoctor3 {
  margin-left: 30px; }

.TVRoom3val {
  color: #000 !important;
  display: flex;
  align-items: center;
  margin-left: 40px; }

.TVCurrent3val {
  color: #000 !important;
  display: flex;
  align-items: center; }

.TVNext3val {
  color: #000 !important;
  display: flex;
  align-items: center; }

.patientQDetails3 {
  width: auto;
  height: 90vh;
  padding: 0 0 43.5px;
  border: solid 1px #979797;
  background-color: #f2f2f2; }

.patientQDetailsdiv3 {
  display: flex;
  flex-direction: row; }

.Line3 {
  width: auto;
  height: 1px;
  margin: 10px 0;
  border: solid 1px #979797; }

.qdoctorImg3 {
  width: 70px;
  height: 70px;
  margin: 10px 10px 15px 30px;
  border: solid 2px #6c3964;
  border-radius: 40px; }

.patientQHeaderTitles3 {
  font-family: Avenir;
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.8px;
  color: #fff;
  display: flex; }

.qDoc3 {
  display: flex;
  flex-direction: column;
  margin: 15px 0; }

.qDocDetails3 {
  display: flex;
  flex-direction: row; }

.pointer {
  display: list-item;
  cursor: pointer; }

.vitals {
  width: 50px;
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  margin: 7px 12px; }

.custom-container {
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
  margin-top: 10px; }

.hide_department {
  display: none; }

@media only screen and (min-width: 1900px) {
  .doctorsDetailsDiv {
    padding: 300px 30px 300px; } }

ul.slider.animated {
  transition-duration: 10ms !important; }

@keyframes fadeIn {
  0% {
    opacity: 0.3; }
  25% {
    opacity: 0.5; }
  50% {
    opacity: 0.7; }
  75% {
    opacity: 0.9; }
  100% {
    opacity: 1; } }

.slide.selected {
  animation: fadeIn ease 1.5s;
  -webkit-animation: fadeIn ease 1s;
  -moz-animation: fadeIn ease 1s;
  -o-animation: fadeIn ease 1s;
  -ms-animation: fadeIn ease 1s; }

.ant-carousel .slick-slide img {
  display: inline;
  display: initial; }

body {
  overflow: auto; }

.bg-thistle {
  background: #34e2a199 !important; }

.bg-bluish-grey {
  background: #007bff6b !important; }

.bg-grey {
  background: #f2f2f2 !important; }

.review {
  font-size: 20px; }

.blink_tvscreen {
  animation: tvblinker 1s step-start infinite; }

@keyframes tvblinker {
  50% {
    opacity: 0.5; } }

.nodoctortvscreen {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100vh; }
  .nodoctortvscreen .message {
    margin: -40% 0 0 0;
    border-radius: 10px;
    color: #6c3964;
    opacity: 0.8;
    font-size: 50px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center; }
  .nodoctortvscreen .tv-bg {
    align-items: center; }

.ant-tabs-nav .ant-tabs-tab-active {
  color: white;
  font-weight: 500;
  border-radius: 4px;
  border: solid 1px #6c3964 !important;
  background: #8c2ba4; }

:where(.css-dev-only-do-not-override-1okl62o).ant-input-affix-wrapper .ant-input-prefix {
  margin-inline-end: 4px;
  padding-left: 5px; }

:where(.css-dev-only-do-not-override-1okl62o).ant-input-affix-wrapper .ant-input-suffix {
  margin-inline-start: 4px;
  padding-right: 5px; }

.ant-tabs-nav .ant-tabs-tab {
  border-radius: 4px;
  border: solid 1px #6c3964;
  text-align: justify !important;
  background: white;
  width: 100px !important; }

.doctorViewTabs .ant-tabs-nav .ant-tabs-tab {
  border-radius: 4px;
  border: solid 1px #6c3964;
  text-align: justify !important;
  background: white;
  width: 90px !important; }

:where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-btn:focus:not(:focus-visible), :where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-remove:focus:not(:focus-visible), :where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-btn:active, :where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-remove:active {
  color: white; }

.ant-tabs-tab-active {
  background: #8c2ba4 !important; }

.ant-tabs-tab {
  margin-left: 0px !important;
  margin-right: 2px !important;
  border-bottom: none !important; }

.custom-btn {
  background-color: #8c2ba4;
  color: white;
  font-size: 40px;
  padding: 10px 2px;
  max-width: 30%;
  margin-bottom: 10px; }

.custom-btn:hover {
  color: lightgray; }

.doctorBreakText {
  color: #FFF0AB; }

.edit_size.ant-btn.ant-btn-icon-only .anticon {
  font-size: 20px; }

.patients .ant-tabs-nav .ant-tabs-tab {
  margin-right: 2px;
  padding: 10px 38.3px !important;
  max-width: -webkit-fit-content !important;
  max-width: -moz-fit-content !important;
  max-width: fit-content !important;
  width: -webkit-fit-content !important;
  width: -moz-fit-content !important;
  width: fit-content !important; }

.ant-input-group-wrapper {
  border-radius: 7px !important;
  border: none !important;
  box-shadow: 0px 1px 8px #717272 !important; }

.ant-input-affix-wrapper-focused {
  border-color: #fff !important; }

.ant-input-search .ant-input:focus .ant-btn-default {
  border-color: #fff !important; }

.ant-select-selector {
  min-height: 32px !important; }

.ant-tabs-nav {
  width: 97%; }

.ant-tabs-nav .ant-tabs-tab {
  margin-right: 2px; }

.ant-tabs-nav-scroll {
  display: flex;
  justify-content: center; }

.ant-tabs-nav .ant-tabs-tab-active:hover {
  color: white !important; }

.ant-tabs-nav .ant-tabs-tab:hover {
  color: #000;
  color: initial; }

.ant-tabs-ink-bar {
  background-color: transparent; }

.que-completed-patients {
  background-color: #f9f9f9; }

.reports-details td:first-child, .reports-details td:first-child + td {
  border-right: solid 1px #ae8ca6; }

.tv-row td {
  border-bottom: 1px solid #ae8ca6; }

.ant-modal-footer div {
  text-align: center; }

.ant-modal-footer .ant-btn-primary {
  background-color: #8c2ba4;
  border-color: #8c2ba4; }

.profile_pic svg {
  font-size: 20px; }

.doctor_profile_pic {
  min-width: 60px;
  min-height: 41px;
  max-width: 40px;
  max-height: 27px;
  background-color: #6c3964; }

.doctor_list {
  display: flex;
  flex-direction: row; }

.delete_profile svg {
  font-size: 20px;
  color: red; }

.view_doctor_pic svg {
  font-size: 40px; }

.profile_green svg {
  color: green; }

.edit_doctor_profile_pic {
  min-width: 100px;
  min-height: 100px;
  max-width: 100px;
  max-height: 100px;
  background-color: #6c3964; }

span.anticon.anticon-calendar {
  padding-left: 6px;
  padding-bottom: 6px; }
`, "",{"version":3,"sources":["webpack://./node_modules/bootstrap/scss/bootstrap.scss","webpack://./src/index.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_functions.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./src/StyleSheets/_index.scss","webpack://./src/StyleSheets/Components/_navigation.scss","webpack://./src/StyleSheets/Constants/_variables.scss","webpack://./src/StyleSheets/Components/_footer.scss","webpack://./src/StyleSheets/Components/_breadCrums.scss","webpack://./src/StyleSheets/Pages/_CustomPage.scss","webpack://./src/StyleSheets/Pages/_queue.scss","webpack://./src/StyleSheets/Pages/_appointement.scss"],"names":[],"mappings":"AAAA;;;;;ECME;ACNF;EAGI,eAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,eAAc;EAAd,cAAc;EAAd,iBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,eAAc;EAAd,oBAAc;EAId,kBAAc;EAAd,oBAAc;EAAd,kBAAc;EAAd,eAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,eAAc;EAId,kBAAiC;EAAjC,sBAAiC;EAAjC,sBAAiC;EAAjC,sBAAiC;EAAjC,uBAAiC;EAKnC,kOAAyB;EACzB,6GAAwB,EAAA;;ACC1B;;;EAGE,sBAAsB,EAAA;;AAGxB;EACE,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,6CCXa,EAAA;;ADiBf;EACE,cAAc,EAAA;;AAUhB;EACE,SAAS;EACT,qNCsOoO;ECjGhO,eAAW;EFnIf,gBC+O+B;ED9O/B,gBCmP+B;EDlP/B,cCnCgB;EDoChB,gBAAgB;EAChB,sBC9Ca,EAAA;;AHsDf;EEKE,qBAAqB,EAAA;;AASvB;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB,EAAA;;AAanB;EACE,aAAa;EACb,qBCiNwC,EAAA;;AD1M1C;EACE,aAAa;EACb,mBCoF8B,EAAA;;ADzEhC;;EAEE,0BAA0B;EAC1B,yCAAiC;UAAjC,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,sCAA8B;UAA9B,8BAA8B,EAAA;;AAGhC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAA;;AAGtB;;;EAGE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;;;;EAIE,gBAAgB,EAAA;;AAGlB;EACE,gBCkJ+B,EAAA;;AD/IjC;EACE,oBAAoB;EACpB,cAAc,EAAA;;AAGhB;EACE,gBAAgB,EAAA;;AAGlB;;EAEE,mBCqIkC,EAAA;;ADlIpC;EEII,cAAW,EAAA;;AFKf;;EAEE,kBAAkB;EEPhB,cAAW;EFSb,cAAc;EACd,wBAAwB,EAAA;;AAG1B;EAAM,cAAc,EAAA;;AACpB;EAAM,UAAU,EAAA;;AAOhB;EACE,cCvJe;EDwJf,qBCX4C;EDY5C,6BAA6B,EAAA;EGhL7B;IHmLE,cCd8D;IDe9D,0BCd+C,EAAA;;ADuBnD;EACE,cAAc;EACd,qBAAqB,EAAA;EG/LrB;IHkME,cAAc;IACd,qBAAqB,EAAA;;AASzB;;;;EAIE,iGC0DgH;EClH9G,cAAW,EAAA;;AF4Df;EAEE,aAAa;EAEb,mBAAmB;EAEnB,cAAc;EAGd,6BAA6B,EAAA;;AAQ/B;EAEE,gBAAgB,EAAA;;AAQlB;EACE,sBAAsB;EACtB,kBAAkB,EAAA;;AAGpB;EAGE,gBAAgB;EAChB,sBAAsB,EAAA;;AAQxB;EACE,yBAAyB,EAAA;;AAG3B;EACE,oBC8EkC;ED7ElC,uBC6EkC;ED5ElC,cCtQgB;EDuQhB,gBAAgB;EAChB,oBAAoB,EAAA;;AAOtB;EAEE,mBAAmB;EACnB,gCAAgC,EAAA;;AAQlC;EAEE,qBAAqB;EACrB,qBC4J2C,EAAA;;ADtJ7C;EAEE,gBAAgB,EAAA;;AAQlB;EACE,UAAU,EAAA;;AAGZ;;;;;EAKE,SAAS;EACT,oBAAoB;EEhKlB,kBAAW;EFkKb,oBAAoB,EAAA;;AAGtB;;EAEE,iBAAiB,EAAA;;AAGnB;;EAEE,oBAAoB,EAAA;;AF3HtB;EEkIE,eAAe,EAAA;;AAMjB;EACE,iBAAiB,EAAA;;AAOnB;;;;EAIE,0BAA0B,EAAA;;AAK1B;;;;EAKI,eAAe,EAAA;;AAMrB;;;;EAIE,UAAU;EACV,kBAAkB,EAAA;;AAGpB;;EAEE,sBAAsB;EACtB,UAAU,EAAA;;AAIZ;EACE,cAAc;EAEd,gBAAgB,EAAA;;AAGlB;EAME,YAAY;EAEZ,UAAU;EACV,SAAS;EACT,SAAS,EAAA;;AAKX;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,UAAU;EACV,oBAAoB;EE9OhB,iBAAW;EFgPf,oBAAoB;EACpB,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB,EAAA;;AF/J1B;;EEqKE,YAAY,EAAA;;AFjKd;EEyKE,oBAAoB;EACpB,wBAAwB,EAAA;;AFtK1B;EE8KE,wBAAwB,EAAA;;AAQ1B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAO5B;EACE,qBAAqB,EAAA;;AAGvB;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,aAAa,EAAA;;AFxLf;EE8LE,wBAAwB,EAAA;;AI5d1B;;EAEE,qBHsSwC;EGpSxC,gBHsS+B;EGrS/B,gBHsS+B,EAAA;;AGlSjC;EFqKM,iBAAW,EAAA;;AEpKjB;EFoKM,eAAW,EAAA;;AEnKjB;EFmKM,kBAAW,EAAA;;AElKjB;EFkKM,iBAAW,EAAA;;AEjKjB;EFiKM,kBAAW,EAAA;;AEhKjB;EFgKM,eAAW,EAAA;;AE9JjB;EF8JM,kBAAW;EE5Jf,gBHwS+B,EAAA;;AGpSjC;EFwJM,eAAW;EEtJf,gBH2R+B;EG1R/B,gBHkR+B,EAAA;;AGhRjC;EFmJM,iBAAW;EEjJf,gBHuR+B;EGtR/B,gBH6Q+B,EAAA;;AG3QjC;EF8IM,iBAAW;EE5If,gBHmR+B;EGlR/B,gBHwQ+B,EAAA;;AGtQjC;EFyIM,iBAAW;EEvIf,gBH+Q+B;EG9Q/B,gBHmQ+B,EAAA;;ADtOjC;EIpBE,gBHgFW;EG/EX,mBH+EW;EG9EX,SAAS;EACT,wCHzCa,EAAA;;AGiDf;;EFkGI,kBAAW;EE/Fb,gBH2N+B,EAAA;;AGxNjC;;EAEE,cHmQgC;EGlQhC,yBH2QmC,EAAA;;AGnQrC;EC/EE,eAAe;EACf,gBAAgB,EAAA;;ADmFlB;ECpFE,eAAe;EACf,gBAAgB,EAAA;;ADsFlB;EACE,qBAAqB,EAAA;EADvB;IAII,oBHqP+B,EAAA;;AG3OnC;EF2DI,cAAW;EEzDb,yBAAyB,EAAA;;AAI3B;EACE,mBHuBW;EC6CP,kBAAW,EAAA;;AEhEjB;EACE,cAAc;EF+CZ,kBAAW;EE7Cb,cH1GgB,EAAA;EGuGlB;IAMI,qBAAqB,EAAA;;AEnHzB;ECIE,eAAe;EAGf,YAAY,EAAA;;ADDd;EACE,gBLqgCwC;EKpgCxC,sBLRa;EKSb,yBLNgB;EOQd,sBP6NgC;EMpOlC,eAAe;EAGf,YAAY,EAAA;;ADcd;EAEE,qBAAqB,EAAA;;AAGvB;EACE,qBAA2B;EAC3B,cAAc,EAAA;;AAGhB;EJ8HI,cAAW;EI5Hb,cL3BgB,EAAA;;AQZlB;EPmKI,gBAAW;EOjKb,cRmCe;EQlCf,qBAAqB,EAAA;EAGrB;IACE,cAAc,EAAA;;AAKlB;EACE,sBR0lCuC;ECp8BrC,gBAAW;EOpJb,WRTa;EQUb,yBRDgB;EOEd,qBP+N+B,EAAA;EQpOnC;IASI,UAAU;IP8IV,eAAW;IO5IX,gBRyQ6B,EAAA;;ADjEjC;ESjME,cAAc;EPqIZ,gBAAW;EOnIb,cRjBgB,EAAA;EQclB;IPsII,kBAAW;IO9HX,cAAc;IACd,kBAAkB,EAAA;;AAKtB;EACE,iBRikCuC;EQhkCvC,kBAAkB,EAAA;;ACxClB;;;;;;ECDA,WAAW;EACX,mBAA2B;EAC3B,kBAA0B;EAC1B,kBAAkB;EAClB,iBAAiB,EAAA;;ACmDf;EFzCE;IACE,gBT+LG,EAAA,ES9LJ;;AEuCH;EFzCE;IACE,gBTgMG,EAAA,ES/LJ;;AEuCH;EFzCE;IACE,gBTiMG,EAAA,EShMJ;;AEuCH;EFzCE;IACE,iBTkMI,EAAA,ESjML;;AA2BL;ECnCA,aAAa;EACb,eAAe;EACf,mBAA2B;EAC3B,kBAA0B,EAAA;;ADsC1B;EACE,eAAe;EACf,cAAc,EAAA;EAFhB;;IAMI,gBAAgB;IAChB,eAAe,EAAA;;AGtDnB;;;;;;EACE,kBAAkB;EAClB,WAAW;EACX,mBAA2B;EAC3B,kBAA0B,EAAA;;AAsBxB;EACE,aAAa;EACb,YAAY;EACZ,eAAe,EAAA;;AAKb;EFwBN,cTuBqD;EStBrD,eTsBqD,EAAA;;AW/C/C;EFwBN,aTuBqD;EStBrD,cTsBqD,EAAA;;AW/C/C;EFwBN,mBTuBqD;EStBrD,oBTsBqD,EAAA;;AW/C/C;EFwBN,aTuBqD;EStBrD,cTsBqD,EAAA;;AW/C/C;EFwBN,aTuBqD;EStBrD,cTsBqD,EAAA;;AW/C/C;EFwBN,mBTuBqD;EStBrD,oBTsBqD,EAAA;;AWzCnD;EFCJ,cAAc;EACd,WAAW;EACX,eAAe,EAAA;;AEGP;EFbR,kBAA6C;EAI7C,mBAA8C,EAAA;;AEStC;EFbR,mBAA6C;EAI7C,oBAA8C,EAAA;;AEStC;EFbR,aAA6C;EAI7C,cAA8C,EAAA;;AEStC;EFbR,mBAA6C;EAI7C,oBAA8C,EAAA;;AEStC;EFbR,mBAA6C;EAI7C,oBAA8C,EAAA;;AEStC;EFbR,aAA6C;EAI7C,cAA8C,EAAA;;AEStC;EFbR,mBAA6C;EAI7C,oBAA8C,EAAA;;AEStC;EFbR,mBAA6C;EAI7C,oBAA8C,EAAA;;AEStC;EFbR,aAA6C;EAI7C,cAA8C,EAAA;;AEStC;EFbR,mBAA6C;EAI7C,oBAA8C,EAAA;;AEStC;EFbR,mBAA6C;EAI7C,oBAA8C,EAAA;;AEStC;EFbR,cAA6C;EAI7C,eAA8C,EAAA;;AEe1C;EAAwB,SAAS,EAAA;;AAEjC;EAAuB,SZmKG,EAAA;;AYhKxB;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,QADZ,EAAA;;AACZ;EAAwB,SADZ,EAAA;;AACZ;EAAwB,SADZ,EAAA;;AACZ;EAAwB,SADZ,EAAA;;AAQR;EFhBV,qBAA8C,EAAA;;AEgBpC;EFhBV,sBAA8C,EAAA;;AEgBpC;EFhBV,gBAA8C,EAAA;;AEgBpC;EFhBV,sBAA8C,EAAA;;AEgBpC;EFhBV,sBAA8C,EAAA;;AEgBpC;EFhBV,gBAA8C,EAAA;;AEgBpC;EFhBV,sBAA8C,EAAA;;AEgBpC;EFhBV,sBAA8C,EAAA;;AEgBpC;EFhBV,gBAA8C,EAAA;;AEgBpC;EFhBV,sBAA8C,EAAA;;AEgBpC;EFhBV,sBAA8C,EAAA;;ACK5C;EC3BE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAA;EAKb;IFwBN,cTuBqD;IStBrD,eTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,mBTuBqD;IStBrD,oBTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,mBTuBqD;IStBrD,oBTsBqD,EAAA;EWzCnD;IFCJ,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EEGP;IFbR,kBAA6C;IAI7C,mBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,cAA6C;IAI7C,eAA8C,EAAA;EEe1C;IAAwB,SAAS,EAAA;EAEjC;IAAuB,SZmKG,EAAA;EYhKxB;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EAQR;IFhBV,cAA4B,EAAA;EEgBlB;IFhBV,qBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA,EEkBnC;;ADbT;EC3BE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAA;EAKb;IFwBN,cTuBqD;IStBrD,eTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,mBTuBqD;IStBrD,oBTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,mBTuBqD;IStBrD,oBTsBqD,EAAA;EWzCnD;IFCJ,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EEGP;IFbR,kBAA6C;IAI7C,mBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,cAA6C;IAI7C,eAA8C,EAAA;EEe1C;IAAwB,SAAS,EAAA;EAEjC;IAAuB,SZmKG,EAAA;EYhKxB;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EAQR;IFhBV,cAA4B,EAAA;EEgBlB;IFhBV,qBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA,EEkBnC;;ADbT;EC3BE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAA;EAKb;IFwBN,cTuBqD;IStBrD,eTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,mBTuBqD;IStBrD,oBTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,mBTuBqD;IStBrD,oBTsBqD,EAAA;EWzCnD;IFCJ,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EEGP;IFbR,kBAA6C;IAI7C,mBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,cAA6C;IAI7C,eAA8C,EAAA;EEe1C;IAAwB,SAAS,EAAA;EAEjC;IAAuB,SZmKG,EAAA;EYhKxB;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EAQR;IFhBV,cAA4B,EAAA;EEgBlB;IFhBV,qBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA,EEkBnC;;ADbT;EC3BE;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAA;EAKb;IFwBN,cTuBqD;IStBrD,eTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,mBTuBqD;IStBrD,oBTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,aTuBqD;IStBrD,cTsBqD,EAAA;EW/C/C;IFwBN,mBTuBqD;IStBrD,oBTsBqD,EAAA;EWzCnD;IFCJ,cAAc;IACd,WAAW;IACX,eAAe,EAAA;EEGP;IFbR,kBAA6C;IAI7C,mBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,aAA6C;IAI7C,cAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,mBAA6C;IAI7C,oBAA8C,EAAA;EEStC;IFbR,cAA6C;IAI7C,eAA8C,EAAA;EEe1C;IAAwB,SAAS,EAAA;EAEjC;IAAuB,SZmKG,EAAA;EYhKxB;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,QADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EACZ;IAAwB,SADZ,EAAA;EAQR;IFhBV,cAA4B,EAAA;EEgBlB;IFhBV,qBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,gBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA;EEgBpC;IFhBV,sBAA8C,EAAA,EEkBnC;;ACrEb;EACE,WAAW;EACX,mBbiIW;EahIX,cbSgB,EAAA;EaZlB;;IAQI,gBbmVgC;IalVhC,mBAAmB;IACnB,6BbJc,EAAA;EaNlB;IAcI,sBAAsB;IACtB,gCbTc,EAAA;EaNlB;IAmBI,6Bbbc,EAAA;;AasBlB;;EAGI,eb6T+B,EAAA;;AapTnC;EACE,yBbnCgB,EAAA;EakClB;;IAKI,yBbvCc,EAAA;EakClB;;IAWM,wBAA4C,EAAA;;AAKlD;;;;EAKI,SAAS,EAAA;;AAQb;EAEI,qCb1DW,EAAA;;AELb;EW2EI,cbvEY;EawEZ,sCbvES,EAAA;;AcZb;;;EAII,yBCgG4D,EAAA;;ADpGhE;;;;EAYM,qBCwF0D,EAAA;;Ab7FhE;EYiBM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AApB5C;;;EAII,yBCgG4D,EAAA;;ADpGhE;;;;EAYM,qBCwF0D,EAAA;;Ab7FhE;EYiBM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AApB5C;;;EAII,yBCgG4D,EAAA;;ADpGhE;;;;EAYM,qBCwF0D,EAAA;;Ab7FhE;EYiBM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AApB5C;;;EAII,yBCgG4D,EAAA;;ADpGhE;;;;EAYM,qBCwF0D,EAAA;;Ab7FhE;EYiBM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AApB5C;;;EAII,yBCgG4D,EAAA;;ADpGhE;;;;EAYM,qBCwF0D,EAAA;;Ab7FhE;EYiBM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AApB5C;;;EAII,yBCgG4D,EAAA;;ADpGhE;;;;EAYM,qBCwF0D,EAAA;;Ab7FhE;EYiBM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AApB5C;;;EAII,yBCgG4D,EAAA;;ADpGhE;;;;EAYM,qBCwF0D,EAAA;;Ab7FhE;EYiBM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AApB5C;;;EAII,yBCgG4D,EAAA;;ADpGhE;;;;EAYM,qBCwF0D,EAAA;;Ab7FhE;EYiBM,yBAJsC,EAAA;EAD5C;;IASQ,yBARoC,EAAA;;AApB5C;;;EAII,sCdQS,EAAA;;AELb;EYiBM,sCAJsC,EAAA;EAD5C;;IASQ,sCARoC,EAAA;;ADsF9C;EAGM,Wb3GS;Ea4GT,yBbpGY;EaqGZ,qBbiQqD,EAAA;;AatQ3D;EAWM,cb5GY;Ea6GZ,yBblHY;EamHZ,qBblHY,EAAA;;AauHlB;EACE,Wb3Ha;Ea4Hb,yBbpHgB,EAAA;EakHlB;;;IAOI,qBb6OuD,EAAA;EapP3D;IAWI,SAAS,EAAA;EAXb;IAgBM,2Cb1IS,EAAA;EEKb;IW4IM,WbjJO;IakJP,4CblJO,EAAA;;AWkEX;EEiGA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAA;IALpC;MASK,SAAS,EAAA,EACV;;AF3GL;EEiGA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAA;IALpC;MASK,SAAS,EAAA,EACV;;AF3GL;EEiGA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAA;IALpC;MASK,SAAS,EAAA,EACV;;AF3GL;EEiGA;IAEI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAA;IALpC;MASK,SAAS,EAAA,EACV;;AAfT;EAOQ,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC,EAAA;EAVzC;IAcU,SAAS,EAAA;;AG7KnB;EACE,cAAc;EACd,WAAW;EACX,mCDiH8D;EChH9D,yBhB0XkC;EChN9B,eAAW;EevKf,gBhBmR+B;EgBlR/B,gBhBuR+B;EgBtR/B,chBDgB;EgBEhB,sBhBTa;EgBUb,4BAA4B;EAC5B,yBhBPgB;EOOd,sBP6NgC;EiB/N9B,wEjBwe4F,EAAA;EiBpe5F;IDdN;MCeQ,gBAAgB,EAAA,EDgCvB;EA/CD;IAsBI,6BAA6B;IAC7B,SAAS,EAAA;EEhBX;IACE,clBAc;IkBCd,sBlBRW;IkBSX,qBlBsdsE;IkBrdtE,UAAU;IAKR,gDlBaW,EAAA;EgB7BjB;IA+BI,chBxBc;IgB0Bd,UAAU,EAAA;EAjCd;IA2CI,yBhBxCc;IgB0Cd,UAAU,EAAA;;AAId;;;;EAKI,wBAAgB;UAAhB,gBAAgB,EAAA;;AAIpB;EAGI,kBAAkB;EAClB,0BhBtDc,EAAA;;AgBkDlB;EAaI,chB/Dc;EgBgEd,sBhBvEW,EAAA;;AgB4Ef;;EAEE,cAAc;EACd,WAAW,EAAA;;AAUb;EACE,iCDyB8D;ECxB9D,oCDwB8D;ECvB9D,gBAAgB;EfiEd,kBAAW;Ee/Db,gBhBgM+B,EAAA;;AgB7LjC;EACE,+BDiB8D;EChB9D,kCDgB8D;Ed0D1D,kBAAW;EexEf,gBhB6H+B,EAAA;;AgB1HjC;EACE,gCDU8D;ECT9D,mCDS8D;Ed0D1D,mBAAW;EejEf,gBhBuH+B,EAAA;;AgB9GjC;EACE,cAAc;EACd,WAAW;EACX,mBAA2B;EAC3B,gBAAgB;EfoDZ,eAAW;EelDf,gBhBmK+B;EgBlK/B,chBnHgB;EgBoHhB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmC,EAAA;EAVrC;IAcI,gBAAgB;IAChB,eAAe,EAAA;;AAYnB;EACE,kCD9B8D;EC+B9D,uBhBqPiC;EC1N7B,mBAAW;EezBf,gBhB+E+B;EOxN7B,qBP+N+B,EAAA;;AgBlFnC;EACE,gCDtC8D;ECuC9D,oBhBkPgC;EC/N5B,kBAAW;EejBf,gBhBsE+B;EOvN7B,qBP8N+B,EAAA;;AgBxEnC;EAGI,YAAY,EAAA;;AAIhB;EACE,YAAY,EAAA;;AAQd;EACE,mBhB2U0C,EAAA;;AgBxU5C;EACE,cAAc;EACd,mBhB4T4C,EAAA;;AgBpT9C;EACE,aAAa;EACb,eAAe;EACf,kBAA2C;EAC3C,iBAA0C,EAAA;EAJ5C;;IAQI,kBAA2C;IAC3C,iBAA0C,EAAA;;AAS9C;EACE,kBAAkB;EAClB,cAAc;EACd,qBhBiS6C,EAAA;;AgB9R/C;EACE,kBAAkB;EAClB,kBhB6R2C;EgB5R3C,qBhB2R6C,EAAA;EgB9R/C;;IAQI,chBzNc,EAAA;;AgB6NlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,qBhB8Q4C,EAAA;EgBlR9C;IAQI,gBAAgB;IAChB,aAAa;IACb,uBhByQ4C;IgBxQ5C,cAAc,EAAA;;AE7MhB;EACE,aAAa;EACb,WAAW;EACX,mBlB2c0C;ECtV1C,kBAAW;EiBnHX,clBPa,EAAA;;AkBUf;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBlBsyBqC;EkBryBrC,iBAAiB;EjBwHf,mBAAW;EiBtHb,gBlBuO6B;EkBtO7B,WlBxDW;EkByDX,wClBtBa;EOxBb,sBP6NgC,EAAA;EkB1KhC;;IAEE,SAAkC,EAAA;;AAvCpC;;;;EA8CE,cAAc,EAAA;;AA9ChB;EAoDE,qBlB1CW;EkB6CT,+CAA6C;EAC7C,yDH3B0E;EG4B1E,4BAA4B;EAC5B,2DAA6D;EAC7D,gEH+BwD,EAAA;EG1F5D;IA+DI,qBlBrDS;IkBsDT,gDlBtDS,EAAA;;AkBVb;EAyEI,8BAA8C;EAC9C,wCAAsD,EAAA;;AA1E1D;EAmFI,oCHOwD;EGNxD,kFHMwD,EAAA;;AG1F5D;EA2FE,qBlBjFW;EkBoFT,kDAAoE;EACpE,wNAA8J,EAAA;EA/FlK;IAmGI,qBlBzFS;IkB0FT,gDlB1FS,EAAA;;AkBVb;EA4GI,clBlGS,EAAA;;AkBVb;;;EAiHI,cAAc,EAAA;;AAjHlB;EAyHI,clB/GS,EAAA;EkBVb;IA4HM,qBlBlHO,EAAA;;AkBVb;EAkIM,qBAAkC;EC5JxC,yBD6J+C,EAAA;;AAnI/C;EAyIM,gDlB/HO,EAAA;;AkBVb;EA6IM,qBlBnIO,EAAA;;AkBVb;EAuJI,qBlB7IS,EAAA;;AkBVb;EA4JM,qBlBlJO;EkBmJP,gDlBnJO,EAAA;;AkBEf;EACE,aAAa;EACb,WAAW;EACX,mBlB2c0C;ECtV1C,kBAAW;EiBnHX,clBVa,EAAA;;AkBaf;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBlBsyBqC;EkBryBrC,iBAAiB;EjBwHf,mBAAW;EiBtHb,gBlBuO6B;EkBtO7B,WlBxDW;EkByDX,wClBzBa;EOrBb,sBP6NgC,EAAA;EkB1KhC;;IAEE,SAAkC,EAAA;;AAvCpC;;;;EA8CE,cAAc,EAAA;;AA9ChB;EAoDE,qBlB7CW;EkBgDT,+CAA6C;EAC7C,yDH3B0E;EG4B1E,4BAA4B;EAC5B,2DAA6D;EAC7D,gEH+BwD,EAAA;EG1F5D;IA+DI,qBlBxDS;IkByDT,gDlBzDS,EAAA;;AkBPb;EAyEI,8BAA8C;EAC9C,wCAAsD,EAAA;;AA1E1D;EAmFI,oCHOwD;EGNxD,kFHMwD,EAAA;;AG1F5D;EA2FE,qBlBpFW;EkBuFT,kDAAoE;EACpE,wNAA8J,EAAA;EA/FlK;IAmGI,qBlB5FS;IkB6FT,gDlB7FS,EAAA;;AkBPb;EA4GI,clBrGS,EAAA;;AkBPb;;;EAiHI,cAAc,EAAA;;AAjHlB;EAyHI,clBlHS,EAAA;EkBPb;IA4HM,qBlBrHO,EAAA;;AkBPb;EAkIM,qBAAkC;EC5JxC,yBD6J+C,EAAA;;AAnI/C;EAyIM,gDlBlIO,EAAA;;AkBPb;EA6IM,qBlBtIO,EAAA;;AkBPb;EAuJI,qBlBhJS,EAAA;;AkBPb;EA4JM,qBlBrJO;EkBsJP,gDlBtJO,EAAA;;AgB2OjB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAA;EAHrB;IASI,WAAW,EAAA;EL/NX;IKsNJ;MAeM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB,EAAA;IAlBtB;MAuBM,aAAa;MACb,cAAc;MACd,mBAAmB;MACnB,mBAAmB;MACnB,gBAAgB,EAAA;IA3BtB;MAgCM,qBAAqB;MACrB,WAAW;MACX,sBAAsB,EAAA;IAlC5B;MAuCM,qBAAqB,EAAA;IAvC3B;;MA4CM,WAAW,EAAA;IA5CjB;MAkDM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,eAAe,EAAA;IAtDrB;MAyDM,kBAAkB;MAClB,cAAc;MACd,aAAa;MACb,qBhBgLwC;MgB/KxC,cAAc,EAAA;IA7DpB;MAiEM,mBAAmB;MACnB,uBAAuB,EAAA;IAlE7B;MAqEM,gBAAgB,EAAA,EACjB;;AIlVL;EACE,qBAAqB;EAErB,gBpBuR+B;EoBtR/B,cpBMgB;EoBLhB,kBAAkB;EAGlB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA2C;ECuF3C,yBrB4RkC;EChN9B,eAAW;EoB1Ef,gBrB2L+B;EOnR7B,sBP6NgC;EiB/N9B,qIjBib6I,EAAA;EiB7a7I;IGdN;MHeQ,gBAAgB,EAAA,EG8BvB;ElBvCC;IkBUE,cpBNc;IoBOd,qBAAqB,EAAA;EAjBzB;IAsBI,UAAU;IACV,gDpBMa,EAAA;EoB7BjB;IA6BI,apBkZ6B,EAAA;EoB/ajC;IAkCI,eAAsD,EAAA;;AAc1D;;EAEE,oBAAoB,EAAA;;AASpB;EC3DA,WrBCa;EmBDX,yBnB6Ba;EqB3Bf,qBrB2Be,EAAA;EEvBf;ImBAE,WrBLW;ImBDX,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAEE,WrBZW;ImBDX,yBEDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WrB1BW;IqB2BX,yBrBCa;IqBAb,qBrBAa,EAAA;EqBOf;;IAGE,WrBtCW;IqBuCX,yBAzCuK;IA6CvK,qBA7C+M,EAAA;IA+C/M;;MAKI,gDAAiF,EAAA;;ADQvF;EC3DA,WrBCa;EmBDX,yBnBOc;EqBLhB,qBrBKgB,EAAA;EEDhB;ImBAE,WrBLW;ImBDX,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAEE,WrBZW;ImBDX,yBEDoF;IAgBpF,qBAhByH;IAqBvH,iDAAiF,EAAA;EAKrF;IAEE,WrB1BW;IqB2BX,yBrBrBc;IqBsBd,qBrBtBc,EAAA;EqB6BhB;;IAGE,WrBtCW;IqBuCX,yBAzCuK;IA6CvK,qBA7C+M,EAAA;IA+C/M;;MAKI,iDAAiF,EAAA;;ADQvF;EC3DA,WrBCa;EmBDX,yBnBoCa;EqBlCf,qBrBkCe,EAAA;EE9Bf;ImBAE,WrBLW;ImBDX,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAEE,WrBZW;ImBDX,yBEDoF;IAgBpF,qBAhByH;IAqBvH,+CAAiF,EAAA;EAKrF;IAEE,WrB1BW;IqB2BX,yBrBQa;IqBPb,qBrBOa,EAAA;EqBAf;;IAGE,WrBtCW;IqBuCX,yBAzCuK;IA6CvK,qBA7C+M,EAAA;IA+C/M;;MAKI,+CAAiF,EAAA;;ADQvF;EC3DA,WrBCa;EmBDX,yBnBsCa;EqBpCf,qBrBoCe,EAAA;EEhCf;ImBAE,WrBLW;ImBDX,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAEE,WrBZW;ImBDX,yBEDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,WrB1BW;IqB2BX,yBrBUa;IqBTb,qBrBSa,EAAA;EqBFf;;IAGE,WrBtCW;IqBuCX,yBAzCuK;IA6CvK,qBA7C+M,EAAA;IA+C/M;;MAKI,gDAAiF,EAAA;;ADQvF;EC3DA,crBUgB;EmBVd,yBnBmCa;EqBjCf,qBrBiCe,EAAA;EE7Bf;ImBAE,crBIc;ImBVd,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAEE,crBHc;ImBVd,yBEDoF;IAgBpF,qBAhByH;IAqBvH,gDAAiF,EAAA;EAKrF;IAEE,crBjBc;IqBkBd,yBrBOa;IqBNb,qBrBMa,EAAA;EqBCf;;IAGE,crB7Bc;IqB8Bd,yBAzCuK;IA6CvK,qBA7C+M,EAAA;IA+C/M;;MAKI,gDAAiF,EAAA;;ADQvF;EC3DA,WrBCa;EmBDX,yBnBiCa;EqB/Bf,qBrB+Be,EAAA;EE3Bf;ImBAE,WrBLW;ImBDX,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAEE,WrBZW;ImBDX,yBEDoF;IAgBpF,qBAhByH;IAqBvH,+CAAiF,EAAA;EAKrF;IAEE,WrB1BW;IqB2BX,yBrBKa;IqBJb,qBrBIa,EAAA;EqBGf;;IAGE,WrBtCW;IqBuCX,yBAzCuK;IA6CvK,qBA7C+M,EAAA;IA+C/M;;MAKI,+CAAiF,EAAA;;ADQvF;EC3DA,crBUgB;EmBVd,yBnBEc;EqBAhB,qBrBAgB,EAAA;EEIhB;ImBAE,crBIc;ImBVd,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAEE,crBHc;ImBVd,yBEDoF;IAgBpF,qBAhByH;IAqBvH,iDAAiF,EAAA;EAKrF;IAEE,crBjBc;IqBkBd,yBrB1Bc;IqB2Bd,qBrB3Bc,EAAA;EqBkChB;;IAGE,crB7Bc;IqB8Bd,yBAzCuK;IA6CvK,qBA7C+M,EAAA;IA+C/M;;MAKI,iDAAiF,EAAA;;ADQvF;EC3DA,WrBCa;EmBDX,yBnBSc;EqBPhB,qBrBOgB,EAAA;EEHhB;ImBAE,WrBLW;ImBDX,yBEDoF;IASpF,qBATyH,EAAA;EAY3H;IAEE,WrBZW;ImBDX,yBEDoF;IAgBpF,qBAhByH;IAqBvH,8CAAiF,EAAA;EAKrF;IAEE,WrB1BW;IqB2BX,yBrBnBc;IqBoBd,qBrBpBc,EAAA;EqB2BhB;;IAGE,WrBtCW;IqBuCX,yBAzCuK;IA6CvK,qBA7C+M,EAAA;IA+C/M;;MAKI,8CAAiF,EAAA;;ADcvF;ECPA,crB7Be;EqB8Bf,qBrB9Be,EAAA;EEvBf;ImBwDE,WrB7DW;IqB8DX,yBrBlCa;IqBmCb,qBrBnCa,EAAA;EqBsCf;IAEE,+CrBxCa,EAAA;EqB2Cf;IAEE,crB7Ca;IqB8Cb,6BAA6B,EAAA;EAG/B;;IAGE,WrBhFW;IqBiFX,yBrBrDa;IqBsDb,qBrBtDa,EAAA;IqBwDb;;MAKI,+CrB7DS,EAAA;;AoBoCf;ECPA,crBnDgB;EqBoDhB,qBrBpDgB,EAAA;EEDhB;ImBwDE,WrB7DW;IqB8DX,yBrBxDc;IqByDd,qBrBzDc,EAAA;EqB4DhB;IAEE,iDrB9Dc,EAAA;EqBiEhB;IAEE,crBnEc;IqBoEd,6BAA6B,EAAA;EAG/B;;IAGE,WrBhFW;IqBiFX,yBrB3Ec;IqB4Ed,qBrB5Ec,EAAA;IqB8Ed;;MAKI,iDrBnFU,EAAA;;AoB0DhB;ECPA,crBtBe;EqBuBf,qBrBvBe,EAAA;EE9Bf;ImBwDE,WrB7DW;IqB8DX,yBrB3Ba;IqB4Bb,qBrB5Ba,EAAA;EqB+Bf;IAEE,+CrBjCa,EAAA;EqBoCf;IAEE,crBtCa;IqBuCb,6BAA6B,EAAA;EAG/B;;IAGE,WrBhFW;IqBiFX,yBrB9Ca;IqB+Cb,qBrB/Ca,EAAA;IqBiDb;;MAKI,+CrBtDS,EAAA;;AoB6Bf;ECPA,crBpBe;EqBqBf,qBrBrBe,EAAA;EEhCf;ImBwDE,WrB7DW;IqB8DX,yBrBzBa;IqB0Bb,qBrB1Ba,EAAA;EqB6Bf;IAEE,gDrB/Ba,EAAA;EqBkCf;IAEE,crBpCa;IqBqCb,6BAA6B,EAAA;EAG/B;;IAGE,WrBhFW;IqBiFX,yBrB5Ca;IqB6Cb,qBrB7Ca,EAAA;IqB+Cb;;MAKI,gDrBpDS,EAAA;;AoB2Bf;ECPA,crBvBe;EqBwBf,qBrBxBe,EAAA;EE7Bf;ImBwDE,crBpDc;IqBqDd,yBrB5Ba;IqB6Bb,qBrB7Ba,EAAA;EqBgCf;IAEE,+CrBlCa,EAAA;EqBqCf;IAEE,crBvCa;IqBwCb,6BAA6B,EAAA;EAG/B;;IAGE,crBvEc;IqBwEd,yBrB/Ca;IqBgDb,qBrBhDa,EAAA;IqBkDb;;MAKI,+CrBvDS,EAAA;;AoB8Bf;ECPA,crBzBe;EqB0Bf,qBrB1Be,EAAA;EE3Bf;ImBwDE,WrB7DW;IqB8DX,yBrB9Ba;IqB+Bb,qBrB/Ba,EAAA;EqBkCf;IAEE,+CrBpCa,EAAA;EqBuCf;IAEE,crBzCa;IqB0Cb,6BAA6B,EAAA;EAG/B;;IAGE,WrBhFW;IqBiFX,yBrBjDa;IqBkDb,qBrBlDa,EAAA;IqBoDb;;MAKI,+CrBzDS,EAAA;;AoBgCf;ECPA,crBxDgB;EqByDhB,qBrBzDgB,EAAA;EEIhB;ImBwDE,crBpDc;IqBqDd,yBrB7Dc;IqB8Dd,qBrB9Dc,EAAA;EqBiEhB;IAEE,iDrBnEc,EAAA;EqBsEhB;IAEE,crBxEc;IqByEd,6BAA6B,EAAA;EAG/B;;IAGE,crBvEc;IqBwEd,yBrBhFc;IqBiFd,qBrBjFc,EAAA;IqBmFd;;MAKI,iDrBxFU,EAAA;;AoB+DhB;ECPA,crBjDgB;EqBkDhB,qBrBlDgB,EAAA;EEHhB;ImBwDE,WrB7DW;IqB8DX,yBrBtDc;IqBuDd,qBrBvDc,EAAA;EqB0DhB;IAEE,8CrB5Dc,EAAA;EqB+DhB;IAEE,crBjEc;IqBkEd,6BAA6B,EAAA;EAG/B;;IAGE,WrBhFW;IqBiFX,yBrBzEc;IqB0Ed,qBrB1Ec,EAAA;IqB4Ed;;MAKI,8CrBjFU,EAAA;;AoBmElB;EACE,gBpB6M+B;EoB5M/B,cpBjDe;EoBkDf,qBpB2F4C,EAAA;EEpK5C;IkB4EE,cpByF8D;IoBxF9D,0BpByF+C,EAAA;EoBhGnD;IAYI,0BpBoF+C,EAAA;EoBhGnD;IAiBI,cpBtFc;IoBuFd,oBAAoB,EAAA;;AAWxB;ECPE,oBrB2SgC;EC/N5B,kBAAW;EoB1Ef,gBrB+H+B;EOvN7B,qBP8N+B,EAAA;;AoB7HnC;ECXE,uBrBsSiC;EC1N7B,mBAAW;EoB1Ef,gBrBgI+B;EOxN7B,qBP+N+B,EAAA;;AoBrHnC;EACE,cAAc;EACd,WAAW,EAAA;EAFb;IAMI,kBpBwT+B,EAAA;;AoBnTnC;;;EAII,WAAW,EAAA;;AE3If;ELgBM,gCjBiP2C,EAAA;EiB7O3C;IKpBN;MLqBQ,gBAAgB,EAAA,EKfvB;EAND;IAII,UAAU,EAAA;;AAId;EAEI,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;ELDZ,6BjBkPwC,EAAA;EiB9OxC;IKNN;MLOQ,gBAAgB,EAAA,EKIvB;EAXD;IAOI,QAAQ;IACR,YAAY;ILNV,4BjBmPuC,EAAA;IiB/OvC;MKNN;QLOQ,gBAAgB,EAAA,EKGrB;;ACvBH;;;;EAIE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;ECoBjB;IACE,qBAAqB;IACrB,oBxB+N0C;IwB9N1C,uBxB6N0C;IwB5N1C,WAAW;IAhCf,uBAA8B;IAC9B,qCAA4C;IAC5C,gBAAgB;IAChB,oCAA2C,EAAA;EAqDzC;IACE,cAAc,EAAA;;AD1CpB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,avBypBsC;EuBxpBtC,aAAa;EACb,WAAW;EACX,gBvBiuBuC;EuBhuBvC,iBvBiuBmC;EuBhuBnC,oBAA4B;EtB2JxB,eAAW;EsBzJf,cvBXgB;EuBYhB,gBAAgB;EAChB,gBAAgB;EAChB,sBvBvBa;EuBwBb,4BAA4B;EAC5B,qCvBfa;EOCX,sBP6NgC,EAAA;;AuBtMhC;EACE,WAAW;EACX,OAAO,EAAA;;AAGT;EACE,QAAQ;EACR,UAAU,EAAA;;AZYZ;EYnBA;IACE,WAAW;IACX,OAAO,EAAA;EAGT;IACE,QAAQ;IACR,UAAU,EAAA,EACX;;AZWD;EYnBA;IACE,WAAW;IACX,OAAO,EAAA;EAGT;IACE,QAAQ;IACR,UAAU,EAAA,EACX;;AZWD;EYnBA;IACE,WAAW;IACX,OAAO,EAAA;EAGT;IACE,QAAQ;IACR,UAAU,EAAA,EACX;;AZWD;EYnBA;IACE,WAAW;IACX,OAAO,EAAA;EAGT;IACE,QAAQ;IACR,UAAU,EAAA,EACX;;AAML;EAEI,SAAS;EACT,YAAY;EACZ,aAAa;EACb,uBvB+rBuC,EAAA;;AwB9tBvC;EACE,qBAAqB;EACrB,oBxB+N0C;EwB9N1C,uBxB6N0C;EwB5N1C,WAAW;EAzBf,aAAa;EACb,qCAA4C;EAC5C,0BAAiC;EACjC,oCAA2C,EAAA;;AA8CzC;EACE,cAAc,EAAA;;ADUpB;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,qBvBirBuC,EAAA;;AwB9tBvC;EACE,qBAAqB;EACrB,oBxB+N0C;EwB9N1C,uBxB6N0C;EwB5N1C,WAAW;EAlBf,mCAA0C;EAC1C,eAAe;EACf,sCAA6C;EAC7C,wBAA+B,EAAA;;AAuC7B;EACE,cAAc,EAAA;;AA7BhB;EDmDE,iBAAiB,EAAA;;AAKvB;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBvBgqBuC,EAAA;;AwB9tBvC;EACE,qBAAqB;EACrB,oBxB+N0C;EwB9N1C,uBxB6N0C;EwB5N1C,WAAW,EAAA;;AAJb;EAgBI,aAAa,EAAA;;AAGf;EACE,qBAAqB;EACrB,qBxB4MwC;EwB3MxC,uBxB0MwC;EwBzMxC,WAAW;EA9BjB,mCAA0C;EAC1C,yBAAgC;EAChC,sCAA6C,EAAA;;AAiC3C;EACE,cAAc,EAAA;;AAVd;EDiDA,iBAAiB,EAAA;;AAOvB;EAKI,WAAW;EACX,YAAY,EAAA;;AAKhB;EE9GE,SAAS;EACT,gBAAmB;EACnB,gBAAgB;EAChB,6BzBCgB,EAAA;;AuBiHlB;EACE,cAAc;EACd,WAAW;EACX,uBvBopBwC;EuBnpBxC,WAAW;EACX,gBvBiK+B;EuBhK/B,cvBhHgB;EuBiHhB,mBAAmB;EAEnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS,EAAA;ErBrHT;IqBoIE,cvBonBqD;IuBnnBrD,qBAAqB;IJ/IrB,yBnBGc,EAAA;EuBiHlB;IAiCI,WvBpJW;IuBqJX,qBAAqB;IJtJrB,yBnB6Ba,EAAA;EuBuFjB;IAwCI,cvBtJc;IuBuJd,oBAAoB;IACpB,6BAA6B,EAAA;;AAQjC;EACE,cAAc,EAAA;;AAIhB;EACE,cAAc;EACd,sBvB8lBwC;EuB7lBxC,gBAAgB;EtBAZ,mBAAW;EsBEf,cvBzKgB;EuB0KhB,mBAAmB,EAAA;;AAIrB;EACE,cAAc;EACd,uBvBolBwC;EuBnlBxC,cvB9KgB,EAAA;;A0BblB;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAA;EAJxB;;IAOI,kBAAkB;IAClB,cAAc,EAAA;IxBChB;;MwBII,UAAU,EAAA;IAbhB;;;;MAkBM,UAAU,EAAA;;AAMhB;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAA;EAH7B;IAMI,WAAW,EAAA;;AAIf;;EAII,iB1BmM6B,EAAA;;A0BvMjC;;EnBHI,0BmBa8B;EnBZ9B,6BmBY8B,EAAA;;AAVlC;;EnBWI,yBmBI6B;EnBH7B,4BmBG6B,EAAA;;AAgBjC;EACE,wBAAmC;EACnC,uBAAkC,EAAA;EAFpC;;;IAOI,cAAc,EAAA;EAGhB;IACE,eAAe,EAAA;;AAInB;EACE,uBAAsC;EACtC,sBAAqC,EAAA;;AAGvC;EACE,sBAAsC;EACtC,qBAAqC,EAAA;;AAoBvC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAA;EAHzB;;IAOI,WAAW,EAAA;EAPf;;IAYI,gB1BkH6B,EAAA;E0B9HjC;;InBrEI,6BmBuF+B;InBtF/B,4BmBsF+B,EAAA;EAlBnC;;InBnFI,yBmB0G4B;InBzG5B,0BmByG4B,EAAA;;AAiBhC;;EAGI,gBAAgB,EAAA;EAHpB;;;;IAOM,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB,EAAA;;ACzJ1B;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAA;EALb;;;;IAWI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY;IACZ,gBAAgB,EAAA;IAfpB;;;;;;;;;;;;MAoBM,iB3BkN2B,EAAA;E2BtOjC;;;IA4BI,UAAU,EAAA;EA5Bd;IAiCI,UAAU,EAAA;EAjCd;;IpB0CI,yBoBJmD;IpBKnD,4BoBLmD,EAAA;EAtCvD;IA4CI,aAAa;IACb,mBAAmB,EAAA;IA7CvB;;MpB4BI,0BoBoB6E;MpBnB7E,6BoBmB6E,EAAA;IAhDjF;MpB0CI,yBoBOsE;MpBNtE,4BoBMsE,EAAA;EAjD1E;;;;IpB4BI,0BoB6BgC;IpB5BhC,6BoB4BgC,EAAA;EAzDpC;;;;IpB4BI,0BoBsCgC;IpBrChC,6BoBqCgC,EAAA;;AAYpC;;EAEE,aAAa,EAAA;EAFf;;IAQI,kBAAkB;IAClB,UAAU,EAAA;IATd;;MAYM,UAAU,EAAA;EAZhB;;;;;;;;IAoBI,iB3BoI6B,EAAA;;A2BhIjC;EAAuB,kB3BgIU,EAAA;;A2B/HjC;EAAsB,iB3B+HW,EAAA;;A2BvHjC;EACE,aAAa;EACb,mBAAmB;EACnB,yB3B4QkC;E2B3QlC,gBAAgB;E1B2DZ,eAAW;E0BzDf,gB3BqK+B;E2BpK/B,gB3ByK+B;E2BxK/B,c3B/GgB;E2BgHhB,kBAAkB;EAClB,mBAAmB;EACnB,yB3BvHgB;E2BwHhB,yB3BtHgB;EOOd,sBP6NgC,EAAA;E2B1HpC;;IAkBI,aAAa,EAAA;;AAUjB;;EAEE,gCZzB8D,EAAA;;AY4BhE;;;;;;EAME,oB3BuPgC;EC/N5B,kBAAW;E0BtBf,gB3B2E+B;EOvN7B,qBP8N+B,EAAA;;A2B9EnC;;EAEE,kCZ1C8D,EAAA;;AY6ChE;;;;;;EAME,uB3BiOiC;EC1N7B,mBAAW;E0BLf,gB3B2D+B;EOxN7B,qBP+N+B,EAAA;;A2B9DnC;;EAEE,sBAA0E,EAAA;;AAW5E;;;;;;;;EpB9JI,0BoBsK4B;EpBrK5B,6BoBqK4B,EAAA;;AAGhC;;;;;;EpB3JI,yBoBiK2B;EpBhK3B,4BoBgK2B,EAAA;;ACxM/B;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,kBAA+C;EAC/C,oBAAqE;EACrE,iCAAyB;UAAzB,yBAAyB,EAAA;;AAG3B;EACE,oBAAoB;EACpB,kB5Byf0C,EAAA;;A4Btf5C;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,W5Bqf0C;E4Bpf1C,eAAmF;EACnF,UAAU,EAAA;EANZ;IASI,W5BzBW;I4B0BX,qB5BEa;ImB7Bb,yBnB6Ba,EAAA;E4BZjB;IAoBM,gD5BRW,EAAA;E4BZjB;IAyBI,qB5BsbsE,EAAA;E4B/c1E;IA6BI,W5B7CW;I4B8CX,yB5Bkf8E;I4Bjf9E,qB5Bif8E,EAAA;E4BhhBlF;IAuCM,c5BjDY,EAAA;I4BUlB;MA0CQ,yB5BxDU,EAAA;;A4BkElB;EACE,kBAAkB;EAClB,gBAAgB;EAEhB,mBAAmB,EAAA;EAJrB;IASI,kBAAkB;IAClB,YAAgF;IAChF,aAA+D;IAC/D,cAAc;IACd,W5BwbwC;I4BvbxC,Y5BubwC;I4BtbxC,oBAAoB;IACpB,WAAW;IACX,sB5BrFW;I4BsFX,yB5BjFc,EAAA;E4B+DlB;IAwBI,kBAAkB;IAClB,YAAgF;IAChF,aAA+D;IAC/D,cAAc;IACd,W5ByawC;I4BxaxC,Y5BwawC;I4BvaxC,WAAW;IACX,mCAAgE,EAAA;;AASpE;ErBjGI,sBP6NgC,EAAA;;A4B5HpC;EAOM,yDb7D4E,EAAA;;AasDlF;EAaM,qB5B7FW;EmB7Bb,yBnB6Ba,EAAA;;A4BgFjB;EAkBM,yDbxE4E,EAAA;;AasDlF;ET7GI,wCnB6Ba,EAAA;;A4BgFjB;ET7GI,wCnB6Ba,EAAA;;A4BoHjB;EAGI,kB5B0Z+C,EAAA;;A4B7ZnD;EAQM,yDblG4E,EAAA;;Aa0FlF;ETjJI,wCnB6Ba,EAAA;;A4B4IjB;EACE,qBAA2D,EAAA;EAD7D;IAKM,cAAqD;IACrD,c5BkY+E;I4BjY/E,mBAAmB;IAEnB,qB5BgY6E,EAAA;E4BzYnF;IAaM,wBblE0D;IamE1D,0BbnE0D;IaoE1D,uBb5C0D;Ia6C1D,wBb7C0D;Ia8C1D,yB5BpLY;I4BsLZ,qB5BsX6E;IiBxiB7E,yIjB0f+H,EAAA;IiBtf/H;MW2JN;QX1JQ,gBAAgB,EAAA,EW+KnB;EArBL;IA0BM,sB5BlMS;I4BmMT,8BAA4E,EAAA;EA3BlF;ITzKI,wCnB6Ba,EAAA;;A4ByLjB;EACE,qBAAqB;EACrB,WAAW;EACX,mCbrG8D;EasG9D,0C5BoKkC;EChN9B,eAAW;E2B+Cf,gB5B6D+B;E4B5D/B,gB5BiE+B;E4BhE/B,c5BvNgB;E4BwNhB,sBAAsB;EACtB,gG5BmW+I;E4BlW/I,yB5B7NgB;EOOd,sBP6NgC;E4BJlC,wBAAgB;UAAhB,gBAAgB,EAAA;EAflB;IAkBI,qB5BwPsE;I4BvPtE,UAAU;IAKR,gD5BjNW,EAAA;I4ByLjB;MAiCM,c5B/OY;M4BgPZ,sB5BvPS,EAAA;E4BqNf;IAwCI,YAAY;IACZ,sB5B+HgC;I4B9HhC,sBAAsB,EAAA;EA1C1B;IA8CI,c5B7Pc;I4B8Pd,yB5BlQc,EAAA;E4BmNlB;IAoDI,aAAa,EAAA;EApDjB;IAyDI,kBAAkB;IAClB,0B5BxQc,EAAA;;A4B4QlB;EACE,kCbjK8D;EakK9D,oB5BiHkC;E4BhHlC,uB5BgHkC;E4B/GlC,oB5BgHiC;EC1N7B,mBAAW,EAAA;;A2B8GjB;EACE,gCbzK8D;Ea0K9D,mB5B8GiC;E4B7GjC,sB5B6GiC;E4B5GjC,kB5B6GgC;EC/N5B,kBAAW,EAAA;;A2B2HjB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,mCbzL8D;Ea0L9D,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mCbjM8D;EakM9D,SAAS;EACT,gBAAgB;EAChB,UAAU,EAAA;EAPZ;IAUI,qB5BqKsE;I4BpKtE,gD5B/Ra,EAAA;E4BoRjB;;IAiBI,yB5B/Tc,EAAA;E4B8SlB;IAsBM,iB5B4TQ,EAAA;E4BlVd;IA2BI,0BAA0B,EAAA;;AAI9B;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,UAAU;EACV,mCblO8D;EamO9D,yB5BuCkC;E4BtClC,gBAAgB;EAEhB,gB5BhE+B;E4BiE/B,gB5B5D+B;E4B6D/B,c5BpVgB;E4BqVhB,sB5B5Va;E4B6Vb,yB5BzVgB;EOOd,sBP6NgC,EAAA;E4BuGpC;IAmBI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;IACV,cAAc;IACd,6BbrP4D;IasP5D,yB5BoBgC;I4BnBhC,gB5B5E6B;I4B6E7B,c5BpWc;I4BqWd,iBAAiB;IT7WjB,yBnBGc;I4B4Wd,oBAAoB;IrBnWpB,kCqBoWgF,EAAA;;AAUpF;EACE,WAAW;EACX,cb3Q2B;Ea4Q3B,UAAU;EACV,6BAA6B;EAC7B,wBAAgB;UAAhB,gBAAgB,EAAA;EALlB;IAQI,UAAU,EAAA;IARd;MAY8B,gE5BzWb,EAAA;I4B6VjB;MAa8B,gE5B1Wb,EAAA;I4B6VjB;MAc8B,gE5B3Wb,EAAA;E4B6VjB;IAkBI,SAAS,EAAA;EAlBb;IAsBI,W5BoN6C;I4BnN7C,Y5BmN6C;I4BlN7C,oBAA0E;ITlZ1E,yBnB6Ba;I4BuXb,S5BmN0C;IO3lB1C,mBP4lB6C;IiB9lB3C,oHjB0f+H;IiB1f/H,4GjB0f+H;I4B5GjI,wBAAgB;YAAhB,gBAAgB,EAAA;IX1Yd;MW4WN;QX3WQ,wBAAgB;QAAhB,gBAAgB,EAAA,EW8YrB;IAnCH;MT1XI,yBnB4mB2E,EAAA;E4BlP/E;IAsCI,W5B6LoC;I4B5LpC,c5B6LqC;I4B5LrC,kBAAkB;IAClB,e5B4LuC;I4B3LvC,yB5Bhac;I4Biad,yBAAyB;IrBzZzB,mBPqlBoC,EAAA;E4BvOxC;IAiDI,W5ByL6C;I4BxL7C,Y5BwL6C;ImBpmB7C,yBnB6Ba;I4BiZb,S5ByL0C;IO3lB1C,mBP4lB6C;IiB9lB3C,iHjB0f+H;IiB1f/H,4GjB0f+H;I4BlFjI,gBAAgB,EAAA;IXpad;MW4WN;QX3WQ,qBAAgB;QAAhB,gBAAgB,EAAA,EWwarB;IA7DH;MT1XI,yBnB4mB2E,EAAA;E4BlP/E;IAgEI,W5BmKoC;I4BlKpC,c5BmKqC;I4BlKrC,kBAAkB;IAClB,e5BkKuC;I4BjKvC,yB5B1bc;I4B2bd,yBAAyB;IrBnbzB,mBPqlBoC,EAAA;E4BvOxC;IA2EI,W5B+J6C;I4B9J7C,Y5B8J6C;I4B7J7C,aAAa;IACb,oB5BrE+B;I4BsE/B,mB5BtE+B;ImBnY/B,yBnB6Ba;I4B8ab,S5B4J0C;IO3lB1C,mBP4lB6C;IiB9lB3C,gHjB0f+H;IiB1f/H,4GjB0f+H;I4BrDjI,gBAAgB,EAAA;IXjcd;MW4WN;QX3WQ,oBAAgB;QAAhB,gBAAgB,EAAA,EWqcrB;IA1FH;MT1XI,yBnB4mB2E,EAAA;E4BlP/E;IA6FI,W5BsIoC;I4BrIpC,c5BsIqC;I4BrIrC,kBAAkB;IAClB,e5BqIuC;I4BpIvC,6BAA6B;IAC7B,yBAAyB;IACzB,oBAA6C,EAAA;EAnGjD;IAwGI,yB5B9dc;IOQd,mBPqlBoC,EAAA;E4BvOxC;IA6GI,kBAAkB;IAClB,yB5Bpec;IOQd,mBPqlBoC,EAAA;E4BvOxC;IAoHM,yB5BxeY,EAAA;E4BoXlB;IAwHM,eAAe,EAAA;EAxHrB;IA4HM,yB5BhfY,EAAA;E4BoXlB;IAgIM,eAAe,EAAA;EAhIrB;IAoIM,yB5BxfY,EAAA;;A4B6flB;;;EXzfM,4GjB0f+H,EAAA;EiBtf/H;IWqfN;;;MXpfQ,gBAAgB,EAAA,EWwfvB;;ACxgBD;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,oB7B0qBsC,EAAA;EEzqBtC;I2BGE,qBAAqB,EAAA;EANzB;IAWI,c7BXc;I6BYd,oBAAoB;IACpB,eAAe,EAAA;;AAQnB;EACE,gC7BzBgB,EAAA;E6BwBlB;IAII,mB7BsM6B;I6BrM7B,6BAA6B;IAC7B,6BAAgD;ItBbhD,+BPoNgC;IOnNhC,gCPmNgC,EAAA;IE/NlC;M2B6BI,kBAAkB;MAClB,qC7BpCY,EAAA;I6BwBlB;MAgBM,c7BrCY;M6BsCZ,6BAA6B;MAC7B,yBAAyB,EAAA;EAlB/B;;IAwBI,c7B5Cc;I6B6Cd,sB7BpDW;I6BqDX,kC7BrDW,EAAA;E6B2Bf;IA+BI,gB7B2K6B;IOjN7B,yBsBwC4B;ItBvC5B,0BsBuC4B,EAAA;;AAShC;EAEI,gBAAgB;EAChB,SAAS;EtB7DT,sBP6NgC,EAAA;;A6BnKpC;;EASI,W7B9EW;E6B+EX,yB7BnDa,EAAA;;A6B4DjB;;EAGI,cAAc;EACd,kBAAkB,EAAA;;AAItB;;EAGI,aAAa;EACb,YAAY;EACZ,kBAAkB,EAAA;;AAStB;EAEI,aAAa,EAAA;;AAFjB;EAKI,cAAc,EAAA;;ACzGlB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,oB9BgHW,EAAA;E8BtHb;;IAWI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B,EAAA;;AAoBlC;EACE,qBAAqB;EACrB,sB9BkqBgF;E8BjqBhF,yB9BiqBgF;E8BhqBhF,kB9BgFW;EC6CP,kBAAW;E6B3Hf,oBAAoB;EACpB,mBAAmB,EAAA;E5B1CnB;I4B6CE,qBAAqB,EAAA;;AASzB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;EALlB;IAQI,gBAAgB;IAChB,eAAe,EAAA;EATnB;IAaI,gBAAgB;IAChB,WAAW,EAAA;;AASf;EACE,qBAAqB;EACrB,mB9BylBuC;E8BxlBvC,sB9BwlBuC,EAAA;;A8B5kBzC;EACE,gBAAgB;EAChB,YAAY;EAGZ,mBAAmB,EAAA;;AAIrB;EACE,wB9BomBwC;ECtiBpC,kBAAW;E6B5Df,cAAc;EACd,6BAA6B;EAC7B,6BAAuC;EvBxGrC,sBP6NgC,EAAA;EE/NlC;I4B8GE,qBAAqB,EAAA;;AAMzB;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qCAAqC,EAAA;;AAGvC;EACE,gB9BglBsC;E8B/kBtC,gBAAgB,EAAA;;AnBtEd;EmBgFC;;IAGK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;AnBlGL;EmB6FA;IAoBI,qBAAqB;IACrB,2BAA2B,EAAA;IArB9B;MAwBK,mBAAmB,EAAA;MAxBxB;QA2BO,kBAAkB,EAAA;MA3BzB;QA+BO,qB9ByhB6B;Q8BxhB7B,oB9BwhB6B,EAAA;I8BxjBpC;;MAsCK,iBAAiB,EAAA;IAtCtB;MAqDK,iBAAiB,EAAA;IArDtB;MAyDK,wBAAwB;MAGxB,gBAAgB,EAAA;IA5DrB;MAgEK,aAAa,EAAA,EACd;;AnBjJL;EmBgFC;;IAGK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;AnBlGL;EmB6FA;IAoBI,qBAAqB;IACrB,2BAA2B,EAAA;IArB9B;MAwBK,mBAAmB,EAAA;MAxBxB;QA2BO,kBAAkB,EAAA;MA3BzB;QA+BO,qB9ByhB6B;Q8BxhB7B,oB9BwhB6B,EAAA;I8BxjBpC;;MAsCK,iBAAiB,EAAA;IAtCtB;MAqDK,iBAAiB,EAAA;IArDtB;MAyDK,wBAAwB;MAGxB,gBAAgB,EAAA;IA5DrB;MAgEK,aAAa,EAAA,EACd;;AnBjJL;EmBgFC;;IAGK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;AnBlGL;EmB6FA;IAoBI,qBAAqB;IACrB,2BAA2B,EAAA;IArB9B;MAwBK,mBAAmB,EAAA;MAxBxB;QA2BO,kBAAkB,EAAA;MA3BzB;QA+BO,qB9ByhB6B;Q8BxhB7B,oB9BwhB6B,EAAA;I8BxjBpC;;MAsCK,iBAAiB,EAAA;IAtCtB;MAqDK,iBAAiB,EAAA;IArDtB;MAyDK,wBAAwB;MAGxB,gBAAgB,EAAA;IA5DrB;MAgEK,aAAa,EAAA,EACd;;AnBjJL;EmBgFC;;IAGK,gBAAgB;IAChB,eAAe,EAAA,EAChB;;AnBlGL;EmB6FA;IAoBI,qBAAqB;IACrB,2BAA2B,EAAA;IArB9B;MAwBK,mBAAmB,EAAA;MAxBxB;QA2BO,kBAAkB,EAAA;MA3BzB;QA+BO,qB9ByhB6B;Q8BxhB7B,oB9BwhB6B,EAAA;I8BxjBpC;;MAsCK,iBAAiB,EAAA;IAtCtB;MAqDK,iBAAiB,EAAA;IArDtB;MAyDK,wBAAwB;MAGxB,gBAAgB,EAAA;IA5DrB;MAgEK,aAAa,EAAA,EACd;;AAtET;EAyBQ,qBAAqB;EACrB,2BAA2B,EAAA;EA1BnC;;IAQU,gBAAgB;IAChB,eAAe,EAAA;EATzB;IA6BU,mBAAmB,EAAA;IA7B7B;MAgCY,kBAAkB,EAAA;IAhC9B;MAoCY,qB9ByhB6B;M8BxhB7B,oB9BwhB6B,EAAA;E8B7jBzC;;IA2CU,iBAAiB,EAAA;EA3C3B;IA0DU,iBAAiB,EAAA;EA1D3B;IA8DU,wBAAwB;IAGxB,gBAAgB,EAAA;EAjE1B;IAqEU,aAAa,EAAA;;AAavB;EAEI,yB9BvNW,EAAA;EEDb;I4B2NI,yB9B1NS,EAAA;;A8BqNf;EAWM,yB9BhOS,EAAA;EEDb;I4BoOM,yB9BnOO,EAAA;E8BqNf;IAkBQ,yB9BvOO,EAAA;;A8BqNf;;;;EA0BM,yB9B/OS,EAAA;;A8BqNf;EA+BI,yB9BpPW;E8BqPX,gC9BrPW,EAAA;;A8BqNf;EAoCI,yDf7M8E,EAAA;;AeyKlF;EAwCI,yB9B7PW,EAAA;E8BqNf;IA0CM,yB9B/PS,EAAA;IEDb;M4BmQM,yB9BlQO,EAAA;;A8ByQf;EAEI,W9BrRW,EAAA;EESb;I4B+QI,W9BxRS,EAAA;;A8BmRf;EAWM,+B9B9RS,EAAA;EESb;I4BwRM,gC9BjSO,EAAA;E8BmRf;IAkBQ,gC9BrSO,EAAA;;A8BmRf;;;;EA0BM,W9B7SS,EAAA;;A8BmRf;EA+BI,+B9BlTW;E8BmTX,sC9BnTW,EAAA;;A8BmRf;EAoCI,yDfjQ8E,EAAA;;Ae6NlF;EAwCI,+B9B3TW,EAAA;E8BmRf;IA0CM,W9B7TS,EAAA;IESb;M4BuTM,W9BhUO,EAAA;;A+BHf;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EAEZ,qBAAqB;EACrB,sB/BJa;E+BKb,2BAA2B;EAC3B,sC/BIa;EOCX,sBP6NgC,EAAA;E+B3OpC;IAaI,eAAe;IACf,cAAc,EAAA;EAdlB;IAkBI,mBAAmB;IACnB,sBAAsB,EAAA;IAnB1B;MAsBM,mBAAmB;MxBCrB,2CQuH4D;MRtH5D,4CQsH4D,EAAA;IgB9IhE;MA2BM,sBAAsB;MxBUxB,+CQyG4D;MRxG5D,8CQwG4D,EAAA;EgB9IhE;;IAoCI,aAAa,EAAA;;AAIjB;EAGE,cAAc;EAGd,eAAe;EACf,gB/BgxByC,EAAA;;A+B5wB3C;EACE,sB/B0wBwC,EAAA;;A+BvwB1C;EACE,qBAAgC;EAChC,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;A7BrDhB;E6B0DE,qBAAqB,EAAA;;AAFzB;EAMI,oB/ByvBuC,EAAA;;A+BjvB3C;EACE,wB/BgvByC;E+B/uBzC,gBAAgB;EAEhB,qC/BrEa;E+BsEb,6C/BtEa,EAAA;E+BiEf;IxBhEI,0DwBwE8E,EAAA;;AAIlF;EACE,wB/BouByC;E+BluBzC,qC/BhFa;E+BiFb,0C/BjFa,EAAA;E+B6Ef;IxB5EI,0DQgI4D,EAAA;;AgBpChE;EACE,uBAAkC;EAClC,uB/BktBwC;E+BjtBxC,sBAAiC;EACjC,gBAAgB,EAAA;;AAGlB;EACE,uBAAkC;EAClC,sBAAiC,EAAA;;AAInC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gB/B6sByC;EO5zBvC,kCQgI4D,EAAA;;AgBbhE;;;EAGE,cAAc;EACd,WAAW,EAAA;;AAGb;;ExBjHI,2CQuH4D;ERtH5D,4CQsH4D,EAAA;;AgBDhE;;ExBxGI,+CQyG4D;ERxG5D,8CQwG4D,EAAA;;AgBOhE;EAEI,mB/BqrBuD,EAAA;;AWpxBvD;EoB6FJ;IAMI,aAAa;IACb,mBAAmB;IACnB,mB/B+qBuD;I+B9qBvD,kB/B8qBuD,EAAA;I+BvrB3D;MAaM,SAAY;MACZ,kB/ByqBqD;M+BxqBrD,gBAAgB;MAChB,iB/BuqBqD,EAAA,E+BtqBtD;;AASL;EAII,mB/BypBuD,EAAA;;AWpxBvD;EoBuHJ;IAQI,aAAa;IACb,mBAAmB,EAAA;IATvB;MAcM,SAAY;MACZ,gBAAgB,EAAA;MAftB;QAkBQ,cAAc;QACd,cAAc,EAAA;MAnBtB;QxBjJI,0BwB0KoC;QxBzKpC,6BwByKoC,EAAA;QAzBxC;;UA8BY,0BAA0B,EAAA;QA9BtC;;UAmCY,6BAA6B,EAAA;MAnCzC;QxBnII,yBwB2KmC;QxB1KnC,4BwB0KmC,EAAA;QAxCvC;;UA6CY,yBAAyB,EAAA;QA7CrC;;UAkDY,4BAA4B,EAAA,EAC7B;;AAYX;EAEI,sB/B8kBsC,EAAA;;AWtwBtC;EoBsLJ;IAMI,e/B2lBiC;I+B1lBjC,mB/B2lBuC;I+B1lBvC,UAAU;IACV,SAAS,EAAA;IATb;MAYM,qBAAqB;MACrB,WAAW,EAAA,EACZ;;AASL;EACE,qBAAqB,EAAA;EADvB;IAII,gBAAgB,EAAA;IAJpB;MAOM,gBAAgB;MxBvOlB,6BwBwOiC;MxBvOjC,4BwBuOiC,EAAA;IARrC;MxB9OI,yBwB0P8B;MxBzP9B,0BwByP8B,EAAA;IAZlC;MxBvPI,gBwBuQ0B;MACxB,mB/B9C2B,EAAA;;AgC5OjC;EACE,aAAa;EACb,eAAe;EACf,qBhCmiCsC;EgCliCtC,mBhCqiCsC;EgCniCtC,gBAAgB;EAChB,yBhCEgB;EOSd,sBP6NgC,EAAA;;AgCpOpC;EAGI,oBhCyhCqC,EAAA;EgC5hCzC;IAMM,WAAW;IACX,qBhCqhCmC;IgCphCnC,chCNY;IgCOZ,YhC0hCuC,EAAA;;AgCniC7C;EAoBI,0BAA0B,EAAA;;AApB9B;EAwBI,qBAAqB,EAAA;;AAxBzB;EA4BI,chC1Bc,EAAA;;AiCblB;EACE,aAAa;E7BGb,eAAe;EACf,gBAAgB;EGad,sBP6NgC,EAAA;;AiCzOpC;EACE,kBAAkB;EAClB,cAAc;EACd,uBjCixBwC;EiChxBxC,iBjCkO+B;EiCjO/B,iBjCoxBsC;EiCnxBtC,cjCuBe;EiCrBf,sBjCPa;EiCQb,yBjCLgB,EAAA;EiCJlB;IAYI,UAAU;IACV,cjC8J8D;IiC7J9D,qBAAqB;IACrB,yBjCZc;IiCad,qBjCZc,EAAA;EiCJlB;IAoBI,UAAU;IACV,UjC4wBiC;IiC3wBjC,gDjCOa,EAAA;;AiCHjB;EAGM,cAAc;E1BahB,+BP+LgC;EO9LhC,kCP8LgC,EAAA;;AiC/MpC;E1BEI,gCP6MgC;EO5MhC,mCP4MgC,EAAA;;AiC/MpC;EAcI,UAAU;EACV,WjCxCW;EiCyCX,yBjCba;EiCcb,qBjCda,EAAA;;AiCHjB;EAqBI,cjCxCc;EiCyCd,oBAAoB;EAEpB,YAAY;EACZ,sBjClDW;EiCmDX,qBjChDc,EAAA;;AkCPhB;EACE,uBlC0xBsC;EC1mBpC,kBAAW;EiC9Kb,gBlCmO6B,EAAA;;AkC9N3B;E3BqCF,8BPgM+B;EO/L/B,iCP+L+B,EAAA;;AkChO7B;E3BkBF,+BP8M+B;EO7M/B,kCP6M+B,EAAA;;AkC7OjC;EACE,uBlCwxBqC;ECxmBnC,mBAAW;EiC9Kb,gBlCoO6B,EAAA;;AkC/N3B;E3BqCF,8BPiM+B;EOhM/B,iCPgM+B,EAAA;;AkCjO7B;E3BkBF,+BP+M+B;EO9M/B,kCP8M+B,EAAA;;AmC5OnC;EACE,qBAAqB;EACrB,qBnC45BsC;EC/vBpC,cAAW;EkC3Jb,gBnCwR+B;EmCvR/B,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;E5BKtB,sBP6NgC;EiB/N9B,qIjBib6I,EAAA;EiB7a7I;IkBfN;MlBgBQ,gBAAgB,EAAA,EkBMvB;EjCXC;IiCGI,qBAAqB,EAAA;EAd3B;IAoBI,aAAa,EAAA;;AAKjB;EACE,kBAAkB;EAClB,SAAS,EAAA;;AAOX;EACE,oBnCi4BsC;EmCh4BtC,mBnCg4BsC;EOv5BpC,oBP05BqC,EAAA;;AmC13BvC;ECjDA,WpCMa;EoCLb,yBpCiCe,EAAA;EEnBf;IkCVI,WpCCS;IoCAT,yBAAkC,EAAA;EAH9B;IAQJ,UAAU;IACV,+CpCsBW,EAAA;;AmCef;ECjDA,WpCMa;EoCLb,yBpCWgB,EAAA;EEGhB;IkCVI,WpCCS;IoCAT,yBAAkC,EAAA;EAH9B;IAQJ,UAAU;IACV,iDpCAY,EAAA;;AmCqChB;ECjDA,WpCMa;EoCLb,yBpCwCe,EAAA;EE1Bf;IkCVI,WpCCS;IoCAT,yBAAkC,EAAA;EAH9B;IAQJ,UAAU;IACV,+CpC6BW,EAAA;;AmCQf;ECjDA,WpCMa;EoCLb,yBpC0Ce,EAAA;EE5Bf;IkCVI,WpCCS;IoCAT,yBAAkC,EAAA;EAH9B;IAQJ,UAAU;IACV,gDpC+BW,EAAA;;AmCMf;ECjDA,cpCegB;EoCdhB,yBpCuCe,EAAA;EEzBf;IkCVI,cpCUY;IoCTZ,yBAAkC,EAAA;EAH9B;IAQJ,UAAU;IACV,+CpC4BW,EAAA;;AmCSf;ECjDA,WpCMa;EoCLb,yBpCqCe,EAAA;EEvBf;IkCVI,WpCCS;IoCAT,yBAAkC,EAAA;EAH9B;IAQJ,UAAU;IACV,+CpC0BW,EAAA;;AmCWf;ECjDA,cpCegB;EoCdhB,yBpCMgB,EAAA;EEQhB;IkCVI,cpCUY;IoCTZ,yBAAkC,EAAA;EAH9B;IAQJ,UAAU;IACV,iDpCLY,EAAA;;AmC0ChB;ECjDA,WpCMa;EoCLb,yBpCagB,EAAA;EEChB;IkCVI,WpCCS;IoCAT,yBAAkC,EAAA;EAH9B;IAQJ,UAAU;IACV,8CpCEY,EAAA;;AqCflB;EACE,kBAAqD;EACrD,mBrCyzBsC;EqCvzBtC,yBrCKgB;EOSd,qBP8N+B,EAAA;EWpL/B;I0B5DJ;MAQI,kBrCmzBoC,EAAA,EqCjzBvC;;AAED;EACE,gBAAgB;EAChB,eAAe;E9BIb,gB8BHsB,EAAA;;ACX1B;EACE,kBAAkB;EAClB,wBtCy9ByC;EsCx9BzC,mBtCy9BsC;EsCx9BtC,6BAA6C;E/BU3C,sBP6NgC,EAAA;;AsClOpC;EAEE,cAAc,EAAA;;AAIhB;EACE,gBtC6Q+B,EAAA;;AsCrQjC;EACE,mBAAsD,EAAA;EADxD;IAKI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,wBtC07BuC;IsCz7BvC,cAAc,EAAA;;AAUhB;EC/CA,cxBwGgE;EInG9D,yBJmG8D;EwBtGhE,qBxBsGgE,EAAA;EwBpGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADsC5B;EC/CA,cxBwGgE;EInG9D,yBJmG8D;EwBtGhE,qBxBsGgE,EAAA;EwBpGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADsC5B;EC/CA,cxBwGgE;EInG9D,yBJmG8D;EwBtGhE,qBxBsGgE,EAAA;EwBpGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADsC5B;EC/CA,cxBwGgE;EInG9D,yBJmG8D;EwBtGhE,qBxBsGgE,EAAA;EwBpGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADsC5B;EC/CA,cxBwGgE;EInG9D,yBJmG8D;EwBtGhE,qBxBsGgE,EAAA;EwBpGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADsC5B;EC/CA,cxBwGgE;EInG9D,yBJmG8D;EwBtGhE,qBxBsGgE,EAAA;EwBpGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADsC5B;EC/CA,cxBwGgE;EInG9D,yBJmG8D;EwBtGhE,qBxBsGgE,EAAA;EwBpGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ADsC5B;EC/CA,cxBwGgE;EInG9D,yBJmG8D;EwBtGhE,qBxBsGgE,EAAA;EwBpGhE;IACE,yBAAqC,EAAA;EAGvC;IACE,cAA0B,EAAA;;ACR5B;EACE;IAAO,2BAAuC,EAAA;EAC9C;IAAK,wBAAwB,EAAA,EAAA;;AAIjC;EACE,aAAa;EACb,YxCk+BsC;EwCj+BtC,gBAAgB;EAChB,cAAc;EvCwKV,kBAAW;EuCtKf,yBxCLgB;EOSd,sBP6NgC,EAAA;;AwC5NpC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,WxCjBa;EwCkBb,kBAAkB;EAClB,mBAAmB;EACnB,yBxCQe;EiBnBX,2BjBo+B4C,EAAA;EiBh+B5C;IuBDN;MvBEQ,gBAAgB,EAAA,EuBQvB;;AAED;ErBYE,qMAA6I;EqBV7I,0BxC28BsC,EAAA;;AwCv8BtC;EACE,kDAA8D,EAAA;EAG5D;IAJJ;MAKM,eAAe,EAAA,EAGpB;;AC7CH;EACE,aAAa;EACb,uBAAuB,EAAA;;AAGzB;EACE,SAAO,EAAA;;ACFT;EACE,aAAa;EACb,sBAAsB;EAGtB,eAAe;EACf,gBAAgB;EnCQd,sBP6NgC,EAAA;;A0C3NpC;EACE,WAAW;EACX,c1CRgB;E0CShB,mBAAmB,EAAA;ExCPnB;IwCWE,UAAU;IACV,c1Cdc;I0Ced,qBAAqB;IACrB,yB1CtBc,EAAA;E0CYlB;IAcI,c1ClBc;I0CmBd,yB1C1Bc,EAAA;;A0CmClB;EACE,kBAAkB;EAClB,cAAc;EACd,wB1Ci9ByC;E0C98BzC,sB1C3Ca;E0C4Cb,sC1ClCa,EAAA;E0C2Bf;InCjBI,+BmC2BkC;InC1BlC,gCmC0BkC,EAAA;EAVtC;InCHI,mCmCiBqC;InChBrC,kCmCgBqC,EAAA;EAdzC;IAmBI,c1ClDc;I0CmDd,oBAAoB;IACpB,sB1C1DW,EAAA;E0CqCf;IA0BI,UAAU;IACV,W1ChEW;I0CiEX,yB1CrCa;I0CsCb,qB1CtCa,EAAA;E0CSjB;IAiCI,mBAAmB,EAAA;IAjCvB;MAoCM,gB1C4J2B;M0C3J3B,qB1C2J2B,EAAA;;A0C7I7B;EACE,mBAAmB,EAAA;EADrB;InCtBA,kCPsKgC;IOlLhC,0BmCwCwC,EAAA;EANxC;InClCA,gCPkLgC;IOtKhC,4BmCiC0C,EAAA;EAX1C;IAeM,aAAa,EAAA;EAfnB;IAmBM,qB1C0HuB;I0CzHvB,oBAAoB,EAAA;IApB1B;MAuBQ,iB1CsHqB;M0CrHrB,sB1CqHqB,EAAA;;AWhL7B;E+BmCA;IACE,mBAAmB,EAAA;IADrB;MnCtBA,kCPsKgC;MOlLhC,0BmCwCwC,EAAA;IANxC;MnClCA,gCPkLgC;MOtKhC,4BmCiC0C,EAAA;IAX1C;MAeM,aAAa,EAAA;IAfnB;MAmBM,qB1C0HuB;M0CzHvB,oBAAoB,EAAA;MApB1B;QAuBQ,iB1CsHqB;Q0CrHrB,sB1CqHqB,EAAA,E0CpHtB;;A/B5DP;E+BmCA;IACE,mBAAmB,EAAA;IADrB;MnCtBA,kCPsKgC;MOlLhC,0BmCwCwC,EAAA;IANxC;MnClCA,gCPkLgC;MOtKhC,4BmCiC0C,EAAA;IAX1C;MAeM,aAAa,EAAA;IAfnB;MAmBM,qB1C0HuB;M0CzHvB,oBAAoB,EAAA;MApB1B;QAuBQ,iB1CsHqB;Q0CrHrB,sB1CqHqB,EAAA,E0CpHtB;;A/B5DP;E+BmCA;IACE,mBAAmB,EAAA;IADrB;MnCtBA,kCPsKgC;MOlLhC,0BmCwCwC,EAAA;IANxC;MnClCA,gCPkLgC;MOtKhC,4BmCiC0C,EAAA;IAX1C;MAeM,aAAa,EAAA;IAfnB;MAmBM,qB1C0HuB;M0CzHvB,oBAAoB,EAAA;MApB1B;QAuBQ,iB1CsHqB;Q0CrHrB,sB1CqHqB,EAAA,E0CpHtB;;A/B5DP;E+BmCA;IACE,mBAAmB,EAAA;IADrB;MnCtBA,kCPsKgC;MOlLhC,0BmCwCwC,EAAA;IANxC;MnClCA,gCPkLgC;MOtKhC,4BmCiC0C,EAAA;IAX1C;MAeM,aAAa,EAAA;IAfnB;MAmBM,qB1C0HuB;M0CzHvB,oBAAoB,EAAA;MApB1B;QAuBQ,iB1CsHqB;Q0CrHrB,sB1CqHqB,EAAA,E0CpHtB;;AAaX;EnCnHI,gBmCoHsB,EAAA;EAD1B;IAII,qB1CmG6B,EAAA;I0CvGjC;MAOM,sBAAsB,EAAA;;ACzI1B;EACE,c5BqG8D;E4BpG9D,yB5BoG8D,EAAA;EbzFhE;IyCPM,c5BgG0D;I4B/F1D,yBAAyC,EAAA;EAP/C;IAWM,W3CPO;I2CQP,yB5B0F0D;I4BzF1D,qB5ByF0D,EAAA;;A4BtGhE;EACE,c5BqG8D;E4BpG9D,yB5BoG8D,EAAA;EbzFhE;IyCPM,c5BgG0D;I4B/F1D,yBAAyC,EAAA;EAP/C;IAWM,W3CPO;I2CQP,yB5B0F0D;I4BzF1D,qB5ByF0D,EAAA;;A4BtGhE;EACE,c5BqG8D;E4BpG9D,yB5BoG8D,EAAA;EbzFhE;IyCPM,c5BgG0D;I4B/F1D,yBAAyC,EAAA;EAP/C;IAWM,W3CPO;I2CQP,yB5B0F0D;I4BzF1D,qB5ByF0D,EAAA;;A4BtGhE;EACE,c5BqG8D;E4BpG9D,yB5BoG8D,EAAA;EbzFhE;IyCPM,c5BgG0D;I4B/F1D,yBAAyC,EAAA;EAP/C;IAWM,W3CPO;I2CQP,yB5B0F0D;I4BzF1D,qB5ByF0D,EAAA;;A4BtGhE;EACE,c5BqG8D;E4BpG9D,yB5BoG8D,EAAA;EbzFhE;IyCPM,c5BgG0D;I4B/F1D,yBAAyC,EAAA;EAP/C;IAWM,W3CPO;I2CQP,yB5B0F0D;I4BzF1D,qB5ByF0D,EAAA;;A4BtGhE;EACE,c5BqG8D;E4BpG9D,yB5BoG8D,EAAA;EbzFhE;IyCPM,c5BgG0D;I4B/F1D,yBAAyC,EAAA;EAP/C;IAWM,W3CPO;I2CQP,yB5B0F0D;I4BzF1D,qB5ByF0D,EAAA;;A4BtGhE;EACE,c5BqG8D;E4BpG9D,yB5BoG8D,EAAA;EbzFhE;IyCPM,c5BgG0D;I4B/F1D,yBAAyC,EAAA;EAP/C;IAWM,W3CPO;I2CQP,yB5B0F0D;I4BzF1D,qB5ByF0D,EAAA;;A4BtGhE;EACE,c5BqG8D;E4BpG9D,yB5BoG8D,EAAA;EbzFhE;IyCPM,c5BgG0D;I4B/F1D,yBAAyC,EAAA;EAP/C;IAWM,W3CPO;I2CQP,yB5B0F0D;I4BzF1D,qB5ByF0D,EAAA;;A6BzGlE;EACE,YAAY;E3CmLR,iBAAW;E2CjLf,gB5C8R+B;E4C7R/B,cAAc;EACd,W5CYa;E4CXb,yB5CCa;E4CAb,WAAW,EAAA;E1CKX;I0CDE,W5CMW;I4CLX,qBAAqB,EAAA;E1CIvB;I0CCI,YAAY,EAAA;;AAWlB;EACE,UAAU;EACV,6BAA6B;EAC7B,SAAS,EAAA;;AAMX;EACE,oBAAoB,EAAA;;ACtCtB;EAGE,iB7C24BuC;E6C14BvC,gB7C04BuC;EC1tBnC,mBAAW;E4C7Kf,2C7CAa;E6CCb,4BAA4B;EAC5B,oC7C44BmD;E6C34BnD,gD7COa;E6CNb,UAAU;EtCOR,sBPo4BsC,EAAA;E6Ct5B1C;IAeI,sB7Cg4BsC,EAAA;E6C/4B1C;IAmBI,UAAU,EAAA;EAnBd;IAuBI,cAAc;IACd,UAAU,EAAA;EAxBd;IA4BI,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,mBAAmB;EACnB,wB7C42BwC;E6C32BxC,c7CvBgB;E6CwBhB,2C7C9Ba;E6C+Bb,4BAA4B;EAC5B,4C7Co3BoD;EOh4BlD,2CQuH4D;ERtH5D,4CQsH4D,EAAA;;A8BvGhE;EACE,gB7Cm2BwC,EAAA;;A8Cz4B1C;EAEE,gBAAgB,EAAA;EAFlB;IAKI,kBAAkB;IAClB,gBAAgB,EAAA;;AAKpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,a9C4pBsC;E8C3pBtC,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAGhB,UAAU,EAAA;;AAOZ;EACE,kBAAkB;EAClB,WAAW;EACX,c9Ci5BuC;E8C/4BvC,oBAAoB,EAAA;EAGpB;I7B3BI,mCjBs8BoD;I8Cz6BtD,8B9Cu6BmD,EAAA;IiBh8BjD;M6BuBJ;Q7BtBM,gBAAgB,EAAA,E6ByBrB;EACD;IACE,e9Cq6BoC,EAAA;E8Cj6BtC;IACE,sB9Ck6B2C,EAAA;;A8C95B/C;EACE,aAAa;EACb,6B/BuF8D,EAAA;E+BzFhE;IAKI,8B/BoF4D;I+BnF5D,gBAAgB,EAAA;EANpB;;IAWI,cAAc,EAAA;EAXlB;IAeI,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,mBAAmB;EACnB,6B/BmE8D,EAAA;E+BtEhE;IAOI,cAAc;IACd,0B/B8D4D;I+B7D5D,2BAAmB;IAAnB,mBAAmB;IACnB,WAAW,EAAA;EAVf;IAeI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY,EAAA;IAjBhB;MAoBM,gBAAgB,EAAA;IApBtB;MAwBM,aAAa,EAAA;;AAMnB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EAGX,oBAAoB;EACpB,sB9C3Ga;E8C4Gb,4BAA4B;EAC5B,oC9CnGa;EOCX,qBP8N+B;E8CxHjC,UAAU,EAAA;;AAIZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,a9CgjBsC;E8C/iBtC,YAAY;EACZ,aAAa;EACb,sB9ClHa,EAAA;E8C2Gf;IAUW,UAAU,EAAA;EAVrB;IAWW,Y9C+zB2B,EAAA;;A8C1zBtC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kB9C4zBsC;E8C3zBtC,gC9CvIgB;EOiBd,0CQuH4D;ERtH5D,2CQsH4D,EAAA;E+BNhE;IASI,kB9CuzBoC;I8CrzBpC,8BAA6F,EAAA;;AAKjG;EACE,gBAAgB;EAChB,gB9CuI+B,EAAA;;A8ClIjC;EACE,kBAAkB;EAGlB,cAAc;EACd,a9C0wBsC,EAAA;;A8CtwBxC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAiE;EACjE,6B9CxKgB;EO+Bd,8CQyG4D;ERxG5D,6CQwG4D,EAAA;E+B0BhE;IAaI,eAAyC,EAAA;;AAK7C;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAA;;AnCvId;EmCzBJ;IAuKI,gB9CuwBqC;I8CtwBrC,oBAAyC,EAAA;EAlJ7C;IAsJI,+B/B7D4D,EAAA;I+BzFhE;MAyJM,gC/BhE0D,EAAA;E+BtEhE;IA2II,+B/BrE4D,EAAA;I+BtEhE;MA8IM,4B/BxE0D;M+ByE1D,2BAAmB;MAAnB,mBAAmB,EAAA;EAQvB;IAAY,gB9C+uB2B,EAAA,E8C/uBH;;AnCvKlC;EmC2KF;;IAEE,gB9CuuBqC,EAAA,E8CtuBtC;;AnC9KC;EmCkLF;IAAY,iB9CiuB4B,EAAA,E8CjuBJ;;AC7OtC;EACE,kBAAkB;EAClB,a/CgrBsC;E+C/qBtC,cAAc;EACd,S/C61BmC;EgDj2BnC,qNhDoRoO;EgDlRpO,kBAAkB;EAClB,gBhD4R+B;EgD3R/B,gBhDgS+B;EgD/R/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;E/CqKZ,mBAAW;E8CzKf,qBAAqB;EACrB,UAAU,EAAA;EAXZ;IAaW,Y/Ci1B2B,EAAA;E+C91BtC;IAgBI,kBAAkB;IAClB,cAAc;IACd,a/Ci1BqC;I+Ch1BrC,c/Ci1BqC,EAAA;I+Cp2BzC;MAsBM,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAKzB;EACE,iBAAgC,EAAA;EADlC;IAII,SAAS,EAAA;IAJb;MAOM,MAAM;MACN,6BAAiE;MACjE,sB/CvBS,EAAA;;A+C4Bf;EACE,iB/CuzBuC,EAAA;E+CxzBzC;IAII,OAAO;IACP,a/CmzBqC;I+ClzBrC,c/CizBqC,EAAA;I+CvzBzC;MASM,QAAQ;MACR,oCAA6F;MAC7F,wB/CvCS,EAAA;;A+C4Cf;EACE,iBAAgC,EAAA;EADlC;IAII,MAAM,EAAA;IAJV;MAOM,SAAS;MACT,6B/CgyBmC;M+C/xBnC,yB/CrDS,EAAA;;A+C0Df;EACE,iB/CyxBuC,EAAA;E+C1xBzC;IAII,QAAQ;IACR,a/CqxBqC;I+CpxBrC,c/CmxBqC,EAAA;I+CzxBzC;MASM,OAAO;MACP,oC/CgxBmC;M+C/wBnC,uB/CrES,EAAA;;A+C0Ff;EACE,gB/C+uBuC;E+C9uBvC,uB/CovBuC;E+CnvBvC,W/CvGa;E+CwGb,kBAAkB;EAClB,sB/C/Fa;EOCX,sBP6NgC,EAAA;;AiD/OpC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,ajD8qBsC;EiD7qBtC,cAAc;EACd,gBjD+2BuC;EgDp3BvC,qNhDoRoO;EgDlRpO,kBAAkB;EAClB,gBhD4R+B;EgD3R/B,gBhDgS+B;EgD/R/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;E/CqKZ,mBAAW;EgDxKf,qBAAqB;EACrB,sBjDNa;EiDOb,4BAA4B;EAC5B,oCjDEa;EOCX,qBP8N+B,EAAA;EiDhPnC;IAoBI,kBAAkB;IAClB,cAAc;IACd,WjD+2BoC;IiD92BpC,cjD+2BqC;IiD92BrC,gBjDwN+B,EAAA;IiDhPnC;MA4BM,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAKzB;EACE,qBjDg2BuC,EAAA;EiDj2BzC;IAII,2BlCyG4D,EAAA;IkC7GhE;MAOM,SAAS;MACT,6BAAiE;MACjE,qCjD21BiE,EAAA;IiDp2BvE;MAaM,WjD0L2B;MiDzL3B,6BAAiE;MACjE,sBjD7CS,EAAA;;AiDkDf;EACE,mBjD40BuC,EAAA;EiD70BzC;IAII,yBlCqF4D;IkCpF5D,ajDw0BqC;IiDv0BrC,YjDs0BoC;IiDr0BpC,gBAAgC,EAAA;IAPpC;MAUM,OAAO;MACP,oCAA6F;MAC7F,uCjDo0BiE,EAAA;IiDh1BvE;MAgBM,SjDmK2B;MiDlK3B,oCAA6F;MAC7F,wBjDpES,EAAA;;AiDyEf;EACE,kBjDqzBuC,EAAA;EiDtzBzC;IAII,wBlC8D4D,EAAA;IkClEhE;MAOM,MAAM;MACN,oCAA6F;MAC7F,wCjDgzBiE,EAAA;IiDzzBvE;MAaM,QjD+I2B;MiD9I3B,oCAA6F;MAC7F,yBjDxFS,EAAA;EiDyEf;IAqBI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,cAAc;IACd,WjD4xBoC;IiD3xBpC,oBAAuC;IACvC,WAAW;IACX,gCjDgxBuD,EAAA;;AiD5wB3D;EACE,oBjDqxBuC,EAAA;EiDtxBzC;IAII,0BlC8B4D;IkC7B5D,ajDixBqC;IiDhxBrC,YjD+wBoC;IiD9wBpC,gBAAgC,EAAA;IAPpC;MAUM,QAAQ;MACR,oCjD2wBmC;MiD1wBnC,sCjD6wBiE,EAAA;IiDzxBvE;MAgBM,UjD4G2B;MiD3G3B,oCjDqwBmC;MiDpwBnC,uBjD3HS,EAAA;;AiDiJf;EACE,uBjDsuBwC;EiDruBxC,gBAAgB;EhD0BZ,eAAW;EgDvBf,yBjD+tByD;EiD9tBzD,gCAAyE;E1CnIvE,0CQuH4D;ERtH5D,2CQsH4D,EAAA;EkCMhE;IAUI,aAAa,EAAA;;AAIjB;EACE,uBjDwtBwC;EiDvtBxC,cjDxJgB,EAAA;;AkDHlB;EACE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;ECvBhB;IACE,cAAc;IACd,WAAW;IACX,WAAW,EAAA;;ADwBf;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mCAA2B;UAA3B,2BAA2B;EjClBvB,sCjB2jCkF,EAAA;EiBvjClF;IiCQN;MjCPQ,gBAAgB,EAAA,EiCevB;;AAED;;;EAGE,cAAc,EAAA;;AAGhB;;EAEE,2BAA2B,EAAA;;AAG7B;;EAEE,4BAA4B,EAAA;;AAQ9B;EAEI,UAAU;EACV,4BAA4B;EAC5B,eAAe,EAAA;;AAJnB;;;EAUI,UAAU;EACV,UAAU,EAAA;;AAXd;;EAgBI,UAAU;EACV,UAAU;EjC5DR,2BjB0jCkC,EAAA;EiBtjClC;IiCuCN;;MjCtCQ,gBAAgB,EAAA,EiCyDrB;;AAQH;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EAEV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UlDs9BsC;EkDr9BtC,UAAU;EACV,WlD3Fa;EkD4Fb,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,YlDi9BqC;EiBviCjC,8BjByiCgD,EAAA;EiBriChD;IiCkEN;;MjCjEQ,gBAAgB,EAAA,EiC2FvB;EhDhGC;;;IgD2FE,WlDpGW;IkDqGX,qBAAqB;IACrB,UAAU;IACV,YlD08BmC,EAAA;;AkDv8BvC;EACE,OAAO,EAAA;;AAKT;EACE,QAAQ,EAAA;;AAOV;;EAEE,qBAAqB;EACrB,WlDm8BuC;EkDl8BvC,YlDk8BuC;EkDj8BvC,qCAAqC,EAAA;;AAEvC;EACE,yDnC1EgF,EAAA;;AmC4ElF;EACE,yDnC7EgF,EAAA;;AmCsFlF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;EAEf,iBlDy5BsC;EkDx5BtC,gBlDw5BsC;EkDv5BtC,gBAAgB,EAAA;EAZlB;IAeI,uBAAuB;IACvB,cAAc;IACd,WlDu5BqC;IkDt5BrC,WlDu5BoC;IkDt5BpC,iBlDw5BoC;IkDv5BpC,gBlDu5BoC;IkDt5BpC,mBAAmB;IACnB,eAAe;IACf,sBlDnKW;IkDoKX,4BAA4B;IAE5B,kCAAiE;IACjE,qCAAoE;IACpE,WAAW;IjC/JT,6BjBgjC+C,EAAA;IiB5iC/C;MiC+HN;QjC9HQ,gBAAgB,EAAA,EiC4JrB;EA9BH;IAiCI,UAAU,EAAA;;AASd;EACE,kBAAkB;EAClB,UAA4C;EAC5C,YAAY;EACZ,SAA2C;EAC3C,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WlD9La;EkD+Lb,kBAAkB,EAAA;;AElMpB;EACE;IAAK,yBAAyB,EAAA,EAAA;;AAGhC;EACE,qBAAqB;EACrB,WpDskC4B;EoDrkC5B,YpDqkC4B;EoDpkC5B,wBpDskC+B;EoDrkC/B,iCAAgD;EAChD,+BAA+B;EAE/B,kBAAkB;EAClB,8CAA8C,EAAA;;AAGhD;EACE,WpDgkC4B;EoD/jC5B,YpD+jC4B;EoD9jC5B,mBpDgkC4B,EAAA;;AoDzjC9B;EACE;IACE,mBAAmB,EAAA;EAErB;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAInB;EACE,qBAAqB;EACrB,WpDsiC4B;EoDriC5B,YpDqiC4B;EoDpiC5B,wBpDsiC+B;EoDriC/B,8BAA8B;EAE9B,kBAAkB;EAClB,UAAU;EACV,4CAA4C,EAAA;;AAG9C;EACE,WpDgiC4B;EoD/hC5B,YpD+hC4B,EAAA;;AoD3hC5B;EACE;;IAEE,wBAAwB,EAAA,EACzB;;AC5DL;EAAqB,mCAAmC,EAAA;;AACxD;EAAqB,8BAA8B,EAAA;;AACnD;EAAqB,iCAAiC,EAAA;;AACtD;EAAqB,iCAAiC,EAAA;;AACtD;EAAqB,sCAAsC,EAAA;;AAC3D;EAAqB,mCAAmC,EAAA;;ACFtD;EACE,oCAAmC,EAAA;;ApDUrC;;;EoDLI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;ApDUrC;;;EoDLI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;ApDUrC;;;EoDLI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;ApDUrC;;;EoDLI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;ApDUrC;;;EoDLI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;ApDUrC;;;EoDLI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;ApDUrC;;;EoDLI,oCAAgD,EAAA;;AANpD;EACE,oCAAmC,EAAA;;ApDUrC;;;EoDLI,oCAAgD,EAAA;;ACCtD;EACE,iCAAmC,EAAA;;AAGrC;EACE,wCAAwC,EAAA;;ACX1C;EAAkB,oCAAoD,EAAA;;AACtE;EAAkB,wCAAwD,EAAA;;AAC1E;EAAkB,0CAA0D,EAAA;;AAC5E;EAAkB,2CAA2D,EAAA;;AAC7E;EAAkB,yCAAyD,EAAA;;AAE3E;EAAmB,oBAAoB,EAAA;;AACvC;EAAmB,wBAAwB,EAAA;;AAC3C;EAAmB,0BAA0B,EAAA;;AAC7C;EAAmB,2BAA2B,EAAA;;AAC9C;EAAmB,yBAAyB,EAAA;;AAG1C;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AADjC;EACE,gCAA+B,EAAA;;AAInC;EACE,6BAA+B,EAAA;;AAOjC;EACE,gCAA2C,EAAA;;AAG7C;EACE,iCAAwC,EAAA;;AAG1C;EACE,0CAAiD;EACjD,2CAAkD,EAAA;;AAGpD;EACE,2CAAkD;EAClD,8CAAqD,EAAA;;AAGvD;EACE,8CAAqD;EACrD,6CAAoD,EAAA;;AAGtD;EACE,0CAAiD;EACjD,6CAAoD,EAAA;;AAGtD;EACE,gCAA2C,EAAA;;AAG7C;EACE,6BAA6B,EAAA;;AAG/B;EACE,+BAAuC,EAAA;;AAGzC;EACE,2BAA2B,EAAA;;ALxE3B;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAA;;AMOT;EAAwB,wBAA0B,EAAA;;AAAlD;EAAwB,0BAA0B,EAAA;;AAAlD;EAAwB,gCAA0B,EAAA;;AAAlD;EAAwB,yBAA0B,EAAA;;AAAlD;EAAwB,yBAA0B,EAAA;;AAAlD;EAAwB,6BAA0B,EAAA;;AAAlD;EAAwB,8BAA0B,EAAA;;AAAlD;EAAwB,wBAA0B,EAAA;;AAAlD;EAAwB,+BAA0B,EAAA;;A9CiDpD;E8CjDE;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,0BAA0B,EAAA;EAAlD;IAAwB,gCAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,6BAA0B,EAAA;EAAlD;IAAwB,8BAA0B,EAAA;EAAlD;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,+BAA0B,EAAA,EAAI;;A9CiDxD;E8CjDE;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,0BAA0B,EAAA;EAAlD;IAAwB,gCAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,6BAA0B,EAAA;EAAlD;IAAwB,8BAA0B,EAAA;EAAlD;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,+BAA0B,EAAA,EAAI;;A9CiDxD;E8CjDE;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,0BAA0B,EAAA;EAAlD;IAAwB,gCAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,6BAA0B,EAAA;EAAlD;IAAwB,8BAA0B,EAAA;EAAlD;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,+BAA0B,EAAA,EAAI;;A9CiDxD;E8CjDE;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,0BAA0B,EAAA;EAAlD;IAAwB,gCAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,yBAA0B,EAAA;EAAlD;IAAwB,6BAA0B,EAAA;EAAlD;IAAwB,8BAA0B,EAAA;EAAlD;IAAwB,wBAA0B,EAAA;EAAlD;IAAwB,+BAA0B,EAAA,EAAI;;AAU5D;EAEI;IAAqB,wBAA0B,EAAA;EAA/C;IAAqB,0BAA0B,EAAA;EAA/C;IAAqB,gCAA0B,EAAA;EAA/C;IAAqB,yBAA0B,EAAA;EAA/C;IAAqB,yBAA0B,EAAA;EAA/C;IAAqB,6BAA0B,EAAA;EAA/C;IAAqB,8BAA0B,EAAA;EAA/C;IAAqB,wBAA0B,EAAA;EAA/C;IAAqB,+BAA0B,EAAA,EAAI;;ACrBvD;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,gBAAgB,EAAA;EALlB;IAQI,cAAc;IACd,WAAW,EAAA;EATf;;;;;IAiBI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,SAAS,EAAA;;AAQX;EAEI,sBAAmG,EAAA;;AAFvG;EAEI,mBAAmG,EAAA;;AAFvG;EAEI,gBAAmG,EAAA;;AAFvG;EAEI,iBAAmG,EAAA;;ACzBrG;EAAgC,8BAA8B,EAAA;;AAC9D;EAAgC,iCAAiC,EAAA;;AACjE;EAAgC,sCAAsC,EAAA;;AACtE;EAAgC,yCAAyC,EAAA;;AAEzE;EAA8B,0BAA0B,EAAA;;AACxD;EAA8B,4BAA4B,EAAA;;AAC1D;EAA8B,kCAAkC,EAAA;;AAChE;EAA8B,yBAAyB,EAAA;;AACvD;EAA8B,uBAAuB,EAAA;;AACrD;EAA8B,uBAAuB,EAAA;;AACrD;EAA8B,yBAAyB,EAAA;;AACvD;EAA8B,yBAAyB,EAAA;;AAEvD;EAAoC,sCAAsC,EAAA;;AAC1E;EAAoC,oCAAoC,EAAA;;AACxE;EAAoC,kCAAkC,EAAA;;AACtE;EAAoC,yCAAyC,EAAA;;AAC7E;EAAoC,wCAAwC,EAAA;;AAE5E;EAAiC,kCAAkC,EAAA;;AACnE;EAAiC,gCAAgC,EAAA;;AACjE;EAAiC,8BAA8B,EAAA;;AAC/D;EAAiC,gCAAgC,EAAA;;AACjE;EAAiC,+BAA+B,EAAA;;AAEhE;EAAkC,oCAAoC,EAAA;;AACtE;EAAkC,kCAAkC,EAAA;;AACpE;EAAkC,gCAAgC,EAAA;;AAClE;EAAkC,uCAAuC,EAAA;;AACzE;EAAkC,sCAAsC,EAAA;;AACxE;EAAkC,iCAAiC,EAAA;;AAEnE;EAAgC,2BAA2B,EAAA;;AAC3D;EAAgC,iCAAiC,EAAA;;AACjE;EAAgC,+BAA+B,EAAA;;AAC/D;EAAgC,6BAA6B,EAAA;;AAC7D;EAAgC,+BAA+B,EAAA;;AAC/D;EAAgC,8BAA8B,EAAA;;AhDY9D;EgDlDA;IAAgC,8BAA8B,EAAA;EAC9D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,sCAAsC,EAAA;EACtE;IAAgC,yCAAyC,EAAA;EAEzE;IAA8B,0BAA0B,EAAA;EACxD;IAA8B,4BAA4B,EAAA;EAC1D;IAA8B,kCAAkC,EAAA;EAChE;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,yBAAyB,EAAA;EAEvD;IAAoC,sCAAsC,EAAA;EAC1E;IAAoC,oCAAoC,EAAA;EACxE;IAAoC,kCAAkC,EAAA;EACtE;IAAoC,yCAAyC,EAAA;EAC7E;IAAoC,wCAAwC,EAAA;EAE5E;IAAiC,kCAAkC,EAAA;EACnE;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,8BAA8B,EAAA;EAC/D;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,+BAA+B,EAAA;EAEhE;IAAkC,oCAAoC,EAAA;EACtE;IAAkC,kCAAkC,EAAA;EACpE;IAAkC,gCAAgC,EAAA;EAClE;IAAkC,uCAAuC,EAAA;EACzE;IAAkC,sCAAsC,EAAA;EACxE;IAAkC,iCAAiC,EAAA;EAEnE;IAAgC,2BAA2B,EAAA;EAC3D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,6BAA6B,EAAA;EAC7D;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,8BAA8B,EAAA,EAAI;;AhDYlE;EgDlDA;IAAgC,8BAA8B,EAAA;EAC9D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,sCAAsC,EAAA;EACtE;IAAgC,yCAAyC,EAAA;EAEzE;IAA8B,0BAA0B,EAAA;EACxD;IAA8B,4BAA4B,EAAA;EAC1D;IAA8B,kCAAkC,EAAA;EAChE;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,yBAAyB,EAAA;EAEvD;IAAoC,sCAAsC,EAAA;EAC1E;IAAoC,oCAAoC,EAAA;EACxE;IAAoC,kCAAkC,EAAA;EACtE;IAAoC,yCAAyC,EAAA;EAC7E;IAAoC,wCAAwC,EAAA;EAE5E;IAAiC,kCAAkC,EAAA;EACnE;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,8BAA8B,EAAA;EAC/D;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,+BAA+B,EAAA;EAEhE;IAAkC,oCAAoC,EAAA;EACtE;IAAkC,kCAAkC,EAAA;EACpE;IAAkC,gCAAgC,EAAA;EAClE;IAAkC,uCAAuC,EAAA;EACzE;IAAkC,sCAAsC,EAAA;EACxE;IAAkC,iCAAiC,EAAA;EAEnE;IAAgC,2BAA2B,EAAA;EAC3D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,6BAA6B,EAAA;EAC7D;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,8BAA8B,EAAA,EAAI;;AhDYlE;EgDlDA;IAAgC,8BAA8B,EAAA;EAC9D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,sCAAsC,EAAA;EACtE;IAAgC,yCAAyC,EAAA;EAEzE;IAA8B,0BAA0B,EAAA;EACxD;IAA8B,4BAA4B,EAAA;EAC1D;IAA8B,kCAAkC,EAAA;EAChE;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,yBAAyB,EAAA;EAEvD;IAAoC,sCAAsC,EAAA;EAC1E;IAAoC,oCAAoC,EAAA;EACxE;IAAoC,kCAAkC,EAAA;EACtE;IAAoC,yCAAyC,EAAA;EAC7E;IAAoC,wCAAwC,EAAA;EAE5E;IAAiC,kCAAkC,EAAA;EACnE;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,8BAA8B,EAAA;EAC/D;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,+BAA+B,EAAA;EAEhE;IAAkC,oCAAoC,EAAA;EACtE;IAAkC,kCAAkC,EAAA;EACpE;IAAkC,gCAAgC,EAAA;EAClE;IAAkC,uCAAuC,EAAA;EACzE;IAAkC,sCAAsC,EAAA;EACxE;IAAkC,iCAAiC,EAAA;EAEnE;IAAgC,2BAA2B,EAAA;EAC3D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,6BAA6B,EAAA;EAC7D;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,8BAA8B,EAAA,EAAI;;AhDYlE;EgDlDA;IAAgC,8BAA8B,EAAA;EAC9D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,sCAAsC,EAAA;EACtE;IAAgC,yCAAyC,EAAA;EAEzE;IAA8B,0BAA0B,EAAA;EACxD;IAA8B,4BAA4B,EAAA;EAC1D;IAA8B,kCAAkC,EAAA;EAChE;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,uBAAuB,EAAA;EACrD;IAA8B,yBAAyB,EAAA;EACvD;IAA8B,yBAAyB,EAAA;EAEvD;IAAoC,sCAAsC,EAAA;EAC1E;IAAoC,oCAAoC,EAAA;EACxE;IAAoC,kCAAkC,EAAA;EACtE;IAAoC,yCAAyC,EAAA;EAC7E;IAAoC,wCAAwC,EAAA;EAE5E;IAAiC,kCAAkC,EAAA;EACnE;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,8BAA8B,EAAA;EAC/D;IAAiC,gCAAgC,EAAA;EACjE;IAAiC,+BAA+B,EAAA;EAEhE;IAAkC,oCAAoC,EAAA;EACtE;IAAkC,kCAAkC,EAAA;EACpE;IAAkC,gCAAgC,EAAA;EAClE;IAAkC,uCAAuC,EAAA;EACzE;IAAkC,sCAAsC,EAAA;EACxE;IAAkC,iCAAiC,EAAA;EAEnE;IAAgC,2BAA2B,EAAA;EAC3D;IAAgC,iCAAiC,EAAA;EACjE;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,6BAA6B,EAAA;EAC7D;IAAgC,+BAA+B,EAAA;EAC/D;IAAgC,8BAA8B,EAAA,EAAI;;AC1ClE;EAAwB,sBAAsB,EAAA;;AAC9C;EAAwB,uBAAuB,EAAA;;AAC/C;EAAwB,sBAAsB,EAAA;;AjDoD9C;EiDtDA;IAAwB,sBAAsB,EAAA;EAC9C;IAAwB,uBAAuB,EAAA;EAC/C;IAAwB,sBAAsB,EAAA,EAAI;;AjDoDlD;EiDtDA;IAAwB,sBAAsB,EAAA;EAC9C;IAAwB,uBAAuB,EAAA;EAC/C;IAAwB,sBAAsB,EAAA,EAAI;;AjDoDlD;EiDtDA;IAAwB,sBAAsB,EAAA;EAC9C;IAAwB,uBAAuB,EAAA;EAC/C;IAAwB,sBAAsB,EAAA,EAAI;;AjDoDlD;EiDtDA;IAAwB,sBAAsB,EAAA;EAC9C;IAAwB,uBAAuB,EAAA;EAC/C;IAAwB,sBAAsB,EAAA,EAAI;;ACLpD;EAAyB,mCAA8B;UAA9B,2BAA8B,EAAA;;AAAvD;EAAyB,oCAA8B;UAA9B,4BAA8B,EAAA;;AAAvD;EAAyB,oCAA8B;UAA9B,4BAA8B,EAAA;;ACAvD;EAAsB,yBAA2B,EAAA;;AAAjD;EAAsB,2BAA2B,EAAA;;ACCjD;EAAyB,2BAA8B,EAAA;;AAAvD;EAAyB,6BAA8B,EAAA;;AAAvD;EAAyB,6BAA8B,EAAA;;AAAvD;EAAyB,0BAA8B,EAAA;;AAAvD;EAAyB,mCAA8B;EAA9B,2BAA8B,EAAA;;AAKzD;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,a/DiqBsC,EAAA;;A+D9pBxC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,a/DypBsC,EAAA;;A+DrpBV;EAD9B;IAEI,wBAAgB;IAAhB,gBAAgB;IAChB,MAAM;IACN,a/DipBoC,EAAA,E+D/oBvC;;AC3BD;ECEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS,EAAA;;AAUT;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,mBAAmB,EAAA;;AC7BvB;EAAa,8DAAqC,EAAA;;AAClD;EAAU,wDAAkC,EAAA;;AAC5C;EAAa,uDAAqC,EAAA;;AAClD;EAAe,2BAA2B,EAAA;;ACCtC;EAAuB,qBAA4B,EAAA;;AAAnD;EAAuB,qBAA4B,EAAA;;AAAnD;EAAuB,qBAA4B,EAAA;;AAAnD;EAAuB,sBAA4B,EAAA;;AAAnD;EAAuB,sBAA4B,EAAA;;AAAnD;EAAuB,sBAA4B,EAAA;;AAAnD;EAAuB,sBAA4B,EAAA;;AAAnD;EAAuB,sBAA4B,EAAA;;AAAnD;EAAuB,uBAA4B,EAAA;;AAAnD;EAAuB,uBAA4B,EAAA;;AAIvD;EAAU,0BAA0B,EAAA;;AACpC;EAAU,2BAA2B,EAAA;;AAIrC;EAAc,2BAA2B,EAAA;;AACzC;EAAc,4BAA4B,EAAA;;AAE1C;EAAU,uBAAuB,EAAA;;AACjC;EAAU,wBAAwB,EAAA;;ACT1B;EAAgC,oBAA4B,EAAA;;AAC5D;;EAEE,wBAAoC,EAAA;;AAEtC;;EAEE,0BAAwC,EAAA;;AAE1C;;EAEE,2BAA0C,EAAA;;AAE5C;;EAEE,yBAAsC,EAAA;;AAfxC;EAAgC,0BAA4B,EAAA;;AAC5D;;EAEE,8BAAoC,EAAA;;AAEtC;;EAEE,gCAAwC,EAAA;;AAE1C;;EAEE,iCAA0C,EAAA;;AAE5C;;EAEE,+BAAsC,EAAA;;AAfxC;EAAgC,yBAA4B,EAAA;;AAC5D;;EAEE,6BAAoC,EAAA;;AAEtC;;EAEE,+BAAwC,EAAA;;AAE1C;;EAEE,gCAA0C,EAAA;;AAE5C;;EAEE,8BAAsC,EAAA;;AAfxC;EAAgC,uBAA4B,EAAA;;AAC5D;;EAEE,2BAAoC,EAAA;;AAEtC;;EAEE,6BAAwC,EAAA;;AAE1C;;EAEE,8BAA0C,EAAA;;AAE5C;;EAEE,4BAAsC,EAAA;;AAfxC;EAAgC,yBAA4B,EAAA;;AAC5D;;EAEE,6BAAoC,EAAA;;AAEtC;;EAEE,+BAAwC,EAAA;;AAE1C;;EAEE,gCAA0C,EAAA;;AAE5C;;EAEE,8BAAsC,EAAA;;AAfxC;EAAgC,uBAA4B,EAAA;;AAC5D;;EAEE,2BAAoC,EAAA;;AAEtC;;EAEE,6BAAwC,EAAA;;AAE1C;;EAEE,8BAA0C,EAAA;;AAE5C;;EAEE,4BAAsC,EAAA;;AAfxC;EAAgC,qBAA4B,EAAA;;AAC5D;;EAEE,yBAAoC,EAAA;;AAEtC;;EAEE,2BAAwC,EAAA;;AAE1C;;EAEE,4BAA0C,EAAA;;AAE5C;;EAEE,0BAAsC,EAAA;;AAfxC;EAAgC,2BAA4B,EAAA;;AAC5D;;EAEE,+BAAoC,EAAA;;AAEtC;;EAEE,iCAAwC,EAAA;;AAE1C;;EAEE,kCAA0C,EAAA;;AAE5C;;EAEE,gCAAsC,EAAA;;AAfxC;EAAgC,0BAA4B,EAAA;;AAC5D;;EAEE,8BAAoC,EAAA;;AAEtC;;EAEE,gCAAwC,EAAA;;AAE1C;;EAEE,iCAA0C,EAAA;;AAE5C;;EAEE,+BAAsC,EAAA;;AAfxC;EAAgC,wBAA4B,EAAA;;AAC5D;;EAEE,4BAAoC,EAAA;;AAEtC;;EAEE,8BAAwC,EAAA;;AAE1C;;EAEE,+BAA0C,EAAA;;AAE5C;;EAEE,6BAAsC,EAAA;;AAfxC;EAAgC,0BAA4B,EAAA;;AAC5D;;EAEE,8BAAoC,EAAA;;AAEtC;;EAEE,gCAAwC,EAAA;;AAE1C;;EAEE,iCAA0C,EAAA;;AAE5C;;EAEE,+BAAsC,EAAA;;AAfxC;EAAgC,wBAA4B,EAAA;;AAC5D;;EAEE,4BAAoC,EAAA;;AAEtC;;EAEE,8BAAwC,EAAA;;AAE1C;;EAEE,+BAA0C,EAAA;;AAE5C;;EAEE,6BAAsC,EAAA;;AAQxC;EAAwB,2BAA2B,EAAA;;AACnD;;EAEE,+BAA+B,EAAA;;AAEjC;;EAEE,iCAAiC,EAAA;;AAEnC;;EAEE,kCAAkC,EAAA;;AAEpC;;EAEE,gCAAgC,EAAA;;AAflC;EAAwB,0BAA2B,EAAA;;AACnD;;EAEE,8BAA+B,EAAA;;AAEjC;;EAEE,gCAAiC,EAAA;;AAEnC;;EAEE,iCAAkC,EAAA;;AAEpC;;EAEE,+BAAgC,EAAA;;AAflC;EAAwB,wBAA2B,EAAA;;AACnD;;EAEE,4BAA+B,EAAA;;AAEjC;;EAEE,8BAAiC,EAAA;;AAEnC;;EAEE,+BAAkC,EAAA;;AAEpC;;EAEE,6BAAgC,EAAA;;AAflC;EAAwB,0BAA2B,EAAA;;AACnD;;EAEE,8BAA+B,EAAA;;AAEjC;;EAEE,gCAAiC,EAAA;;AAEnC;;EAEE,iCAAkC,EAAA;;AAEpC;;EAEE,+BAAgC,EAAA;;AAflC;EAAwB,wBAA2B,EAAA;;AACnD;;EAEE,4BAA+B,EAAA;;AAEjC;;EAEE,8BAAiC,EAAA;;AAEnC;;EAEE,+BAAkC,EAAA;;AAEpC;;EAEE,6BAAgC,EAAA;;AAMtC;EAAmB,uBAAuB,EAAA;;AAC1C;;EAEE,2BAA2B,EAAA;;AAE7B;;EAEE,6BAA6B,EAAA;;AAE/B;;EAEE,8BAA8B,EAAA;;AAEhC;;EAEE,4BAA4B,EAAA;;AzDT9B;EyDlDI;IAAgC,oBAA4B,EAAA;EAC5D;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAfxC;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAfxC;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAfxC;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAfxC;IAAgC,qBAA4B,EAAA;EAC5D;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EAfxC;IAAgC,2BAA4B,EAAA;EAC5D;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAQxC;IAAwB,2BAA2B,EAAA;EACnD;;IAEE,+BAA+B,EAAA;EAEjC;;IAEE,iCAAiC,EAAA;EAEnC;;IAEE,kCAAkC,EAAA;EAEpC;;IAEE,gCAAgC,EAAA;EAflC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EAflC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EAflC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EAflC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EAMtC;IAAmB,uBAAuB,EAAA;EAC1C;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA,EAC7B;;AzDVD;EyDlDI;IAAgC,oBAA4B,EAAA;EAC5D;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAfxC;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAfxC;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAfxC;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAfxC;IAAgC,qBAA4B,EAAA;EAC5D;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EAfxC;IAAgC,2BAA4B,EAAA;EAC5D;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAQxC;IAAwB,2BAA2B,EAAA;EACnD;;IAEE,+BAA+B,EAAA;EAEjC;;IAEE,iCAAiC,EAAA;EAEnC;;IAEE,kCAAkC,EAAA;EAEpC;;IAEE,gCAAgC,EAAA;EAflC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EAflC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EAflC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EAflC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EAMtC;IAAmB,uBAAuB,EAAA;EAC1C;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA,EAC7B;;AzDVD;EyDlDI;IAAgC,oBAA4B,EAAA;EAC5D;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAfxC;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAfxC;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAfxC;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAfxC;IAAgC,qBAA4B,EAAA;EAC5D;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EAfxC;IAAgC,2BAA4B,EAAA;EAC5D;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAQxC;IAAwB,2BAA2B,EAAA;EACnD;;IAEE,+BAA+B,EAAA;EAEjC;;IAEE,iCAAiC,EAAA;EAEnC;;IAEE,kCAAkC,EAAA;EAEpC;;IAEE,gCAAgC,EAAA;EAflC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EAflC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EAflC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EAflC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EAMtC;IAAmB,uBAAuB,EAAA;EAC1C;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA,EAC7B;;AzDVD;EyDlDI;IAAgC,oBAA4B,EAAA;EAC5D;;IAEE,wBAAoC,EAAA;EAEtC;;IAEE,0BAAwC,EAAA;EAE1C;;IAEE,2BAA0C,EAAA;EAE5C;;IAEE,yBAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAfxC;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAfxC;IAAgC,yBAA4B,EAAA;EAC5D;;IAEE,6BAAoC,EAAA;EAEtC;;IAEE,+BAAwC,EAAA;EAE1C;;IAEE,gCAA0C,EAAA;EAE5C;;IAEE,8BAAsC,EAAA;EAfxC;IAAgC,uBAA4B,EAAA;EAC5D;;IAEE,2BAAoC,EAAA;EAEtC;;IAEE,6BAAwC,EAAA;EAE1C;;IAEE,8BAA0C,EAAA;EAE5C;;IAEE,4BAAsC,EAAA;EAfxC;IAAgC,qBAA4B,EAAA;EAC5D;;IAEE,yBAAoC,EAAA;EAEtC;;IAEE,2BAAwC,EAAA;EAE1C;;IAEE,4BAA0C,EAAA;EAE5C;;IAEE,0BAAsC,EAAA;EAfxC;IAAgC,2BAA4B,EAAA;EAC5D;;IAEE,+BAAoC,EAAA;EAEtC;;IAEE,iCAAwC,EAAA;EAE1C;;IAEE,kCAA0C,EAAA;EAE5C;;IAEE,gCAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAfxC;IAAgC,0BAA4B,EAAA;EAC5D;;IAEE,8BAAoC,EAAA;EAEtC;;IAEE,gCAAwC,EAAA;EAE1C;;IAEE,iCAA0C,EAAA;EAE5C;;IAEE,+BAAsC,EAAA;EAfxC;IAAgC,wBAA4B,EAAA;EAC5D;;IAEE,4BAAoC,EAAA;EAEtC;;IAEE,8BAAwC,EAAA;EAE1C;;IAEE,+BAA0C,EAAA;EAE5C;;IAEE,6BAAsC,EAAA;EAQxC;IAAwB,2BAA2B,EAAA;EACnD;;IAEE,+BAA+B,EAAA;EAEjC;;IAEE,iCAAiC,EAAA;EAEnC;;IAEE,kCAAkC,EAAA;EAEpC;;IAEE,gCAAgC,EAAA;EAflC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EAflC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EAflC;IAAwB,0BAA2B,EAAA;EACnD;;IAEE,8BAA+B,EAAA;EAEjC;;IAEE,gCAAiC,EAAA;EAEnC;;IAEE,iCAAkC,EAAA;EAEpC;;IAEE,+BAAgC,EAAA;EAflC;IAAwB,wBAA2B,EAAA;EACnD;;IAEE,4BAA+B,EAAA;EAEjC;;IAEE,8BAAiC,EAAA;EAEnC;;IAEE,+BAAkC,EAAA;EAEpC;;IAEE,6BAAgC,EAAA;EAMtC;IAAmB,uBAAuB,EAAA;EAC1C;;IAEE,2BAA2B,EAAA;EAE7B;;IAEE,6BAA6B,EAAA;EAE/B;;IAEE,8BAA8B,EAAA;EAEhC;;IAEE,4BAA4B,EAAA,EAC7B;;AClEL;EAEI,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EAEV,oBAAoB;EACpB,WAAW;EAEX,kCAAkC,EAAA;;ACVtC;EAAkB,4GAA8C,EAAA;;AAIhE;EAAiB,8BAA8B,EAAA;;AAC/C;EAAiB,8BAA8B,EAAA;;AAC/C;EAAiB,8BAA8B,EAAA;;AAC/C;ECTE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;ADejB;EAAwB,2BAA2B,EAAA;;AACnD;EAAwB,4BAA4B,EAAA;;AACpD;EAAwB,6BAA6B,EAAA;;A3DqCrD;E2DvCA;IAAwB,2BAA2B,EAAA;EACnD;IAAwB,4BAA4B,EAAA;EACpD;IAAwB,6BAA6B,EAAA,EAAI;;A3DqCzD;E2DvCA;IAAwB,2BAA2B,EAAA;EACnD;IAAwB,4BAA4B,EAAA;EACpD;IAAwB,6BAA6B,EAAA,EAAI;;A3DqCzD;E2DvCA;IAAwB,2BAA2B,EAAA;EACnD;IAAwB,4BAA4B,EAAA;EACpD;IAAwB,6BAA6B,EAAA,EAAI;;A3DqCzD;E2DvCA;IAAwB,2BAA2B,EAAA;EACnD;IAAwB,4BAA4B,EAAA;EACpD;IAAwB,6BAA6B,EAAA,EAAI;;AAM7D;EAAmB,oCAAoC,EAAA;;AACvD;EAAmB,oCAAoC,EAAA;;AACvD;EAAmB,qCAAqC,EAAA;;AAIxD;EAAuB,2BAA0C,EAAA;;AACjE;EAAuB,+BAA4C,EAAA;;AACnE;EAAuB,2BAA2C,EAAA;;AAClE;EAAuB,2BAAyC,EAAA;;AAChE;EAAuB,8BAA2C,EAAA;;AAClE;EAAuB,6BAA6B,EAAA;;AAIpD;EAAc,sBAAwB,EAAA;;AEvCpC;EACE,yBAAwB,EAAA;;AtEU1B;EsELM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AtEU1B;EsELM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AtEU1B;EsELM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AtEU1B;EsELM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AtEU1B;EsELM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AtEU1B;EsELM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AtEU1B;EsELM,yBAA0E,EAAA;;AANhF;EACE,yBAAwB,EAAA;;AtEU1B;EsELM,yBAA0E,EAAA;;AFuClF;EAAa,yBAA6B,EAAA;;AAC1C;EAAc,yBAA6B,EAAA;;AAE3C;EAAiB,oCAAkC,EAAA;;AACnD;EAAiB,0CAAkC,EAAA;;AAInD;EGvDE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS,EAAA;;AHuDX;EAAwB,gCAAgC,EAAA;;AAExD;EACE,iCAAiC;EACjC,gCAAgC,EAAA;;AAKlC;EAAc,yBAAyB,EAAA;;AIjEvC;EACE,8BAA8B,EAAA;;AAGhC;EACE,6BAA6B,EAAA;;ACA7B;E5EOF;;;I4EDM,4BAA4B;IAE5B,2BAA2B,EAAA;EAG7B;IAEI,0BAA0B,EAAA;EAS9B;IACE,6BAA6B,EAAA;E5E8LnC;I4E/KM,gCAAgC,EAAA;EAElC;;IAEE,yB3EzCY;I2E0CZ,wBAAwB,EAAA;EAG1B;;IAEE,wBAAwB,EAAA;EAG1B;;;IAGE,UAAU;IACV,SAAS,EAAA;EAGX;;IAEE,uBAAuB,EAAA;EAQzB;IACE,Q3E2iCgC,EAAA;ED9kCtC;I4EsCM,2BAA2C,EAAA;EAE7C;IACE,2BAA2C,EAAA;E7CrEjD;I6C0EM,aAAa,EAAA;ExCtFnB;IwCyFM,sB3E7ES,EAAA;Eabf;I8D8FM,oCAAoC,EAAA;IADtC;;MAKI,iCAAmC,EAAA;E9D1D3C;;I8DiEQ,oCAAsC,EAAA;E9DoB9C;I8DfM,cAAc,EAAA;I7D7GlB;;;;M6DmHM,qB3E9GU,EAAA;EaqGlB;I8DcM,cAAc;IACd,qB3EpHY,EAAA,E2EqHb;;A9E1HL;;;EAGE,SAAS;EACT,UAAU;EAEV,mDAAmD;EACnD,mCAAmC,EAAA;;AAGrC;;EAEE,aAAa,EAAA;;AEwKf;EF/JE,qBAAqB,EAAA;EANvB;IAGI,qBAAqB,EAAA;;AEsBzB;E6EvCE,gBAAgB,EAAA;;ACNlB;EAEE,yBC2E0B;ED1E1B,eAAe;EACf,WAAW;EACX,aAAa,EAAA;EALf;IASI,YAAY;IACZ,YAAY,EAAA;EAVhB;IAcI,kBAAkB;IAClB,YAAY,EAAA;IAfhB;MAiBM,WAAW;MACX,YAAY,EAAA;MAlBlB;QAoBQ,kBAAkB;QAClB,6BAA6B,EAAA;QArBrC;UAwBU,uBAAuB;UACvB,qBAAqB,EAAA;QAzB/B;UA4BU,eAAe;UACf,mBAAmB;UACnB,kBAAkB;UAClB,oBAAoB;UACpB,sBAAsB;UACtB,iBAAiB;UACjB,qBAAqB;UACrB,cClCO;UDmCP,kBAAkB;UAClB,sBAAsB;UACtB,cAAc;UACd,kBAAkB,EAAA;UAvC5B;YAyCY,yBCxCK;YDyCL,sBAAwB,EAAA;UA1CpC;YA6CY,yBAAyB;YACzB,sBAAwB,EAAA;UA9CpC;YAiDY,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,iBAAiB;YACjB,gBAAgB,EAAA;QArD5B;UA2DU,0BAA0B;UAC1B,4BAA4B,EAAA;QA5DtC;UA+DU,kBAAkB,EAAA;UA/D5B;YAiEY,cAAc;YACd,gBAAgB;YAChB,oBAAoB;YACpB,iBAAiB;YACjB,QAAQ,EAAA;IArEpB;MA2EM,kBAAkB;MAClB,gBAAgB;MAChB,SAAS;MACT,UAAU;MACV,eAAe,EAAA;EA/ErB;IAoFI,kBAAkB;IAClB,YAAY,EAAA;IArFhB;MAuFM,WAAW;MACX,YAAY,EAAA;MAxFlB;QA0FQ,kBAAkB,EAAA;QA1F1B;UA8FU,uBAAuB,EAAA;QA9FjC;UAiGU,eAAe;UACf,mBAAmB;UACnB,kBAAkB;UAClB,oBAAoB;UACpB,sBAAsB;UACtB,iBAAiB;UACjB,qBAAqB;UACrB,cCvGO;UDwGP,eAAe;UACf,sBAAsB;UACtB,cAAc;UACd,kBAAkB,EAAA;UA5G5B;YA8GY,yBC7GK;YD8GL,sBAAwB,EAAA;UA/GpC;YAkHY,yBAAyB;YACzB,sBAAwB,EAAA;UAnHpC;YAsHY,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,iBAAiB;YACjB,gBAAgB,EAAA;QA1H5B;UAgIU,0BAA0B;UAC1B,4BAA4B,EAAA;QAjItC;UAoIU,kBAAkB,EAAA;UApI5B;YAsIY,cAAc;YACd,gBAAgB;YAChB,oBAAoB;YACpB,iBAAiB;YACjB,QAAQ,EAAA;IA1IpB;MAgJM,kBAAkB;MAClB,gBAAgB;MAChB,SAAS;MACT,UAAU;MACV,eAAe,EAAA;;ArDvHjB;EqD4HF,wBAAwB,EAAA;;AAE1B;EACE;IACE,wBAAwB;IACxB,gCAAgC;IAChC,yBAAyB;IACzB,iCAAiC,EAAA,EAClC;;AAGH;EACE;IACE,2BAA2B;IAC3B,UAAU,EAAA;EAEZ;IACE,2BAA2B;IAC3B,UAAU,EAAA;EAEZ;IACE,2BAA2B;IAC3B,UAAU,EAAA,EAAA;;AAmBd;EAEE,uBAAuB;EACvB,oBAAoB,EAAA;;AErMtB;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,QAAQ,EAAA;EAJV;IAMI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB,EAAA;IAZpB;MAeM,W/ERS,EAAA;;AgFPf;EACE,yBFmFc;EElFd,sBhFKa;EgFJb,gBAAgB,EAAA;EAHlB;IAMI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,cF+DwB,EAAA;EE7E5B;IAiBI,kBAAkB,EAAA;IAjBtB;MAmBM,eAAe,EAAA;MAnBrB;QAqBQ,iCAAiC,EAAA;IArBzC;MA0BQ,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,oBAAoB;MACpB,gBAAgB;MAChB,sBAAsB;MACtB,gBAAgB;MAChB,cAAc;MACd,yBAAyB;MACzB,kBAAkB;MAClB,0BAA0B,EAAA;MApClC;QAsCU,YAAY;QACZ,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,oBAAoB;QACpB,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;QAChB,cFiCW;QEhCX,wBAAwB;QACxB,kBAAkB,EAAA;IAhD5B;MAqDU,cFkCa,EAAA;MEvFvB;QAuDY,WAAW,EAAA;;AJzCvB;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,yBAAyB,EAAA;;AKlB3B;EACE,0BAA0B;EAC1B,YAAY,EAAA;EAFd;IAKI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cHiEwB,EAAA;EG7E5B;IAgBI,yBHoEY;IGnEZ,sBjFVW;IiFWX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB,EAAA;IAtBpB;MAyBM,yBH6Ca;MG5Cb,sBjFnBS;MiFoBT,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,YAAY,EAAA;MAnClB;QAsCQ,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;QAChB,cHyBW,EAAA;MGtEnB;QAiDQ,gBAAiB;QAAjB,mBAAiB,EAAA;IAjDzB;MAsDM,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,oBAAoB;MACpB,sBAAsB;MACtB,kBAAkB;MAClB,WjFrDS,EAAA;MiFPf;QA+DQ,gBAAiB;QAAjB,mBAAiB,EAAA;IA/DzB;MAsEU,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,cHPS,EAAA;IGtEnB;MAoFQ,yBAAyB;MACzB,sBjF9EO;MiF+EP,kBAAkB;MAClB,mBAAmB,EAAA;MAvF3B;QA0FU,WAAW;QACX,YAAY;QACZ,mBAAmB,EAAA;MA5F7B;QAgGU,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,oBAAoB;QACpB,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;QAChB,cHrBU;QGsBV,kBAAkB,EAAA;QAxG5B;UA2GY,eAAe;UACf,mBAAmB;UACnB,kBAAkB;UAClB,oBAAoB;UACpB,gBAAgB;UAChB,sBAAsB;UACtB,gBAAgB;UAChB,cHjCO,EAAA;;AGyCnB;EAGM,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAVpB;EAeQ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,kBAAkB,EAAA;;AAnB1B;EAsBQ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,mBAAmB;EAEnB,yBAAyB,EAAA;;AA9BjC;EAkCQ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,yBAAyB,EAAA;;AAzCjC;EA6CQ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,yBAAyB,EAAA;;AApDjC;EAwDQ,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB,EAAA;;AC9LjC;EAEI,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAA;;AATlB;EAaI,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB,EAAA;;AArBtB;EAyBI,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB,EAAA;EA5BpB;IA+BM,WAAW;IACX,YAAY,EAAA;;AAKlB;EACE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,cAAc;EACd,WAAW;EAEX,YAAY,EAAA;EAJd;IAOI,WAAW;IACX,WAAW;IACX,kBAAkB,EAAA;IATtB;MAYM,kBAAkB;MAClB,UAAU,EAAA;IAbhB;MAiBM,yBJWa;MIVb,sBlFrDS;MkFsDT,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,sBAAsB;MACtB,kBAAkB;MAClB,cJEa;MIDb,cAAc;MACd,eAAe;MACf,cAAc,EAAA;IA7BpB;MAiCM,yBJLa;MIMb,yBAAyB;MACzB,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,sBAAsB;MACtB,kBAAkB;MAClB,cJNsB,EAAA;;AIW5B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EAII,YAAY;EACZ,yBJfY;EIgBZ,yBAAyB;EACzB,kBAAkB,EAAA;EAPtB;IAUM,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,WlFzGS;IkF0GT,kBAAkB,EAAA;EAnBxB;IAuBM,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,sBlFnHS;IkFoHT,sBlFpHS;IkFqHT,kBAAkB;IAClB,oBAAoB,EAAA;IA/B1B;MAkCQ,YAAY;MACZ,kBAAkB;MAClB,cAAc;MACd,SAAS;MACT,OAAO;MACP,QAAQ;MACR,SAAS,EAAA;;AAxCjB;EA8CI,kBAAkB;EAClB,yBJzDY;EI2DZ,aAAa;EACb,aAAa;EAEb,kBAAkB,EAAA;EApDtB;IAsDM,aAAa;IACb,gBAAgB;IAChB,kBAAkB,EAAA;IAxDxB;MA2DQ,oDAAoD;MACpD,yBAAyB,EAAA;IA5DjC;MAgEQ,UAAU;MACV,yBAAyB,EAAA;IAjEjC;MAqEQ,yBAAyB;MACzB,yBAAyB,EAAA;EAtEjC;IA4EM,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB,EAAA;IA/E/B;MAiFQ,eAAe;MACf,cAAc;MACd,YAAY,EAAA;MAnFpB;QAqFU,YAAY,EAAA;MArFtB;QAwFU,YAAY,EAAA;MAxFtB;QA2FU,iBAAiB,EAAA;IA3F3B;MAoGQ,kBAAkB;MAClB,kBAAkB,EAAA;MArG1B;QAwGU,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,oBAAoB;QACpB,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;QAChB,cJ3HU;QI4HV,qBAAqB;QACrB,YAAY;QACZ,gBAAgB,EAAA;MAlH1B;QAsHU,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;QAChB,cJzIU,EAAA;MIYpB;QAiIU,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;QAClB,iBAAiB;QACjB,SAAS,EAAA;MAtInB;QA0IU,eAAe;QACf,wBAAwB,EAAA;EA3IlC;IAiJM,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,WAAW,EAAA;IApJjB;MAsJQ,+BAA+B;MAC/B,eAAe,EAAA;MAvJvB;QA6JU,+BAA+B,EAAA;MA7JzC;QAgKU,yBAAyB;QACzB,4BAA4B;QAC5B,+BAA+B,EAAA;QAlKzC;UAoKY,2BAA2B;UAC3B,8BAA8B;UAC9B,6BAA6B;UAC7B,gCAAgC,EAAA;;AAQ5C;EAEI,yBJ3LY;EI4LZ,yBAAyB,EAAA;EAH7B;IAKM,eAAe;IACf,cAAc;IACd,YAAY,EAAA;IAPlB;MASQ,YAAY,EAAA;IATpB;MAYQ,6BAA6B,EAAA;IAZrC;MAeQ,iBAAiB,EAAA;EAfzB;IAmBM,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,WlFhSS;IkFiST,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,0BAA0B,EAAA;IA9BhC;MAiCQ,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,WlF9SO,EAAA;IkFsQf;MA2CQ,oBAAkB,EAAA;;AA3C1B;EAiDI,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,WlF/TW;EkFgUX,WAAW;EACX,WAAW;EACX,kBAAkB,EAAA;EA5DtB;IA+DM,yBJ3UW,EAAA;EI4QjB;IAwEM,yBAAwB,EAAA;EAxE9B;IA4EM,yBJxVW,EAAA;EI4QjB;IAiFM,yBAAyB,EAAA;EAjF/B;IAqFM,yBAAyB,EAAA;EArF/B;IAyFM,yBAAyB,EAAA;;AAK/B;EAEI,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe,EAAA;;AARnB;EAYI,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB,EAAA;;AArBtB;EAyBI,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,6BAA6B,EAAA;EAtCjC;IAyCM,yBAAyB;IACzB,cJxUsB,EAAA;EI8R5B;IA8CM,oCAAoC;IACpC,WlFnZS,EAAA;;AkFwZf;EAEI,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAA;;AATlB;EAaI,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB,EAAA;EAvBtB;IA0BM,WlFlbS;IkFmbT,yBJ7WsB,EAAA;EIkV5B;IA+BM,yBAAyB;IACzB,WlFxbS,EAAA;;AkF6bf;EACE,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,yDAAyD;EACzD,yBAAyB;EAGzB,iBAAiB,EAAA;;AAGnB;EACE,8BAA8B;EAC9B,mBAAmB,EAAA;;AAGrB;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,yBAAyB,EAAA;;AAG3B;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,yBAAyB,EAAA;;AAG3B;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB,EAAA;;AAG3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,yBAAyB,EAAA;;AAG3B;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB,EAAA;;AAG3B;EAGM,6BJ/cU;EIgdV,gCJhdU;EIidV,sBlF9hBS;EkF+hBT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,cJvea,EAAA;;AI0dnB;EAkBM,iCAAiC;EACjC,gCJ/dU;EIgeV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,cJ9esB,EAAA;;AImf5B;EACE,sBAAsB,EAAA;;AAGxB;EACE,yBJxf0B;EIyf1B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,iBAAiB,EAAA;;AAEnB;EAEI,4BAA4B,EAAA;;AAIhC;EACE,yBJ3gB0B;EI4gB1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,WlFzlBa;EkF0lBb,6BAA6B;EAC7B,iBAAiB,EAAA;;AAGnB;EACE,0BAA0B,EAAA;;AAG5B;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;ACrnBhB;EAEI,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,WnFLW,EAAA;EmFPf;IAeM,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB,EAAA;;AAlBxB;EAuBI,yBL6DY;EK5DZ,sBnFjBW;EmFkBX,kBAAkB,EAAA;;AAzBtB;EA6BI,yBLyCe;EKxCf,kBAAkB,EAAA;;AA9BtB;EAkCI,yBL4CgB;EK3ChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,WnFnCW;EmFoCX,WAAW;EACX,YAAY;EACZ,WAAW,EAAA;;AA7Cf;EAgDI,gBAAgB;EAChB,kBAAkB;EAClB,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,mBAAmB,EAAA;EAFrB;IAKI,kCLyBY;IKxBZ,iCLwBY;IKpBZ,sBnFzDW;ImF0DX,iBAAiB;IACjB,eAAe,EAAA;IAZnB;MAeM,yBAAyB;MACzB,mBAAmB,EAAA;IAhBzB;MAoBM,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,oBAAoB;MACpB,cAAc;MACd,sBAAsB;MACtB,kBAAkB;MAClB,kBAAkB;MAClB,cLAc,EAAA;MK5BpB;QA+BQ,yBAAyB;QACzB,WnF/EO,EAAA;;AmFqFf;;;EAII,oCAAoC,EAAA;EAJxC;;;IAOM,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc,EAAA;;AAdpB;;;EA6BM,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,yBAAyB,EAAA;EAtC/B;;;IAqBQ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS,EAAA;;AA1BjB;;;EA2CI,iCAAiC;EACjC,kBAAkB,EAAA;EA5CtB;;;IA+CM,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAEhB,kBAAkB,EAAA;IAvDxB;;;MA0DQ,WnF/IO;MmFgJP,6BAA6B;MAC7B,yBAAyB;MACzB,iBAAiB,EAAA;;AAMzB;EAEI,kBAAkB;EAClB,mBAAmB,EAAA;;AAHvB;EAOI,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cLxGe,EAAA;;AKyFnB;EAmBI,gCL9FY;EK+FZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cLxGgB;EKyGhB,kBAAkB,EAAA;EA5BtB;IA+BM,+BL1GU,EAAA;EK2EhB;IAmCM,gBAAgB;IAEhB,cAAc,EAAA;EArCpB;IAyCM,gBAAgB;IAEhB,cAAc,EAAA;EA3CpB;IA+CM,gBAAgB;IAEhB,cAAc,EAAA;;AAKpB;EAEI,gBAAgB;EAChB,gCLpIY,EAAA;;AKuIhB;EAEI,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cL/Je;EKgKf,aAAa;EACb,gCLnJY;EKoJZ,iCAAiC;EACjC,2BAA2B,EAAA;EAd/B;IAiBQ,sBAAsB;IACtB,gCLzJQ;IK0JR,2BAA2B,EAAA;IAnBnC;MAqBU,2BAA2B,EAAA;;AArBrC;EA6BM,oCAAoC,EAAA;;AA7B1C;EAkCI,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cLnLgB;EKoLhB,aAAa;EACb,2BAA2B;EAC3B,sBAAsB,EAAA;EA7C1B;IAgDQ,wBAAwB;IACxB,2BAA2B,EAAA;IAjDnC;MAmDU,2BAA2B,EAAA;EAnDrC;IAuDQ,yBAAyB,EAAA;IAvDjC;MAyDU,cAAc,EAAA;EAzDxB;IA6DQ,yBAAyB,EAAA;IA7DjC;MA+DU,cAAc,EAAA;EA/DxB;IAmEQ,2BAA2B,EAAA;IAnEnC;MAqEU,cAAc,EAAA;EArExB;IAyEQ,sBAAsB,EAAA;IAzE9B;MA2EU,cAAc,EAAA;EA3ExB;IA+EQ,4BAA4B,EAAA;IA/EpC;MAiFU,cAAc,EAAA;EAjFxB;IAqFQ,yBAAyB,EAAA;IArFjC;MAuFU,cAAc,EAAA;EAvFxB;IA2FQ,yBAAyB,EAAA;IA3FjC;MA6FU,cAAc,EAAA;EA7FxB;IAiGQ,yBAAyB,EAAA;IAjGjC;MAmGU,cAAc,EAAA;EAnGxB;IAuGQ,uBAAuB,EAAA;IAvG/B;MAyGU,cAAc,EAAA;EAzGxB;IA8GM,2BAA2B;IAC3B,iCAAiC,EAAA;EA/GvC;IAkHM,mCAAmC,EAAA;EAlHzC;IAsHM,gBAAgB;IAEhB,cAAc,EAAA;EAxHpB;IA4HM,gBAAgB;IAEhB,cAAc,EAAA;EA9HpB;IAkIM,gBAAgB;IAEhB,cAAc,EAAA;;AAKpB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAEvB;EACE,eAAe,EAAA;;AAGjB;EACE,4BAA4B,EAAA;;AAG9B;EACE,kBAAkB;EAClB,WAAW;EAEX,OAAO;EACP,SAAS,EAAA;EALX;IAOI,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,0BAA0B;IAC1B,+BAA6B,EAAA;EAXjC;IAcI,yBAAyB,EAAA;EAd7B;IAiBI,yBAAyB,EAAA;EAjB7B;IAoBI,yBAAyB,EAAA;EApB7B;IAuBI,uBAAuB,EAAA;EAvB3B;IA0BI,wCAAwC,EAAA;;AAI5C;;EAIM,UAAU,EAAA;EAJhB;;IAMQ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,SAAS;IACT,YAAY;IACZ,UAAU,EAAA;;AAblB;EAkBI,UAAU,EAAA;EAlBd;IAoBM,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,gBAAgB,EAAA;;APpZtB;EAEI,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AATlB;EAaI,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AApBlB;EAwBI,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AA/BlB;EAmCI,WAAW;EACX,YAAY;EAEZ,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AA9ClB;EAkDI,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAA;;AAIlB;EACE,yBEDc;EFEd,yBAAyB,EAAA;EAF3B;IAKI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,W5EzFW,EAAA;I4E6Ef;MAeM,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,oBAAoB;MACpB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,W5EnGS,EAAA;;A4EwGf;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAA;;AAGvB;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAA;;AAGvB;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAA;;AAGvB;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAA;;AAGvB;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAA;;AAGvB;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAA;;AAGvB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ,EAAA;;AAGV;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EAEI,oBAAoB;EACpB,6BAA6B;EAC7B,4CAA4C,EAAA;EAJhD;IAOM,yBAAyB,EAAA;EAP/B;IAWM,yBAAyB,EAAA;EAX/B;IAeM,yBEpIiB,EAAA;EFqHvB;IAmBM,yBAAyB,EAAA;EAnB/B;IAuBM,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,W5E5NS;I4E6NT,kBAAkB,EAAA;IA/BxB;MAkCQ,cEvJe,EAAA;IFqHvB;MAsCQ,cAAc,EAAA;IAtCtB;MA0CQ,cAAc,EAAA;IA1CtB;MA8CQ,cAAc,EAAA;EA9CtB;IAmDM,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,W5ExPS,EAAA;I4E8Lf;MA6DQ,cEhLY,EAAA;EFmHpB;IAkEM,iBAAiB;IACjB,kBAAkB,EAAA;IAnExB;MAsEQ,WAAW;MACX,YAAY;MACZ,mBAAmB,EAAA;;AAM3B;EAEI,gCAAgC,EAAA;;AAFpC;EAMI,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cEnPmB,EAAA;;AFqOvB;EAkBI,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cExNgB,EAAA;EF8LpB;IA6BM,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,cErOc,EAAA;EFiMpB;IAwCM,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc,EAAA;;AA/CpB;EAoDI,0BAA0B,EAAA;EApD9B;IAwDQ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,cE5QW,EAAA;IF6MnB;MAkEU,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,oBAAoB;MACpB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,cE1QU,EAAA;EFiMpB;IA+EM,6BE9QU;IF+QV,gCE/QU,EAAA;IF+LhB;MAmFQ,kBAAkB,EAAA;MAnF1B;QAsFU,WAAW;QACX,UAAU;QACV,UAAU;QACV,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,SAAS,EAAA;;AAOnB;EAEI,YAAY,EAAA;EAFhB;IAMQ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB,EAAA;EAT1B;IAaQ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,W5EnYO;I4EoYP,kBAAkB;IAClB,MAAM;IACN,4BAA4B,EAAA;EAvBpC;IA6BQ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,cE7UoB,EAAA;EFyS5B;IAwCQ,kBAAkB,EAAA;EAxC1B;IA4CQ,yBErVoB;IFsVpB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,W5EnaO;I4EoaP,WAAW;IACX,iBAAiB,EAAA;;AAMzB;EAEI,kBAAkB;EAClB,6BAA6B,EAAA;EAHjC;IAWM,yBAAyB,EAAA;IAX/B;MAcQ,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,gBAAgB;MAChB,sBAAsB;MACtB,W5E/bO;M4EgcP,yBAAyB;MACzB,+BExaa,EAAA;MF0ab;QAxBR;UA0BU,mBAAmB;UACnB,eAAe;UACf,cAAc;UAEd,uCAAuC,EAAA,EAE1C;EAhCP;IAqCQ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,cAAc;IACd,+BE9ba;IF+bb,aAAa,EAAA;IAEb;MA/CR;QAiDU,mBAAmB;QACnB,eAAe;QACf,uCAAuC,EAAA,EAE1C;EArDP;IAyDU,yBAAyB,EAAA;EAzDnC;IA6DU,yBE/cW,EAAA;;AFqdrB;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB,EAAA;;AAExB;EACE,yBE5ac,EAAA;;AFgbhB;EAEI,YAAY,EAAA;;AAFhB;EAQQ,gBAAgB;EAChB,kBAAkB,EAAA;;AAT1B;EAgBM,gCAAgC,EAAA;;AAhBtC;EAoBM,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B,EAAA;;AAKhC;EACE,iBAAiB,EAAA;EADnB;IAII,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc,EAAA;EAXlB;IAeI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,kBAAkB,EAAA;;AAItB;EACE,kBAAkB;EAClB,oCAAoC,EAAA;EAFtC;IAKI,oCAAoC,EAAA;IALxC;MAQM,mDAAmD,EAAA;EARzD;IAaI,oCAAoC,EAAA;IAbxC;MAgBM,mDAAmD,EAAA;EAhBzD;IAqBI,oCAAoC,EAAA;IArBxC;MAwBM,mDAAmD,EAAA;EAxBzD;IA6BI,oCAAoC,EAAA;IA7BxC;MAgCM,mDAAmD,EAAA;EAhCzD;IAqCI,oCAAoC,EAAA;IArCxC;MAwCM,mDAAmD,EAAA;EAxCzD;IA6CI,kCAAkC,EAAA;IA7CtC;MAgDM,mDAAmD,EAAA;EAhDzD;IAqDI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,sBAAwB,EAAA;EA5D5B;IAgEI,gBAAgB,EAAA;IAhEpB;;MAoEM,6BAA6B;MAC7B,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,oBAAoB;MACpB,iBAAiB;MACjB,sBAAsB;MACtB,kBAAkB;MAElB,sBAAwB;MACxB,cAAc,EAAA;;AAKpB;EACE,WAAW,EAAA;;AAGb;EACE,aAAa,EAAA;;AAGf;EACE;IAEE,8BAA8B,EAAA;EAGhC;IAEE,gCAAgC,EAAA;EAGlC;IAEE,iCAAiC,EAAA;EAGnC;IAEE,8BAA8B,EAAA,EAAA;;AA0BlC;EACE,kBAAkB,EAAA;;AAGpB;EAEE,qBAAqB;EAErB,6BAA6B,EAAA;;AAG/B;EAEE,yCAAyC;EACzC,kBAAkB,EAAA;;AAGpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB,EAAA;;AAGrB;EACE,WAAW;EACX,YAAY;EAEZ,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,SAAS;EACT,UAAU,EAAA;;AAlCZ;EAsCE,uBAAuB;EACvB,wBAAwB;EAExB,qEAAqE,EAAA;;AAGvE;EACE,oCAAoC,EAAA;;AAGtC;EACE,aAAa;EACb,gBAAgB,EAAA;EAFlB;IAKI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB,EAAA;IAPvB;MAUM,SAAS;MACT,SAAS;MACT,UAAU,EAAA;;AAKhB;EACE,eAAe,EAAA;;AxD7tBC;EwDiuBhB,yBAAyB,EAAA;;AAG3B;EAEE,2BAA2B;EAE3B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW,EAAA;;AAEb;EAAyC,wBAAsB,EAAA;;AAC/D;EACC,oDAA8C;EAC7C,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa,EAAA;EAJf;IAQI,YAAY;IACZ,YAAY;IACZ,mBAAmB,EAAA;EAVvB;IAcI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,WAAW,EAAA;EApBf;IAuBI,WAAW,EAAA;EAvBf;IA0BI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,WAAW,EAAA;EAhCf;IAoCM,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW,EAAA;EA3CjB;IA+CI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc,EAAA;EAtDlB;IA0DI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,UAAU,EAAA;IA9Dd;MAiEM,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,mBAAmB;MACnB,sBAAsB;MACtB,kBAAkB;MAClB,WAAW;MACX,yBAAyB,EAAA;IAzE/B;MA6EM,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,oBAAoB;MACpB,cAAc;MACd,sBAAsB;MACtB,kBAAkB;MAClB,cAAc,EAAA;IApFpB;MA0FQ,sBAAsB,EAAA;IA1F9B;MAgGQ,sBAAsB,EAAA;IAhG9B;MAqGM,kBAAkB;MAElB,yBAAyB;MACzB,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,gBAAgB;MAChB,sBAAsB;MACtB,gBAAgB;MAChB,WAAW,EAAA;MA/GjB;QAmHQ,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,oBAAoB;QACpB,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;QAChB,WAAU,EAAA;IA1HlB;MAiJM,UAAU;MACV,kBAAkB;MAElB,yBEx6BW;MFy6BX,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,gBAAgB;MAChB,qBAAqB;MACrB,kBAAkB;MAClB,WAAW;MACX,WAAW,EAAA;;AAMjB;EAEI,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAA;;AAJvB;EAQI,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,W5Eh8BW;E4Ei8BX,kBAAkB,EAAA;;AAhBtB;EAoBI,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,W5E58BW,EAAA;;A4Ei7Bf;EAgCM,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,W5Ex9BS,EAAA;;A4E69Bf;EACE,gCAAgC,EAAA;;AAGlC;EAEE,kBAAkB;EAElB,YAAY,EAAA;EAJd;IAOI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,kBAAkB,EAAA;IAftB;MAkBM,cAAc,EAAA;IAlBpB;MAsBM,WAAW,EAAA;;AAKjB;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,mBAAmB,EAAA;EAJrB;IAOI,cAAc;IACd,WAAW;IACX,YAAY,EAAA;;AAIhB;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,MAAM;EACN,YAAY;EACZ,OAAO;EACP,aAAa,EAAA;;AAGf;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,OAAO;EACP,QAAQ;EACR,eAAe;EACf,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY,EAAA;;AAGd;EACE,WAAW,EAAA;;A3ChjCb;E2CyjCE,qBAAqB,EAAA;;AAGvB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB,EAAA;;AAG3B;EACE,YAAY,EAAA;;AAGd;EACE,sBAAsB,EAAA;;AAGxB;EACE,2BAA2B;EAC3B,8BAA8B,EAAA;;AAGhC;EACE,4BAA4B;EAC5B,+BAA+B,EAAA;;AAGjC;EACE,UAAU,EAAA;;AAGZ;EACE,yBEjmCe;EFkmCf,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,WAAW,EAAA;EAZb;IAiBI,WAAW,EAAA;EAjBf;IAqBI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB,EAAA;;AAItB;EACE,uBAAuB;EACvB,qBAAqB,EAAA;EAFvB;IAOI,YAAY,EAAA;;AAIhB;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,uCAAuC;EACvC,sBAAsB;EACtB,yBE5oCe,EAAA;;AF+oCjB;EACE,0CAA0C;EAC1C,uCAAuC,EAAA;;AAGzC;EACE,uBAAuB,EAAA;;AAGzB;EACE,qBAAqB,EAAA;;AAGvB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,uBAAuB,EAAA;;AAGzB;EACE,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,eAAe,EAAA;;AOv0BjB;EP20BE,eAAe,EAAA;;AAGjB;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,uBAAuB,EAAA;;AAGzB;EACE,2BAA4B;EAA5B,4BAA4B,EAAA;;AAG9B;EACE,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACE,WAAW,EAAA;;AAEb;EAEI,gCAAgC,EAAA;;AAIpC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,yBAAyB,EAAA;EAL3B;IAOI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,yBAAyB,EAAA;EAZ7B;IAeI,iBAAiB,EAAA;EAfrB;IAkBI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB,EAAA;EAtB7B;IAyBI,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB,EAAA;EA7B1B;IAgCI,6BAA6B,EAAA;EAhCjC;IAmCI,cAAc;IACd,8BAA8B,EAAA;EApClC;IAuCI,kBAAkB;IAClB,yBE/vCa;IFgwCb,WAAW,EAAA;EAzCf;IA4CI,sBAAsB,EAAA;;AAQ1B;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAyB,EAAA;;A/E1vC3B;EACE,gCAAiC,EAAA;;AAEnC;EACE,yBiFlCe,EAAA;;AjFoCjB;EACE,qBiFrCe,EAAA;;AjFuCjB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAW,EAAA;;AAIb;EACE,kBAAkB;EAAE,oCAAA,EAAqC;;AAM3D;EAGI,iBAAiB;EAEjB,sBGpDW;EHqDX,kBAAkB,EAAA;EANtB;IASM,iDAAyD;IACzD,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB,EAAA;;AAK5B;EACE,yBiFzEe;EjF0Ef,WAAW;EACX,yBiF3Ee;EjF4Ef,kBAAkB,EAAA;EAJpB;IAMI,yBiF9Ea;IjF+Eb,iBAAiB,EAAA;;AAIrB;EACE,yBAAyB;EACzB,WG/Ea;EHgFb,yBAAyB;EACzB,kBAAkB,EAAA;EAJpB;IAMI,yBAAyB,EAAA;;AAI7B;EACE,aAAa;EACb,yBiFnB0B,EAAA;EjFiB5B;IAKI,WG5FW;IH6FX,eAAe,EAAA;EANnB;IAUI,6BAA6B;IAC7B,2BiFrBY;IjFsBZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,iBAAiB,EAAA;;AAIrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe,EAAA;;AAGjB;EAGM,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,gBAAgB,EAAA;;AAKtB;EAEI,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,gBAAgB,EAAA;;AAIpB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,eAAe;EAEf,sBAAsB;EACtB,0BAA0B,EAAA;;AAG5B;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B,EAAA;;AuB9G1B;EvBkHA,iBAAiB;EAEjB,yBiFpLe;EjFqLf,qBiFrLe,EAAA;;AjFwLjB;EAEE,oCAAqC;EACrC,WAAW;EACX,6BAA6B,EAAA;;AAG/B;EACE,iBAAiB;EACjB,WAAW;EACX,oCAAoC,EAAA;;AAGtC;EACE,WAAW,EAAA;;AEgGb;EF5FE,cAAc;EACd,mBAAmB,EAAA;;AAGrB;EACE,yBAAyB;EACzB,mBAAmB,EAAA;;AAGrB;EACE,aAAa,EAAA;;AqF+Of;ErF3OE,6BAA6B,EAAA;;AAG/B;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,UAAU;EACV,gBAAgB,EAAA;;AAElB;EACE,yBiFlOe;EjFmOf,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EAEnB,qBAAqB;EACrB,4BAA4B;EAC5B,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB,EAAA;;AAGpB;EACE,yBiFtPe;EjFuPf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,4BAA4B;EAC5B,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,sBAAsB,EAAA;;AAGxB;;EAIM,UAAU,EAAA;EAJhB;;IAOQ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAElB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY,EAAA;;AAdpB;EAoBI,UAAU,EAAA;EApBd;IAuBM,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,gBAAgB,EAAA;;AAKtB;EAEI,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc,EAAA;;AARlB;EAYI,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,cAAc,EAAA;;AAIlB;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc,EAAA;;AAGhB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,aAAa,EAAA;;AAGf;EAEI,eAAe,EAAA;;AAFnB;EAMI,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc,EAAA;;AATlB;EAaI,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAA;;AAhBvB;EAoBI,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;;AAIpB;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB,EAAA;EAXlB;IAcI,eAAe,EAAA;EAdnB;IAkBI,yBAAyB;IACzB,WAAW;IACX,YAAY;IAGZ,UAAU;IACV,4BAA4B;IAC5B,+BAA+B;IAC/B,YAAY;IACZ,eAAe;IACf,gBAAgB,EAAA;EA5BpB;IAiCM,WAAW;IACX,eAAe;IACf,gBAAgB,EAAA;;AAMtB;EACE,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB,EAAA;EAXnB;IAcI,eAAe;IACf,qBAAqB,EAAA;;AAIzB;EAEI,QAAQ,EAAA;;AAFZ;EAMI,QAAQ,EAAA;;AAQZ;EAEI,WAAW,EAAA;;AAFf;EAMI,WAAW;EACX,yBAAyB,EAAA;EAP7B;IAUM,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB,EAAA;;AAZvB;EAkBM,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc,EAAA;;AArBpB;EAyBM,kBAAkB,EAAA;;AAKxB;EACE,+BAA+B,EAAA;;AAGjC;EACE,8BAA8B,EAAA;;AAGhC;EAEI,aAAa;EACb,WAAW;EACX,aAAa;EACb,uBAAuB,EAAA;EAL3B;IAQM,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc,EAAA;EAfpB;IAmBM,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,kBAAkB,EAAA;;AAKxB;EAEI,yBiFhgBa,EAAA;EjF8fjB;IAIM,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,0BAA0B,EAAA;;AAZhC;EAkBM,cAAc;EACd,6BAA6B,EAAA;;AAnBnC;EAwBM,cAAc;EACd,6BAA6B,EAAA;;AAKnC;EAEI,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,0BAA0B,EAAA;;AAV9B;EAeM,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,YAAY,EAAA;;AAvBlB;EA2BM,yBAAyB,EAAA;EA3B/B;IA8BQ,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,0BAA0B,EAAA;EAtClC;IA2CU,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc,EAAA;;AAlDxB;EAwDM,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,YAAY,EAAA;;AAnElB;EAuEM,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB,EAAA;;AAjFvB;EAqFM,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAE1B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB,EAAA;;AA/F1B;EAmGM,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,aAAa,EAAA;;AA7GnB;EAkHM,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAA;;AAKpB;EAEI,WAAW;EACX,kBAAkB,EAAA;;AAHtB;EAOI,yBAAyB,EAAA;EAP7B;IAUM,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,0BAA0B,EAAA;;AAlBhC;EAwBM,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AA/BpB;EAmCM,yBAAyB,EAAA;;AKnrB7B;EL2rBA,cAAc;EACd,oCAAoC,EAAA;;AAGtC;EAEI,YAAY,EAAA;;A+E+WhB;E/E1WE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB,EAAA;;AAG3B;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAA;;AAEf;EACE,iCAAgC;EAChC,6BAA6B,EAAA;;AAE/B;EACE,iCAAgC,EAAA;;AAElC;EACE,WAAU,EAAA;;AAEZ;EACE,WAAU,EAAA;;AAEZ;EACE,WAAU;EAGV,8BAA6B,EAAA;;AAE/B;EAEI,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAA;;AATlB;EAaI,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB,EAAA;;AArBtB;EAyBI,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB,EAAA;;AAjCtB;EAqCI,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAA;;AAIlB;EACE,cAAc,EAAA;;AAGhB;EApDA;IAsDI,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EA7D3B;IAiEI,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB,EAAA;EAzEtB;IA6EI,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB,EAAA;EArFtB;IAyFI,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA,EACxB;;AAGH;EAIQ,yBAAyB;EACzB,WAAW,EAAA;;AALnB;EASQ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,wBAAwB;EACxB,WAAW,EAAA;;AAMnB;EAEI,oCAAoC;EACpC,gCAAgC,EAAA;;AAHpC;EAOI,WAAW;EACX,oCAAoC;EACpC,gCAAgC,EAAA;;AAIpC;EACE,oCAAqC,EAAA;;AAGvC;EACE,kBAAkB;EAClB,YAAY,EAAA;EAFd;IAMM,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,kCAAkC,EAAA;EAXxC;IAgBI,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB,EAAA;EAnB1B;IAuBI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,wBAAwB;IACxB,kBAAkB,EAAA;EA/BtB;;IAoCI,cAAc;IACd,qBAAqB;IACrB,yBAAyB,EAAA;;AmB1uB7B;EnB+uBE,kBAAkB,EAAA;;AmB3uBpB;EnB+uBE,kBAAkB;EAClB,aAAa,EAAA;;AAGf;EACE,wBAAwB,EAAA;;AAG1B;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EAEV,WAAW;EACX,yBAAyB,EAAA;;AAG3B;EAEI,eAAe,EAAA;;AAFnB;EAMI,4BAA4B,EAAA;;AANhC;EAUI,eAAe,EAAA;;AAVnB;EAcI,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB,EAAA;;AApB7B;EAwBI,iBAAiB;EACjB,WAAW;EAEX,yBiFt9Ba;EjFw9Bb,eAAe;EACf,YAAY,EAAA;;AAIhB;EACE,kBAAkB;EAClB,QAAQ,EAAA;;AAGV;EAKU,eAAe,EAAA;;AAOzB;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB,EAAA;;AAGlB;EACE,4BAA4B;EAC5B,+BAA+B,EAAA;;AAGjC;EACE,4BAA4B;EAC5B,+BAA+B,EAAA;;AAGjC;EACE,4BAA4B;EAC5B,+BAA+B,EAAA;;AAGjC;EACE,4BAA4B;EAC5B,+BAA+B,EAAA;;AAGjC;EAEI,iBAAiB,EAAA;;AAFrB;EAMI,gBAAgB,EAAA;;AANpB;EAUI,0BAA0B;EAC1B,sBAAsB,EAAA;;AAI1B;EACE,cAAc,EAAA;;AAIhB;EACE,WAAW;EAGX,yBAAyB,EAAA;;AAmC3B;EACE,UAAU;EACV,WAAW,EAAA;;AAIb;EACE,wDAAA;EACA,yBAAyB;EACzB,yBAAA,EAA0B;;AAG5B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wDAAA,EAAyD;;AAE3D;EAEE,wBAAuB;EACvB,qBAAoB,EAAA;;AAEtB;EACE,UAAS;EACT,6CAA6C;EAC/C,gBAAe;EACf,SAAQ,EAAA;;AACR;EAEE,oBAAmB;EACnB,6CAA6C,EAAA;;AAG/C;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B,EAAA;EAH/B;IAMI,6BAA6B,EAAA;;AAKjC;EACE,gBAAgB;EAChB,yBAAyB,EAAA;;AAG3B;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,wBAAwB;EACxB,YAAY;EACZ,uBAAuB,EAAA;;AAIzB;EACE,YAAY;EACZ,uBAAuB,EAAA;;AAGzB;EACE,uBAAuB;EACvB,sBAAsB,EAAA;;AAGxB;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,4DAA4D,EAAA;;AAG9D;EACE,4DAA4D,EAAA;;AAG9D;EACE,4DAA4D,EAAA;;AAG9D;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAI3B;EACE,oCAAoC;EACpC,eAAe,EAAA;;AAEjB;EACE,+BAA+B,EAAA;;AAGjC;EACE,yBAAyB;EACzB,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB;EACzB,2BAA2B,EAAA;;AAG7B;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,MAAM;EACN,qBAAqB,EAAA;;AAGvB;EACE,yBAAyB,EAAA;;AAG3B;EACE,cAAc,EAAA;;AAGhB;EACE,eAAe,EAAA;;AAGjB;EACE,gBAAgB,EAAA;;AAKlB;EACE,yBiFnuCe,EAAA;;AjFquCjB;EAEI,gBAAgB,EAAA;;AAIpB;EAEI,YAAY,EAAA;;AAFhB;EAQI,YAAY;EACZ,SAAS;EACT,WAAW,EAAA;;AAVf;EAeI,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,WAAW,EAAA;;AAlBf;EAsBI,gBAAgB;EAChB,eAAe,EAAA;;AAInB;EAEI,kBAAkB;EAClB,aAAa,EAAA;;AAIjB;EACE,qCAAqC,EAAA;;AAGvC;EACE;IACE,UAAU,EAAA,EAAA;;AAId;EACE,mBAAmB,EAAA;;AAGrB;EAzWA;IA2WI,QAAQ;IACR,WAAW,EAAA,EACZ;;AAGH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;EAHzB;IAMI,eAAe,EAAA;EANnB;IAUI,eAAe,EAAA;EAVnB;IAcI,eAAe,EAAA;EAdnB;IAkBI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,UAAU,EAAA;;AAId;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,MAAM;EACN,SAAS;EACT,YAAY;EACZ,YAAY,EAAA;EAPd;IAWM,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAEhB,UAAU;IACV,kBAAkB;IAClB,QAAQ,EAAA;IAzBd;MA6BQ,UAAU;MACV,gBAAgB,EAAA;EA9BxB;IAmCM,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;IACd,eAAe;IACf,gBAAgB,EAAA;;AAKtB;EACE,kBAAkB,EAAA;EADpB;IAKI,oCAAoC,EAAA;EALxC;IASI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB,EAAA;IAXtB;MAeM,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,kBAAkB;MAElB,sBAAsB;MACtB,gBAAgB;MAChB,cAAc;MACd,kBAAkB;MAClB,yBAAyB;MACzB,kBAAkB;MAClB,UAAU;MACV,aAAa;MACb,WAAW,EAAA;MA5BjB;QA+BQ,WAAW;QACX,yBAAyB;QACzB,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,QAAQ,EAAA;IArChB;MA2CQ,UAAU,EAAA;MA3ClB;QA8CU,QAAQ,EAAA;EA9ClB;IAwDM,iBAAiB;IACjB,kBAAkB,EAAA;IAzDxB;MAsEQ,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,sBAAsB;MACtB,kBAAkB;MAElB,cAAc;MACd,kBAAkB,EAAA;EA/E1B;IAqFI,+BAA+B;IAC/B,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;IAClB,UAAU,EAAA;IAzFd;MA4FM,6BAA6B,EAAA;IA5FnC;MAgGM,iCAAiC;MACjC,YAAY;MACZ,eAAe,EAAA;MAlGrB;QAsGQ,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QAEjB,sBAAsB;QACtB,gBAAgB;QAChB,cAAc;QACd,kBAAkB,EAAA;;AAM1B;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,yBAAyB,EAAA;EAJ3B;IAOI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAElB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc,EAAA;;AAIlB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe,EAAA;EANjB;;;IAWI,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B,EAAA;EAhBlC;IAoBI,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,mCAAmC,EAAA;EAvBvC;IA2BI,eAAe,EAAA;EA3BnB;IA+BI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IAEjB,gBAAgB,EAAA;EAnCpB;IAuCI,yBAAyB,EAAA;EAvC7B;IA2CI,yBAAyB,EAAA;EA3C7B;IA+CI,yBAAyB,EAAA;IA/C7B;;;MAoDM,cAAc,EAAA;EApDpB;IAyDI,+BAA+B,EAAA;EAzDnC;IA6DI,2BAA2B,EAAA;EA7D/B;IAiEI,qBAAqB,EAAA;;AAIzB;EAEE,YAAY;EACZ,+FAMC;EACD,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,aAAa,EAAA;EAbf;IAgBI,0BAA0B;IAC1B,6BAA6B;IAC7B,gBAAgB;IAChB,sBAAsB;IACtB,6BAA6B,EAAA;;AAIjC;EACE,kBAAkB,EAAA;EADpB;IAII,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa,EAAA;EARjB;IAYI,oBAAoB,EAAA;EAZxB;IAgBI,iCAAiC;IACjC,mBAAmB;IACnB,gBAAgB,EAAA;IAlBpB;MAsBQ,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,oBAAoB;MACpB,cAAc;MACd,sBAAsB;MACtB,kBAAkB;MAClB,cAAc;MACd,kBAAkB,EAAA;IA9B1B;MAkCQ,eAAe;MACf,kBAAkB;MAClB,gBAAgB,EAAA;IApCxB;MAwCQ,eAAe;MACf,gBAAgB;MAChB,oBAAoB;MACpB,kBAAkB;MAClB,iBAAiB;MACjB,sBAAsB;MACtB,gBAAgB;MAChB,cAAc;MACd,gBAAgB;MAChB,qBAAqB;MACrB,0BAA0B,EAAA;IAlDlC;MAuDM,kBAAkB,EAAA;MAvDxB;QA0DQ,WAAW;QACX,2BAA2B;QAC3B,UAAU;QACV,aAAa;QACb,kBAAkB;QAClB,UAAU;QACV,OAAO;QACP,QAAQ;QACR,YAAY,EAAA;;AAMpB;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe,EAAA;EAbjB;IAgBI,UAAW;IAAX,aAAW;IACX,SAAS,EAAA;;AAIb;EAEI,YAAY,EAAA;;AkE/pDhB;ElEoqDE,wBAAwB;EACxB,gBAAgB;EAChB,MAAM;EACN,aAAa,EAAA;;AAGf;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,gBAAgB,EAAA;;AkF3sDlB;ElFmuDI,kBAAkB,EAAA;;AAItB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAA;EACA,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,MAAM;EACN,SAAS;EACT,YAAY,EAAA;EAVd;IAcI,SAAS,EAAA;IAdb;MAiBM,gBAAgB,EAAA;EAjBtB;IAsBI,UAAU,EAAA;IAtBd;MAyBM,gBAAgB,EAAA;;AAKtB;EACE,yBAAyB;EACzB,kBAAkB,EAAA;EAFpB;IAKI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,yBAAyB,EAAA;EAX7B;IAgBM,6BAA6B,EAAA;;AAznCnC;EA+nCE,WAAW;EACX,kBAAkB,EAAA;;AAKpB;EACE,YAAY,EAAA;;AAGd;EAEI,gBAAgB,EAAA;;AAIpB;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc,EAAA;;AAIhB;EAEI,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB,EAAA;;AAPtB;EAWI,gBAAgB;EAChB,eAAe,EAAA;;AAZnB;EAgBI,yBAAyB,EAAA;;AAhB7B;EAoBI,yBAAyB,EAAA;;AApB7B;EAwBI,qBAAqB,EAAA;;AAxBzB;EA4BI,yBAAyB,EAAA;;AA5B7B;EAgCI,2BAA2B,EAAA;;AAhC/B;EAoCI,qBAAqB,EAAA;;AApCzB;EAwCI,+BAA+B,EAAA;;AAInC;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,QAAQ,EAAA;;AAGV;EACE,mBAAA;E+Ej4BF;I/Em4BI,WAAW;IACX,gBAAe;IAAf,iBAAe;IACf,iBAAiB,EAAA,EAClB;;AAGH;EACE,gBAAgB;EAChB,mBAAiB;EAAjB,mBAAiB;EACjB,mBAAiB;EAAjB,mBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS,EAAA;EANX;IASI,SAAS,EAAA;;AAIb;EACE,gBAAgB;EAChB,mBAAiB;EAAjB,mBAAiB;EACjB,mBAAiB;EAAjB,mBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS,EAAA;EANX;IASI,yBAAyB;IACzB,wBAAgB;IAAhB,gBAAgB;IAChB,SAAS,EAAA;EAXb;IAeI,yBAAyB;IACzB,wBAAgB;IAAhB,gBAAgB;IAChB,SAAS,EAAA;;AASb;EACE,eAAe;EACf,WAAW;EACX,WAAW,EAAA;;AAGb;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY,EAAA;EAHd;IAQI,yBAAyB;IACzB,wBAAgB;IAAhB,gBAAgB;IAChB,QAAQ,EAAA;EAVZ;IAcI,wBAAgB;IAAhB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,yBAAoC;IACpC,2CAAmC;YAAnC,mCAAmC;IACnC,4BAA4B;IAC5B,UAAU,EAAA;EAtBd;IA0BI,oCAAoC,EAAA;EA1BxC;IAyCI,wBAAgB;IAAhB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,2CAAmC;YAAnC,mCAAmC;IACnC,4BAA4B,EAAA;;AAehC;EACE,WAAW;EACX,YAAY;EAEZ,0BAA0B;EAC1B,gBAAgB,EAAA;EALlB;IAQI,yBAAyB;IACzB,wBAAgB;IAAhB,gBAAgB;IAChB,SAAS,EAAA;EAVb;IAcI,yBAAyB;IACzB,wBAAgB;IAAhB,gBAAgB;IAChB,SAAS,EAAA;EAhBb;IAoBI,wBAAgB;IAAhB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,yBAAoC;IACpC,2CAAmC;YAAnC,mCAAmC;IACnC,4BAA4B;IAC5B,UAAU,EAAA;EA5Bd;IAgCI,oCAAoC,EAAA;EAhCxC;IA+CI,wBAAgB;IAAhB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,sBAAsB;IACtB,2CAAmC;YAAnC,mCAAmC;IACnC,4BAA4B,EAAA;;AAgBhC;EAEI,4BAA4B,EAAA;;AAFhC;EAMI,qBAAqB;EACrB,aAAa;EACb,4BAA4B,EAAA;;AARhC;EAYI,qBAAqB;EACrB,aAAa;EACb,wBAAwB;EACxB,4BAA4B,EAAA;;AAtjBhC;EA2jBE,4BAA4B,EAAA;;AAtf9B;EA0fE,4BAA4B,EAAA;;A2B9hE1B;E3BkiEF,aAAa,EAAA;;AAGf;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B,EAAA;;AAG5B;EACE,aAAa,EAAA;;AAGf;EACE,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB,EAAA;;AAGpB;EACE,aAAa,EAAA;;AAGf;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,mBAAmB,EAAA;;AAGrB;EACE,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW,EAAA;EAJb;IAOI,6BAA6B,EAAA;;AAIjC;EACE,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,gBAAgB,EAAA;;AAzBlB;EA6BE,mBAAmB,EAAA;;A2DxpErB;E3D4pEE,+CAA+C,EAAA;;AAGjD;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,iBAAiB;EACjB,cAAc,EAAA;EAFhB;IAII,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB,EAAA;EAdtB;IAkBI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,eAAe,EAAA;;AAInB;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc,EAAA;;A+Ev7ChB;E/E27CE,cAAc,EAAA;;AAGhB;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,kBAAkB,EAAA;;AAGpB;EACE,UAAU;EACV,wBAAwB,EAAA;;AAG1B;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW,EAAA;;AAGb;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,8BAA8B,EAAA;;AAIhC;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,gBAAgB,EAAA;;AAElB;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,yBiFhtEc;EjFitEd,sBAAsB,EAAA;;AAExB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBiF1yEe;EjF2yEf,kBAAkB,EAAA;;AAEpB;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW,EAAA;;AAEb;EACE,eAAe;EACf,gBAAgB,EAAA;;AAElB;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,yBiFlvEc,EAAA;;AjFovEhB;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB,EAAA;EAHpB;IAMI,oDAAoD;IACpD,yBAAyB,EAAA;EAP7B;IAWI,UAAU;IACV,yBAAyB,EAAA;EAZ7B;IAgBI,yBAAyB;IACzB,yBAAyB,EAAA;;AAG7B;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,WAAW;EACX,cAAc;EACd,YAAY,EAAA;;AAEd;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAE3B;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,iBAAiB,EAAA;;AAEnB;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB,EAAA;;AAEpB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,yBiFh6Ee,EAAA;;AjFk6EjB;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,iBAAiB,EAAA;;AAEnB;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB,EAAA;;AAEzB;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB,EAAA;;AAExB;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAE3B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,yBiFt+Ee,EAAA;;AjFw+EjB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAA;;AAErB;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,eAAe;EACf,mBAAmB,EAAA;;AAErB;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB,EAAA;;AAE3B;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB,EAAA;;AAErB;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,eAAe;EACf,gBAAgB,EAAA;;AAElB;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB,EAAA;;AAE3B;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB,EAAA;;AAErB;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,eAAe;EACf,mBAAmB,EAAA;;AAErB;EACE,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAE3B;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB,EAAA;;AAErB;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB,EAAA;;AAErB;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,yBAAyB,EAAA;;AAE3B;EACE,YAAY;EAEZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,eAAe;EACf,mBAAmB,EAAA;;AAErB;EACE,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAE3B;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,gCAAgC,EAAA;;AAElC;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,eAAe;EACf,gBAAgB,EAAA;;AAElB;EACE,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAE3B;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,mBAAmB,EAAA;;AAErB;EACE,YAAY;EAEZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,eAAe;EACf,gBAAgB,EAAA;;AAElB;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,yBiFlrFe;EjFmrFf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW,EAAA;;AAEb;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW,EAAA;;AAEb;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,yBiFhtFe;EjFitFf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,ciFztFe,EAAA;;AjF2tFjB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,ciFtuFe,EAAA;;AjFwuFjB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAA;;AAErB;EACE,YAAY,EAAA;;AAId;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,yBAAyB,EAAA;;AAE3B;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW,EAAA;;AAEb;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW,EAAA;;AAEb;EACE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,mBAAmB,EAAA;;AAErB;EACE,kBAAkB;EAClB,kBAAkB,EAAA;;AAIpB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB,EAAA;;AAEvB;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,WAAW;EAEX,yBiF7vFc;EjF8vFd,mBAAmB;EACnB,sBAAsB,EAAA;;AAExB;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe,EAAA;;AAEjB;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBiFv4Fe;EjFw4Ff,YAAY,EAAA;;AAEd;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,yBiFj5Fe;EjFk5Ff,ciFl5Fe,EAAA;;AjFo5FjB;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,aAAa,EAAA;;AAEf;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBiFz6Fe;EjF06Ff,0BAA0B,EAAA;;AAE5B;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBiFt7Fe;EjFu7Ff,0BAA0B,EAAA;;AAG5B;EACE,WAAW;EACX,YAAY;EAEZ,2CAA2C;EAC3C,sBAAsB,EAAA;;AAExB;EACE,gBAAgB;EAChB,YAAY,EAAA;;AAEd;EACE,yBAAyB;EACzB,uBAAsB;EACtB,yBAAwB;EACxB,0BAAyB,EAAA;;AAE3B;EACE,YAAY;EACZ,8BAA8B,EAAA;;AAOhC;EACE,uBAAsB,EAAA;;AAExB;EACE,oCAAmC,EAAA;;AAQrC;;;;EAIE,sCAAsC;EACtC,uBAAuB;EACvB,oCAAoC;EAEpC,mDAAmD,EAAA;;AAErD;EACE,uBAAuB;EAAE,kDAAA;EACzB,UAAU;EAAE,wCAAA,EAAyC;;AAEvD;EACE,wBAAuB,EAAA;;AAGzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;;AAGzB,4EAAA;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,UAAU,EAAA;;AAGZ;EACE,WAAU;EACV,UAAS;EACT,yBAAwB,EAAA;;AAM1B;EACE,cACF,EAAA;;AAQA;EACE,yBAAyB,EAAA;;AAE3B;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,yBiFzhGe,EAAA;;AjF2hGjB;EACE,WAAW;EACX,YAAY,EAAA;;AAEd;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,ciF3iGe,EAAA;;AjF6iGjB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gCAAgC,EAAA;;AAElC;EACE,YAAY,EAAA;;AAEd;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gCAAgC,EAAA;;AAElC;EACE,WAAW;EACX,qBAAqB,EAAA;;AAIvB;EACE,WAAW;EACX,wBAAwB,EAAA;;AAE1B;EACE,WAAW;EACX,wBAAwB,EAAA;;AAE1B;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wBAAwB,EAAA;;AAE1B;EACE,WAAW;EACX,qBAAqB,EAAA;;AAGvB;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,yBAAyB,EAAA;;AAE3B;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EAEZ,4BAA4B;EAC5B,mBAAmB;EACnB,yBiFhhGc;EjFihGd,sBAAsB,EAAA;;AAExB;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,yBiF1hGc,EAAA;;AjF4hGhB;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAG3B;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAA;;AAEvB;EACE,YAAY;EACZ,YAAY;EAEZ,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAE3B;EACE,YAAY;EACZ,YAAY;EAEZ,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAE3B;EACE,YAAY;EACZ,YAAY;EAEZ,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAG3B;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB,EAAA;;AAExB;EACE,YAAY;EAGZ,4BAA4B;EAC5B,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAE3B;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAG3B;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB,EAAA;EAJ3B;IAOI,oDAAoD;IACpD,yBAAyB,EAAA;EAR7B;IAYI,UAAU;IACV,yBAAyB,EAAA;EAb7B;IAiBI,yBAAyB;IACzB,yBAAyB,EAAA;;AAG7B;EACE,qBAAqB,EAAA;;AAGvB;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB,EAAA;;AAExB;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc,EAAA;;AAEhB;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,sBAAsB;EACtB,2CAA2C,EAAA;;AAE7C;EACE,wBAAwB;EACxB,4BAA4B,EAAA;;AAE9B;EACE,YAAY;EACZ,kBAAkB,EAAA;;AAEpB;EACE,uBAAuB;EACvB,4BAA4B,EAAA;;AAE9B;EACE,cAAc;EACd,6BAA6B,EAAA;;AAE/B;EACE,4BAA4B;EAC5B,8BAA8B,EAAA;;AAEhC;EACE,YAAY;EACZ,yBAAyB,EAAA;;AAE3B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB,EAAA;;AAErB;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAA;;AAE3B;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,eAAe,EAAA;;AAEjB;EAEE,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAElB;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,mBAAmB,EAAA;;AAIrB;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B,EAAA;;AAE5B;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBiFhzGe;EjFizGf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB,EAAA;;AAEpB;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB,EAAA;;AAEzB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBiFv0Ge,EAAA;;AjFy0GjB;EACE,cAAc;EACd,aAAa;EACb,uBAAuB,EAAA;;AAEzB;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc,EAAA;;AAEhB;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,qBAAqB,EAAA;;AAEvB;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB,EAAA;;AAErB;EACE,gBAAgB;EAChB,qBAAqB,EAAA;;AAEvB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB;EAChB,qBAAqB,EAAA;;AAEvB;EACE,aAAa;EACb,8BAA8B,EAAA;;AAEhC;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,uBAAuB,EAAA;;AAEzB;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW,EAAA;;AAIb;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,yBiFr4Ge;EjFs4Gf,aAAa;EACb,mBAAmB,EAAA;;AAErB;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,yBAAyB,EAAA;;AAE3B;EAEE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW,EAAA;;AAEb;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB,EAAA;;AAEnB;EACE,iBAAiB,EAAA;;AAMnB;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,yBAAyB,EAAA;;AAE3B;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW,EAAA;;AAEb;EACE,eAAe,EAAA;;AAEjB;EACE,eAAe,EAAA;;AAIjB;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB,EAAA;;AAErB;EACE,wBAAwB;EACxB,UAAU;EACV,yBAAyB,EAAA;;AAE3B;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBiFj9Ge;EjFk9Gf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB,EAAA;;AAEpB;EACE,aAAa;EACb,8BAA8B,EAAA;;AAEhC;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW,EAAA;;AAEb;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW,EAAA;;AAEb;EACE,aAAa;EACb,uBAAuB,EAAA;;AAEzB;EACE,WAAW;EACX,YAAY,EAAA;;AAEd;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,cAAc,EAAA;;AAEhB;EACE,WAAW;EACX,WAAW;EACX,yBAAyB,EAAA;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAA;;AAErB;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,mBAAmB,EAAA;;AAErB;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB,EAAA;;AAExB;EACE,WAAW;EACX,WAAW;EACX,yBiFnjHe;EjFojHf,eAAe;EACf,aAAa;EACb,mBAAmB,EAAA;;AAErB;EACE,iBAAiB,EAAA;;AAUnB;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,iBAAiB,EAAA;;AAEnB;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB,EAAA;;AAErB;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB,EAAA;;AAErB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB,EAAA;;AAE3B;EACE,aAAa;EACb,mBAAmB,EAAA;;AAErB;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,yBAAyB,EAAA;;AAE3B;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,yBiFxmHe;EjFymHf,mBAAmB,EAAA;;AAErB;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,aAAa,EAAA;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc,EAAA;;AAEhB;EACE,aAAa;EACb,mBAAmB,EAAA;;AAErB;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAEjB;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;;AoF/oHlB;EpFwpHE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAEhB,gBAAgB,EAAA;;AAIlB;EACE,aAAa,EAAA;;AAEf;EArXA;IAuXI,yBAAyB,EAAA,EAC1B;;AAmCH;EACE,oCAAoC,EAAA;;AAOtC;EACE;IACE,YAAY,EAAA;EAEd;IACE,YAAY,EAAA;EAEd;IACE,YAAY,EAAA;EAEd;IACE,YAAY,EAAA;EAEd;IACE,UAAU,EAAA,EAAA;;AAGd;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B,EAAA;;AAE/B;EACE,eAAe;EAAf,gBAAe,EAAA;;AE7rHjB;EFgsHE,cAAc,EAAA;;AAEhB;EACE,gCAA+B,EAAA;;AAEjC;EACE,gCAAgC,EAAA;;AAElC;EACE,8BAA8B,EAAA;;AAEhC;EACE,eAAe,EAAA;;AAGjB;EACE,2CAA2C,EAAA;;AAG7C;EACE;IACE,YAAY,EAAA,EAAA;;AAIhB;EACI,oDAA6C;EAC7C,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa,EAAA;EAJjB;IAOM,kBAAkB;IAClB,mBAAmB;IAEnB,ciF/wHW;IjFgxHX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB,EAAA;EAlBxB;IAuBM,mBAAmB,EAAA;;AAIzB;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB,EAAA;;AAOrB;EACE,sBAAsB;EACtB,iBAAiB,EAAA;;AAEnB;EACE,wBAAwB;EACxB,kBAAkB,EAAA;;AAEpB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAE9B,iBAAiB;EACjB,uBAAsB,EAAA;;AAOxB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAE9B,iBAAiB;EACjB,sBAAqB,EAAA;;AASvB;EACE,YAAY,EAAA;;AAGd;EACE,8BAA8B,EAAA;;AAKhC;EACE,2BAA2B;EAC3B,4BAA4B;EAE5B,8BAA6B,EAAA;;AAI/B;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAa;EACb,mBAAkB,EAAA;;AAEpB;EACE,gBAAe,EAAA;;AAEjB;EAEC,cAAc,EAAA;;AAGf;EACE,eAAe,EAAA;;AAEjB;EACE,iBAAiB;EACjB,+BAA+B;EAG/B,yCAAiC;EAAjC,sCAAiC;EAAjC,iCAAiC;EAC/B,qCAA6B;EAA7B,kCAA6B;EAA7B,6BAA6B,EAAA;;AAGjC;EACE,6BAA6B;EAC3B,uBAAuB;EACvB,0CAAqD,EAAA;;AAGzD;EACE,6BAA6B,EAAA;;AAE/B;EACE,6BAA6B,EAAA;;AA1yF/B;EA8yFG,2BAA2B,EAAA;;AAc9B;EACE,UAAU,EAAA;;AAvGZ;EA6GM,iBAAiB,EAAA;;AAIvB;EACE,aAAa;EACb,uBAAuB,EAAA;;AAGzB;EACE,uBAAuB,EAAA;;AAGzB;EACE,WAAc;EAAd,cAAc,EAAA;;AAGhB;EACE,6BAA6B,EAAA;;AAG/B;EACE,yBAAyB,EAAA;;AAG3B;EACE,+BAA+B,EAAA;;AArwFjC;EAywFE,gCAAgC,EAAA;;AAGlC;EACE,kBAAkB,EAAA;;AAGpB;EACE,yBAAyB;EACzB,qBAAqB,EAAA;;AAEvB;EACE,eAAe,EAAA;;AAEjB;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB,EAAA;;AAE3B;EACE,aAAa;EACb,mBAAmB,EAAA;;AAErB;EACE,eAAe;EACf,UAAU,EAAA;;AAEZ;EACE,eAAe,EAAA;;AAEjB;EACE,YAAY,EAAA;;AAEd;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB,EAAA;;AAE3B;EACE,iBAAiB;EACf,mBAAmB,EAAA","sourcesContent":["/*!\n * Bootstrap v4.6.2 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"code\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"input-group\";\n@import \"custom-forms\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"jumbotron\";\n@import \"alert\";\n@import \"progress\";\n@import \"media\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"utilities\";\n@import \"print\";\n","// @import url(\"https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900\");\r\n@import url(\"http://fonts.cdnfonts.com/css/avenir-lt-std\");\r\n\r\n@import \"~bootstrap/scss/bootstrap\";\r\n\r\n*,\r\nhtml,\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  // font-family: \"Prompt\", sans-serif, Light 300;\r\n  font-family: \"Avenir LT Std\", sans-serif !important;\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n\r\n*,\r\nbody {\r\n  outline: none;\r\n}\r\n\r\na {\r\n  &:hover,\r\n  &:focus {\r\n    text-decoration: none;\r\n  }\r\n\r\n  text-decoration: none;\r\n}\r\n\r\n@import \"./StyleSheets/index\";\r\n\r\n.ant-radio-checked .ant-radio-inner {\r\n  border-color: $magenta !important ;\r\n}\r\n.ant-radio-checked .ant-radio-inner:after {\r\n  background-color: $magenta;\r\n}\r\n.ant-radio:hover .ant-radio-inner {\r\n  border-color: $magenta;\r\n}\r\n.checkbox-container{\r\n  display: flex;\r\n  flex-direction: row;\r\n  color:black;\r\n  \r\n \r\n}\r\n.vitals-label {\r\n  margin-right: 10px; /* Adjust the margin for tab space */\r\n}\r\n\r\n\r\n\r\n\r\n.selec2Class {\r\n  .ant-select-selection {\r\n    \r\n    padding: 0px 35px;\r\n    // border: solid 1px $cool-grey;\r\n    background-color: $white;\r\n    position: relative;\r\n\r\n    &::before {\r\n      content: url(\"./assets/images/icons/unit-input-icon.png\");\r\n      width: 24px;\r\n      height: 24px;\r\n      position: absolute;\r\n      left: calc(6.7% - 24px);\r\n      top: calc(100% - 24px);\r\n    }\r\n  }\r\n}\r\n\r\n.btn-magenta {\r\n  background-color: $magenta;\r\n  color: #fff;\r\n  border: 1px solid $magenta;\r\n  border-radius: 5px;\r\n  &::after {\r\n    border: 1px solid $magenta;\r\n    border-radius: 5%;\r\n  }\r\n}\r\n\r\n.btn-red {\r\n  background-color: #fc4b6c;\r\n  color: $white;\r\n  border: 1px solid #fc4b6c;\r\n  border-radius: 5px;\r\n  &::after {\r\n    border: 1px solid #fc4b6c;\r\n  }\r\n}\r\n\r\n.loginLayer {\r\n  height: 100vh;\r\n  background-color: $dark-grey-blue-two;\r\n\r\n  h2 {\r\n    color: $white;\r\n    font-size: 24px;\r\n  }\r\n\r\n  button {\r\n    background-color: transparent;\r\n    border: 1.5px solid $silver;\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 2.45;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: #fff;\r\n    padding: 0px 30px;\r\n  }\r\n}\r\n\r\n.nav-info {\r\n  position: absolute;\r\n  margin: 0px auto;\r\n  top: 40px;\r\n  left: 39px;\r\n  font-size: 10px;\r\n}\r\n\r\n.form-row {\r\n  p {\r\n    &.readonly {\r\n      font-size: 13px;\r\n      background-color: whitesmoke;\r\n      color: #696d71;\r\n      line-height: 1.5;\r\n    }\r\n  }\r\n}\r\n\r\n.work-flow-stages p {\r\n  &.readonly {\r\n    font-size: 13px;\r\n    text-align: left;\r\n    background-color: whitesmoke;\r\n    color: #696d71;\r\n    line-height: 1.5;\r\n  }\r\n}\r\n\r\n.q-check label.checked span {\r\n  border: solid 1px #b2b9c4;\r\n  background-color: #d4dce0;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: not-allowed;\r\n  font-style: normal;\r\n  font-stretch: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #364152;\r\n}\r\n\r\n.data-label {\r\n  min-width: 2em;\r\n  color: #455a64;\r\n  font-weight: normal;\r\n  font-size: 16px;\r\n  // line-height: 2.5;\r\n  letter-spacing: normal;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.data-item {\r\n  color: #455a64;\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  letter-spacing: normal;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.btn-success {\r\n  padding: 5px 30px;\r\n  // background-color: #32a257;\r\n  background-color: $magenta;\r\n  border-color: $magenta;\r\n}\r\n\r\n.btn-success:focus {\r\n  // background-color: #32a257 !important;\r\n  background-color: $magenta !important;\r\n  color: #fff;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.btn-next {\r\n  padding: 5px 30px;\r\n  color: #fff;\r\n  background-color: #b37f40 !important;\r\n}\r\n\r\n.btn-next:hover {\r\n  color: #fff;\r\n}\r\n\r\nlabel {\r\n  color: #455a64;\r\n  margin-bottom: 0rem;\r\n}\r\n\r\n.ant-modal-body {\r\n  background-color: #f4f4f4;\r\n  border-radius: 10px;\r\n}\r\n\r\n.ant-modal-close {\r\n  display: none;\r\n}\r\n\r\n.ant-select-selection {\r\n  border-radius: 5px !important;\r\n  \r\n}\r\n.checkoutModal:where(.css-dev-only-do-not-override-1okl62o).ant-modal .ant-modal-content {\r\n  border-radius: 4px !important;\r\n  padding: 25px 37px !important;\r\n  width: 73%;\r\n  margin-left: 12%;\r\n}\r\n.ant-select-arrow {\r\n  background-color: $magenta;\r\n  width: 30px !important;\r\n  height: 32px !important;\r\n  position: absolute !important;\r\n  top: 5px !important;\r\n  // margin-top: 2px;\r\n  right: 0px !important;\r\n  border-top-right-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n  color: white !important;\r\n  font-size: 18px !important;\r\n  font-weight: 900;\r\n  padding-left: 6px;\r\n}\r\n\r\n.ant-select-arrow-icon {\r\n  padding: 5px 0 1px;\r\n}\r\n\r\nspan.ant-time-picker-icon {\r\n  background-color: $magenta;\r\n  width: 30px;\r\n  height: 32px;\r\n  position: absolute;\r\n  top: 7px;\r\n  right: 0px;\r\n  border-top-right-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: 900;\r\n}\r\n\r\n.ant-time-picker-clock-icon {\r\n  padding-top: 5px;\r\n  color: #fff !important;\r\n}\r\n\r\n.generate-token {\r\n  .umr,\r\n  .mobile {\r\n    .form-group {\r\n      width: 90%;\r\n\r\n      &::after {\r\n        content: \"or\";\r\n        color: black;\r\n        position: absolute;\r\n        // top: 5px;\r\n        font-size: 16px;\r\n        bottom: 5px;\r\n        margin: auto;\r\n        right: -33px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .ipnumber {\r\n    width: 80%;\r\n\r\n    button {\r\n      position: absolute;\r\n      top: 0;\r\n      right: 16px;\r\n      font-size: 19px;\r\n      border-radius: 0px;\r\n      padding: 0p;\r\n      line-height: 0px;\r\n    }\r\n  }\r\n}\r\n\r\n.cou-dash {\r\n  h1 {\r\n    font-size: 40px;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 1.2;\r\n    letter-spacing: normal;\r\n    color: #364152;\r\n  }\r\n\r\n  h6 {\r\n    font-size: 25px;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 1;\r\n    letter-spacing: normal;\r\n    color: #455a64;\r\n  }\r\n}\r\n\r\n.text-heading {\r\n  font-size: 40px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: 1.2;\r\n  letter-spacing: normal;\r\n  color: #364152;\r\n}\r\n\r\n.textarea {\r\n  background-color: #f5f5f5;\r\n  border-radius: 5px;\r\n  border: 1px solid #d9d9d9;\r\n  width: 100%;\r\n  height: 120px;\r\n  padding: 10px;\r\n}\r\n\r\n.insurance {\r\n  h5 {\r\n    font-size: 25px;\r\n  }\r\n\r\n  li {\r\n    font-size: 16px;\r\n    font-weight: 300;\r\n    line-height: 1.5;\r\n    color: #455a64;\r\n  }\r\n\r\n  .one {\r\n    color: #364152;\r\n    font-size: 18px;\r\n    line-height: 1.5;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .two {\r\n    color: #455a64;\r\n    font-size: 16px;\r\n    line-height: 1.5;\r\n    font-weight: 300;\r\n  }\r\n}\r\n\r\n.anticon-calendar {\r\n  background-color: #6c3964;\r\n  width: 30px;\r\n  height: 32px;\r\n  position: absolute;\r\n  top: 7px;\r\n  right: -1px;\r\n  border-top-right-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n  color: white;\r\n  font-size: 18px;\r\n  font-weight: 900;\r\n\r\n  svg {\r\n    margin-top: 6px;\r\n  }\r\n\r\n  .ant-input-suffix {\r\n    background-color: #067fb8;\r\n    width: 30px;\r\n    height: 31px;\r\n    // position: absolute;\r\n    // top: 5px;\r\n    right: 0px;\r\n    border-top-right-radius: 5px;\r\n    border-bottom-right-radius: 5px;\r\n    color: white;\r\n    font-size: 18px;\r\n    font-weight: 900;\r\n  }\r\n\r\n  .anticon {\r\n    &.anticon-user {\r\n      color: #fff;\r\n      margin-top: 5px;\r\n      margin-left: 5px;\r\n    }\r\n  }\r\n}\r\n\r\n// calender picker\r\n.ant-calendar-picker:hover .anticon-close-circle.ant-calendar-picker-clear {\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n  width: 30px;\r\n  height: 32px;\r\n  position: absolute;\r\n  right: 0px;\r\n  top: 7px;\r\n  border-top-right-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n  border: 1px solid #1890ff;\r\n  border-left: none;\r\n\r\n  & svg {\r\n    margin-top: 8px;\r\n    display: inline-block;\r\n  }\r\n}\r\n\r\n.card {\r\n  & .anticon-calendar {\r\n    top: 6px;\r\n  }\r\n\r\n  & .ant-calendar-picker:hover .anticon-close-circle.ant-calendar-picker-clear {\r\n    top: 6px;\r\n  }\r\n\r\n  & .ant-select-arrow {\r\n    // right: -1px;\r\n  }\r\n}\r\n\r\n.financial-table {\r\n  .track-bills {\r\n    width: 170%;\r\n  }\r\n\r\n  thead {\r\n    color: #fff;\r\n    background-color: #87979f;\r\n\r\n    & td {\r\n      text-transform: capitalize;\r\n      font-weight: 500;\r\n      font-weight: 14px;\r\n    }\r\n  }\r\n\r\n  tbody {\r\n    & td {\r\n      font-size: 16px;\r\n      font-weight: 300;\r\n      line-height: 1.5;\r\n      color: #455a64;\r\n    }\r\n\r\n    & td ul {\r\n      padding-left: 20px;\r\n    }\r\n  }\r\n}\r\n\r\n.table-bordered td:last-child {\r\n  border-right: 0px solid #dee2e6;\r\n}\r\n\r\n.table-bordered td:first-child {\r\n  border-left: 0px solid #dee2e6;\r\n}\r\n\r\n.man-dash {\r\n  .card {\r\n    height: 170px;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n    h1 {\r\n      font-size: 60px;\r\n      font-weight: 500;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      line-height: 0.69;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: #ffffff;\r\n    }\r\n\r\n    h2 {\r\n      font-size: 20px;\r\n      font-weight: normal;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      line-height: 1.27;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: #ffffff;\r\n      margin-bottom: 0px;\r\n    }\r\n  }\r\n}\r\n\r\n.role_table {\r\n  thead {\r\n    background-color: $magenta;\r\n    th {\r\n      font-size: 16px;\r\n      font-weight: 500;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      line-height: 2.5;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: #084b6b;\r\n      text-transform: capitalize;\r\n    }\r\n  }\r\n  tbody {\r\n    th {\r\n      // color: #b37f40;\r\n      color: #455a64;\r\n      border-top: 1px solid #dee2e6;\r\n    }\r\n\r\n    td {\r\n      // color: #b37f40;\r\n      color: #455a64;\r\n      border-top: 1px solid #dee2e6;\r\n    }\r\n  }\r\n}\r\n\r\n.queue-cards {\r\n  .btn-refresh {\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: #b37f40;\r\n    padding: 3px 5px;\r\n    margin-top: 4px !important;\r\n  }\r\n\r\n  .card {\r\n    .card-header {\r\n      font-size: 25px;\r\n      font-weight: normal;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      line-height: 1.5;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: #ffffff;\r\n      padding: 5px;\r\n    }\r\n\r\n    thead {\r\n      background-color: #d4dade;\r\n\r\n      td {\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n        font-stretch: normal;\r\n        font-style: normal;\r\n        line-height: 1.14;\r\n        letter-spacing: normal;\r\n        text-align: left;\r\n        color: #084b6b;\r\n        text-transform: capitalize;\r\n      }\r\n\r\n      tbody {\r\n        td {\r\n          font-size: 14px;\r\n          font-weight: 300;\r\n          font-stretch: normal;\r\n          font-style: normal;\r\n          line-height: 1.29;\r\n          letter-spacing: normal;\r\n          text-align: left;\r\n          color: #455a64;\r\n        }\r\n      }\r\n    }\r\n\r\n    h1 {\r\n      font-size: 25px;\r\n      font-weight: normal;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      text-transform: capitalize;\r\n      line-height: 1.5;\r\n      letter-spacing: 0.5px;\r\n      text-align: center;\r\n      color: #ffffff;\r\n      border-bottom: 1px solid #257aca;\r\n      margin-bottom: 0px;\r\n      padding: 5px;\r\n    }\r\n\r\n    h2 {\r\n      font-size: 20px;\r\n      font-weight: normal;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      text-transform: capitalize;\r\n      line-height: 1.5;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: #ffffff;\r\n      margin-bottom: 0px;\r\n      padding-top: 20px;\r\n    }\r\n\r\n    h3 {\r\n      font-size: 28px;\r\n      font-weight: normal;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      text-transform: capitalize;\r\n      //   line-height: 1.5;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: #ffffff;\r\n      margin-bottom: 0px;\r\n      padding-bottom: 20px;\r\n    }\r\n\r\n    h4 {\r\n      font-size: 20px;\r\n      font-weight: normal;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      text-transform: uppercase;\r\n      line-height: 0.8;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: #ffffff;\r\n      background-color: #257aca;\r\n      padding: 15px;\r\n      //   margin-bottom: 0px;\r\n    }\r\n\r\n    p {\r\n      font-size: 14px;\r\n      font-weight: 300;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      text-transform: capitalize;\r\n      line-height: 1.29;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: #ffffff;\r\n    }\r\n  }\r\n}\r\n\r\n.card-table {\r\n  .card-header {\r\n    color: #fff;\r\n    border-bottom: 0px;\r\n  }\r\n\r\n  thead {\r\n    background-color: #dee9ef;\r\n\r\n    td {\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      line-height: 1.5;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: #084b6b;\r\n      text-transform: capitalize;\r\n    }\r\n  }\r\n\r\n  tbody {\r\n    td {\r\n      font-size: 14px;\r\n      font-weight: 300;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      line-height: 1.5;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: #455a64;\r\n    }\r\n\r\n    tr.last {\r\n      background-color: #fff1e1;\r\n    }\r\n  }\r\n}\r\n// .table-responsive {\r\n//   height: 432px;\r\n// }\r\n.table-hover tbody tr:hover {\r\n  color: #212529;\r\n  background-color: #f5f5f5 !important;\r\n}\r\n\r\n.bill-details {\r\n  .data-label {\r\n    width: 120px;\r\n  }\r\n}\r\n\r\n.pagination li {\r\n  color: black;\r\n  float: left;\r\n  padding: 6px 16px;\r\n  text-decoration: none;\r\n  border: 1px solid #c1c1cc;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.pagenation-col {\r\n  align-items: center;\r\n  justify-content: center;\r\n  display: flex;\r\n}\r\n.ant-pagination .ant-pagination-item {\r\n  border:1px solid gray !important;\r\n  border-radius: 4px !important;\r\n}\r\n.ant-pagination .ant-pagination-item-active{\r\n  border:1px solid blue !important;\r\n}\r\n.ant-pagination .ant-pagination-prev{\r\n  color:gray;\r\n}\r\n.ant-pagination .ant-pagination-next{\r\n  color:gray;\r\n}\r\n.ant-select .ant-select-selection-item{\r\n  color:gray;\r\n \r\n \r\n  padding-right:24px !important;\r\n}\r\n.token-popup {\r\n  & h1 {\r\n    font-size: 70px;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 0.6;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #364152;\r\n  }\r\n\r\n  & h2 {\r\n    font-size: 35px;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 1.07;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #455a64;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  & h3 {\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 1.6;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #455a64;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  & p {\r\n    font-size: 15px;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 2.4;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #455a64;\r\n  }\r\n}\r\n\r\n.disable {\r\n  color: #455a64;\r\n}\r\n\r\n@media print {\r\n  .token-popup h1 {\r\n    font-size: 80pt;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 0.8;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: black !important;\r\n  }\r\n\r\n  .token-popup h2 {\r\n    font-size: 25pt;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 1.3;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: black !important;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .token-popup h3 {\r\n    font-size: 18pt;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 1.6;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: black !important;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .token-popup p {\r\n    font-size: 16pt;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 2.4;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: black !important;\r\n  }\r\n}\r\n\r\n.user-map {\r\n  & table {\r\n    & tbody {\r\n      & td.active {\r\n        background-color: #b37f40;\r\n        color: #fff;\r\n      }\r\n\r\n      td.active::after {\r\n        position: absolute;\r\n        width: 20px;\r\n        height: 25px;\r\n        background-color: #b37f40;\r\n        content: \"\";\r\n        transform: rotate(45deg);\r\n        right: -8px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.input-group-append {\r\n  .btn-primary {\r\n    background-color: #3093b4 !important;\r\n    border-color: #3093b4 !important;\r\n  }\r\n\r\n  .btn-primary.dropdown-toggle {\r\n    color: #fff;\r\n    background-color: #3093b4 !important;\r\n    border-color: #3093b4 !important;\r\n  }\r\n}\r\n\r\n.ant-switch-checked {\r\n  background-color: $magenta !important;\r\n}\r\n\r\n.input-group-prepend.show {\r\n  position: relative;\r\n  height: 100%;\r\n\r\n  .dropdown-menu {\r\n    a {\r\n      color: #fff;\r\n      text-align: left;\r\n      padding-bottom: 13px;\r\n      padding-top: 13px;\r\n      font-size: 16px;\r\n      border-bottom: 0.1px solid #7fc3e3;\r\n    }\r\n  }\r\n\r\n  .dropdown-menu.show {\r\n    background-color: #067fb8;\r\n    margin-top: 20px;\r\n    animation: 1s fadeIn;\r\n    padding: 3px 15px 25px;\r\n  }\r\n\r\n  .dropdown-menu.show::before {\r\n    content: \"\";\r\n    width: 15px;\r\n    height: 23px;\r\n    background-color: #067fb8;\r\n    position: absolute;\r\n    top: -8px;\r\n    left: 12%;\r\n    transform: rotate(45deg);\r\n    border-radius: 4px;\r\n  }\r\n\r\n  .dropdown-item:hover,\r\n  .dropdown-item:focus {\r\n    color: #084b69;\r\n    text-decoration: none;\r\n    background-color: #067fb8;\r\n  }\r\n}\r\n\r\n.form-group {\r\n  position: relative;\r\n}\r\n\r\n.form-text {\r\n  position: absolute;\r\n  bottom: -20px;\r\n}\r\n\r\n.form-text.text-danger {\r\n  animation: 1s fadeInDown;\r\n}\r\n\r\n.hand {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 0px;\r\n  // left: 93%;\r\n  height: 50%;\r\n  animation: 1s fadeInRight;\r\n}\r\n\r\n.download {\r\n  & button {\r\n    margin-top: 2px;\r\n  }\r\n\r\n  & button:hover img {\r\n    animation: 1s flash infinite;\r\n  }\r\n\r\n  & .btn-success-disabled:hover img {\r\n    animation: none;\r\n  }\r\n\r\n  span {\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 1.5;\r\n    letter-spacing: normal;\r\n    text-transform: uppercase;\r\n  }\r\n\r\n  .btn-success-disabled {\r\n    padding: 5px 31px;\r\n    color: #fff;\r\n    // background-color: #28a745;\r\n    background-color: $magenta;\r\n    // border-color: #28a745;\r\n    font-size: 16px;\r\n    height: 36px;\r\n  }\r\n}\r\n\r\ni.anticon.anticon-loading {\r\n  position: absolute;\r\n  top: 8px;\r\n}\r\n\r\ntable {\r\n  tbody {\r\n    tr {\r\n      td {\r\n        img {\r\n          cursor: pointer;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.anticon-edit {\r\n  color: #6c3964;\r\n  outline: transparent;\r\n  font-size: large;\r\n}\r\n\r\n.room_eligibility_ward .ant-select-arrow {\r\n  border-top-right-radius: 0px;\r\n  border-bottom-right-radius: 0px;\r\n}\r\n\r\n.upgrade_room_ward .ant-select-arrow {\r\n  border-top-right-radius: 0px;\r\n  border-bottom-right-radius: 0px;\r\n}\r\n\r\n.ailment_capping .ant-select-arrow {\r\n  border-top-right-radius: 0px;\r\n  border-bottom-right-radius: 0px;\r\n}\r\n\r\n.surgery_procedure_capped_ailment .ant-select-arrow {\r\n  border-top-right-radius: 0px;\r\n  border-bottom-right-radius: 0px;\r\n}\r\n\r\n.fc-patient-copy {\r\n  .d-inline-flex {\r\n    padding-top: 12px;\r\n  }\r\n\r\n  span.w-label {\r\n    min-width: 170px;\r\n  }\r\n\r\n  span.w-100 {\r\n    text-transform: capitalize;\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n.no-data {\r\n  color: #e3e3e3;\r\n  // animation: 1s flash infinite;\r\n}\r\n\r\n.ant-btn[disabled]:hover {\r\n  color: #fff;\r\n  // background-color: #28a745;\r\n  // border-color: #28a745;\r\n  background-color: #676767;\r\n}\r\n\r\n// .table-responsive{\r\n//   height:500px;\r\n//   overflow: scroll;\r\n// }\r\n// .table-responsive:hover{\r\n//   overflow-y:scroll;\r\n\r\n//   &::-webkit-scrollbar {\r\n//     width: 8px;\r\n//   }\r\n\r\n//   &::-webkit-scrollbar-track {\r\n//     /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);  */\r\n//     background-color: #f4f4f4;\r\n//     /* border-radius: 10px; */\r\n//   }\r\n\r\n//   &::-webkit-scrollbar-thumb {\r\n//     border-radius: 10px;\r\n//     background-color: #c1c1c1;\r\n//     /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);  */\r\n//   }\r\n\r\n// }\r\n//  thead tr:nth-child(1) td{\r\n//     background: white;\r\n//     position: sticky;\r\n//     top: 0;\r\n//     z-index: 10;\r\n//   }\r\n\r\n// page scroll bar\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n\r\n::-webkit-scrollbar-track {\r\n  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);  */\r\n  background-color: #f4f4f4;\r\n  /* border-radius: 10px; */\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  border-radius: 10px;\r\n  background-color: #c1c1c1;\r\n  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);  */\r\n}\r\n.ant-input {\r\n  // box-shadow: 0 1px 8px rgba(23, 110, 222, 0.1);\r\n  border:white !important;\r\n  padding:0 !important;\r\n}\r\n:where(.css-dev-only-do-not-override-1okl62o).ant-input-affix-wrapper {\r\n  padding:0;\r\n  box-shadow: 0 1px 8px rgba(23, 110, 222, 0.1);\r\nline-height:2.3;\r\nborder:0;}\r\n.ant-select-selector{\r\n  \r\n  border:0 !important;\r\n  box-shadow: 0 1px 8px rgba(23, 110, 222, 0.1);\r\n}\r\n\r\n.group-td {\r\n  padding: 10px;\r\n  height: 40px;\r\n  border-top: 1px solid #dee2e6;\r\n\r\n  &:first-child {\r\n    border-top: 0px solid #dee2e6;\r\n  }\r\n}\r\n\r\n// /////////////////////////////////////\r\ntr.hide-table-padding td {\r\n  padding: 0.75rem;\r\n  background-color: #fbeede;\r\n}\r\n\r\n.expand-button {\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.accordion-toggle .expand-button:after {\r\n  position: absolute;\r\n  left: 2.3rem;\r\n  color: #b37f40;\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n  top: 18%;\r\n  transform: translate(0, -50%);\r\n  transform: rotate(45deg);\r\n  content: \"+\";\r\n  transition: 0.2s linear;\r\n  // content: '-';\r\n}\r\n\r\n.accordion-toggle.collapsed .expand-button:after {\r\n  content: \"+\";\r\n  transform: rotate(0deg);\r\n}\r\n\r\n.collapse.show {\r\n  transition: 0.3s linear;\r\n  transition-delay: 0.1s;\r\n}\r\n\r\n.bg1 {\r\n  background-color: #488bd6;\r\n}\r\n\r\n.bg2 {\r\n  background-color: #40b391;\r\n}\r\n\r\n.bg3 {\r\n  background-color: #40a7b3;\r\n}\r\n\r\n.bg4 {\r\n  background-color: #b37f40;\r\n}\r\n\r\n.bg5 {\r\n  background-image: linear-gradient(#2d6296, #224c73, #183551);\r\n}\r\n\r\n.bg6 {\r\n  background-image: linear-gradient(#2e81b9, #246590, #194766);\r\n}\r\n\r\n.bg7 {\r\n  background-image: linear-gradient(#568095, #426171, #2e4550);\r\n}\r\n\r\n.bg8 {\r\n  background-color: #87979f;\r\n}\r\n\r\n.bg9 {\r\n  background-color: #dee9ef;\r\n}\r\n\r\n\r\n.tv-row td {\r\n  border-bottom: 0px solid transparent;\r\n  font-size: 23px;\r\n}\r\n.tv-row tr {\r\n  border-bottom: solid 1px d4dade;\r\n}\r\n\r\n.tv-row .token {\r\n  line-height: 1 !important;\r\n  font-size: 6pc !important;\r\n}\r\n\r\n.tv-row .councellor {\r\n  line-height: 1 !important;\r\n  font-size: 4.5pc !important;\r\n}\r\n\r\n.loadding {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100vh;\r\n  top: 0;\r\n  background: #f1f1f180;\r\n}\r\n\r\n.ant-spin-dot-item {\r\n  background-color: #084b69;\r\n}\r\n\r\n.ant-spin {\r\n  color: #084b69;\r\n}\r\n\r\n.ant-spin-text {\r\n  font-size: 20px;\r\n}\r\n\r\n.ant-input[disabled] {\r\n  color: #000000c7;\r\n}\r\n\r\n.ant-calendar-picker-input .ant-input {\r\n}\r\n.ant-calendar-picker-icon {\r\n  background-color: $magenta;\r\n}\r\n.ant-select-disabled .ant-select-selection {\r\n  .ant-select-selection-selected-value {\r\n    color: #000000c7;\r\n  }\r\n}\r\n\r\n.ant-select-sm {\r\n  .ant-select-selection--single {\r\n    height: 30px;\r\n\r\n\r\n  }\r\n\r\n  .ant-select-selection__placeholder {\r\n    height: 30px;\r\n    top: 13px;\r\n    right: 10px;\r\n    \r\n  }\r\n\r\n  .ant-select-arrow {\r\n    background-color: #067fb8;\r\n    width: 30px;\r\n    height: 30px;\r\n    right: -1px;\r\n  }\r\n\r\n  .ant-select-arrow-icon {\r\n    padding-top: 6px;\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n.token-mobile {\r\n  .form-text {\r\n    position: absolute;\r\n    bottom: -40px;\r\n  }\r\n}\r\n\r\n.blink_me {\r\n  animation: blinker 1s linear infinite;\r\n}\r\n\r\n@keyframes blinker {\r\n  50% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.ant-pagination {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n@media only screen and (max-width: 1024px) {\r\n  .hand {\r\n    top: 55%;\r\n    height: 50%;\r\n  }\r\n}\r\n\r\n.text-ixons {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  span {\r\n    cursor: pointer;\r\n  }\r\n\r\n  .disable {\r\n    cursor: default;\r\n  }\r\n\r\n  .active {\r\n    cursor: pointer;\r\n  }\r\n\r\n  p {\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #084b6b;\r\n    margin-bottom: 0px;\r\n    margin: 0px 12px;\r\n    width: 20%;\r\n  }\r\n}\r\n\r\n.date-container {\r\n  position: absolute;\r\n  width: 18%;\r\n  right: 1.5%;\r\n  top: 0;\r\n  bottom: 0;\r\n  margin: auto;\r\n  height: 30px;\r\n\r\n  .text-ixons {\r\n    input {\r\n      background-color: transparent;\r\n      border: 0px;\r\n      font-size: 18px;\r\n      font-weight: 500;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: #084b6b;\r\n      margin-bottom: 0px;\r\n      margin: 0px 12px;\r\n\r\n      width: 90%;\r\n      position: relative;\r\n      left: 4%;\r\n\r\n      &:focus,\r\n      &:active {\r\n        outline: 0;\r\n        box-shadow: none;\r\n      }\r\n    }\r\n\r\n    .anticon-calendar {\r\n      background-color: transparent;\r\n      width: 30px;\r\n      height: 32px;\r\n      position: absolute;\r\n      top: 7px;\r\n      left: 4px;\r\n      border-top-right-radius: 4px;\r\n      border-bottom-right-radius: 4px;\r\n      color: #084b6b;\r\n      font-size: 18px;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}\r\n\r\n.oppintment-table {\r\n  position: relative;\r\n  // background-color: #084b69;\r\n\r\n  .bg-dark-gray {\r\n    background-color: #dee9ef !important;\r\n  }\r\n\r\n  .title-head {\r\n    background-color: #dee9ef;\r\n    padding: 0px 0px 0px 15px;\r\n    position: relative;\r\n\r\n    p {\r\n      // border-top: 1px solid #cfd8dc;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: #084b6b;\r\n      margin-bottom: 0px;\r\n      text-transform: uppercase;\r\n      position: absolute;\r\n      top: -14px;\r\n      z-index: 1040;\r\n      right: 20px;\r\n\r\n      &::after {\r\n        content: \"\";\r\n        background-color: #87979f;\r\n        width: 25%;\r\n        height: 1px;\r\n        position: absolute;\r\n        right: -37%;\r\n        top: 18%;\r\n      }\r\n    }\r\n\r\n    &.later {\r\n      p {\r\n        top: -19px;\r\n\r\n        &:after {\r\n          top: 43%;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .table-head {\r\n    // background-color: #dee9ef ;\r\n\r\n    .table-head-title {\r\n      padding: 15px 0px;\r\n      position: relative;\r\n      // &::after{\r\n\r\n      //   content: '';\r\n      //   background-color:#dee2e6;\r\n      //   width: 1.5%;\r\n      //   height: 100%;\r\n      //   position: absolute;\r\n      //   right: 1px;\r\n      //   bottom: 0;\r\n\r\n      //   }\r\n      h5 {\r\n        font-size: 16px;\r\n        font-weight: 500;\r\n        font-stretch: normal;\r\n        font-style: normal;\r\n        line-height: 1.5;\r\n        letter-spacing: normal;\r\n        text-align: center;\r\n        // color: #084b6b;\r\n        color: #ffffff;\r\n        margin-bottom: 0px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .table-body {\r\n    border-top: 1px solid #dee2e68f;\r\n    border-left: 1px solid #dee2e6;\r\n    background-color: #fff;\r\n    position: relative;\r\n    top: -10px;\r\n\r\n    &.bold-color {\r\n      border-top: 1px solid #87979f;\r\n    }\r\n\r\n    .table-body-title {\r\n      border-right: 0.5px solid #dee2e6;\r\n      height: 10px;\r\n      cursor: pointer;\r\n\r\n      // border-bottom: 0.5px solid #dee2e6;\r\n      p {\r\n        font-size: 14px;\r\n        font-weight: 300;\r\n        font-stretch: normal;\r\n        font-style: normal;\r\n        line-height: 2.2;\r\n        padding: 0px 10px;\r\n\r\n        letter-spacing: normal;\r\n        text-align: left;\r\n        color: #455a64;\r\n        margin-bottom: 0px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.oppintment-table-body {\r\n  height: 61.7vh;\r\n  overflow: auto;\r\n  padding-top: 10px;\r\n  background-color: #dee9ef;\r\n\r\n  p {\r\n    font-size: 14px;\r\n    font-weight: 300;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #455a64;\r\n  }\r\n}\r\n\r\n.active-block-booked {\r\n  background-color: #067fb8;\r\n  background-color: #067fb8;\r\n  width: 99.9%;\r\n  z-index: 1020;\r\n  position: absolute;\r\n  cursor: pointer;\r\n\r\n  p,\r\n  small,\r\n  label {\r\n    color: #fff !important;\r\n    display: block;\r\n    width: 100%;\r\n    text-align: left;\r\n    margin-bottom: 5px;\r\n    line-height: normal !important;\r\n  }\r\n\r\n  p {\r\n    font-size: 14px;\r\n    margin-bottom: 1px !important;\r\n    margin-top: 1%;\r\n    padding: 2px 0px 2px 0px !important;\r\n  }\r\n\r\n  small {\r\n    font-size: 12px;\r\n  }\r\n\r\n  label {\r\n    font-size: 14px;\r\n    margin-bottom: 0px;\r\n    line-height: 10px;\r\n    // margin-top: 6%;\r\n    font-weight: 300;\r\n  }\r\n\r\n  &.tentative {\r\n    background-color: #ff7f00;\r\n  }\r\n\r\n  &.confirm {\r\n    background-color: #067fb8;\r\n  }\r\n\r\n  &.wheel-in {\r\n    background-color: #22ac50;\r\n\r\n    p,\r\n    small,\r\n    label {\r\n      color: #212529;\r\n    }\r\n  }\r\n\r\n  &.delayed {\r\n    background-color: palevioletred;\r\n  }\r\n\r\n  &.wheel-out {\r\n    background-color: darkgreen;\r\n  }\r\n\r\n  &.delayed-shifted {\r\n    background-color: red;\r\n  }\r\n}\r\n\r\n.active-block-cleaning {\r\n  // background-color: crimson;\r\n  color: white;\r\n  background: repeating-linear-gradient(\r\n    45deg,\r\n    #606dbc,\r\n    #606dbc 10px,\r\n    #465298 10px,\r\n    #465298 20px\r\n  );\r\n  top: -6px;\r\n  position: relative;\r\n  width: 99.9%;\r\n  z-index: 1020;\r\n\r\n  p {\r\n    font-size: 14px !important;\r\n    margin-bottom: 5px !important;\r\n    margin-top: 1.1%;\r\n    color: #fff !important;\r\n    text-align: center !important;\r\n  }\r\n}\r\n\r\n.appointment-modal {\r\n  position: relative;\r\n\r\n  .resend-sms {\r\n    width: 32%;\r\n    position: absolute;\r\n    right: 2%;\r\n    top: 4%;\r\n    display: flex;\r\n  }\r\n\r\n  .ant-modal-header {\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .ant-modal-body {\r\n    background-color: #fff !important;\r\n    border-radius: 10px;\r\n    padding-top: 0px;\r\n\r\n    .modal-body {\r\n      h2 {\r\n        font-size: 20px;\r\n        font-weight: 600;\r\n        font-style: normal;\r\n        font-stretch: normal;\r\n        line-height: 2;\r\n        letter-spacing: normal;\r\n        text-align: center;\r\n        color: #607d8b;\r\n        margin-bottom: 0px;\r\n      }\r\n\r\n      label {\r\n        font-size: 16px;\r\n        margin-bottom: 5px;\r\n        padding: 0px 0px;\r\n      }\r\n\r\n      p {\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        font-stretch: normal;\r\n        font-style: normal;\r\n        padding: 0px 10px;\r\n        letter-spacing: normal;\r\n        text-align: left;\r\n        color: #455a64;\r\n        overflow: hidden;\r\n        word-break: break-all;\r\n        text-transform: capitalize;\r\n      }\r\n    }\r\n\r\n    .top-border {\r\n      position: relative;\r\n\r\n      &::before {\r\n        content: \"\";\r\n        background-color: #bdc0c38f;\r\n        width: 99%;\r\n        height: 1.5px;\r\n        position: absolute;\r\n        top: -15px;\r\n        left: 0;\r\n        right: 0;\r\n        margin: auto;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.close-icon {\r\n  display: flex;\r\n  position: absolute;\r\n  top: 2%;\r\n  left: 5%;\r\n  background-color: #fff;\r\n  box-shadow: 0px 2px 6px #eeeeee;\r\n  width: 30px;\r\n  height: 30px;\r\n  text-align: center;\r\n  border-radius: 50%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n\r\n  &.left {\r\n    left: unset;\r\n    right: 2%;\r\n  }\r\n}\r\n\r\n.search-width {\r\n  .form-group {\r\n    width: 400px;\r\n  }\r\n}\r\n\r\n.sticky-top {\r\n  position: -webkit-sticky;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1000;\r\n}\r\n\r\n.slot_disabled {\r\n  background-color: #dddddd;\r\n  height: 100%;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.title-Text {\r\n  font-size: 19px;\r\n  font-weight: 600;\r\n}\r\n\r\n// .new-style-length{\r\n//   width: 88% !important;\r\n//   position: relative;\r\n//   left: 8%;\r\n//   z-index: 1020;\r\n// }\r\n// .active-block{\r\n//   z-index: 1019;\r\n// }\r\n\r\n// .oppintment-table-body {\r\n//   height: 67.7vh;\r\n//   overflow: auto;\r\n//   padding-top: 4.8%;\r\n//   background-color: #dee9ef;\r\n//   position: relative;\r\n//   top: -54px;\r\n// }\r\n\r\nfooter {\r\n  p {\r\n    margin-bottom: 0px;\r\n  }\r\n}\r\n\r\n.calendar-button {\r\n  position: absolute;\r\n  background: #fff;\r\n  /* padding: 10px; */\r\n  border-radius: 50%;\r\n  height: 55%;\r\n  margin: auto;\r\n  width: 2.5%;\r\n  top: 0;\r\n  bottom: 0;\r\n  z-index: 100;\r\n\r\n  // box-shadow: 0 4px 12px rgb(171,167,167);\r\n  &.right {\r\n    right: 1%;\r\n\r\n    span {\r\n      padding: 0px 9px;\r\n    }\r\n  }\r\n\r\n  &.left {\r\n    left: 9.4%;\r\n\r\n    span {\r\n      padding: 0px 7px;\r\n    }\r\n  }\r\n}\r\n\r\n.table-head {\r\n  background-color: #13b6a5;\r\n  position: relative;\r\n\r\n  &:after {\r\n    content: \"\";\r\n    width: 1px;\r\n    height: 100%;\r\n    position: absolute;\r\n    right: 2px;\r\n    top: 0;\r\n    background-color: #dee2e6;\r\n  }\r\n\r\n  &.last-child {\r\n    &:after {\r\n      background-color: transparent;\r\n    }\r\n  }\r\n}\r\n\r\n.card-table .card-header {\r\n  color: #fff;\r\n  border-bottom: 0px;\r\n  // background-color: #13b6a5;\r\n  // background-image: linear-gradient(to top, #10baa4, #338eb5 ), linear-gradient(to bottom, #10baa4, #338eb5);\r\n}\r\n\r\n.active-block {\r\n  z-index: 200;\r\n}\r\n\r\n.card-table thead td {\r\n  &:not(:first-child) {\r\n    min-width: 150px;\r\n  }\r\n}\r\n\r\n.text-blue-color {\r\n  position: absolute;\r\n  top: -12px;\r\n  color: #067fb8;\r\n}\r\n\r\n// add appointments legend\r\n.slegend {\r\n  span {\r\n    height: 20px;\r\n    width: 20px;\r\n    display: inline-block;\r\n    vertical-align: text-top;\r\n    margin-right: 3px;\r\n    border-radius: 3px;\r\n  }\r\n\r\n  b {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .legtentative {\r\n    background-color: #ff7f00;\r\n  }\r\n\r\n  .legconfirm {\r\n    background-color: #067fb8;\r\n  }\r\n\r\n  .legemergency {\r\n    background-color: red;\r\n  }\r\n\r\n  .legwheelin {\r\n    background-color: #22ac50;\r\n  }\r\n\r\n  .legwheelout {\r\n    background-color: darkgreen;\r\n  }\r\n\r\n  .legshifted {\r\n    background-color: red;\r\n  }\r\n\r\n  .legdelayed {\r\n    background-color: palevioletred;\r\n  }\r\n}\r\n\r\n.badgee {\r\n  background-color: red;\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 8px;\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  /* Styles go here */\r\n  .login-footer {\r\n    bottom: 0px;\r\n    position: unset;\r\n    padding-top: 10px;\r\n  }\r\n}\r\n\r\n.table-scroll {\r\n  max-height: 100%;\r\n  overflow-y: unset;\r\n  overflow-x: unset;\r\n  margin-left: -48px;\r\n  transition: ease-in-out 1s;\r\n  top: 50px;\r\n\r\n  & thead tr td {\r\n    top: 38px;\r\n  }\r\n}\r\n\r\n.table-scroll2 {\r\n  max-height: 100%;\r\n  overflow-y: unset;\r\n  overflow-x: unset;\r\n  margin-left: -48px;\r\n  transition: ease-in-out 1s;\r\n  top: 50px;\r\n\r\n  & thead tr:first-child td {\r\n    background-color: #dee9ef;\r\n    position: sticky;\r\n    top: 39px;\r\n  }\r\n\r\n  & thead tr:nth-child(2) td {\r\n    background-color: #dee9ef;\r\n    position: sticky;\r\n    top: 84px;\r\n  }\r\n}\r\n\r\n// .bread-sticky {\r\n//   position: fixed;\r\n//   width: 100%;\r\n// }\r\n\r\n.btn-sticky {\r\n  position: fixed;\r\n  width: 100%;\r\n  left: -3rem;\r\n}\r\n\r\n.sticky-header {\r\n  transition: ease-in-out 0.5s;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  // max-height: 600px;\r\n  // overflow-y: auto;\r\n  & thead td {\r\n    background-color: #dee9ef;\r\n    position: sticky;\r\n    top: 0px;\r\n  }\r\n\r\n  & thead tr td:nth-child(2) {\r\n    position: sticky;\r\n    width: 140px;\r\n    min-width: 140px;\r\n    max-width: 140px;\r\n    left: -1px;\r\n    background-color: rgb(222, 233, 239);\r\n    clip-path: inset(0px -15px 0px 0px);\r\n    box-shadow: 0 0 15px #dee2e6;\r\n    z-index: 1;\r\n  }\r\n\r\n  & tbody tr:hover td {\r\n    background-color: #f5f5f5 !important;\r\n  }\r\n\r\n  // & thead tr td:nth-child(3){\r\n  //   position: sticky;\r\n  //   width: 130px;\r\n  //   min-width: 130px;\r\n  //   max-width: 130px;\r\n  //   left: 138px;\r\n  //   background-color: rgb(222, 233 ,239);\r\n  //   clip-path: inset(0px -15px 0px 0px);\r\n  //   box-shadow: 0 0 15px #dee2e6;\r\n  //   z-index: 1;\r\n  // }\r\n  tbody tr td:nth-child(2) {\r\n    position: sticky;\r\n    width: 140px;\r\n    min-width: 140px;\r\n    max-width: 140px;\r\n    left: -1px;\r\n    background-color: #fff;\r\n    clip-path: inset(0px -15px 0px 0px);\r\n    box-shadow: 0 0 15px #dee2e6;\r\n  }\r\n\r\n  // tbody tr td:nth-child(3){\r\n  //   position: sticky;\r\n  //   width: 130px;\r\n  //   min-width: 130px;\r\n  //   max-width: 130px;\r\n  //   left: 138px;\r\n  //   background-color:#fff;\r\n  //   clip-path: inset(0px -15px 0px 0px);\r\n  //   box-shadow: 0 0 15px#dee2e6;\r\n  // }\r\n}\r\n\r\n.sticky-header2 {\r\n  width: 100%;\r\n  height: 100%;\r\n  // max-height: 600px;\r\n  transition: ease-in-out 1s;\r\n  overflow-y: auto;\r\n\r\n  & thead tr:first-child td {\r\n    background-color: #dee9ef;\r\n    position: sticky;\r\n    top: -1px;\r\n  }\r\n\r\n  & thead tr:nth-child(2) td {\r\n    background-color: #dee9ef;\r\n    position: sticky;\r\n    top: 44px;\r\n  }\r\n\r\n  & thead tr:first-child td:nth-child(2) {\r\n    position: sticky;\r\n    width: 140px;\r\n    min-width: 140px;\r\n    max-width: 140px;\r\n    left: -1px;\r\n    background-color: rgb(222, 233, 239);\r\n    clip-path: inset(0px -15px 0px 0px);\r\n    box-shadow: 0 0 15px #dee2e6;\r\n    z-index: 1;\r\n  }\r\n\r\n  & tbody tr:hover td {\r\n    background-color: #f5f5f5 !important;\r\n  }\r\n\r\n  // & thead tr td:nth-child(3){\r\n  //   position: sticky;\r\n  //   width: 130px;\r\n  //   min-width: 130px;\r\n  //   max-width: 130px;\r\n  //   left: 138px;\r\n  //   background-color: rgb(222, 233 ,239);\r\n  //   clip-path: inset(0px -15px 0px 0px);\r\n  //   box-shadow: 0 0 15px #dee2e6;\r\n  //   z-index: 1;\r\n  // }\r\n  tbody tr td:nth-child(2) {\r\n    position: sticky;\r\n    width: 140px;\r\n    min-width: 140px;\r\n    max-width: 140px;\r\n    left: -1px;\r\n    background-color: #fff;\r\n    clip-path: inset(0px -15px 0px 0px);\r\n    box-shadow: 0 0 15px #dee2e6;\r\n  }\r\n\r\n  // tbody tr td:nth-child(3){\r\n  //   position: sticky;\r\n  //   width: 130px;\r\n  //   min-width: 130px;\r\n  //   max-width: 130px;\r\n  //   left: 138px;\r\n  //   background-color:#fff;\r\n  //   clip-path: inset(0px -15px 0px 0px);\r\n  //   box-shadow: 0 0 15px#dee2e6;\r\n  // }\r\n}\r\n\r\n// appointments hover zoom\r\n.table-body-title:hover {\r\n  .active-block.overflow-hidden {\r\n    overflow: visible !important;\r\n  }\r\n\r\n  .active-block-cleaning {\r\n    transform: scale(1.1);\r\n    z-index: 1021;\r\n    transition: ease-in-out 0.5s;\r\n  }\r\n\r\n  .active-block-booked {\r\n    transform: scale(1.1);\r\n    z-index: 1021;\r\n    height: 110px !important;\r\n    transition: ease-in-out 0.5s;\r\n  }\r\n}\r\n\r\n.active-block-booked {\r\n  transition: ease-in-out 0.5s;\r\n}\r\n\r\n.active-block-cleaning {\r\n  transition: ease-in-out 0.5s;\r\n}\r\n\r\n.dropdown-toggle::after {\r\n  content: none;\r\n}\r\n\r\n.card-label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  overflow: hidden;\r\n  word-break: break-all;\r\n  text-transform: capitalize;\r\n  margin-bottom: 5px;\r\n  padding: 0px 0px;\r\n  color: #17b1a7;\r\n}\r\n\r\n.card-item {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  padding: 0px 0px;\r\n  margin-bottom: 0px;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #455a64;\r\n  overflow: hidden;\r\n  word-break: break-all;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.radio-button input[type=\"radio\"] {\r\n  display: none;\r\n}\r\n\r\n.radio-button label {\r\n  padding: 5px 20px;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  color: #676767;\r\n  border-radius: 25px;\r\n  border: 1px solid #17b1a7;\r\n  font-weight: 500;\r\n  opacity: 0.5;\r\n  font-size: 16px;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.radio-button .blank-label {\r\n  display: none;\r\n}\r\n\r\n.radio-button input[type=\"radio\"]:checked + label {\r\n  color: #17b1a7;\r\n  padding: 5px 20px;\r\n  border-radius: 25px;\r\n  border: 1px solid #17b1a7;\r\n  background-color: #676767;\r\n  font-weight: 500;\r\n  opacity: 0.5;\r\n  font-size: 16px;\r\n}\r\n\r\n.radio-button input[type=\"radio\"][disabled] + label {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.text-height-5 {\r\n  line-height: 3rem;\r\n}\r\n\r\n.appointment-radio-group {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  height: 50%;\r\n\r\n  label {\r\n    margin-bottom: 0px !important;\r\n  }\r\n}\r\n\r\nspan.ant-time-picker.timepicker-width {\r\n  width: 220px;\r\n}\r\n\r\n.radio_button_clear_label {\r\n  margin-top: -5px;\r\n  margin-left: 5px;\r\n}\r\n\r\n.radio-button input[type=\"radio\"][disabled] + label {\r\n  background: #e7f0f4;\r\n}\r\n\r\n.border {\r\n  border: 2px solid rgba(0, 0, 0, 0.1) !important;\r\n}\r\n\r\n.saveSize svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  color: #17b1a7;\r\n}\r\n\r\n.table_new_medical {\r\n  max-height: 450px;\r\n  overflow: auto;\r\n  .radio-button label {\r\n    padding: 4px 16px;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #000;\r\n    border-radius: 25px;\r\n    border: 1px solid #1930d2;\r\n    font-weight: 500;\r\n    opacity: 0.6;\r\n    font-size: 12px;\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n\r\n  .radio-button input[type=\"radio\"]:checked + label {\r\n    color: #fff;\r\n    padding: 4px 16px;\r\n    border-radius: 25px;\r\n    border: 1px solid #1930d2;\r\n    background-color: #1930d2;\r\n    font-weight: 500;\r\n    opacity: 0.6;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n.medical_button {\r\n  background-color: #fff;\r\n  box-shadow: 0px 2px 6px #eeeeee;\r\n  border: 1px solid #1930d2;\r\n  color: #1930d2;\r\n}\r\n\r\n.new-login-layer {\r\n  overflow: auto;\r\n}\r\n\r\n.login-para-1 {\r\n  width: 390px;\r\n  height: 75px;\r\n  flex-grow: 0;\r\n  margin: 10px 0 15px;\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #000;\r\n  padding-right: 2em;\r\n}\r\n\r\n.login-btn {\r\n  width: 8em;\r\n  padding: 0 4.5em 2em 2em;\r\n}\r\n\r\n.heading {\r\n  width: 540px;\r\n  height: 152px;\r\n  margin: 0 0 25px;\r\n  font-size: 56px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #fff;\r\n}\r\n\r\n.login-para-2 {\r\n  width: 534px;\r\n  height: 132px;\r\n  margin: 25px 6px 0 0;\r\n  font-size: 24px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #fff;\r\n}\r\n\r\n.displaySpaceBetween {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n// Biller\r\n.Biller-Screen {\r\n  width: 1440px;\r\n  height: 84vh;\r\n  background-color: #f9f9f9;\r\n  overflow: hidden;\r\n}\r\n.Biller {\r\n  width: 72px;\r\n  height: 35px;\r\n  margin: 8px 322px 0 22px;\r\n  font-family: Avenir;\r\n  font-size: 30px;\r\n  font-weight: 900;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.DoctorDetailsCard {\r\n  width: 340px;\r\n  height: 90px;\r\n  flex-grow: 0;\r\n  padding: 10px 0 10px 8px;\r\n  border-radius: 10px;\r\n  border: solid 1px $silver;\r\n  background-color: #fff;\r\n}\r\n.DoctorImgOval {\r\n  width: 60px;\r\n  height: 60px;\r\n  flex-grow: 0;\r\n  border: solid 4px $magenta;\r\n  border-radius: 50%;\r\n}\r\n.Billing-Station-Gro {\r\n  width: 110px;\r\n  height: 44px;\r\n  font-family: Avenir;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #000;\r\n}\r\n.Billing-Station-Gro .text-style-1 {\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n}\r\n.PatientCardsDisplay {\r\n  width: 340px;\r\n  height: auto;\r\n  margin: 8px 0 0;\r\n  padding: 11.4px 14px 0px 10px;\r\n  border-radius: 10px;\r\n  background-color: #fff;\r\n  border: solid 1px $silver;\r\n}\r\n.PatientCardsDisplayScroll {\r\n  height: 100%;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n\r\n  &::-webkit-scrollbar-track {\r\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n    background-color: #f5f5f5;\r\n  }\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 5px;\r\n    background-color: #f5f5f5;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background-color: #000000;\r\n    border: 2px solid #555555;\r\n  }\r\n}\r\n.PatientsTitle {\r\n  width: 135px;\r\n  height: 33px;\r\n  margin: 0 20px 10px 0;\r\n  font-family: Avenir;\r\n  font-size: 24px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #1f1f39;\r\n}\r\n.biller-search-icon-img {\r\n  width: 50px;\r\n  height: 32.2px;\r\n  flex-grow: 0;\r\n}\r\n.PatientCard {\r\n  width: auto;\r\n  height: 100px;\r\n  margin: 2px 10px 0 -15px;\r\n  border-radius: 5px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n.patientIcon {\r\n  width: 17.9px;\r\n  height: 21.6px;\r\n  flex-grow: 0;\r\n  margin-left: 10px;\r\n}\r\n.Patientname {\r\n  width: 150px;\r\n  height: 19px;\r\n  margin: 1px 0 1.6px 5.6px;\r\n  font-family: Avenir-Roman;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #1f1f39;\r\n}\r\n.time {\r\n  width: 36px;\r\n  height: 10px;\r\n  margin: 0 9.9px 15px 32.5px;\r\n  font-family: Avenir;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #1f1f39;\r\n  padding-left: 10px;\r\n}\r\n.statusDiv {\r\n  width: 60px;\r\n  height: 30px;\r\n  flex-grow: 0;\r\n  margin: 0 10px;\r\n  padding: 2px 0 7px 17px;\r\n  border-radius: 3px;\r\n  background-color: $magenta;\r\n}\r\n.status {\r\n  width: 50px;\r\n  font-family: Avenir;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #fff;\r\n  margin: 10px 20px;\r\n}\r\n.uidIcon {\r\n  width: 17.9px;\r\n  height: 18px;\r\n  flex-grow: 0;\r\n  margin: 1.2px 5.6px 0 0;\r\n}\r\n.PatientUid {\r\n  width: 105px;\r\n  height: 19px;\r\n  font-family: Avenir-Roman;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #1f1f39;\r\n}\r\n.currentpatient {\r\n  width: 1002px;\r\n  height: 580px;\r\n  margin: 0 22px 0 25px;\r\n  padding: 20px 357px 387px 23px;\r\n  border-radius: 10px;\r\n  background-color: #fff;\r\n}\r\n.Current-Patient-Title {\r\n  height: 33px;\r\n  margin: 0 108px 30px 0;\r\n  font-family: Avenir;\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.billerPatientDetails {\r\n  width: 400px;\r\n  height: 300px;\r\n  margin: 26px 0 53px 1px;\r\n  padding: 39px 31px 38px 16px;\r\n  border-radius: 7px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n.patientNameIcon {\r\n  width: 50px;\r\n  height: 50px;\r\n  margin: 0 10px 0 0;\r\n  padding: 13px 10px 12px 13px;\r\n  border-radius: 6px;\r\n  background-color: $magenta;\r\n}\r\n.patientNameIconImage {\r\n  width: 25px;\r\n  height: 25px;\r\n  object-fit: contain;\r\n}\r\n.patientNamedetails {\r\n  width: 200px;\r\n  height: 48px;\r\n  margin: 2px 30px 0 0;\r\n  font-family: Avenir;\r\n  font-size: 18px;\r\n  font-weight: 900;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.patientNamedetails .text-style-1 {\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n}\r\n.patientGenderIcon {\r\n  width: 50px;\r\n  height: 50px;\r\n  margin: 25px 10px 0 0;\r\n  padding: 13px 13.3px 12px 13px;\r\n  border-radius: 6px;\r\n  background-color: #ff8b3e;\r\n}\r\n.patientGenderIconImage {\r\n  width: 23.8px;\r\n  height: 25px;\r\n  object-fit: contain;\r\n}\r\n.patientGender {\r\n  width: 60px;\r\n  height: 48px;\r\n  margin: 27px 165px 0 1px;\r\n  font-family: Avenir;\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.patientGender .text-style-1 {\r\n  font-size: 18px;\r\n  font-weight: 900;\r\n}\r\n.patientageIcon {\r\n  width: 50px;\r\n  height: 50px;\r\n  margin: 25px 10px 0 0;\r\n  padding: 13px 13.5px 12px 13px;\r\n  border-radius: 6px;\r\n  background-color: #12539e;\r\n}\r\n.patientageIconImage {\r\n  width: 23.5px;\r\n  height: 25px;\r\n  object-fit: contain;\r\n}\r\n.patientAge {\r\n  width: 230px;\r\n  height: 48px;\r\n  margin: 26px 0 1px 1px;\r\n  font-family: Avenir;\r\n  font-size: 18px;\r\n  font-weight: 900;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.patientAge .text-style-1 {\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n}\r\n.uidcard {\r\n  width: 270px;\r\n  height: 86px;\r\n  margin: 26px 0 14px 12px;\r\n  padding: 18px 100px 17px 15px;\r\n  border-radius: 7px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n.uidcardIcon {\r\n  width: 25px;\r\n  height: 25px;\r\n  margin: 11px 9px 12px 0;\r\n  object-fit: contain;\r\n}\r\n.PatientIcon {\r\n  width: 30px;\r\n  height: 30px;\r\n  margin: 11px 4px 12px 0;\r\n  object-fit: contain;\r\n}\r\n.LineCopy {\r\n  width: 1px;\r\n  height: 40px;\r\n  margin: 2px 0 7px;\r\n  border: solid 1px #979797;\r\n}\r\n.UID-no {\r\n  width: 200px;\r\n  // height: 40px;\r\n  margin: 0 0 0 9px;\r\n  font-family: Avenir;\r\n  font-size: 18px;\r\n  font-weight: 900;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.UID-no .text-style-1 {\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n}\r\n.tokenCard {\r\n  width: 270px;\r\n  height: 86px;\r\n  margin: 20px 0 20px 12px;\r\n  padding: 18px 100px 17px 15px;\r\n  border-radius: 7px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n.tokenCardIcon {\r\n  width: 25px;\r\n  height: 25px;\r\n  margin: 12px 10px 11px 0;\r\n  padding: 0.6px 0.6px 0.6px 0.6px;\r\n}\r\n.Token-No {\r\n  width: 100px;\r\n  height: 48px;\r\n  margin: 0 0 0 9px;\r\n  font-family: Avenir;\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.Token-No .text-style-1 {\r\n  font-size: 18px;\r\n  font-weight: 900;\r\n}\r\n.serviceCard {\r\n  width: 270px;\r\n  height: 86px;\r\n  margin: 14px 0 53px 12px;\r\n  padding: 18px 100px 17px 15px;\r\n  border-radius: 7px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n.serviceCardimg {\r\n  width: 24.4px;\r\n  height: 25px;\r\n  margin: 11px 9.6px 12px 0;\r\n  object-fit: contain;\r\n}\r\n.Service-Name-Billing {\r\n  width: 200px;\r\n  // height: 48px;\r\n  margin: 0 0 0 9px;\r\n  font-family: Avenir;\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.Service-Name-Billing .text-style-1 {\r\n  font-size: 18px;\r\n  font-weight: 900;\r\n}\r\n.Chekoutandnext {\r\n  width: 186px;\r\n  height: 46px;\r\n  margin: 0 20px 0 18px;\r\n  padding: 11px 20px 10px;\r\n  border-radius: 4px;\r\n  background-color: $magenta;\r\n  font-family: Avenir;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #fff;\r\n}\r\n.CheckOut {\r\n  width: 146px;\r\n  height: 25px;\r\n  font-family: Avenir;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #fff;\r\n}\r\n.Skipandnext {\r\n  width: 140px;\r\n  height: 46px;\r\n  margin: 0 0 0 20px;\r\n  padding: 11px 21px 10px;\r\n  border-radius: 4px;\r\n  border: solid 1px $magenta;\r\n  font-family: Avenir;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: $magenta;\r\n}\r\n.Skip {\r\n  width: 98px;\r\n  height: 25px;\r\n  font-family: Avenir;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: $magenta;\r\n}\r\n.StartTG {\r\n  margin: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n.TGStartBtn {\r\n  width: 300px;\r\n}\r\n\r\n// Operator\r\n.-Operator-View-OPD-or-Radiology {\r\n  width: auto;\r\n  height: 100vh;\r\n  flex-grow: 0;\r\n  padding: 5px 0 0;\r\n  background-color: #f9f9f9;\r\n}\r\n.Operator {\r\n  width: 131px;\r\n  height: 41px;\r\n  margin: 33px 223px 29px 22px;\r\n  font-family: Avenir;\r\n  font-size: 30px;\r\n  font-weight: 900;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.OperatorName {\r\n  width: 129px;\r\n  height: 25px;\r\n  margin: 0 0 1.9px;\r\n  font-family: Avenir;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #000;\r\n}\r\n.OperatorType {\r\n  width: 77px;\r\n  height: 19px;\r\n  margin: 1.9px 52px 0 0;\r\n  font-family: Avenir;\r\n  font-size: 14px;\r\n  font-weight: 300;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #000;\r\n}\r\n.operatorRoom {\r\n  width: 100px;\r\n  height: 19px;\r\n  margin: 11.2px 0.2px 0 4px;\r\n  font-family: Avenir-Roman;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #000;\r\n  white-space: normal;\r\n}\r\n.operatorSearchicon {\r\n  padding-left: 18px;\r\n  margin-left: -20px;\r\n}\r\n\r\n// token generator\r\n.-Token-Generator {\r\n  width: auto;\r\n  height: 60vh;\r\n  background-color: #f9f9f9;\r\n  margin: 6px 0 0.4px 0;\r\n}\r\n.Token-Generator {\r\n  width: 500px;\r\n  height: 41px;\r\n  margin: 33px 100px 25px 22px;\r\n  font-family: Avenir;\r\n  font-size: 30px;\r\n  font-weight: 900;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.tokenGenerationDiv {\r\n  width: auto;\r\n  // padding: 20px 680px 436px 20px;\r\n  border: solid 1px $silver;\r\n  border-radius: 10px;\r\n  background-color: #fff;\r\n}\r\n.Token-Generation {\r\n  height: 33px;\r\n  margin: 0 108px 30px 0;\r\n  font-family: Avenir;\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.Token-Type {\r\n  width: 136px;\r\n  height: 19px;\r\n  margin: 0 60px 10px 0;\r\n  font-family: Avenir;\r\n  font-size: 20px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.tokenRadioGroup {\r\n  width: 300px;\r\n  height: 24px;\r\n  margin: 10px 0 0;\r\n  font-size: 20px;\r\n}\r\n.Enter-Phone-No {\r\n  width: 250px;\r\n  height: 19px;\r\n  margin: 50px 111px 10px 0;\r\n  font-family: Avenir;\r\n  font-size: 20px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.Rectangle-Copy-10 {\r\n  width: 250px;\r\n  height: 40px;\r\n  border-radius: 5px;\r\n  background-color: $magenta;\r\n  color: white;\r\n}\r\n.Rectangle-Copy-11 {\r\n  width: 121px;\r\n  height: 46px;\r\n  flex-grow: 0;\r\n  margin: 0 0 0 20px;\r\n  padding: 12px 34px 12px 35px;\r\n  border-radius: 5px;\r\n  border: solid 1px $magenta;\r\n  color: $magenta;\r\n}\r\n.tPatientname {\r\n  font-family: Avenir-Roman;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #1f1f39;\r\n  display: flex;\r\n}\r\n.tstatus {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #fff;\r\n  margin: 10px 20px;\r\n  border-radius: 3px;\r\n  background-color: $magenta;\r\n  padding: 6px 18px 3px 18px;\r\n}\r\n.buttonVitals {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #fff;\r\n  margin: 0px 20px;\r\n  border-radius: 3px;\r\n  background-color: $magenta;\r\n  padding: 6px 18px 3px 18px;\r\n}\r\n// Navigation bar\r\n.navBar {\r\n  width: auto;\r\n  height: 70px;\r\n  // padding: 19px 22px 0;\r\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);\r\n  background-color: #fff;\r\n}\r\n.hospitalicon {\r\n  margin: 5px 20px;\r\n  flex-grow: 0;\r\n}\r\n.multiple-unit:where(.css-dev-only-do-not-override-1okl62o).ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {\r\n  border: 1px solid #d9d9d9;\r\n  color:white !important;\r\n  background-color:#8c2ba4;\r\n  font-size:16px !important;\r\n}\r\n.multiple-unit.ant-select .ant-select-selection-item {\r\n  color: white;\r\n  padding-right: 24px !important;\r\n  \r\n}\r\n\r\n// .custom-input .ant-select-selection__placeholder{\r\n//   color : blue !important;\r\n// }\r\n.custom-input{\r\n  color:white !important;\r\n}\r\n.custom-input .ant-input-affix-wrapper-focused{\r\n  background-color:#12539e !important;\r\n}\r\n// .custom-input input:-internal-autofill-selected {\r\n//   appearance: menulist-button;\r\n//   background-image: none !important;\r\n//   background-color: light-dark(rgb(29, 93, 203), rgba(70, 90, 126, 0.4)) !important;\r\n//   color: fieldtext !important;\r\n// }\r\n.custom-input:-webkit-autofill,\r\n.custom-input:-webkit-autofill:hover,\r\n.custom-input:-webkit-autofill:focus,\r\n.custom-input:-webkit-autofill:active {\r\n  background-color: lightgray !important;\r\n  color: white !important;\r\n  border: solid 1px #66b1d0 !important;\r\n  -webkit-box-shadow: 0 0 0 1000px lightgray inset !important;\r\n  box-shadow: 0 0 0 1000px lightgray inset !important;\r\n}\r\n.custom-input input::placeholder {\r\n  color: white !important; /* Change this to your desired placeholder color */\r\n  opacity: 1; /* Ensure the color is not transparent */\r\n}\r\n.ant-picker-clear{\r\n  display:none !important;\r\n}\r\n\r\n.ant-picker-suffix {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Prevent hover effect from replacing the suffix icon with the clear icon */\r\n.ant-picker-input:hover .ant-picker-suffix {\r\n  display: flex !important;\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.vitals-header .ant-modal-header {\r\n  padding:0%;\r\n  margin:0%;\r\n  background-color:#f4f4f4;\r\n}\r\n// :where(.css-dev-only-do-not-override-1okl62o).ant-btn-primary{\r\n//   background-color: #8c2ba4;\r\n//   color:#067fb8;\r\n// }\r\n.someting{\r\n  color:#cfd3d5\r\n}\r\n\r\n// .multiple-unit .ant-select-selection.ant-select-selection--single{\r\n//   background-color: #8c2ba4;\r\n//   border-color: #8c2ba4;\r\n//   color: #fff;\r\n//   font-size: 16px;\r\n// }\r\n.multiple-unit .ant-select-arrow {\r\n  background-color: #8c2ba4;\r\n} \r\n.navDivider {\r\n  width: 1px;\r\n  height: 40px;\r\n  margin: 15px 35px 0 6px;\r\n  border: solid 1px $magenta;\r\n}\r\n.dashboardIcon {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.DashboardSpan {\r\n  width: 70px;\r\n  height: 22px;\r\n  margin: 1px 0 1px 10px;\r\n  font-family: Avenir-Roman;\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: $magenta;\r\n}\r\n.tokenGeneratorIcon {\r\n  width: 24px;\r\n  height: 24px;\r\n  flex-grow: 0;\r\n  padding: 0.6px 0.6px 0.6px 0.6px;\r\n}\r\n.Token-GeneratorSpan {\r\n  width: 121px;\r\n}\r\n.billerIcon {\r\n  width: 18.7px;\r\n  height: 24px;\r\n  flex-grow: 0;\r\n  padding: 1.1px 1.1px 1.2px 1.1px;\r\n}\r\n.BillerSpan {\r\n  width: 37px;\r\n  margin: 1px 0 1px 4px;\r\n}\r\n.operatorIcon {\r\n}\r\n.OperatorSpan {\r\n  width: 67px;\r\n  margin: 1px 0 1px 10.6px;\r\n}\r\n.DoctorSpan {\r\n  width: 50px;\r\n  margin: 1px 0 1px 11.1px;\r\n}\r\n.reportsIcon {\r\n  width: 24px;\r\n  height: 24px;\r\n  flex-grow: 0;\r\n  padding: 2.6px 2.6px 0 0;\r\n}\r\n.ReportsSpan {\r\n  width: 57px;\r\n  margin: 1px 0 1px 4px;\r\n}\r\n// Technician\r\n.technician {\r\n  width: auto;\r\n  height: 100vh;\r\n  flex-grow: 0;\r\n  padding: 10px 0 10px 20px;\r\n  background-color: #f9f9f9;\r\n}\r\n.TechnicianCard {\r\n  width: 340px;\r\n  height: 90px;\r\n  flex-grow: 0;\r\n  // margin: 20px 25px 15px 22px;\r\n  padding: 10px 20px 10px 10px;\r\n  border-radius: 10px;\r\n  border: solid 1px $silver;\r\n  background-color: #fff;\r\n}\r\n.TechnicianCardsDisplay {\r\n  width: 340px;\r\n  height: 71%;\r\n  margin: 8px 0 0;\r\n  padding: 11.4px 14px 0 10px;\r\n  border-radius: 10px;\r\n  background-color: #fff;\r\n  border: solid 1px $silver;\r\n}\r\n.TechnicianPatientCard {\r\n  width: 300px;\r\n  height: 100px;\r\n  margin: 2px 10px 0 0;\r\n  border-radius: 5px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n// Doctor and Nurse Screen\r\n.doctorNurseScreen {\r\n  width: auto;\r\n  background-color: #f9f9f9;\r\n  margin: 6px 0 0.4px 0;\r\n}\r\n.DNuidcard {\r\n  width: 270px;\r\n  height: 92px;\r\n  // margin: 26px 0 14px 12px;\r\n  padding: 18px 100px 17px 15px;\r\n  border-radius: 7px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n.DNtokenCard {\r\n  width: 270px;\r\n  height: 92px;\r\n  // margin: 20px 0 20px 12px;\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n  padding: 18px 100px 17px 15px;\r\n  border-radius: 7px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n.DNserviceCard {\r\n  width: 270px;\r\n  height: 92px;\r\n  // margin: 14px 0 53px 12px;\r\n  padding: 18px 100px 17px 15px;\r\n  border-radius: 7px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n// Doctor\r\n.doctorcurrentpatient {\r\n  width: auto;\r\n  border-radius: 10px;\r\n  background-color: #fff;\r\n}\r\n.PatientDetails {\r\n  width: 400px;\r\n  // height: 277px;\r\n  // margin: 26px 15px 53px 1px;\r\n  padding: 39px 50px 38px 16px;\r\n  border-radius: 7px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n.patient {\r\n  width: 281px;\r\n  height: 83px;\r\n  margin: 0 0 13px;\r\n  padding: 18px 126px 17px 25px;\r\n  border-radius: 7px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n//Queue config\r\n.qConfigScroll {\r\n  height: 85vh;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  background-color: #f9f9f9;\r\n\r\n  &::-webkit-scrollbar-track {\r\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n    background-color: #f5f5f5;\r\n  }\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 5px;\r\n    background-color: #f5f5f5;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background-color: #000000;\r\n    border: 2px solid #555555;\r\n  }\r\n}\r\n.addQueue {\r\n  padding-bottom: 150px;\r\n}\r\n// Dashboard\r\n.DashboardView {\r\n  height: 90vh;\r\n  width: auto;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  background-color: #f9f9f9;\r\n  padding: 0 10px 0 20px;\r\n}\r\n.titles {\r\n  height: 33px;\r\n  font-family: Avenir;\r\n  font-size: 24px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n}\r\n.dashboard {\r\n  width: 629px;\r\n  height: 380px;\r\n  flex-grow: 0;\r\n  border-radius: 10px;\r\n  border: solid 3px rgba(204, 203, 203, 0.16);\r\n  background-color: #fff;\r\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);\r\n}\r\n.dashboardPatientDetails {\r\n  margin: 20px 28px 0 22px;\r\n  padding: 24px 31px 25px 27px;\r\n}\r\n.cpdTitle {\r\n  width: 249px;\r\n  margin: 0 0 0 10px;\r\n}\r\n.dashboardOpd {\r\n  margin: 20px 22px 0 0px;\r\n  padding: 24px 31px 25px 28px;\r\n}\r\n.opdTitle {\r\n  width: 269.4px;\r\n  margin: 0 319.6px 25.8px 10px;\r\n}\r\n.dashboardRadiology {\r\n  margin: 20px 28px 150px 22px;\r\n  padding: 24px 32px 28.2px 27px;\r\n}\r\n.radiologyTitle {\r\n  width: 109px;\r\n  margin: 0 300px 25px 10px;\r\n}\r\n.patientImg {\r\n  width: 25px;\r\n  height: 30px;\r\n  margin: 5px 0 10px;\r\n  object-fit: contain;\r\n}\r\n.dashboardCard {\r\n  width: 140px;\r\n  height: 83px;\r\n  margin: 10px 11.2px 0 0;\r\n  padding: 7px 74.8px 12px 20px;\r\n  border-radius: 7px;\r\n  border: solid 1px rgba(151, 151, 151, 0.15);\r\n  background-color: #f5fafe;\r\n}\r\n.dashboardCardDetails {\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #09050f;\r\n  cursor: pointer;\r\n}\r\n.count {\r\n  // margin: 0 25px 1px 0;\r\n  font-family: Avenir;\r\n  font-size: 20px;\r\n  font-weight: 900;\r\n}\r\n.detail {\r\n  width: 200px;\r\n  padding: 8px 0 0;\r\n  font-family: Avenir-Roman;\r\n  font-size: 15px;\r\n  font-weight: normal;\r\n}\r\n// TV screens\r\n// screen1\r\n.tvScreen1 {\r\n  height: 95vh;\r\n  width: 105%;\r\n  margin: 10px 2px 10px 20px;\r\n}\r\n.doctorsDetailsDiv {\r\n  margin: 0 10px 0 0;\r\n  padding: 55px 30px 50px;\r\n  background-color: $magenta;\r\n  font-family: Avenir;\r\n  font-size: 30px;\r\n  font-weight: 900;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #fff;\r\n  text-align: center;\r\n}\r\n.qdoctorImg {\r\n  width: 150px;\r\n  height: 150px;\r\n  margin: 30px 130px 10px;\r\n}\r\n.qdoctorImg1 {\r\n  min-width: 200px;\r\n  min-height: 190px;\r\n  max-width: 200px;\r\n  max-height: 190px;\r\n  margin: 10px 100px;\r\n  border-radius: 60%;\r\n  background-color: $magenta;\r\n}\r\n.qdoctorName {\r\n  margin: 14px 0;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.qdoctorProf {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 20px 0;\r\n}\r\n.qdoctorExp {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 15px 0;\r\n  letter-spacing: 1.5px;\r\n}\r\n.qroom_status {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  margin: 20px 0 50px;\r\n}\r\n.qdoctorRoom {\r\n  font-weight: 500;\r\n  letter-spacing: 1.5px;\r\n}\r\n.qdoctor-text-style-1 {\r\n  font-weight: 900;\r\n}\r\n.qdoctorStatus {\r\n  font-weight: 500;\r\n  letter-spacing: 1.5px;\r\n}\r\n.qdocTimings {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.qdoctorTimings {\r\n  margin: 10px 0;\r\n  letter-spacing: 1.5px;\r\n  margin: 10px 0;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.qdoctorTime {\r\n  height: 41px;\r\n  font-family: Avenir;\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: 1.13px;\r\n  color: #fff;\r\n}\r\n.patientQ {\r\n}\r\n.patientQHeader {\r\n  width: auto;\r\n  height: 10%;\r\n  padding: 10px 0;\r\n  background-color: $magenta;\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n.patientQDetails {\r\n  width: auto;\r\n  height: 85.5vh;\r\n  border: solid 1px #979797;\r\n  background-color: #f2f2f2;\r\n}\r\n.patientQHeaderTitles {\r\n  // font-family: Arial;\r\n  font-family: Avenir;\r\n  font-size: 30px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: 1.8px;\r\n  text-align: center;\r\n  color: #fff;\r\n}\r\n.docTitle {\r\n  display: flex;\r\n  justify-content: left;\r\n  margin-left: 10px;\r\n}\r\n.TVDoctor {\r\n  margin-left: 25px;\r\n}\r\n.TVCurrent {\r\n}\r\n.TVNext {\r\n}\r\n.Line {\r\n  width: auto;\r\n  height: 1px;\r\n  margin: 10px 0;\r\n  border: solid 1px #979797;\r\n}\r\n.qdoctorFonts {\r\n  // font-family: Arial;\r\n  font-family: Avenir;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #000;\r\n}\r\n.qdoctor {\r\n  font-size: 25px;\r\n}\r\n.qdoctorProfq {\r\n  font-size: 14px;\r\n}\r\n\r\n// Tv screen2\r\n.tvScreen2 {\r\n  height: 95vh;\r\n  width: auto;\r\n  margin: 0 80px 100px 0;\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n.screenColumn {\r\n  margin: 10px 15px 0 10px;\r\n  padding: 0;\r\n  border: solid 1px #979797;\r\n}\r\n.screen2doctorsDetailsDiv {\r\n  width: 100%;\r\n  height: 50%;\r\n  margin: auto;\r\n  padding: 10px 30px 0 25px;\r\n  background-color: $magenta;\r\n  font-family: Avenir;\r\n  font-size: 30px;\r\n  font-weight: 900;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #fff;\r\n  text-align: center;\r\n}\r\n.qroomstatus2 {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.screen2qdoctorRoom {\r\n  font-family: Avenir;\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: 1.5px;\r\n  color: #fff;\r\n}\r\n.screen2qdoctorStatus {\r\n  font-family: Avenir;\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: 1.5px;\r\n  text-align: left;\r\n  color: #fff;\r\n}\r\n.screen2qdoctorImgDiv {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.screen2qdoctorImg {\r\n  width: 80px;\r\n  height: 80px;\r\n}\r\n.screen2qdoctorname {\r\n  font-family: Avenir;\r\n  font-size: 30px;\r\n  font-weight: 900;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #fff;\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 10px 0;\r\n}\r\n.DividerLine {\r\n  width: auto;\r\n  height: 1px;\r\n  border: solid 1px #979797;\r\n}\r\n.rowDetails {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0 30px 10px;\r\n}\r\n.CurrentNextQ {\r\n  font-family: Avenir;\r\n  font-size: 20px;\r\n  font-weight: 900;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #000;\r\n  margin: 25px 0 10px;\r\n}\r\n.CNQPatientDetails {\r\n  font-family: Avenir;\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #000;\r\n}\r\n// Tv screen3\r\n.tvScreen3 {\r\n  height: 100vh;\r\n  margin: 5px 10px 100px;\r\n}\r\n.patientQHeader3 {\r\n  width: auto;\r\n  height: 8vh;\r\n  background-color: $magenta;\r\n  padding: 10px 0;\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n.TVDoctor3 {\r\n  margin-left: 30px;\r\n}\r\n.TVRoom3 {\r\n}\r\n.TVCurrent3 {\r\n}\r\n.TVNext3 {\r\n}\r\n.TVDoctor3val {\r\n}\r\n.TVRoom3val {\r\n  color: #000 !important;\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: 40px;\r\n}\r\n.TVCurrent3val {\r\n  color: #000 !important;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.TVNext3val {\r\n  color: #000 !important;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.patientQDetails3 {\r\n  width: auto;\r\n  height: 90vh;\r\n  padding: 0 0 43.5px;\r\n  border: solid 1px #979797;\r\n  background-color: #f2f2f2;\r\n}\r\n.patientQDetailsdiv3 {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n.Line3 {\r\n  width: auto;\r\n  height: 1px;\r\n  margin: 10px 0;\r\n  border: solid 1px #979797;\r\n}\r\n.qdoctorImg3 {\r\n  width: 70px;\r\n  height: 70px;\r\n  margin: 10px 10px 15px 30px;\r\n  border: solid 2px $magenta;\r\n  border-radius: 40px;\r\n}\r\n.patientQHeaderTitles3 {\r\n  font-family: Avenir;\r\n  font-size: 30px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: 1.8px;\r\n  color: #fff;\r\n  display: flex;\r\n}\r\n.qDoc3 {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 15px 0;\r\n}\r\n.qDocDetails3 {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n.pointer {\r\n  display: list-item;\r\n  cursor: pointer;\r\n}\r\n.vitals {\r\n  width: 50px;\r\n  font-family: Avenir;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #fff;\r\n  margin: 7px 12px;\r\n}\r\n// .financial-table thead{\r\n//   background-color: #dee9ef;\r\n//   color: #000;\r\n//   font-size: 14px;\r\n// }\r\n.custom-container {\r\n  // padding: 0px 40px 40px 40px;\r\n  height: auto;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  // height: 85vh;\r\n  margin-top: 10px;\r\n  // testing\r\n  // background-color: #40b391;\r\n}\r\n.hide_department {\r\n  display: none;\r\n}\r\n@media only screen and (min-width: 1900px) {\r\n  .doctorsDetailsDiv {\r\n    padding: 300px 30px 300px;\r\n  }\r\n}\r\n// for react-responsive-slider\r\n// ul.slider.animated {\r\n//   transition-duration: 10ms !important;\r\n//   // animation: fadeIn ease 5s;\r\n//   // -webkit-animation: fadeIn ease 5s;\r\n//   // -moz-animation: fadeIn ease 5s;\r\n//   // -o-animation: fadeIn ease 5s;\r\n//   // -ms-animation: fadeIn ease 5s;\r\n// }\r\n// @keyframes fadeIn {\r\n//   0% {\r\n//     opacity: 0.3;\r\n//   }\r\n//   25% {\r\n//     opacity: 0.5;\r\n//   }\r\n//   50% {\r\n//     opacity: 0.7;\r\n//   }\r\n//   75% {\r\n//     opacity: 0.9;\r\n//   }\r\n//   100% {\r\n//     opacity: 1;\r\n//   }\r\n// }\r\n// .slide.selected {\r\n//   animation: fadeIn ease 1.5s;\r\n//   -webkit-animation: fadeIn ease 1s;\r\n//   -moz-animation: fadeIn ease 1s;\r\n//   -o-animation: fadeIn ease 1s;\r\n//   -ms-animation: fadeIn ease 1s;\r\n// }\r\nul.slider.animated {\r\n  transition-duration: 10ms !important;\r\n  // animation: fadeIn ease 5s;\r\n  // -webkit-animation: fadeIn ease 5s;\r\n  // -moz-animation: fadeIn ease 5s;\r\n  // -o-animation: fadeIn ease 5s;\r\n  // -ms-animation: fadeIn ease 5s;\r\n}\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0.3;\r\n  }\r\n  25% {\r\n    opacity: 0.5;\r\n  }\r\n  50% {\r\n    opacity: 0.7;\r\n  }\r\n  75% {\r\n    opacity: 0.9;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n.slide.selected {\r\n  animation: fadeIn ease 1.5s;\r\n  -webkit-animation: fadeIn ease 1s;\r\n  -moz-animation: fadeIn ease 1s;\r\n  -o-animation: fadeIn ease 1s;\r\n  -ms-animation: fadeIn ease 1s;\r\n}\r\n.ant-carousel .slick-slide img{\r\n  display:initial;\r\n}\r\nbody {\r\n  overflow: auto;\r\n}\r\n.bg-thistle{\r\n  background:#34e2a199 !important;\r\n}\r\n.bg-bluish-grey{\r\n  background: #007bff6b !important;\r\n}\r\n.bg-grey{\r\n  background: #f2f2f2 !important;\r\n}\r\n.review{\r\n  font-size: 20px;\r\n}\r\n\r\n.blink_tvscreen {\r\n  animation: tvblinker 1s step-start infinite;\r\n}\r\n\r\n@keyframes tvblinker {\r\n  50% {\r\n    opacity: 0.5;\r\n  }\r\n}\r\n\r\n.nodoctortvscreen {\r\n    background: url(assets/images/tvscreenbg.jpg);\r\n    background-repeat: no-repeat;\r\n    background-size: 100% 100%;\r\n    height: 100vh;\r\n\r\n    .message {\r\n      margin: -40% 0 0 0;\r\n      border-radius: 10px;\r\n      // background-color: rgb(250, 243, 243);\r\n      color: $magenta;\r\n      opacity: 0.8;\r\n      font-size: 50px;\r\n      font-weight: 900;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      line-height: normal;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n    }\r\n\r\n    .tv-bg {\r\n      // background-color: #00000091;\r\n      align-items: center;\r\n    }\r\n}\r\n\r\n.ant-tabs-nav .ant-tabs-tab-active {\r\n  color: white;\r\n  font-weight: 500;\r\n  border-radius: 4px;\r\n  border: solid 1px #6c3964 !important;\r\n  background: #8c2ba4;\r\n \r\n}\r\n// .css-dev-only-do-not-override-1okl62o.ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {\r\n//   background-color: brown ; /* Background color */\r\n//   color: gray  /* Text color */\r\n// }\r\n:where(.css-dev-only-do-not-override-1okl62o).ant-input-affix-wrapper .ant-input-prefix {\r\n  margin-inline-end: 4px;\r\n  padding-left: 5px;\r\n}\r\n:where(.css-dev-only-do-not-override-1okl62o).ant-input-affix-wrapper .ant-input-suffix {\r\n  margin-inline-start: 4px;\r\n  padding-right: 5px;\r\n}\r\n.ant-tabs-nav .ant-tabs-tab{\r\n  border-radius: 4px;\r\n  border: solid 1px #6c3964;\r\n  text-align: justify !important;\r\n  @extend .col-4;\r\n  background: white;\r\n  width:100px !important;\r\n  //  padding-left:16px  !important;\r\n \r\n  // padding-top:10px  !important;\r\n  // max-width:fit-content !important ;\r\n  //  width:100% !important;\r\n}\r\n.doctorViewTabs .ant-tabs-nav .ant-tabs-tab{\r\n  border-radius: 4px;\r\n  border: solid 1px #6c3964;\r\n  text-align: justify !important;\r\n  @extend .col-4;\r\n  background: white;\r\n  width:90px !important;\r\n  //  padding-left:16px  !important;\r\n \r\n  // padding-top:10px  !important;\r\n  // max-width:fit-content !important ;\r\n  //  width:100% !important;\r\n}\r\n\r\n\r\n:where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-btn:focus:not(:focus-visible), :where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-remove:focus:not(:focus-visible), :where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-btn:active, :where(.css-dev-only-do-not-override-1okl62o).ant-tabs .ant-tabs-tab-remove:active {\r\n  color: white;\r\n}\r\n\r\n.ant-tabs-tab-active{\r\n  background: #8c2ba4 !important;\r\n}\r\n// .ant-tabs-tab.ant-tabs-tab-active {\r\n//   // max-width:fit-content !important;\r\n// }\r\n.ant-tabs-tab {\r\n  margin-left: 0px !important;\r\n  margin-right: 2px !important;\r\n  // max-width:fit-content !important;\r\n  border-bottom:none !important;\r\n \r\n\r\n}\r\n.custom-btn {\r\n  background-color: #8c2ba4;\r\n  color: white; \r\n  font-size: 40px; \r\n  padding: 10px 2px; \r\n  max-width:30%;\r\n  margin-bottom:10px;\r\n}\r\n.custom-btn:hover{\r\n  color:lightgray;\r\n}\r\n.doctorBreakText{\r\n  // color:rgb(244, 239, 239);\r\n color: #FFF0AB;\r\n}\r\n\r\n.edit_size.ant-btn.ant-btn-icon-only .anticon {\r\n  font-size: 20px;\r\n}\r\n.patients .ant-tabs-nav .ant-tabs-tab {\r\n  margin-right: 2px;\r\n  padding: 10px 38.3px !important;\r\n  // border:2px solid blue !important;\r\n  // margin-left:5px !important;\r\n  max-width: fit-content !important;\r\n    width: fit-content !important;\r\n}\r\n\r\n.ant-input-group-wrapper{\r\n  border-radius: 7px !important;\r\n    border: none !important;\r\n    box-shadow: 0px 1px 8px rgb(113, 114, 114) !important;\r\n\r\n}\r\n.ant-input-affix-wrapper-focused{\r\n  border-color: #fff !important;\r\n}\r\n.ant-input-search .ant-input:focus .ant-btn-default{\r\n  border-color: #fff !important;\r\n}\r\n\r\n.ant-select-selector {\r\n   min-height: 32px !important;\r\n}\r\n\r\n// .ant-tabs-bar{\r\n//   position: fixed;\r\n//   z-index: 999;\r\n// }\r\n\r\n// .ant-tabs-content{\r\n//   margin-left: 0%;\r\n//   margin-top: 70px;\r\n//   z-index: -1;\r\n// }\r\n\r\n.ant-tabs-nav{\r\n  width: 97%;\r\n}\r\n\r\n.ant-tabs {\r\n  &-nav {\r\n  .ant-tabs-tab {\r\n      margin-right: 2px;\r\n    }\r\n  }\r\n}\r\n.ant-tabs-nav-scroll {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.ant-tabs-nav .ant-tabs-tab-active:hover {\r\n  color: white !important;\r\n}\r\n\r\n.ant-tabs-nav .ant-tabs-tab:hover {\r\n  color: initial;\r\n}\r\n\r\n.ant-tabs-ink-bar {\r\n  background-color: transparent;\r\n}\r\n\r\n.que-completed-patients{\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.reports-details td:first-child, .reports-details td:first-child + td {\r\n  border-right: solid 1px #ae8ca6;\r\n}\r\n\r\n.tv-row td {\r\n  border-bottom: 1px solid #ae8ca6;\r\n}\r\n\r\n.ant-modal-footer div{\r\n  text-align: center;\r\n}\r\n\r\n.ant-modal-footer .ant-btn-primary{\r\n  background-color: #8c2ba4;\r\n  border-color: #8c2ba4;\r\n}\r\n.profile_pic svg{\r\n  font-size: 20px;\r\n}\r\n.doctor_profile_pic{\r\n  min-width: 60px;\r\n  min-height: 41px;\r\n  max-width: 40px;\r\n  max-height: 27px;\r\n  background-color: #6c3964;\r\n}\r\n.doctor_list{\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n.delete_profile svg{\r\n  font-size: 20px;\r\n  color: red;\r\n}\r\n.view_doctor_pic svg{\r\n  font-size: 40px;\r\n}\r\n.profile_green svg{\r\n  color: green;\r\n}\r\n.edit_doctor_profile_pic{\r\n  min-width: 100px;\r\n  min-height: 100px;\r\n  max-width: 100px;\r\n  max-height: 100px;\r\n  background-color: #6c3964;\r\n}\r\nspan.anticon.anticon-calendar {\r\n  padding-left: 6px;\r\n    padding-bottom: 6px;\r\n}",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// Bootstrap functions\n//\n// Utility mixins and functions for evaluating source code across our variables, maps, and mixins.\n\n// Ascending\n// Used to evaluate Sass maps like our grid breakpoints.\n@mixin _assert-ascending($map, $map-name) {\n  $prev-key: null;\n  $prev-num: null;\n  @each $key, $num in $map {\n    @if $prev-num == null or unit($num) == \"%\" or unit($prev-num) == \"%\" {\n      // Do nothing\n    } @else if not comparable($prev-num, $num) {\n      @warn \"Potentially invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} whose unit makes it incomparable to #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    } @else if $prev-num >= $num {\n      @warn \"Invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} which isn't greater than #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    }\n    $prev-key: $key;\n    $prev-num: $num;\n  }\n}\n\n// Starts at zero\n// Used to ensure the min-width of the lowest breakpoint starts at 0.\n@mixin _assert-starts-at-zero($map, $map-name: \"$grid-breakpoints\") {\n  @if length($map) > 0 {\n    $values: map-values($map);\n    $first-value: nth($values, 1);\n    @if $first-value != 0 {\n      @warn \"First breakpoint in #{$map-name} must start at 0, but starts at #{$first-value}.\";\n    }\n  }\n}\n\n// Replace `$search` with `$replace` in `$string`\n// Used on our SVG icon backgrounds for custom forms.\n//\n// @author Hugo Giraudel\n// @param {String} $string - Initial string\n// @param {String} $search - Substring to replace\n// @param {String} $replace ('') - New value\n// @return {String} - Updated string\n@function str-replace($string, $search, $replace: \"\") {\n  $index: str-index($string, $search);\n\n  @if $index {\n    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);\n  }\n\n  @return $string;\n}\n\n// See https://codepen.io/kevinweber/pen/dXWoRw\n//\n// Requires the use of quotes around data URIs.\n\n@function escape-svg($string) {\n  @if str-index($string, \"data:image/svg+xml\") {\n    @each $char, $encoded in $escaped-characters {\n      // Do not escape the url brackets\n      @if str-index($string, \"url(\") == 1 {\n        $string: url(\"#{str-replace(str-slice($string, 6, -3), $char, $encoded)}\");\n      } @else {\n        $string: str-replace($string, $char, $encoded);\n      }\n    }\n  }\n\n  @return $string;\n}\n\n// Color contrast\n@function color-yiq($color, $dark: $yiq-text-dark, $light: $yiq-text-light) {\n  $r: red($color);\n  $g: green($color);\n  $b: blue($color);\n\n  $yiq: (($r * 299) + ($g * 587) + ($b * 114)) * .001;\n\n  @if ($yiq >= $yiq-contrasted-threshold) {\n    @return $dark;\n  } @else {\n    @return $light;\n  }\n}\n\n// Retrieve color Sass maps\n@function color($key: \"blue\") {\n  @return map-get($colors, $key);\n}\n\n@function theme-color($key: \"primary\") {\n  @return map-get($theme-colors, $key);\n}\n\n@function gray($key: \"100\") {\n  @return map-get($grays, $key);\n}\n\n// Request a theme color level\n@function theme-color-level($color-name: \"primary\", $level: 0) {\n  $color: theme-color($color-name);\n  $color-base: if($level > 0, $black, $white);\n  $level: abs($level);\n\n  @return mix($color-base, $color, $level * $theme-color-interval);\n}\n\n// Return valid calc\n@function add($value1, $value2, $return-calc: true) {\n  @if $value1 == null {\n    @return $value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 + $value2;\n  }\n\n  @return if($return-calc == true, calc(#{$value1} + #{$value2}), $value1 + unquote(\" + \") + $value2);\n}\n\n@function subtract($value1, $value2, $return-calc: true) {\n  @if $value1 == null and $value2 == null {\n    @return null;\n  }\n\n  @if $value1 == null {\n    @return -$value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 - $value2;\n  }\n\n  @if type-of($value2) != number {\n    $value2: unquote(\"(\") + $value2 + unquote(\")\");\n  }\n\n  @return if($return-calc == true, calc(#{$value1} - #{$value2}), $value1 + unquote(\" - \") + $value2);\n}\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n\n    // See https://github.com/twbs/bootstrap/pull/31557\n    // Align tooltip to form elements\n    .form-row > .col > &,\n    .form-row > [class*=\"col-\"] > & {\n      left: $form-grid-gutter-width * .5;\n    }\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner !important; // stylelint-disable-line declaration-no-important\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  select.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-padding-x * 4 !important; // stylelint-disable-line declaration-no-important\n        background-position: right $input-padding-x * 2 center;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right !important; // stylelint-disable-line declaration-no-important\n        background: $custom-select-background, $custom-select-bg escape-svg($icon) $custom-select-feedback-icon-position / $custom-select-feedback-icon-size no-repeat;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  // Prevents from shrinking in IE11, when in a flex container\n  // See https://github.com/twbs/bootstrap/issues/28341\n  flex-basis: $toast-max-width;\n  max-width: $toast-max-width;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","// constants\r\n\r\n@import \"./Constants/variables\";\r\n\r\nbody {\r\n  // background-color: $pale-grey-four;\r\n  overflow: hidden;\r\n  // testing\r\n  // background-color: #60b6b4 !important;\r\n}\r\n\r\n@import \"./Components/navigation\", \"./Components/footer\",\r\n  \"./Components/breadCrums\";\r\n\r\n.body-container {\r\n  position: relative;\r\n  top: 70px;\r\n  min-height: 80vh;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n@import \"./Pages/CustomPage\", \"./Pages/queue\", \"./Pages/appointement\";\r\n\r\n.queue-config-list {\r\n  .text-p-light {\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 3.43;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: #b2b9c4;\r\n  }\r\n\r\n  .text-p-bold {\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.29;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: #455a64;\r\n  }\r\n\r\n  .number-p-light {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.29;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: #0089ca;\r\n  }\r\n\r\n  .text-p-bold-exceeds {\r\n    width: 48px;\r\n    height: 11px;\r\n    // font-family: \"Poppins\", sans-serif;\r\n    font-family: \"Avenir\", sans-serif;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.29;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: #ff2400;\r\n  }\r\n\r\n  .number-p-center {\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.29;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #455a64;\r\n  }\r\n}\r\n\r\n.card-top-heading {\r\n  border: solid 1px $silver;\r\n  background-color: #26c7db;\r\n\r\n  p {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 2;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: $white;\r\n\r\n    &.text-light-d {\r\n      font-size: 14px;\r\n      font-weight: normal;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 1.13;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.next-btn {\r\n  width: 100%;\r\n  background-color: #26c7db;\r\n  border-color: #26c7db;\r\n}\r\n\r\n.next-btn:hover {\r\n  width: 100%;\r\n  background-color: #26c7db;\r\n  border-color: #26c7db;\r\n}\r\n\r\n.checkout-btn {\r\n  width: 100%;\r\n  background-color: #fc4b6c;\r\n  border-color: #fc4b6c;\r\n}\r\n\r\n.skip-btn {\r\n  width: 100%;\r\n  background-color: #cde7f4;\r\n  border-color: #cde7f4;\r\n}\r\n\r\n.checkout-btn:hover {\r\n  width: 100%;\r\n  background-color: #fc4b6c;\r\n  border-color: #fc4b6c;\r\n}\r\n\r\n.skip-btn:hover {\r\n  width: 100%;\r\n  background-color: #cde7f4;\r\n  border-color: #cde7f4;\r\n}\r\n\r\n.card-detail-text-light {\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-stretch: normal;\r\n  line-height: 1.2;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #607d8b;\r\n}\r\n\r\n.card-detail-text-bold {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-stretch: normal;\r\n  line-height: 1.2;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #364152;\r\n}\r\n\r\n.card-detail-text-token {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-stretch: normal;\r\n  line-height: 1.4;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #fc4b6c;\r\n}\r\n\r\n.card-colon::after {\r\n  content: \":\";\r\n  position: absolute;\r\n  right: 0;\r\n}\r\n\r\n.card-text-icons {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-stretch: normal;\r\n  line-height: 3.43;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #455a64;\r\n}\r\n\r\n.dashboard-container {\r\n  .info-card {\r\n    border-radius: 5.3px;\r\n    border: 0px solid transparent;\r\n    box-shadow: 0 0 3px 0 rgba(45, 58, 66, 0.35);\r\n\r\n    &.bg-purple {\r\n      background-color: #745af2;\r\n    }\r\n\r\n    &.bg-blue {\r\n      background-color: #26c6da;\r\n    }\r\n\r\n    &.bg-primary {\r\n      background-color: $dark-sky-blue;\r\n    }\r\n\r\n    &.bg-warning {\r\n      background-color: #ffb22b;\r\n    }\r\n\r\n    p {\r\n      font-size: 36px;\r\n      font-weight: 500;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 1;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: $white;\r\n      margin-bottom: 0px;\r\n\r\n      &.text-primary {\r\n        color: $dark-sky-blue;\r\n      }\r\n\r\n      &.text-greenblue {\r\n        color: #26da90;\r\n      }\r\n\r\n      &.text-warning {\r\n        color: #ffb22b;\r\n      }\r\n\r\n      &.text-error {\r\n        color: #fc4b6c;\r\n      }\r\n    }\r\n\r\n    span {\r\n      font-size: 15px;\r\n      font-weight: normal;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 1.6;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: $white;\r\n\r\n      &.text-black {\r\n        color: $slate-four;\r\n      }\r\n    }\r\n\r\n    figure {\r\n      text-align: right;\r\n      margin-bottom: 0px;\r\n\r\n      img {\r\n        width: 20px;\r\n        height: 20px;\r\n        object-fit: contain;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.card-horizantal {\r\n  .c-head {\r\n    border-bottom: 1px solid #e9f1f3;\r\n  }\r\n\r\n  h2 {\r\n    margin-bottom: 0px;\r\n    font-size: 21px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.29;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: $twilight-blue;\r\n  }\r\n\r\n  p {\r\n    margin-bottom: 0px;\r\n    font-size: 15px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 2.4;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: $bluey-grey;\r\n\r\n    &.text-black {\r\n      font-size: 15px;\r\n      font-weight: normal;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2.4;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: $slate-four;\r\n    }\r\n\r\n    &.text-red {\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2.57;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: #fc4b6c;\r\n    }\r\n  }\r\n\r\n  .c-body {\r\n    padding: 0px 15px 0px 15px;\r\n\r\n    .table-card {\r\n      p {\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n        font-style: normal;\r\n        font-stretch: normal;\r\n        line-height: 2;\r\n        letter-spacing: normal;\r\n        text-align: left;\r\n        color: $cool-grey;\r\n\r\n        &.text-black {\r\n          font-size: 14px;\r\n          font-weight: normal;\r\n          font-style: normal;\r\n          font-stretch: normal;\r\n          line-height: 1.29;\r\n          letter-spacing: normal;\r\n          text-align: left;\r\n          color: $slate-four;\r\n        }\r\n      }\r\n    }\r\n\r\n    .border {\r\n      border-top: solid 1px $silver;\r\n      border-bottom: solid 1px $silver;\r\n\r\n      .col-1 {\r\n        position: relative;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          width: 2px;\r\n          right: 0px;\r\n          height: 120%;\r\n          background-color: #d4dade;\r\n          position: absolute;\r\n          top: -7px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.admin-addform {\r\n  .ant-modal-body {\r\n    padding: 0px;\r\n\r\n    .figure-block {\r\n      figure {\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: contain;\r\n        margin-bottom: 0px;\r\n      }\r\n\r\n      p {\r\n        font-size: 16px;\r\n        font-weight: 500;\r\n        font-style: normal;\r\n        font-stretch: normal;\r\n        line-height: 1.67;\r\n        letter-spacing: normal;\r\n        text-align: left;\r\n        color: $white;\r\n        position: absolute;\r\n        top: 0;\r\n        padding: 24px 50px 24px 24px;\r\n      }\r\n    }\r\n\r\n    .form-block {\r\n      h2 {\r\n        font-size: 24px;\r\n        font-weight: normal;\r\n        font-style: normal;\r\n        font-stretch: normal;\r\n        line-height: 2;\r\n        letter-spacing: normal;\r\n        text-align: left;\r\n        color: $dark-grey-blue-two;\r\n      }\r\n\r\n      input {\r\n        border-radius: 0px;\r\n      }\r\n\r\n      button {\r\n        background-color: $dark-grey-blue-two;\r\n        font-size: 14px;\r\n        font-weight: normal;\r\n        font-style: normal;\r\n        font-stretch: normal;\r\n        line-height: 2.43;\r\n        letter-spacing: normal;\r\n        text-align: left;\r\n        color: $white;\r\n        border: 0px;\r\n        padding: 4px 60px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.counter-details {\r\n  .card {\r\n    border-radius: 0px;\r\n    border: 0px solid transparent;\r\n\r\n    .head-row {\r\n      // @media screen and (min-width: 1900px) {\r\n      //    height: 175px;\r\n      //   }\r\n      // background-color: #607d8b;\r\n\r\n      background-color: #6c3964;\r\n\r\n      th {\r\n        font-size: 20px;\r\n        font-weight: 900;\r\n        font-style: normal;\r\n        font-stretch: normal;\r\n        line-height: 3.4;\r\n        letter-spacing: normal;\r\n        color: $white;\r\n        text-transform: uppercase;\r\n        border-right: 1px solid $white-seven;\r\n\r\n        @media screen and (min-width: 1900px) {\r\n          //transform: scale(2)\r\n          letter-spacing: 1px;\r\n          font-size: 40px;\r\n          line-height: 2;\r\n\r\n          transform: matrix(1.1, 0, 0, 1.1, 0, 0);\r\n        }\r\n      }\r\n    }\r\n\r\n    .table-body {\r\n      td {\r\n        font-size: 30px;\r\n        font-weight: 600;\r\n        font-style: normal;\r\n        font-stretch: normal;\r\n        line-height: 2;\r\n        letter-spacing: normal;\r\n        color: #607d8b;\r\n        border-right: 1px solid $white-seven;\r\n        padding: 15px;\r\n\r\n        @media only screen and (min-width: 1900px) {\r\n          //transform: scale(2)\r\n          letter-spacing: 1px;\r\n          font-size: 40px;\r\n          transform: matrix(1.1, 0, 0, 1.1, 0, 0);\r\n        }\r\n      }\r\n\r\n      tr {\r\n        &:nth-child(even) {\r\n          background-color: #d7e6ef;\r\n        }\r\n\r\n        &:nth-child(odd) {\r\n          background-color: $white-seven;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.table-header {\r\n  display: flex;\r\n  justify-content: center;\r\n  font-size: 26px !important;\r\n  font-weight: 900 !important;\r\n  font-style: normal;\r\n  font-stretch: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n}\r\n.tv-screen-bg {\r\n  background-color: $silver;\r\n  // testing\r\n  // background-color: #888888;\r\n}\r\n.new-details-table {\r\n  .table-responsive {\r\n    padding: 0px;\r\n  }\r\n\r\n  thead {\r\n    tr {\r\n      th {\r\n        min-width: 135px;\r\n        padding: 20px 15px;\r\n      }\r\n    }\r\n  }\r\n\r\n  tbody {\r\n    tr {\r\n      border-bottom: solid 1px #d4dade;\r\n    }\r\n\r\n    td {\r\n      border-bottom: solid 0px #d4dade;\r\n      padding: 20px 15px;\r\n      min-width: 135px;\r\n      line-height: 1.4;\r\n      text-transform: capitalize;\r\n    }\r\n  }\r\n}\r\n\r\n.static {\r\n  padding: 0px 15px;\r\n\r\n  label {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 2.43;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: #b2b9c4;\r\n  }\r\n\r\n  p {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: #455a64;\r\n    margin-bottom: 0px;\r\n  }\r\n}\r\n\r\n.booked-slot {\r\n  position: relative;\r\n  background-color: #26c6da !important;\r\n\r\n  &.ip {\r\n    background-color: #df0136 !important;\r\n\r\n    &.emergency {\r\n      background-color: rgba(255, 0, 0, 0.911) !important;\r\n    }\r\n  }\r\n\r\n  &.IP {\r\n    background-color: #df0136 !important;\r\n\r\n    &.emergency {\r\n      background-color: rgba(255, 0, 0, 0.911) !important;\r\n    }\r\n  }\r\n\r\n  &.op {\r\n    background-color: #26c6da !important;\r\n\r\n    &.emergency {\r\n      background-color: rgba(255, 0, 0, 0.911) !important;\r\n    }\r\n  }\r\n\r\n  &.OP {\r\n    background-color: #26c6da !important;\r\n\r\n    &.emergency {\r\n      background-color: rgba(255, 0, 0, 0.911) !important;\r\n    }\r\n  }\r\n\r\n  &.Bedside {\r\n    background-color: #6f848e !important;\r\n\r\n    &.emergency {\r\n      background-color: rgba(255, 0, 0, 0.911) !important;\r\n    }\r\n  }\r\n\r\n  &.Buffer {\r\n    background-color: green !important;\r\n\r\n    &.emergency {\r\n      background-color: rgba(255, 0, 0, 0.911) !important;\r\n    }\r\n  }\r\n\r\n  p {\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: $white !important;\r\n  }\r\n\r\n  .booked-data {\r\n    margin: 30px 0px;\r\n\r\n    p,\r\n    small {\r\n      background-color: transparent;\r\n      font-size: 14px;\r\n      font-weight: normal;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 1.71;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      //   color: $slate-four !important;\r\n      color: $white !important;\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\n.ant-popover {\r\n  width: auto;\r\n}\r\n\r\n.ant-select-dropdown {\r\n  z-index: 1600;\r\n}\r\n\r\n@keyframes lds-magnify {\r\n  0% {\r\n    -webkit-transform: translate(2px, 2px);\r\n    transform: translate(2px, 2px);\r\n  }\r\n\r\n  33.33% {\r\n    -webkit-transform: translate(102px, 2px);\r\n    transform: translate(102px, 2px);\r\n  }\r\n\r\n  66.66% {\r\n    -webkit-transform: translate(42px, 102px);\r\n    transform: translate(42px, 102px);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translate(2px, 2px);\r\n    transform: translate(2px, 2px);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes lds-magnify {\r\n  0% {\r\n    -webkit-transform: translate(2px, 2px);\r\n    transform: translate(2px, 2px);\r\n  }\r\n\r\n  33.33% {\r\n    -webkit-transform: translate(102px, 2px);\r\n    transform: translate(102px, 2px);\r\n  }\r\n\r\n  66.66% {\r\n    -webkit-transform: translate(42px, 102px);\r\n    transform: translate(42px, 102px);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translate(2px, 2px);\r\n    transform: translate(2px, 2px);\r\n  }\r\n}\r\n\r\n.lds-magnify {\r\n  position: relative;\r\n}\r\n\r\n.lds-magnify > div {\r\n  -webkit-transform: scale(0.8);\r\n  transform: scale(0.8);\r\n  -webkit-transform-origin: 100px 100px;\r\n  transform-origin: 100px 100px;\r\n}\r\n\r\n.lds-magnify > div > div {\r\n  -webkit-animation: lds-magnify 1s linear infinite;\r\n  animation: lds-magnify 1s linear infinite;\r\n  position: absolute;\r\n}\r\n\r\n.lds-magnify > div > div div:nth-child(1) {\r\n  width: 96px;\r\n  height: 96px;\r\n  border-radius: 50%;\r\n  border: 12px solid #337ab7;\r\n  background: #5bc0de;\r\n}\r\n\r\n.lds-magnify > div > div div:nth-child(2) {\r\n  width: 17px;\r\n  height: 51px;\r\n  -webkit-transform: rotate(-45deg);\r\n  transform: rotate(-45deg);\r\n  background: #337ab7;\r\n  border-radius: 0 0 8px 8px;\r\n  position: absolute;\r\n  top: 68px;\r\n  left: 85px;\r\n}\r\n\r\n.lds-magnify {\r\n  width: 200px !important;\r\n  height: 200px !important;\r\n  -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);\r\n  transform: translate(-100px, -100px) scale(1) translate(100px, 100px);\r\n}\r\n\r\n.time-exceed {\r\n  border: 3px solid #fd000d !important;\r\n}\r\n\r\n.dissablslotLi {\r\n  height: 200px;\r\n  overflow-y: auto;\r\n\r\n  div {\r\n    background-color: #eef5f9;\r\n    padding: 5px;\r\n    border-radius: 20px;\r\n\r\n    button {\r\n      top: -2px;\r\n      bottom: 0;\r\n      left: 20px;\r\n    }\r\n  }\r\n}\r\n\r\n.f-14 {\r\n  font-size: 14px;\r\n}\r\n\r\n.disabled {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.login-bg {\r\n  // background-color: #37546491;\r\n  background-color: #00000091;\r\n  // opacity: 0.65;\r\n  display: flex;\r\n  align-items: center;\r\n  font-family: Avenir;\r\n  color: #fff;\r\n}\r\niframe#webpack-dev-server-client-overlay{display:none!important}\r\n.new-login-layer {\r\n background: url(../assets/images/login_bg.png);\r\n  background-repeat: no-repeat;\r\n  background-size: 100% 100%;\r\n  height: 100vh;\r\n  // background-position: -60px 0%;\r\n\r\n  figure {\r\n    width: 155px;\r\n    height: 49px;\r\n    object-fit: contain;\r\n  }\r\n\r\n  h1 {\r\n    font-size: 60px;\r\n    font-weight: 200;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.3;\r\n    letter-spacing: 1.2px;\r\n    color: #fff;\r\n  }\r\n  sup {\r\n    top: -0.3em;\r\n  }\r\n  h2 {\r\n    font-size: 33px;\r\n    font-weight: 300;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.3;\r\n    letter-spacing: 1.2px;\r\n    color: #fff;\r\n  }\r\n  ul {\r\n    li {\r\n      font-size: 18px;\r\n      font-weight: 300;\r\n      font-stretch: normal;\r\n      font-style: normal;\r\n      line-height: 1.36;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: #fff;\r\n    }\r\n  }\r\n  .forgot-pass {\r\n    font-size: 12px;\r\n    font-weight: 300;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: 2.5;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: #ffffff;\r\n  }\r\n\r\n  .login-card {\r\n    padding: 50px;\r\n    margin: 50px;\r\n    border-radius: 10px;\r\n    background-color: #fff;\r\n    opacity: 1;\r\n\r\n    h2 {\r\n      font-size: 20px;\r\n      font-weight: 300;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: normal;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: #fff;\r\n      text-transform: uppercase;\r\n    }\r\n\r\n    h2 + small {\r\n      font-size: 13px;\r\n      font-weight: normal;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: #868686;\r\n    }\r\n\r\n    .ant-input-prefix {\r\n      \r\n      i {\r\n        color: #fff !important;\r\n      }\r\n    }\r\n\r\n    .ant-input-suffix {\r\n      i {\r\n        color: #fff !important;\r\n      }\r\n    }\r\n\r\n    input {\r\n      border-radius: 5px;\r\n     //box-shadow: inset 0 0 2px 0 #b0b0b0;\r\n      border: solid 1px #66b1d0;\r\n      font-size: 14px;\r\n      font-weight: 300;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2.2;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: #000;\r\n      // background-color: lightgray;\r\n\r\n      &::placeholder {\r\n        font-size: 13px;\r\n        font-weight: normal;\r\n        font-style: normal;\r\n        font-stretch: normal;\r\n        line-height: 3.2;\r\n        letter-spacing: normal;\r\n        text-align: left;\r\n        color:gray;\r\n      }\r\n    }\r\n  \r\n    \r\n    //   input {\r\n\r\n   \r\n\r\n    //  &::placeholder {\r\n    // //     font-size: 13px;\r\n    // //     font-weight: normal;\r\n    // //     font-style: normal;\r\n    // //     font-stretch: normal;\r\n    // //     line-height: 3.2;\r\n    // //     letter-spacing: normal;\r\n    // //     text-align: left;\r\n    //    color: #fff;\r\n    //   }\r\n     \r\n    // }\r\n   \r\n    button {\r\n      width: 50%;\r\n      border-radius: 5px;\r\n      // background-color: #32a257;\r\n      background-color: $magenta;\r\n      font-size: 16px;\r\n      font-weight: 600;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2.2;\r\n      letter-spacing: 0.9px;\r\n      text-align: center;\r\n      color: #fff;\r\n      border: 0px;\r\n      // text-transform: uppercase;\r\n    }\r\n  }\r\n}\r\n\r\n.text-explination {\r\n  img {\r\n    width: 36px;\r\n    height: 36px;\r\n    object-fit: contain;\r\n  }\r\n\r\n  h3 {\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: $white;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  p {\r\n    font-size: 14px;\r\n    font-weight: 300;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.43;\r\n    letter-spacing: 0.7px;\r\n    text-align: left;\r\n    color: $white;\r\n  }\r\n\r\n  ul {\r\n    li {\r\n      font-size: 14px;\r\n      font-weight: 300;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2.14;\r\n      letter-spacing: 0.28px;\r\n      text-align: left;\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.border-botton-lay {\r\n  border-bottom: 1px solid #02a3b3;\r\n}\r\n\r\n.login-footer {\r\n  // border-top:1px solid #02a3b3;\r\n  position: absolute;\r\n  // width: 98%;\r\n  bottom: 50px;\r\n\r\n  p {\r\n    font-size: 11px;\r\n    font-weight: 200;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.43;\r\n    letter-spacing: 1.2px;\r\n    text-align: left;\r\n    color: #fff;\r\n    margin-bottom: 0px;\r\n\r\n    &:nth-child(2) {\r\n      color: #77c8f2;\r\n    }\r\n\r\n    a {\r\n      color: #fff;\r\n    }\r\n  }\r\n}\r\n\r\n.card-row {\r\n  display: flex;\r\n  margin-left: -20px;\r\n  overflow: auto;\r\n  white-space: nowrap;\r\n  // width:360px;\r\n  .card-dynamic {\r\n    display: block;\r\n    width: auto;\r\n    height: auto;\r\n  }\r\n}\r\n\r\n.loader {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(212, 218, 222, 0.5);\r\n  z-index: 2000;\r\n  top: 0;\r\n  cursor: wait;\r\n  left: 0;\r\n  z-index: 2000;\r\n}\r\n\r\n.app-loader {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(96, 125, 139, 0.5);\r\n  top: 0%;\r\n  left: 0%;\r\n  position: fixed;\r\n  z-index: 2000;\r\n}\r\n\r\n.ant-spin-spinning {\r\n  position: relative;\r\n  top: calc(100% - 50%);\r\n  bottom: calc(100% - 50%);\r\n  left: calc(100% - 50%);\r\n  right: calc(100% - 50%);\r\n  margin: auto;\r\n}\r\n\r\n.popover-custom {\r\n  width: auto;\r\n}\r\n\r\n// @media only screen and (min-width: 1900px) {\r\n// .tv-row{\r\n//     height: 175px;\r\n// }\r\n// }\r\n.pagination {\r\n  display: inline-block;\r\n}\r\n\r\n.pagination li {\r\n  color: black;\r\n  float: left;\r\n  padding: 8px 16px;\r\n  text-decoration: none;\r\n  border: 1px solid #c1c1cc;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.pagination li.active {\r\n  background-color: #337ab7;\r\n  color: white;\r\n  border: 1px solid #337ab7;\r\n}\r\n\r\n.pagination li.active a {\r\n  color: white;\r\n}\r\n\r\n.pagination li:hover:not(.active) {\r\n  background-color: #ddd;\r\n}\r\n\r\n.pagination li:first-child {\r\n  border-top-left-radius: 5px;\r\n  border-bottom-left-radius: 5px;\r\n}\r\n\r\n.pagination li:last-child {\r\n  border-top-right-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n}\r\n\r\n.error-color {\r\n  color: red;\r\n}\r\n\r\n.download-csv-btn {\r\n  background-color: $magenta;\r\n  font-size: 14px;\r\n  border: 0px solid transparent;\r\n  margin: auto 10px;\r\n  font-weight: normal;\r\n  font-style: normal;\r\n  font-stretch: normal;\r\n  line-height: 3 !important;\r\n  padding: 0px 20px !important;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #fff;\r\n\r\n  &:focus,\r\n  &:hover,\r\n  &:active {\r\n    color: #fff;\r\n  }\r\n\r\n  img {\r\n    width: 18px;\r\n    height: 18px;\r\n    object-fit: contain;\r\n    margin-right: 10px;\r\n  }\r\n}\r\n\r\n.not-active-download {\r\n  pointer-events: inherit;\r\n  text-decoration: none;\r\n\r\n  &:focus,\r\n  &:hover,\r\n  &:active {\r\n    cursor: wait;\r\n  }\r\n}\r\n\r\n.search-btn-modal {\r\n  width: 62px !important;\r\n  border-bottom-right-radius: 4px !important;\r\n  border-top-right-radius: 4px !important;\r\n  margin: 0px !important;\r\n  background-color: $magenta;\r\n}\r\n\r\n.bill-search-btn {\r\n  border-bottom-right-radius: 0px !important;\r\n  border-top-right-radius: 0px !important;\r\n}\r\n\r\n.input-padding {\r\n  padding: 0px !important;\r\n}\r\n\r\n.left-adding {\r\n  left: -2px !important;\r\n}\r\n\r\n.dropdown-img {\r\n  width: 13px;\r\n  height: 14px;\r\n  margin-right: 3px;\r\n}\r\n\r\n.service-in-card {\r\n  padding-left: 2.5em !important;\r\n  text-indent: -1.5em !important;\r\n  height: auto !important;\r\n}\r\n\r\n.ant-calendar-picker {\r\n  width: 100%;\r\n}\r\n\r\n.operator-card-clock {\r\n  position: absolute;\r\n  top: 0;\r\n  z-index: 9;\r\n  left: -8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.remove-icon-app {\r\n  position: absolute !important;\r\n  right: 3px !important;\r\n  cursor: pointer;\r\n  width: 11px !important;\r\n  height: 20px !important;\r\n}\r\n\r\n.operator-service-app-p {\r\n  position: initial !important;\r\n}\r\n\r\n.text-checkin-disable {\r\n  background: #7593a4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.chart-filter {\r\n  margin-top: 10px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.ant-badge {\r\n  width: 100%;\r\n}\r\n.patient-queue-title {\r\n  h3 {\r\n    border-bottom: 1px solid #eef5f9;\r\n  }\r\n}\r\n\r\n.patient-queue {\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  height: 595px;\r\n  padding-top: 5px;\r\n  background-color: #eef5f9;\r\n  h6 {\r\n    line-height: 1.5;\r\n    margin-bottom: 0;\r\n    padding-left: 10px;\r\n    padding-bottom: 5px;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n  }\r\n  h6:first-child {\r\n    padding-top: 10px;\r\n  }\r\n  h4 {\r\n    line-height: 1.5;\r\n    margin-bottom: 0;\r\n    padding-left: 10px;\r\n    padding-bottom: 5px;\r\n    text-transform: uppercase;\r\n  }\r\n  .borderb {\r\n    border-bottom: 1px solid #eef5f9;\r\n    padding-top: 10px;\r\n    margin-bottom: 5px;\r\n    position: relative;\r\n    background-color: #fff;\r\n  }\r\n  .borderb:last-child {\r\n    border-bottom: 1px solid #fff;\r\n  }\r\n  .borderb:hover .overlay {\r\n    display: block;\r\n    background: rgba(0, 0, 0, 0.3);\r\n  }\r\n  .btn {\r\n    margin-right: 10px;\r\n    background-color: $magenta;\r\n    color: #fff;\r\n  }\r\n  .btn-success {\r\n    padding: 0.375rem 1rem;\r\n  }\r\n}\r\n\r\n//   .patient-queue::-webkit-scrollbar {\r\n//     display: none;\r\n//   }\r\n\r\n.popup-close {\r\n  width: 30px;\r\n  height: 30px;\r\n  padding: 6px 0px;\r\n  border-radius: 15px;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  line-height: 1.2;\r\n  background-color: #6c3964;\r\n  color: #fff;\r\n  position: absolute;\r\n  right: -10px;\r\n  top: -10px;\r\n  border: 1px solid #d9d9d9;\r\n}\r\n","header {\r\n  // box-shadow: 1.5px 2.6px 7px 0 $dark-grey-blue-35;\r\n  background-color: $dark-grey-blue-two;\r\n  position: fixed;\r\n  width: 100%;\r\n  z-index: 1030;\r\n  .logo {\r\n    // width: 160px;\r\n    // height: 50px;\r\n    width: 129px;\r\n    height: 41px;\r\n  }\r\n\r\n  .menu-List {\r\n    position: relative;\r\n    height: 100%;\r\n    ul {\r\n      width: 100%;\r\n      height: 100%;\r\n      li {\r\n        position: relative;\r\n        margin-right: 0rem !important;\r\n        // height: 100%;\r\n        .menuIcon {\r\n          background-color: white;\r\n          margin: 2px 6px 2px 0;\r\n        }\r\n        a {\r\n          font-size: 14px;\r\n          font-weight: normal;\r\n          font-style: normal;\r\n          font-stretch: normal;\r\n          letter-spacing: normal;\r\n          text-align: right;\r\n          text-decoration: none;\r\n          color: $magenta;\r\n          padding: 18px 15px;\r\n          top: calc(100% - 40px);\r\n          display: block;\r\n          position: relative;\r\n          &:hover {\r\n            background-color: $magenta;\r\n            color: $white !important;\r\n          }\r\n          &.active {\r\n            background-color: #0075ad;\r\n            color: $white !important;\r\n          }\r\n          img {\r\n            width: 30px;\r\n            height: 30px;\r\n            object-fit: contain;\r\n            margin-right: 8px;\r\n            margin-top: -2px;\r\n            // filter: brightness(200%);\r\n            // -webkit-filter: brightness(200%);\r\n          }\r\n        }\r\n        &.list-inline-item.dropdown.show i {\r\n          transform: rotateX(160deg);\r\n          transition: 0.3s ease-in-out;\r\n        }\r\n        .dropdown-menu {\r\n          position: relative;\r\n          a {\r\n            color: #212529;\r\n            text-align: left;\r\n            padding-bottom: 10px;\r\n            padding-top: 10px;\r\n            top: 0px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .nav-info {\r\n      position: absolute;\r\n      margin: 1px auto;\r\n      top: 40px;\r\n      left: 39px;\r\n      font-size: 10px;\r\n    }\r\n  }\r\n\r\n  .profile-menu-List {\r\n    position: relative;\r\n    height: 100%;\r\n    ul {\r\n      width: 100%;\r\n      height: 100%;\r\n      li {\r\n        position: relative;\r\n        // margin-right: 0rem !important;\r\n        // height: 100%;\r\n        .menuIcon {\r\n          background-color: white;\r\n        }\r\n        a {\r\n          font-size: 14px;\r\n          font-weight: normal;\r\n          font-style: normal;\r\n          font-stretch: normal;\r\n          letter-spacing: normal;\r\n          text-align: right;\r\n          text-decoration: none;\r\n          color: $magenta;\r\n          padding: 18px 0;\r\n          top: calc(100% - 40px);\r\n          display: block;\r\n          position: relative;\r\n          &:hover {\r\n            background-color: $magenta;\r\n            color: $white !important;\r\n          }\r\n          &.active {\r\n            background-color: #0075ad;\r\n            color: $white !important;\r\n          }\r\n          img {\r\n            width: 30px;\r\n            height: 30px;\r\n            object-fit: contain;\r\n            margin-right: 8px;\r\n            margin-top: -2px;\r\n            // filter: brightness(200%);\r\n            // -webkit-filter: brightness(200%);\r\n          }\r\n        }\r\n        &.list-inline-item.dropdown.show i {\r\n          transform: rotateX(160deg);\r\n          transition: 0.3s ease-in-out;\r\n        }\r\n        .dropdown-menu {\r\n          position: relative;\r\n          a {\r\n            color: #212529;\r\n            text-align: left;\r\n            padding-bottom: 10px;\r\n            padding-top: 10px;\r\n            top: 0px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .nav-info {\r\n      position: absolute;\r\n      margin: 0px auto;\r\n      top: 40px;\r\n      left: 39px;\r\n      font-size: 10px;\r\n    }\r\n  }\r\n}\r\n.dropdown-toggle::after {\r\n  display: none !important;\r\n}\r\n@media (min-width: 992px) {\r\n  .animate {\r\n    animation-duration: 0.3s;\r\n    -webkit-animation-duration: 0.3s;\r\n    animation-fill-mode: both;\r\n    -webkit-animation-fill-mode: both;\r\n  }\r\n}\r\n\r\n@keyframes slideIn {\r\n  0% {\r\n    transform: translateY(1rem);\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    transform: translateY(0rem);\r\n    opacity: 1;\r\n  }\r\n  0% {\r\n    transform: translateY(1rem);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes slideIn {\r\n  0% {\r\n    -webkit-transform: transform;\r\n    -webkit-opacity: 0;\r\n  }\r\n  100% {\r\n    -webkit-transform: translateY(0);\r\n    -webkit-opacity: 1;\r\n  }\r\n  0% {\r\n    -webkit-transform: translateY(1rem);\r\n    -webkit-opacity: 0;\r\n  }\r\n}\r\n\r\n.slideIn {\r\n  -webkit-animation-name: slideIn;\r\n  animation-name: slideIn;\r\n  top: 50px !important;\r\n}\r\n\r\n// header {\r\n//   // box-shadow: 1.5px 2.6px 7px 0 $dark-grey-blue-35;\r\n//   // background-color: #084b69;\r\n//   background-image: linear-gradient(to top, #10baa4, #338eb5),\r\n//     linear-gradient(to bottom, #10baa4, #338eb5);\r\n//   position: fixed;\r\n//   width: 100%;\r\n//   z-index: 1001;\r\n//   top: 0;\r\n//   transition: top 0.3s;\r\n//   .logo {\r\n//     // width: 160px;\r\n//     // height: 50px;\r\n//     width: 129px;\r\n//     height: 41px;\r\n//   }\r\n\r\n//   .menu-List {\r\n//     position: relative;\r\n//     height: 100%;\r\n//     ul {\r\n//       width: 100%;\r\n//       height: 100%;\r\n//       margin-bottom: 0px;\r\n//       li {\r\n//         position: relative;\r\n//         // height: 100%;\r\n//         a {\r\n//           font-size: 14px;\r\n//           font-weight: normal;\r\n//           font-style: normal;\r\n//           font-stretch: normal;\r\n//           letter-spacing: normal;\r\n//           text-align: right;\r\n//           text-decoration: none;\r\n//           // color: #7fc3e3;\r\n//           color: #6c3964;\r\n//           padding: 18px 15px;\r\n//           top: calc(100% - 40px);\r\n//           display: block;\r\n//           position: relative;\r\n//           img {\r\n//             width: 17px;\r\n//             height: 17px;\r\n//             object-fit: contain;\r\n//             margin-right: 5px;\r\n//             margin-top: -2px;\r\n//             filter: brightness(150%);\r\n//             -webkit-filter: brightness(150%);\r\n//           }\r\n//         }\r\n//         a:hover {\r\n//           color: #7fc3e3;\r\n//         }\r\n//         a.active {\r\n//           background-color: #b37f40;\r\n//         }\r\n//         &.list-inline-item:hover a:first-child(1) {\r\n//           filter: brightness(200%);\r\n//           -webkit-filter: brightness(200%);\r\n//         }\r\n//         &.list-inline-item:hover img {\r\n//           filter: brightness(150%);\r\n//           -webkit-filter: brightness(150%);\r\n//           animation: jello 1s;\r\n//         }\r\n//         .dropdown-menu {\r\n//           position: relative;\r\n//           a {\r\n//             //color: #7fc3e3;\r\n//             color: #ffffff;\r\n//             text-align: left;\r\n//             padding-bottom: 13px;\r\n//             padding-top: 13px;\r\n//             font-size: 16px;\r\n//             border-bottom: 0.1px solid #7fc3e3;\r\n//           }\r\n//         }\r\n//         .dropdown-menu.show {\r\n//           // background-color: #084b69;\r\n//           background-image: linear-gradient(to top, #10baa4, #338eb5),\r\n//             linear-gradient(to bottom, #10baa4, #338eb5);\r\n//           margin-top: 12px;\r\n//           animation: 1s fadeIn;\r\n//           padding: 3px 15px 25px;\r\n//         }\r\n//         .dropdown-menu.show::before {\r\n//           content: \"\";\r\n//           width: 15px;\r\n//           height: 23px;\r\n//           background-color: #3192b4;\r\n//           position: absolute;\r\n//           top: -8px;\r\n//           left: 12%;\r\n//           transform: rotate(45deg);\r\n//           border-radius: 4px;\r\n//         }\r\n//         .dropdown-item:hover,\r\n//         .dropdown-item:focus {\r\n//           color: #fff;\r\n//           text-decoration: none;\r\n//           background-color: #10baa4;\r\n//         }\r\n//       }\r\n//       li:hover {\r\n//         background-color: #6c3964;\r\n//       }\r\n//       li:hover a:first-child() {\r\n//         color: #fff;\r\n//       }\r\n//     }\r\n//   }\r\n// }\r\n","$white-four: #f6f6f6 !default;\r\n$magenta: #6c3964 !default;\r\n$dark-navy-blue: #070027 !default;\r\n$cherry-red: #e30027 !default;\r\n$scarlet: #b4001f !default;\r\n$dark-maroon: #50000b !default;\r\n$greyish: #a3a3a3 !default;\r\n$very-dark-brown: #280000 !default;\r\n$black-two: #282828 !default;\r\n$black-three: #232323 !default;\r\n$cerulean: #0095da !default;\r\n$sapphire: #252abd !default;\r\n$warm-grey: #8d8d8d !default;\r\n$cherry-red-two: #e70021 !default;\r\n$sunflower-yellow: #ffcc00 !default;\r\n$white-two: #d2d2d2 !default;\r\n$almost-black: #040405 !default;\r\n$white-three: #d5d5d5 !default;\r\n$cerulean-two: #0086d6 !default;\r\n$cherry-red-three: #ff002c !default;\r\n$crimson: #880013 !default;\r\n$warm-grey-two: #a2a2a2 !default;\r\n$dark-navy-blue-two: #05001e !default;\r\n$white: #ffffff !default;\r\n$lipstick: #e71d66 !default;\r\n$white-five: #dddddd !default;\r\n$black-four: #3a3a3a !default;\r\n$white-six: #f9f9f9 !default;\r\n$warm-grey-25: rgba(130, 130, 130, 0.25) !default;\r\n$dusk-blue: #362482 !default;\r\n$wine-red: #790317 !default;\r\n$dark-maroon-two: #350007 !default;\r\n$white-seven: #f2f2f2 !default;\r\n$white-eight: #f0f0f0 !default;\r\n$almost-black-two: #080909 !default;\r\n$sunflower-yellow-two: #ffd400 !default;\r\n$plum: #3c131a !default;\r\n$slate: #475669 !default;\r\n$azure: #00adef !default;\r\n$pale-grey: #f9fafc !default;\r\n$pale-grey-two: #eff2f7 !default;\r\n$black-five: #080808 !default;\r\n$pinkish-grey: #cccccc !default;\r\n$sunflower: #ffcb08 !default;\r\n$white-nine: #eeeeee !default;\r\n$cloudy-blue: #c0ccda !default;\r\n$twilight-blue: #083f88 !default;\r\n$black: #191919 !default;\r\n$white-ten: #dedede !default;\r\n$sunflower-yellow-three: #ffcf03 !default;\r\n$marigold: #fcbc04 !default;\r\n$greeny-blue: #47adad !default;\r\n$dark: #252135 !default;\r\n$greyblue: #60b6b4 !default;\r\n$dark-grey-blue: #325857 !default;\r\n$brownish-grey: #666666 !default;\r\n$midnight-blue: #0b0034 !default;\r\n$charcoal-grey-25: rgba(45, 58, 66, 0.25) !default;\r\n$squash: #f0c317 !default;\r\n$pale-grey-three: #eeeff3 !default;\r\n$coral-pink: #fc5f61 !default;\r\n$pale-teal: #61bfad !default;\r\n$windows-blue: #4a94cb !default;\r\n$bright-sky-blue: #00d2ff !default;\r\n$warm-grey-three: #888888 !default;\r\n$greyblue-two: #61b7b6 !default;\r\n$black-75: rgba(0, 0, 0, 0.75) !default;\r\n$slate-two: #5e667f !default;\r\n$teal: #00908d !default;\r\n$dark-navy-blue-three: #000920 !default;\r\n$cool-grey: #b2b9c4 !default;\r\n$dark-grey-blue-35: rgba(41, 59, 73, 0.35) !default;\r\n$dark-two: #161421 !default;\r\n$marigold-two: #ffc000 !default;\r\n$orange-yellow: #ffa200 !default;\r\n$sunflower-yellow-four: #ffd800 !default;\r\n$yellow-orange: #e9af00 !default;\r\n$dark-grey-blue-two: #364152 !default;\r\n$ocean-blue: #0075ad !default;\r\n$slate-three: #54667a !default;\r\n$dark-sky-blue: #1e88e5 !default;\r\n$grey-blue: #647485 !default;\r\n$slate-four: #455a64 !default;\r\n$pale-grey-four: #eef5f9 !default;\r\n$silver: #d4dade !default;\r\n$bluey-grey: #99abb4 !default;\r\n$light-blue-grey: #b9d8e7 !default;\r\n$cool-grey-two: #a6afbb !default;\r\n\r\n$bg1: #488bd6 !default;\r\n$bg2: #40b391 !default;\r\n$bg3: #40a7b3 !default;\r\n$bg4: #b37f40 !default;\r\n$bg5: #2e659a !default;\r\n$bg6: #2f84bd !default;\r\n$bg7: #568095 !default;\r\n","footer {\r\n  position: fixed;\r\n  bottom: 2%;\r\n  left: 0;\r\n  right: 0;\r\n  p {\r\n    font-size: 15px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.73;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    // color: $bluey-grey;\r\n    a {\r\n      color: $white;\r\n      // &:hover {\r\n      //   color: $slate-four;\r\n      // }\r\n    }\r\n  }\r\n}\r\n",".breadCrums {\r\n  border: solid 1px $silver;\r\n  background-color: $white;\r\n  padding: 7px 0px;\r\n\r\n  p {\r\n    font-size: 16px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.4;\r\n    margin-bottom: 0px;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: $dark-grey-blue-two;\r\n  }\r\n  ol {\r\n    margin-bottom: 0px;\r\n    &.list-inline {\r\n      display: inline;\r\n      &:hover a::after {\r\n        animation: 1s fadeInLeft infinite;\r\n      }\r\n    }\r\n    li {\r\n      a {\r\n        font-size: 14px;\r\n        font-weight: normal;\r\n        font-style: normal;\r\n        font-stretch: normal;\r\n        line-height: 1.5;\r\n        letter-spacing: normal;\r\n        text-align: left;\r\n        color: #455a64;\r\n        padding: 0px 15px 0px 0px;\r\n        position: relative;\r\n        text-transform: capitalize;\r\n        &::after {\r\n          content: \">\";\r\n          font-size: 18px;\r\n          font-weight: normal;\r\n          font-style: normal;\r\n          font-stretch: normal;\r\n          line-height: 1.5;\r\n          letter-spacing: normal;\r\n          text-align: left;\r\n          color: $slate-three;\r\n          padding: 0px 0px 0px 5px;\r\n          position: absolute;\r\n        }\r\n      }\r\n      &:last-child {\r\n        a {\r\n          color: $cool-grey-two;\r\n          &::after {\r\n            content: \"\";\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n",".custom-container {\r\n  padding: 10px 0px 20px 0px;\r\n  height: auto;\r\n\r\n  h6 {\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 2.67;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: $dark-grey-blue-two;\r\n  }\r\n\r\n  .table-container {\r\n    border: solid 1px $silver;\r\n    background-color: $white;\r\n    padding: 40px 0 0;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    height: 75vh;\r\n    margin-top: 10px;\r\n\r\n    input {\r\n      border: solid 1px $cool-grey;\r\n      background-color: $white;\r\n      padding: 15px 10px;\r\n      font-size: 14px;\r\n      font-weight: 300;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 3.43;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: black;\r\n\r\n      &::-moz-placeholder {\r\n        font-size: 14px;\r\n        font-weight: 300;\r\n        font-style: normal;\r\n        font-stretch: normal;\r\n        line-height: 3.43;\r\n        letter-spacing: normal;\r\n        text-align: left;\r\n        color: $cool-grey;\r\n      }\r\n\r\n      &:focus {\r\n        box-shadow: unset;\r\n      }\r\n    }\r\n\r\n    button {\r\n      font-size: 14px;\r\n      font-weight: normal;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: $white;\r\n\r\n      &:focus {\r\n        box-shadow: unset;\r\n      }\r\n    }\r\n\r\n    thead {\r\n      tr {\r\n        th {\r\n          font-size: 14px;\r\n          font-weight: 500;\r\n          font-style: normal;\r\n          font-stretch: normal;\r\n          line-height: 3.43;\r\n          letter-spacing: normal;\r\n          text-align: left;\r\n          color: $cool-grey;\r\n        }\r\n      }\r\n    }\r\n\r\n    tbody {\r\n      tr {\r\n        border: solid 1px #d4dbdb;\r\n        background-color: $white;\r\n        padding: 15px 15px;\r\n        vertical-align: sub;\r\n\r\n        img {\r\n          width: 22px;\r\n          height: 21px;\r\n          object-fit: contain;\r\n        }\r\n\r\n        td {\r\n          font-size: 14px;\r\n          font-weight: normal;\r\n          font-style: normal;\r\n          font-stretch: normal;\r\n          line-height: 1.29;\r\n          letter-spacing: normal;\r\n          text-align: left;\r\n          color: $slate-four;\r\n          margin-bottom: 0px;\r\n\r\n          &.light {\r\n            font-size: 12px;\r\n            font-weight: normal;\r\n            font-style: normal;\r\n            font-stretch: normal;\r\n            line-height: 1.5;\r\n            letter-spacing: normal;\r\n            text-align: left;\r\n            color: $grey-blue;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\ntbody {\r\n  tr {\r\n    th {\r\n      font-size: 14px;\r\n      font-weight: 600;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: #455a64;\r\n    }\r\n\r\n    td {\r\n      label {\r\n        width: 25px;\r\n        margin: 5px 0px;\r\n        position: relative;\r\n        float: left;\r\n        margin-bottom: 0px;\r\n      }\r\n      label span {\r\n        cursor: pointer;\r\n        position: absolute;\r\n        width: 20px;\r\n        height: 20px;\r\n        top: 0;\r\n        left: 0;\r\n        background: #ffffff;\r\n        // border: 2px solid #2196f3;\r\n        border: 2px solid #6c3964;\r\n      }\r\n\r\n      label input[type=\"checkbox\"]:checked + span {\r\n        cursor: pointer;\r\n        position: absolute;\r\n        width: 20px;\r\n        height: 20px;\r\n        top: 0;\r\n        left: 0;\r\n        background: #ffffff;\r\n        border: 2px solid #04c82d;\r\n      }\r\n\r\n      label input[type=\"checkbox\"]:disabled + span {\r\n        cursor: pointer;\r\n        position: absolute;\r\n        width: 20px;\r\n        height: 20px;\r\n        top: 0;\r\n        left: 0;\r\n        background: #f4f4f4;\r\n        border: 2px solid #f4f4f4;\r\n      }\r\n\r\n      label input[type=\"checkbox\"]:checked + span:after {\r\n        opacity: 1;\r\n        content: \"\";\r\n        position: absolute;\r\n        width: 18px;\r\n        height: 9px;\r\n        background: #fff;\r\n        top: -1px;\r\n        left: 4px;\r\n        border: 3px solid #04c82d;\r\n        border-top: none;\r\n        border-right: none;\r\n        transition: all 0.5s ease-in-out;\r\n        transform: rotate(-45deg);\r\n      }\r\n    }\r\n  }\r\n}\r\n",".work-flow-stages {\r\n  h2 {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 2.4;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #607d8b;\r\n  }\r\n\r\n  p {\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 3.2;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #607d8b;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .icon {\r\n    width: 34px;\r\n    height: 34px;\r\n    object-fit: contain;\r\n    margin: 0px auto;\r\n\r\n    img {\r\n      width: 100%;\r\n      height: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n.queue-imahe {\r\n  height: 458px;\r\n  object-fit: contain;\r\n}\r\n\r\n.q-check {\r\n  overflow: auto;\r\n  float: left;\r\n\r\n  padding: 0px;\r\n\r\n  label {\r\n    float: left;\r\n    width: 100%;\r\n    margin-bottom: 0px;\r\n\r\n    input {\r\n      position: absolute;\r\n      top: -20px;\r\n    }\r\n\r\n    span {\r\n      border: solid 1px $cool-grey;\r\n      background-color: $white;\r\n      border-radius: 4px;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: $cool-grey;\r\n      line-height: 2;\r\n      cursor: pointer;\r\n      display: block;\r\n    }\r\n\r\n    input:checked + span {\r\n      border: solid 1px $cool-grey;\r\n      background-color: #d4dce0;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: $dark-grey-blue-two;\r\n    }\r\n  }\r\n}\r\n\r\n.b-card-footerColor {\r\n  background-color: #d4dce0;\r\n  border-radius: 10px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.q-p-details {\r\n  // width: auto;\r\n  // overflow: hidden;\r\n  .h-card {\r\n    height: 90px;   \r\n    border: solid 1px $silver;\r\n    background-color: #6c3964;\r\n    border-radius: 8px;\r\n\r\n    p {\r\n      font-family: Avenir;\r\n      font-size: 25px;\r\n      font-weight: 900;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2.3;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: $white;\r\n      margin-bottom: 0px;\r\n    }\r\n\r\n    .q-p-add {\r\n      width: 22px;\r\n      height: 22px;\r\n      position: relative;\r\n      font-size: 20px;\r\n      color: #6c3964;\r\n      background-color: $white;\r\n      border: 0px solid $white;\r\n      border-radius: 50%;\r\n      outline: transparent;\r\n\r\n      &::before {\r\n        content: \"+\";\r\n        position: absolute;\r\n        color: #6c3964;\r\n        top: -3px;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .b-card {\r\n    border-radius: 8px;\r\n    border: solid 1px $silver;\r\n    // background-color: #f2f2f2;\r\n    height: 420px;\r\n    padding: 10px;\r\n\r\n    position: relative;\r\n    .b-card-scroll {\r\n      height: 350px;\r\n      overflow-y: auto;\r\n      overflow-x: hidden;\r\n\r\n      &::-webkit-scrollbar-track {\r\n        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n        background-color: #f5f5f5;\r\n      }\r\n\r\n      &::-webkit-scrollbar {\r\n        width: 5px;\r\n        background-color: #f5f5f5;\r\n      }\r\n\r\n      &::-webkit-scrollbar-thumb {\r\n        background-color: #000000;\r\n        border: 2px solid #555555;\r\n      }\r\n    }  \r\n    .b-card-body {\r\n      // border-bottom: solid 1px $silver;\r\n      // border-top: solid 1px #d4dade;\r\n      border: solid 1px #d4dade;\r\n      border-radius: 10px;\r\n      margin-bottom: 2px;\r\n      background-color: #f5fafe;\r\n      .ant-select {\r\n        font-size: 12px;\r\n        line-height: 1;\r\n        height: 25px;\r\n        .ant-select-selection--single {\r\n          height: 25px;\r\n        }\r\n        .ant-select-selection {\r\n          height: 32px;\r\n        }\r\n        .ant-select-selection__rendered {\r\n          line-height: 25px;\r\n        }\r\n      }\r\n\r\n      // &:last-child {\r\n      //     border-bottom: solid 0px $silver;\r\n      // }\r\n\r\n      p {\r\n        margin-bottom: 0px;\r\n        position: relative;\r\n\r\n        &.text-p-light {\r\n          font-size: 14px;\r\n          font-weight: normal;\r\n          font-style: normal;\r\n          font-stretch: normal;\r\n          line-height: 1.5;\r\n          letter-spacing: normal;\r\n          text-align: left;\r\n          color: $slate-four;\r\n          word-break: break-all;\r\n          height: 20px;\r\n          overflow: hidden;\r\n        }\r\n\r\n        &.text-p-bold {\r\n          font-size: 14px;\r\n          font-weight: 500;\r\n          font-style: normal;\r\n          font-stretch: normal;\r\n          line-height: 1.7;\r\n          letter-spacing: normal;\r\n          text-align: left;\r\n          color: $slate-four;\r\n        }\r\n\r\n        img {\r\n          width: 13px;\r\n          height: 14px;\r\n          object-fit: contain;\r\n          position: relative;\r\n          margin-right: 7px;\r\n          top: -2px;\r\n        }\r\n\r\n        i {\r\n          font-size: 30px;\r\n          transform: rotate(90deg);\r\n        }\r\n      }\r\n    }\r\n\r\n    .b-card-footer {\r\n      border-radius: 10px;\r\n      background-color: #dee9ef;\r\n      width: 80%;\r\n      bottom: 0px;\r\n      figure {\r\n        border-right: 1px solid #ffffff;\r\n        cursor: pointer;\r\n\r\n        //   &.active{\r\n        //     background-color: #7593a4;\r\n        //   }\r\n        &:last-child {\r\n          border-right: 0px solid #ffffff;\r\n        }\r\n        &.active {\r\n          background-color: #7593a4;\r\n          border-top-left-radius: 10px;\r\n          border-bottom-left-radius: 10px;\r\n          &:last-child {\r\n            border-top-left-radius: 0px;\r\n            border-bottom-left-radius: 0px;\r\n            border-top-right-radius: 10px;\r\n            border-bottom-right-radius: 10px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.q-p-d-list {\r\n  .h-card {\r\n    border: solid 1px $silver;\r\n    background-color: #26c7db;\r\n    .ant-select {\r\n      font-size: 12px;\r\n      line-height: 1;\r\n      height: 25px;\r\n      .ant-select-selection--single {\r\n        height: 25px;\r\n      }\r\n      .ant-select-selection {\r\n        border: 0px solid transparent;\r\n      }\r\n      .ant-select-selection__rendered {\r\n        line-height: 25px;\r\n      }\r\n    }\r\n    p {\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 1.5;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: $white;\r\n      word-break: break-all;\r\n      height: 20px;\r\n      overflow: hidden;\r\n      text-transform: capitalize;\r\n\r\n      &.text-light-d {\r\n        font-size: 13px;\r\n        font-weight: 500;\r\n        font-style: normal;\r\n        font-stretch: normal;\r\n        line-height: 1.13;\r\n        letter-spacing: normal;\r\n        text-align: left;\r\n        color: $white;\r\n      }\r\n      &.line-height-0 {\r\n        line-height: unset;\r\n      }\r\n    }\r\n  }\r\n\r\n  button {\r\n    border-radius: 3.6px;\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.7;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: $white;\r\n    border: 0px;\r\n    width: 100%;\r\n    text-align: center;\r\n\r\n    &.text-checkin {\r\n      background-color: $magenta;\r\n    }\r\n    &.text-vitals {\r\n      // background-color: #ca7ce4;\r\n      // background-color:#9704c8;\r\n      // background-color:#550273;\r\n      // background-color:#600382;\r\n      // background-color:#c21b69;\r\n      // background-color:#dc2d7f;\r\n      background-color:#522bb6;\r\n    }\r\n    &.text-reports {\r\n      \r\n      background-color:$magenta;\r\n      // background-color: #e81798;\r\n    }\r\n\r\n    &.text-checkout {\r\n      background-color: #fc4b6c;\r\n    }\r\n\r\n    &.text-hold {\r\n      background-color: #d0ac02;\r\n    }\r\n\r\n    &.text-cancel {\r\n      background-color: #df0136;\r\n    }\r\n  }\r\n}\r\n\r\n.popup {\r\n  img {\r\n    width: 22px;\r\n    height: 22px;\r\n    object-fit: contain;\r\n    position: absolute;\r\n    right: -25px;\r\n    top: -22px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  h4 {\r\n    position: relative;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.7;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: #607d8b;\r\n    margin-bottom: 4px;\r\n  }\r\n\r\n  Button {\r\n    margin: 5px 7px;\r\n    width: 110px;\r\n    height: 34px;\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    border-radius: 0px;\r\n    outline: transparent;\r\n    outline: none;\r\n    border: 0px solid transparent;\r\n\r\n    &.btn-gray {\r\n      background-color: #d7d9dd;\r\n      color: $dark-grey-blue-two;\r\n    }\r\n\r\n    &.btn-red {\r\n      background-color: #fc4b6c !important;\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.k-modal {\r\n  h2 {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 2.4;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #607d8b;\r\n  }\r\n\r\n  button {\r\n    margin: 5px 7px;\r\n    width: 125px;\r\n    border: 0px solid transparent;\r\n    border-radius: 0px;\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.5;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n\r\n    &.btn-dark-gray {\r\n      color: $white;\r\n      background-color: $dark-grey-blue-two;\r\n    }\r\n\r\n    &.btn-dark-red {\r\n      background-color: #df0136;\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.ant-select-selection {\r\n  display: block;\r\n  box-sizing: border-box;\r\n  background-color: #fff;\r\n  border: 1px solid #d9d9d9;\r\n  border-top-width: 1.02px;\r\n  border-radius: 0px;\r\n  outline: none;\r\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.ant-select-disabled .ant-select-selection {\r\n  background: #f5f5f5 !important;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.checkboxFive {\r\n  width: 25px;\r\n  margin: 5px 0px;\r\n  position: relative;\r\n  float: right;\r\n}\r\n\r\n.checkboxFive label {\r\n  cursor: pointer;\r\n  position: absolute;\r\n  width: 25px;\r\n  height: 25px;\r\n  top: 0;\r\n  left: 0;\r\n  background: #ffffff;\r\n  border: 2px solid #2196f3;\r\n}\r\n\r\n.checkboxFive input[type=\"checkbox\"]:checked + label {\r\n  cursor: pointer;\r\n  position: absolute;\r\n  width: 25px;\r\n  height: 25px;\r\n  top: 0;\r\n  left: 0;\r\n  background: #ffffff;\r\n  border: 2px solid #04c82d;\r\n}\r\n\r\n.checkboxFive input[type=\"checkbox\"]:checked + label:after {\r\n  opacity: 1;\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 22px;\r\n  height: 12px;\r\n  background: #fff;\r\n  top: 0px;\r\n  left: 5px;\r\n  border: 3px solid #04c82d;\r\n  border-top: none;\r\n  border-right: none;\r\n  transition: all 0.5s ease-in-out;\r\n  transform: rotate(-45deg);\r\n}\r\n\r\n.checkboxFive .checked + label {\r\n  cursor: not-allowed;\r\n  position: absolute;\r\n  width: 25px;\r\n  height: 25px;\r\n  top: 0;\r\n  left: 0;\r\n  background: #ffffff;\r\n  border: 2px solid #04c82d;\r\n}\r\n\r\n.checkboxFive .checked + label:after {\r\n  opacity: 1;\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 22px;\r\n  height: 12px;\r\n  background: #fff;\r\n  top: 0px;\r\n  left: 5px;\r\n  border: 3px solid #04c82d;\r\n  border-top: none;\r\n  border-right: none;\r\n  transition: all 0.5s ease-in-out;\r\n  transform: rotate(-45deg);\r\n}\r\n\r\n.q-table {\r\n  thead {\r\n    th {\r\n      border-top: solid 1px $silver;\r\n      border-bottom: solid 1px $silver;\r\n      background-color: $white;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: $cool-grey;\r\n    }\r\n  }\r\n  tbody {\r\n    td {\r\n      border-top: solid 0px transparent;\r\n      border-bottom: solid 1px $silver;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      color: $dark-grey-blue-two;\r\n    }\r\n  }\r\n}\r\n\r\n.ant-input-number {\r\n  width: 100% !important;\r\n}\r\n\r\n.generate-button {\r\n  background-color: $dark-grey-blue-two;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  font-style: normal;\r\n  font-stretch: normal;\r\n  line-height: 3;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #fff;\r\n  border: 0px;\r\n  padding: 0px 60px;\r\n}\r\n.queeadd {\r\n  button {\r\n    padding: 0px 50px !important;\r\n  }\r\n}\r\n\r\n.addButton {\r\n  background-color: $dark-grey-blue-two;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-stretch: normal;\r\n  line-height: 2;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: $white;\r\n  border: 0px solid transparent;\r\n  padding: 3px 40px;\r\n}\r\n\r\n.f-12 {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.appt {\r\n  width: 100px;\r\n  height: 19px;\r\n  margin: 0 0 0 5.1px;\r\n  font-family: Avenir-Roman;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: left;\r\n  color: #1f1f39;\r\n}\r\n",".appointement-screen {\r\n  button {\r\n    font-size: 14px;\r\n    border: 0px solid transparent;\r\n    margin: auto 10px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 3;\r\n    padding: 0px 20px;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    color: $white;\r\n\r\n    img {\r\n      width: 18px;\r\n      height: 18px;\r\n      object-fit: contain;\r\n      margin-right: 10px;\r\n    }\r\n  }\r\n\r\n  .card {\r\n    border: solid 1px $silver;\r\n    background-color: $white;\r\n    border-radius: 0px;\r\n  }\r\n\r\n  .ant-calendar-picker .ant-input {\r\n    border: solid 1px $cool-grey;\r\n    border-radius: 0px;\r\n  }\r\n\r\n  .gobutton {\r\n    background-color: $ocean-blue;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 2;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: $white;\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 0px;\r\n  }\r\n  .btn {\r\n    line-height: 2.4;\r\n    border-radius: 0px;\r\n    outline: none;\r\n  }\r\n}\r\n\r\n.timecard {\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n\r\n  .time-block {\r\n    border-bottom: solid 0.5px $silver;\r\n    border-right: solid 0.5px $silver;\r\n    // &:nth-of-type(even){\r\n    //     border: solid 0.5px $silver;\r\n    // }\r\n    background-color: $white;\r\n    min-height: 141px;\r\n    cursor: pointer;\r\n\r\n    &.disable {\r\n      background-color: #f5f4f4;\r\n      cursor: not-allowed;\r\n    }\r\n\r\n    p {\r\n      font-size: 15px;\r\n      font-weight: normal;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      margin-bottom: 0px;\r\n      color: $slate-four;\r\n\r\n      .assigned {\r\n        background-color: #26c6da;\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.appointment-modal,\r\n.dissable-modal,\r\n.appointment-view-modal {\r\n  .ant-modal-header {\r\n    border-bottom: 0px solid transparent;\r\n\r\n    .ant-modal-title {\r\n      font-size: 20px;\r\n      font-weight: 600;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2.4;\r\n      letter-spacing: normal;\r\n      text-align: center;\r\n      color: #607d8b;\r\n    }\r\n  }\r\n\r\n  .ant-modal-body {\r\n    p {\r\n      img {\r\n        width: 20px;\r\n        height: 20px;\r\n        object-fit: contain;\r\n        margin-right: 7px;\r\n        position: relative;\r\n        top: -1px;\r\n      }\r\n\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2.43;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n      padding: 0px 20px;\r\n      color: #6f848e;\r\n      background-color: #e7f0f4;\r\n    }\r\n  }\r\n\r\n  .ant-modal-footer {\r\n    border-top: 0px solid transparent;\r\n    text-align: center;\r\n\r\n    button {\r\n      font-size: 14px;\r\n      font-weight: normal;\r\n      font-style: normal;\r\n      font-stretch: normal;\r\n      line-height: 2;\r\n      letter-spacing: normal;\r\n      text-align: left;\r\n\r\n      border-radius: 0px;\r\n\r\n      &.add {\r\n        color: $white;\r\n        border: 0px solid transparent;\r\n        background-color: #df0136;\r\n        padding: 0px 30px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.reports-details {\r\n  .card {\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n  }\r\n\r\n  th {\r\n    border: 0px solid transparent;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.4;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: $cool-grey;\r\n  }\r\n\r\n  td {\r\n    border-bottom: solid 1px $silver;\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.29;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: $slate-four;\r\n    padding: 30px 15px;\r\n\r\n    &:first-child {\r\n      border-right: solid 2px $silver;\r\n    }\r\n\r\n    &.text-primary {\r\n      font-weight: 600;\r\n\r\n      color: #1d84b6;\r\n    }\r\n\r\n    &.text-success {\r\n      font-weight: 600;\r\n\r\n      color: #0ec200;\r\n    }\r\n\r\n    &.text-error {\r\n      font-weight: 600;\r\n\r\n      color: #df0136;\r\n    }\r\n  }\r\n}\r\n\r\n.timecard {\r\n  .new_name_data {\r\n    min-height: 60px;\r\n    border-bottom: solid 1px $silver;\r\n  }\r\n}\r\n.new-details-table {\r\n  th {\r\n    border: 0px solid transparent;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.4;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: $cool-grey;\r\n    padding: 15px;\r\n    border-bottom: solid 1px $silver;\r\n    vertical-align: middle !important;\r\n    min-width: 170px !important;\r\n    tr {\r\n      th {\r\n        vertical-align: middle;\r\n        border-bottom: solid 0px $silver;\r\n        min-width: 170px !important;\r\n        &.name {\r\n          min-width: 100px !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  tr {\r\n    &:last-child {\r\n      border-bottom: solid 0px transparent;\r\n    }\r\n  }\r\n\r\n  td {\r\n    border-bottom: solid 1px transparent;\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.29;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: $slate-four;\r\n    padding: 15px;\r\n    min-width: 170px !important;\r\n    vertical-align: middle;\r\n    tr {\r\n      td {\r\n        padding: 15px !important;\r\n        min-width: 170px !important;\r\n        &.name {\r\n          min-width: 100px !important;\r\n        }\r\n      }\r\n      &.ip {\r\n        background-color: #df0136;\r\n        td {\r\n          color: #ffffff;\r\n        }\r\n      }\r\n      &.IP {\r\n        background-color: #df0136;\r\n        td {\r\n          color: #ffffff;\r\n        }\r\n      }\r\n      &.notLinked {\r\n        background-color: #ff003dde;\r\n        td {\r\n          color: #ffffff;\r\n        }\r\n      }\r\n      &.cancelled {\r\n        background-color: gray;\r\n        td {\r\n          color: #ffffff;\r\n        }\r\n      }\r\n      &.linked {\r\n        background-color: chartreuse;\r\n        td {\r\n          color: #ffffff;\r\n        }\r\n      }\r\n      &.op {\r\n        background-color: #26c6da;\r\n        td {\r\n          color: #ffffff;\r\n        }\r\n      }\r\n      &.OP {\r\n        background-color: #26c6da;\r\n        td {\r\n          color: #ffffff;\r\n        }\r\n      }\r\n      &.Bedside {\r\n        background-color: #6f848e;\r\n        td {\r\n          color: #ffffff;\r\n        }\r\n      }\r\n      &.Buffer {\r\n        background-color: green;\r\n        td {\r\n          color: #ffffff;\r\n        }\r\n      }\r\n    }\r\n    td {\r\n      min-width: 150px !important;\r\n      border-top: solid 0px transparent;\r\n    }\r\n    &:first-child {\r\n      border-right: solid 0px transparent;\r\n    }\r\n\r\n    &.text-primary {\r\n      font-weight: 600;\r\n\r\n      color: #1d84b6;\r\n    }\r\n\r\n    &.text-success {\r\n      font-weight: 600;\r\n\r\n      color: #0ec200;\r\n    }\r\n\r\n    &.text-error {\r\n      font-weight: 600;\r\n\r\n      color: #df0136;\r\n    }\r\n  }\r\n}\r\n\r\n.dissable-modal {\r\n  width: 80% !important;\r\n}\r\n\r\n.appointment-view-modal {\r\n  width: 60% !important;\r\n}\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.new-time-block {\r\n  min-height: 100px !important;\r\n}\r\n\r\n.patient-type {\r\n  position: absolute;\r\n  width: 100%;\r\n  // background-color: red;\r\n  left: 0;\r\n  bottom: 0;\r\n  p {\r\n    color: #ffffff !important;\r\n    text-align: left !important;\r\n    margin-bottom: 0px !important;\r\n    font-size: 10px !important;\r\n    line-height: unset !important;\r\n  }\r\n  &.IP {\r\n    background-color: #df0136;\r\n  }\r\n  &.OP {\r\n    background-color: #26c6da;\r\n  }\r\n  &.BedSide {\r\n    background-color: #6f848e;\r\n  }\r\n  &.Buffer {\r\n    background-color: green;\r\n  }\r\n  &.emergency {\r\n    background-color: rgba(255, 0, 0, 0.911);\r\n  }\r\n}\r\n\r\n.appointment-modal {\r\n  .umr,\r\n  .mobile {\r\n    .form-group {\r\n      width: 90%;\r\n      &::after {\r\n        content: \"OR\";\r\n        color: black;\r\n        position: absolute;\r\n        top: 5px;\r\n        font-size: 16px;\r\n        bottom: 0;\r\n        margin: auto;\r\n        right: 2px;\r\n      }\r\n    }\r\n  }\r\n  .ipnumber {\r\n    width: 80%;\r\n    button {\r\n      position: absolute;\r\n      top: 0;\r\n      right: 16px;\r\n      font-size: 19px;\r\n      border-radius: 0px;\r\n      padding: 0p;\r\n      line-height: 0px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
